function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("3Zqmb", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "FiltersDirectory", ()=>$0d1498ba14553dee$export$c47481051d3723fd);
    $parcel$export(module.exports, "default", ()=>$0d1498ba14553dee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("2Geeh");
    var $iFYlf;
    var $4041n;
    var $yxvUH;
    var $kUACW;
    var $dRl24;
    var $5qVrc;
    var $4dRjY;
    var $9OXo1;
    var $l8ruj;
    var $2YP9W;
    var $1bQGJ;
    var $bRTld;
    const $0d1498ba14553dee$var$useFiltersDirectoryResource = (0, (0, parcelRequire("kUACW")).withSuspense)(()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dRl24")).filtersDirectoryResource)));
    const $0d1498ba14553dee$export$c47481051d3723fd = ({ location: location })=>{
        const state = $0d1498ba14553dee$var$useFiltersDirectoryResource();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("yxvUH")).default), {
            location: location
        }, ({ query: query, onQueryChanged: onQueryChanged })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4041n")).FavoriteChangeConsumer), null, (favoriteChangeContext)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
                    name: "filters-directory"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bRTld")).default), {
                    tenantContext: tenantContext,
                    prefetchResult: {
                        ...state
                    },
                    favoriteChangeContext: favoriteChangeContext,
                    query: query,
                    onQueryChanged: onQueryChanged
                }))));
    };
    const $0d1498ba14553dee$var$RouterWrapper = (0, (0, parcelRequire("1bQGJ")).withRouter)($0d1498ba14553dee$export$c47481051d3723fd);
    var $0d1498ba14553dee$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5qVrc")).default), {
            id: "spa-app-bootstrap.directories.filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iFYlf")).default), {
            appNameSuffixForV2Event: "directory.filters",
            appNameForV3OperationalEvent: "filtersDirectory"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($0d1498ba14553dee$var$RouterWrapper, props)));
});
parcelRegister("iFYlf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d4f9fac2e290ba9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    const $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
        };
    var $3d4f9fac2e290ba9$export$2e2bcd8739ae039 = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: ""
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
        }));
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("yxvUH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$155570b6ec56a1d1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iJPdQ;
    var $aRmgJ;
    var $2J2h7;
    var $kSlYX;
    var $155570b6ec56a1d1$export$2e2bcd8739ae039 = ({ location: location, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iJPdQ")).default), {
            location: location,
            sortFieldToParam: (0, (0, parcelRequire("kSlYX")).sortFieldToParam),
            sortFieldFromParam: (0, (0, parcelRequire("kSlYX")).sortFieldFromParam),
            filterFromParams: (0, (0, parcelRequire("2J2h7")).filterFromParams),
            filterToParams: (0, (0, parcelRequire("2J2h7")).filterToParams),
            defaultQuery: (0, (0, parcelRequire("aRmgJ")).initialQuery)
        }, children);
});
parcelRegister("iJPdQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34933f66e78f501b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $67TwH;
    var $4P5qU;
    var $cd2Ri;
    var $34933f66e78f501b$export$2e2bcd8739ae039 = ({ location: location, children: children, sortFieldFromParam: sortFieldFromParam, filterFromParams: filterFromParams, sortFieldToParam: sortFieldToParam, filterToParams: filterToParams, defaultQuery: defaultQuery })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("67TwH")).default), {
            location: location,
            queryFromUrl: (0, (0, parcelRequire("cd2Ri")).default)(sortFieldFromParam, filterFromParams),
            queryToUrl: (0, (0, parcelRequire("4P5qU")).default)(sortFieldToParam, filterToParams),
            defaultQuery: defaultQuery
        }, children);
});
parcelRegister("67TwH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41e75e9a90d3818a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hJCUd = parcelRequire("hJCUd");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $ebyGx = parcelRequire("ebyGx");
    var $5y0F0;
    var $6wlPy;
    var $aJXmP;
    var $41e75e9a90d3818a$export$2e2bcd8739ae039 = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
        const toQuery = (search)=>(0, ($parcel$interopDefault($hJCUd)))((0, (0, parcelRequire("6wlPy")).default)(queryFromUrl)((0, ($parcel$interopDefault($ebyGx))).parse(search)), defaultQuery);
        const replaceUrl = (replace, query, prevParams)=>replace(`?${(0, ($parcel$interopDefault($ebyGx))).stringify({
                ...prevParams,
                ...queryToUrl(query)
            })}`, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5y0F0")).RouterActions), null, ({ replace: replace })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aJXmP")).AdapterWithState), {
                search: location.search,
                toQuery: (search)=>toQuery(search),
                onChange: false ? (0, ($parcel$interopDefault($8Rkzz))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
            }, children));
    };
});
parcelRegister("hJCUd", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $g7i7g = parcelRequire("g7i7g");
    var $3KORh = parcelRequire("3KORh");
    var $3dHKF = parcelRequire("3dHKF");
    var $ce94d17a4ae582d5$var$defaultsDeep = $g7i7g(function(args) {
        args.push(undefined, $3KORh);
        return $hlchF($3dHKF, undefined, args);
    });
    module.exports = $ce94d17a4ae582d5$var$defaultsDeep;
});
parcelRegister("3KORh", function(module, exports) {
    var $1m1GH = parcelRequire("1m1GH");
    var $k0qYG = parcelRequire("k0qYG");
    function $2bbd1e633373e9a1$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if ($k0qYG(objValue) && $k0qYG(srcValue)) {
            stack.set(srcValue, objValue);
            $1m1GH(objValue, srcValue, undefined, $2bbd1e633373e9a1$var$customDefaultsMerge, stack);
            stack['delete'](srcValue);
        }
        return objValue;
    }
    module.exports = $2bbd1e633373e9a1$var$customDefaultsMerge;
});
parcelRegister("3dHKF", function(module, exports) {
    var $1m1GH = parcelRequire("1m1GH");
    var $9MM2g = parcelRequire("9MM2g");
    var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
        $1m1GH(object, source, srcIndex, customizer);
    });
    module.exports = $2584862af7fb4983$var$mergeWith;
});
parcelRegister("6wlPy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c011c7ab8644dae0$export$2e2bcd8739ae039);
    var $basmW = parcelRequire("basmW");
    var $dPSWJ = parcelRequire("dPSWJ");
    const $c011c7ab8644dae0$var$fromUrlTransformerFactory = (transformer)=>(0, ($parcel$interopDefault($basmW)))([
            (params)=>(0, ($parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
            (params)=>transformer(params)
        ]);
    var $c011c7ab8644dae0$export$2e2bcd8739ae039 = $c011c7ab8644dae0$var$fromUrlTransformerFactory;
});
parcelRegister("dPSWJ", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $hDnyx = parcelRequire("hDnyx");
    var $bxDef = parcelRequire("bxDef");
    function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
        var result = {};
        iteratee = $bxDef(iteratee, 3);
        $hDnyx(object, function(value, key, object) {
            $1m3dq(result, key, iteratee(value, key, object));
        });
        return result;
    }
    module.exports = $a12aa8fd8ab9a7da$var$mapValues;
});
parcelRegister("aJXmP", function(module, exports) {
    $parcel$export(module.exports, "AdapterWithState", ()=>$1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $ebyGx = parcelRequire("ebyGx");
    class $1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            if (props.search !== state.prevSearch) return {
                query: props.toQuery(props.search),
                prevSearch: props.search
            };
            return null;
        }
        componentDidUpdate(prevProps, prevState) {
            if (!(0, ($parcel$interopDefault($ajpes)))(prevState.query, this.state.query)) {
                const prevParams = (0, ($parcel$interopDefault($ebyGx))).parse(prevState.prevSearch);
                this.props.onChange(this.state.query, prevParams);
            }
        }
        render() {
            return this.props.children({
                query: this.state.query,
                onQueryChanged: this.onQueryChanged
            });
        }
        constructor(...args){
            super(...args), this.state = {
                query: this.props.toQuery(this.props.search),
                prevSearch: this.props.search
            }, this.onQueryChanged = (query)=>{
                this.setState({
                    query: query
                });
            };
        }
    }
});
parcelRegister("4P5qU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$053ceb3ca02e043a$export$2e2bcd8739ae039);
    var $27NS3 = parcelRequire("27NS3");
    var $aud83;
    const $053ceb3ca02e043a$var$toUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
        const valueTransformers = {
            page: (page)=>({
                    page: (0, (0, parcelRequire("aud83")).number).stringify(page)
                }),
            sortDirection: (dir)=>({
                    sortOrder: (0, (0, parcelRequire("aud83")).string).stringify(dir)
                }),
            sortField: (field)=>({
                    sortKey: sortFieldTransformer(field)
                }),
            filter: filterTransformer
        };
        return (query)=>(0, ($parcel$interopDefault($27NS3)))(query, (params, value, key)=>valueTransformers[key] ? {
                    ...params,
                    ...valueTransformers[key](value)
                } : params, {});
    };
    var $053ceb3ca02e043a$export$2e2bcd8739ae039 = $053ceb3ca02e043a$var$toUrlTransformerFactory;
});
parcelRegister("27NS3", function(module, exports) {
    var $2YkAc = parcelRequire("2YkAc");
    var $e7pfQ = parcelRequire("e7pfQ");
    var $bxDef = parcelRequire("bxDef");
    var $87mh8 = parcelRequire("87mh8");
    var $8LQ84 = parcelRequire("8LQ84");
    function $18c2eb891b6f17d9$var$reduce(collection, iteratee, accumulator) {
        var func = $8LQ84(collection) ? $2YkAc : $87mh8, initAccum = arguments.length < 3;
        return func(collection, $bxDef(iteratee, 4), accumulator, initAccum, $e7pfQ);
    }
    module.exports = $18c2eb891b6f17d9$var$reduce;
});
parcelRegister("87mh8", function(module, exports) {
    function $5e90419f1ca7764f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    module.exports = $5e90419f1ca7764f$var$baseReduce;
});
parcelRegister("cd2Ri", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ae9eca70c694773$export$2e2bcd8739ae039);
    var $basmW = parcelRequire("basmW");
    var $dPSWJ = parcelRequire("dPSWJ");
    var $27NS3 = parcelRequire("27NS3");
    var $k15gu;
    var $aud83;
    const $5ae9eca70c694773$var$fromUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
        const transformers = {
            page: (page)=>(0, (0, parcelRequire("k15gu")).validatePageNumber)((0, (0, parcelRequire("aud83")).number).parse(page)) ? {
                    page: (0, (0, parcelRequire("aud83")).number).parse(page)
                } : {},
            sortOrder: (order)=>(0, (0, parcelRequire("k15gu")).validateSortDirection)(order) ? {
                    sortDirection: order
                } : {},
            sortKey: (key)=>sortFieldTransformer(key) ? {
                    sortField: sortFieldTransformer(key)
                } : {}
        };
        return (0, ($parcel$interopDefault($basmW)))([
            (params)=>(0, ($parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
            (params)=>(0, ($parcel$interopDefault($27NS3)))(params, (query, value, key)=>transformers[key] ? {
                        ...query,
                        ...transformers[key](value)
                    } : query, {
                    filter: filterTransformer(params)
                })
        ]);
    };
    var $5ae9eca70c694773$export$2e2bcd8739ae039 = $5ae9eca70c694773$var$fromUrlTransformerFactory;
});
parcelRegister("k15gu", function(module, exports) {
    $parcel$export(module.exports, "calculateTotalPages", ()=>$871ef586a0cb0e22$export$fba88641b8ab6cd8);
    $parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", ()=>$871ef586a0cb0e22$export$3179e82a0f1565e1);
    $parcel$export(module.exports, "validatePageNumber", ()=>$871ef586a0cb0e22$export$231cde03e0d8b537);
    $parcel$export(module.exports, "validateSortDirection", ()=>$871ef586a0cb0e22$export$407c10b4791d7a16);
    const $871ef586a0cb0e22$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
    const $871ef586a0cb0e22$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
        const maxPossiblePage = $871ef586a0cb0e22$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
        return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
    };
    const $871ef586a0cb0e22$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
    const $871ef586a0cb0e22$export$407c10b4791d7a16 = (input)=>[
            (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
            (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
        ].includes(input);
});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';
parcelRegister("aRmgJ", function(module, exports) {
    $parcel$export(module.exports, "ITEMS_PER_PAGE", ()=>$5fe1f06734b48f8e$export$ec93a669a20aa982);
    $parcel$export(module.exports, "initialQuery", ()=>$5fe1f06734b48f8e$export$8af7177c92ae79e3);
    $parcel$export(module.exports, "EXPAND_PARAMETERS", ()=>$5fe1f06734b48f8e$export$ac5ed0fd17aacb1c);
    var $e9yg4;
    const $5fe1f06734b48f8e$export$ec93a669a20aa982 = 25;
    const $5fe1f06734b48f8e$export$8af7177c92ae79e3 = {
        sortField: (0, (0, parcelRequire("e9yg4")).NAME),
        sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        page: 1,
        filter: {
            query: undefined,
            project: undefined,
            group: undefined,
            owner: undefined
        }
    };
    const $5fe1f06734b48f8e$export$ac5ed0fd17aacb1c = [
        'owner',
        'favourite',
        'favouritedCount',
        'sharePermissions',
        'editPermissions',
        'description',
        'isWritable'
    ];
});
parcelRegister("e9yg4", function(module, exports) {
    $parcel$export(module.exports, "FAVOURITED", ()=>$4b8a21f619a20b61$export$fdb541a0853ce91e);
    $parcel$export(module.exports, "NAME", ()=>$4b8a21f619a20b61$export$3c5e605ca7ade9f2);
    $parcel$export(module.exports, "OWNER", ()=>$4b8a21f619a20b61$export$8c6af90262e3c6cd);
    $parcel$export(module.exports, "POPULARITY", ()=>$4b8a21f619a20b61$export$baf77a5a5061f88f);
    const $4b8a21f619a20b61$export$fdb541a0853ce91e = 'favourite';
    const $4b8a21f619a20b61$export$3c5e605ca7ade9f2 = 'name';
    const $4b8a21f619a20b61$export$8c6af90262e3c6cd = 'owner';
    const $4b8a21f619a20b61$export$baf77a5a5061f88f = 'popularity';
    var $4b8a21f619a20b61$export$2e2bcd8739ae039 = [
        $4b8a21f619a20b61$export$3c5e605ca7ade9f2,
        $4b8a21f619a20b61$export$8c6af90262e3c6cd,
        $4b8a21f619a20b61$export$baf77a5a5061f88f,
        $4b8a21f619a20b61$export$fdb541a0853ce91e
    ];
});
parcelRegister("2J2h7", function(module, exports) {
    $parcel$export(module.exports, "filterToParams", ()=>$fb2a70bfcb5bf9f1$export$cb128e46cc7ba0f1);
    $parcel$export(module.exports, "filterFromParams", ()=>$fb2a70bfcb5bf9f1$export$f6542f27c27241c6);
    var $g5X3G;
    const $fb2a70bfcb5bf9f1$export$cb128e46cc7ba0f1 = (filter = {})=>({
            name: filter.query || undefined,
            owner: filter.owner && filter.owner.accountId || undefined,
            selectedProject: filter.project && filter.project.value || 'anything',
            selectedGroup: filter.group && filter.group.value || 'anything'
        });
    const $fb2a70bfcb5bf9f1$var$transformSelectedOwner = (input)=>input ? {
            accountId: (0, (0, parcelRequire("g5X3G")).toAccountId)(input)
        } : undefined;
    const $fb2a70bfcb5bf9f1$var$transformSelectedProject = (input)=>input && input !== 'anything' ? {
            value: input
        } : undefined;
    const $fb2a70bfcb5bf9f1$var$transformSelectedGroup = (input)=>input && input !== 'anything' ? {
            value: input,
            name: input
        } : undefined;
    const $fb2a70bfcb5bf9f1$export$f6542f27c27241c6 = (params)=>({
            query: params.name || params.searchName || undefined,
            owner: $fb2a70bfcb5bf9f1$var$transformSelectedOwner(params.owner),
            project: $fb2a70bfcb5bf9f1$var$transformSelectedProject(params.selectedProject),
            group: $fb2a70bfcb5bf9f1$var$transformSelectedGroup(params.selectedGroup)
        });
});
parcelRegister("kSlYX", function(module, exports) {
    $parcel$export(module.exports, "sortFieldToParam", ()=>$78da06d69c5b9374$export$9a7ae3517c7d79c2);
    $parcel$export(module.exports, "sortFieldFromParam", ()=>$78da06d69c5b9374$export$307ee63ec20d9c92);
    var $e9yg4;
    const $78da06d69c5b9374$var$sortFieldMap = {
        [(0, (0, parcelRequire("e9yg4")).NAME).toLowerCase()]: (0, (0, parcelRequire("e9yg4")).NAME),
        [(0, (0, parcelRequire("e9yg4")).OWNER).toLowerCase()]: (0, (0, parcelRequire("e9yg4")).OWNER),
        [(0, (0, parcelRequire("e9yg4")).POPULARITY).toLowerCase()]: (0, (0, parcelRequire("e9yg4")).POPULARITY),
        [(0, (0, parcelRequire("e9yg4")).FAVOURITED).toLowerCase()]: (0, (0, parcelRequire("e9yg4")).FAVOURITED)
    };
    const $78da06d69c5b9374$export$9a7ae3517c7d79c2 = (field)=>field.toLowerCase();
    const $78da06d69c5b9374$export$307ee63ec20d9c92 = (param)=>$78da06d69c5b9374$var$sortFieldMap[param] ? $78da06d69c5b9374$var$sortFieldMap[param] : null;
});
parcelRegister("kUACW", function(module, exports) {
    $parcel$export(module.exports, "withSuspense", ()=>$4c5a941fc6e9229e$export$a3bce93d4fb4eda6);
    const $4c5a941fc6e9229e$var$isDataEmpty = (data)=>data == null;
    function $4c5a941fc6e9229e$export$a3bce93d4fb4eda6(theHook) {
        return (...args)=>{
            const result = theHook(...args);
            if (!false && $4c5a941fc6e9229e$var$isDataEmpty(result.data) && result.loading) throw result.promise;
            return result;
        };
    }
});
parcelRegister("5qVrc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34104383eeaa69f9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iqr2y;
    var $bVDE5;
    const $34104383eeaa69f9$var$ErrorBoundaryWithExtraEventData = ({ children: children, id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorBoundaryFlag), {
            id: "spa-apps.error-boundary"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bVDE5")).default), null, ({ transitionsCount: transitionsCount = 0, lastTransition: lastTransition = '', navigationStart: navigationStart = '' })=>{
            const extraEventData = {
                transitionsCount: transitionsCount,
                lastTransition: lastTransition,
                navigationStart: navigationStart
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorBoundaryFlag), {
                id: id,
                extraEventData: extraEventData
            }, children);
        }));
    const $34104383eeaa69f9$var$SpaErrorBoundary = $34104383eeaa69f9$var$ErrorBoundaryWithExtraEventData;
    var $34104383eeaa69f9$export$2e2bcd8739ae039 = $34104383eeaa69f9$var$SpaErrorBoundary;
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
parcelRegister("bRTld", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a8aff1b63f49f92$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9sGI6;
    var $9dbF6;
    var $bibyx;
    const $3a8aff1b63f49f92$var$Updater = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "platform"
        });
    var $3a8aff1b63f49f92$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("bibyx")).default), {
        Updater: $3a8aff1b63f49f92$var$Updater
    });
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("bibyx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87506a67be7d894a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jzjy1;
    var $iqr2y;
    var $7iJwP;
    var $4QISh;
    var $8PRuf;
    var $5rqex;
    var $g5X3G;
    var $3iOSp;
    var $fhVq7;
    var $cJXov;
    const $87506a67be7d894a$var$noop = ()=>{};
    function $87506a67be7d894a$var$FiltersDirectory({ Updater: Updater, tenantContext: tenantContext, prefetchResult: prefetchResult, favoriteChangeContext: favoriteChangeContext, query: query, onQueryChanged: onQueryChanged }) {
        const { baseUrl: baseUrl, xsrfToken: xsrfToken, atlassianAccountId: atlassianAccountId } = tenantContext;
        const { error: prefetchError, loading: loading, data: data } = prefetchResult;
        if (prefetchError && !loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
            id: "directories-filters",
            error: prefetchError
        });
        if (!data) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iOSp")).FiltersDirectorySkeleton), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fhVq7")).PageLayout), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "unhandled",
            packageName: "jiraSpaAppsDirectoriesFilters",
            teamName: "jira-cosmos"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Updater, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4QISh")).default), {
            isServer: false,
            baseUrl: baseUrl,
            atlassianAccountId: atlassianAccountId ? (0, (0, parcelRequire("g5X3G")).toAccountId)(atlassianAccountId) : undefined,
            xsrfToken: xsrfToken,
            query: query,
            favoriteChangeContext: favoriteChangeContext,
            prefetchedData: data,
            onQueryChanged: onQueryChanged,
            onUnmount: $87506a67be7d894a$var$noop,
            withPageReadyMetrics: false,
            withoutHeader: false
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            metricKey: "jira.directories.filters",
            metric: (0, (0, parcelRequire("cJXov")).filtersDirectoryPageLoad),
            isExpectedToHaveSsr: true,
            withMarks: [
                (0, (0, parcelRequire("8PRuf")).appBundleReadyMark),
                (0, (0, parcelRequire("8PRuf")).prefetchApiReadyMark)
            ]
        })));
    }
    var $87506a67be7d894a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('filters', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($87506a67be7d894a$var$FiltersDirectory);
});
parcelRegister("4QISh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6c201c0b6db69c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hZHze;
    var $jD5no;
    var $lf2Au;
    var $7iJwP;
    var $97Kan;
    var $ew1Lk;
    var $aWse0;
    var $itmJb;
    var $2DwI3;
    var $aRmgJ;
    var $ds4d2;
    var $lgrrw;
    var $9U2WO;
    var $2UX9B;
    var $g81jz;
    var $hGfxd;
    var $4biUB;
    var $64LCo;
    var $jTnv2;
    class $b6c201c0b6db69c4$var$Filters extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                query: undefined,
                prefetchedData: {},
                withoutHeader: false,
                withPageReadyMetrics: true,
                onQueryChanged: (0, ($parcel$interopDefault($8Rkzz))),
                onUnmount: (0, ($parcel$interopDefault($8Rkzz))),
                isAdmin: false
            };
        }
        constructor(props){
            super(props);
            this.store = (0, (0, parcelRequire("hGfxd")).default)((0, (0, parcelRequire("lgrrw")).default));
            const { filters: filters } = props.prefetchedData;
            const { dispatch: dispatch } = this.store;
            dispatch((0, (0, parcelRequire("9U2WO")).setAppProps)(props));
            dispatch((0, (0, parcelRequire("g81jz")).setQuery)(props.query || (0, (0, parcelRequire("aRmgJ")).initialQuery)));
            dispatch(filters ? (0, (0, parcelRequire("2UX9B")).retrieved)(filters) : (0, (0, parcelRequire("2UX9B")).retrieve)());
        }
        componentDidUpdate(prevProps) {
            const { dispatch: dispatch, getState: getState } = this.store;
            const { query: query } = this.props;
            if (!(0, ($parcel$interopDefault($ajpes)))(prevProps, this.props)) dispatch((0, (0, parcelRequire("9U2WO")).setAppProps)(this.props));
            if (query && (0, (0, parcelRequire("ds4d2")).isQueryChanged)(query, (0, (0, parcelRequire("4biUB")).getQuery)(getState()))) {
                dispatch((0, (0, parcelRequire("g81jz")).setQuery)(query));
                dispatch((0, (0, parcelRequire("2UX9B")).retrieve)());
            }
        }
        componentWillUnmount() {
            this.props.onUnmount();
        }
        render() {
            const { intl: { formatMessage: formatMessage } } = this.props;
            const headerConfiguration = (0, (0, parcelRequire("jTnv2")).getHeaderConfiguration)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
                store: this.store,
                id: "filter-directory-main",
                hasErrorBoundary: false
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
                id: "unhandled",
                packageName: "jiraFiltersMain",
                teamName: "jira-cosmos"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
                title: headerConfiguration.caption ? formatMessage(headerConfiguration.caption) : ''
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("97Kan")).FlagsDispatcher), {
                mapper: (0, (0, parcelRequire("2DwI3")).default)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lf2Au")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("64LCo")).default), null))));
        }
    }
    const $b6c201c0b6db69c4$var$FiltersWithContext = (props)=>{
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b6c201c0b6db69c4$var$Filters, {
            ...props,
            isAdmin: isAdmin,
            intl: intl
        });
    };
    var $b6c201c0b6db69c4$export$2e2bcd8739ae039 = $b6c201c0b6db69c4$var$FiltersWithContext;
});
parcelRegister("hZHze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69dc4a27be9f367e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $994MI;
    var $cb25w;
    var $gvRPW;
    class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.props.onMount();
        }
        render() {
            return null;
        }
    }
    const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'view-tracker'
    })((0, (0, parcelRequire("cb25w")).default)({
        onMount: (createEvent)=>createEvent({
                action: (0, (0, parcelRequire("gvRPW")).PAGE_EVENT_ACTION)
            }).fire()
    })($69dc4a27be9f367e$var$ViewTracker));
    var $69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
            onMount: (0, ($parcel$interopDefault($8Rkzz)))
        });
});
parcelRegister("lf2Au", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9249f8c63b854f95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $gwIPs;
    var $cSD7y;
    const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>$5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ect41sbm _1wyb1oud _4t3i1kw7 _1dyz4jg8"
            ])
        }, children);
    const $9249f8c63b854f95$var$AppStyleOld = (0, $47bDC.default).div.withConfig({
        componentId: "h5xpn2-0"
    })({
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        fontSize: `${(0, (0, parcelRequire("gwIPs")).fontSize)}px`,
        height: 'inherit',
        letterSpacing: 'normal'
    });
    const $9249f8c63b854f95$var$appStyles = null;
    const $9249f8c63b854f95$var$AppStyleFinal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jfp-1020-use-compiled', $9249f8c63b854f95$var$AppStyle, $9249f8c63b854f95$var$AppStyleOld);
    var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyleFinal;
});
parcelRegister("gwIPs", function(module, exports) {
    $parcel$export(module.exports, "gridSize", ()=>$80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
    $parcel$export(module.exports, "borderRadius", ()=>$80d528dbc2b11cbc$export$7a57f79000377ca2);
    $parcel$export(module.exports, "fontSize", ()=>$80d528dbc2b11cbc$export$85e3c3ca0c6fb93);
    $parcel$export(module.exports, "fontFamily", ()=>$80d528dbc2b11cbc$export$a5975749f0374264);
    $parcel$export(module.exports, "codeFontFamily", ()=>$80d528dbc2b11cbc$export$356129969ee49c55);
    $parcel$export(module.exports, "contentHorizontalSpacing", ()=>$80d528dbc2b11cbc$export$22dec01f2c854397);
    $parcel$export(module.exports, "layers", ()=>$80d528dbc2b11cbc$export$7be255094ccdc533);
    $parcel$export(module.exports, "layout", ()=>$80d528dbc2b11cbc$export$b3219800bda33a1f);
    var $k5uoT;
    const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, (0, parcelRequire("k5uoT")).borderRadius)();
    const $80d528dbc2b11cbc$export$85e3c3ca0c6fb93 = (0, (0, parcelRequire("k5uoT")).fontSize)();
    const $80d528dbc2b11cbc$export$a5975749f0374264 = (0, (0, parcelRequire("k5uoT")).fontFamily)();
    const $80d528dbc2b11cbc$export$356129969ee49c55 = (0, (0, parcelRequire("k5uoT")).codeFontFamily)();
    const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
    const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
    const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
        banner: (0, (0, parcelRequire("k5uoT")).layers).navigation(),
        card: (0, (0, parcelRequire("k5uoT")).layers).card(),
        dialog: (0, (0, parcelRequire("k5uoT")).layers).dialog(),
        navigation: (0, (0, parcelRequire("k5uoT")).layers).navigation(),
        leftSidebar: (0, (0, parcelRequire("k5uoT")).layers).navigation() - 1,
        rightSidebar: (0, (0, parcelRequire("k5uoT")).layers).navigation() - 1,
        layer: (0, (0, parcelRequire("k5uoT")).layers).layer(),
        blanket: (0, (0, parcelRequire("k5uoT")).layers).blanket(),
        modal: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        flag: (0, (0, parcelRequire("k5uoT")).layers).flag(),
        spotlight: (0, (0, parcelRequire("k5uoT")).layers).spotlight(),
        tooltip: (0, (0, parcelRequire("k5uoT")).layers).tooltip(),
        mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
    };
    const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
        issueIconSize: $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 * 2
    };
});
parcelRegister("cSD7y", function(module, exports) {
    $parcel$export(module.exports, "componentWithFG", ()=>$9b560cafc84bf9e8$export$cf56d0f54cfcce4);
    var $7XYc4;
    var $4R6GH;
    const $9b560cafc84bf9e8$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)(gateName), ComponentTrue, ComponentFalse);
});
parcelRegister("7XYc4", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$d8879edec083173e$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $d8879edec083173e$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("97Kan", function(module, exports) {
    $parcel$export(module.exports, "FlagsDispatcher", ()=>$4ddeb9f500a62e17$export$9e60e3d40b6e758f);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $fpHHI;
    const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fpHHI")).Dispatcher), {
            store: store,
            mapper: mapper,
            showFlag: (0, (0, parcelRequire("pa9q9")).showFlag),
            dismissFlag: (0, (0, parcelRequire("pa9q9")).dismissFlag)
        });
});
parcelRegister("fpHHI", function(module, exports) {
    $parcel$export(module.exports, "Dispatcher", ()=>$eef6139685bfb64e$export$ab054a1ef92eeb01);
    var $5uXOq = parcelRequire("5uXOq");
    var $1kijq;
    const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
        const { store: store, ...dispatcherProps } = props;
        const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
        if (store !== lastStore) setLastStore(store);
        const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1kijq")).createDispatcher)(store), [
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
    };
});
parcelRegister("1kijq", function(module, exports) {
    $parcel$export(module.exports, "createDispatcher", ()=>$c324e875f8c6fe8f$export$7b259d28468da15b);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVVL1 = parcelRequire("kVVL1");
    var $pa9q9;
    const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
        if (!store) throw new Error('Store not available through direct injection or Provider context');
        if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
        return store;
    };
    const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
        if (!result) return;
        if ((0, (0, parcelRequire("pa9q9")).isDismissFlag)(result)) dismissFlag(result);
        else if ((0, (0, parcelRequire("pa9q9")).isFlagComponent)(result)) {
            const FlagComponent = result;
            const FlagComponentWithProvider = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                    store: store
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
            showFlag(FlagComponentWithProvider);
        } else showFlag(result);
    };
    const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
        if ((0, (0, parcelRequire("pa9q9")).isBatchAction)(action)) action.payload.forEach((childAction)=>{
            if (childAction.type && typeof childAction.type === 'string') {
                const childResult = mapper(childAction, state);
                $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
            }
        });
        else {
            const result = mapper(action, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
        }
    };
    const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
        const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
        const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
            storeUnchecked
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handleAction = (action, state)=>{
                $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
            };
            store.addActionListener(handleAction);
            return ()=>store.removeActionListener(handleAction);
        }, [
            store,
            mapper,
            showFlag,
            dismissFlag
        ]);
        return null;
    };
    const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
        const store = (0, $kVVL1.useStore)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: store
        });
    };
    const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
        const Dispatcher8CustomStore = (props)=>customStore ? (0, ($parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
                ...props,
                store: customStore
            }) : null;
        return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
    };
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("2DwI3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e41aa4d32fcecaf$export$2e2bcd8739ae039);
    var $705dd;
    var $99OGQ;
    var $lyrWK;
    var $aCttf;
    var $dXrFW;
    var $7B6Sy;
    var $5XpfZ;
    const $8e41aa4d32fcecaf$var$flagsMapper = (action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("705dd")).COPY_INITIATE_FAILED:
                return (0, (0, parcelRequire("5XpfZ")).default)();
            case 0, (0, parcelRequire("99OGQ")).COPIED:
                return (0, (0, parcelRequire("aCttf")).default)({
                    name: action.payload.originalItemName
                });
            case 0, (0, parcelRequire("99OGQ")).COPY_FAILED:
                return (0, (0, parcelRequire("lyrWK")).default)(action.payload);
            case 0, (0, parcelRequire("99OGQ")).DELETED:
                return (0, (0, parcelRequire("7B6Sy")).default)(action.payload);
            case 0, (0, parcelRequire("99OGQ")).DELETE_FAILED:
                return (0, (0, parcelRequire("dXrFW")).default)(action.payload);
            default:
                {
                    const _exhaustiveCheck = action;
                    return undefined;
                }
        }
    };
    var $8e41aa4d32fcecaf$export$2e2bcd8739ae039 = $8e41aa4d32fcecaf$var$flagsMapper;
});
parcelRegister("705dd", function(module, exports) {
    $parcel$export(module.exports, "COPY_INITIATE_FAILED", ()=>$85491ada8f3c7303$export$eff7a7b152af4c1);
    const $85491ada8f3c7303$export$eff7a7b152af4c1 = 'state.actions.copy.COPY_INITIATE_FAILED';
    const $85491ada8f3c7303$export$3f5c30a007387562 = ()=>({
            type: $85491ada8f3c7303$export$eff7a7b152af4c1
        });
});
parcelRegister("99OGQ", function(module, exports) {
    $parcel$export(module.exports, "DELETED", ()=>$4987d65409f61620$export$1cc76b53f23597de);
    $parcel$export(module.exports, "deleted", ()=>$4987d65409f61620$export$bccbf0c716f226f4);
    $parcel$export(module.exports, "DELETE_FAILED", ()=>$4987d65409f61620$export$ae082348f4557243);
    $parcel$export(module.exports, "deleteFailed", ()=>$4987d65409f61620$export$8830effd508d9f31);
    $parcel$export(module.exports, "COPIED", ()=>$4987d65409f61620$export$ab06cbdc503432af);
    $parcel$export(module.exports, "COPY_FAILED", ()=>$4987d65409f61620$export$9db31c0e010caedf);
    const $4987d65409f61620$export$1cc76b53f23597de = 'state.actions.operations.DELETED';
    const $4987d65409f61620$export$bccbf0c716f226f4 = (name)=>({
            type: $4987d65409f61620$export$1cc76b53f23597de,
            payload: {
                name: name
            }
        });
    const $4987d65409f61620$export$ae082348f4557243 = 'state.actions.operations.DELETE_FAILED';
    const $4987d65409f61620$export$8830effd508d9f31 = (name)=>({
            type: $4987d65409f61620$export$ae082348f4557243,
            payload: {
                name: name
            }
        });
    const $4987d65409f61620$export$ab06cbdc503432af = 'state.actions.operations.COPIED';
    const $4987d65409f61620$export$a92b46551664f4e = (payload)=>({
            type: $4987d65409f61620$export$ab06cbdc503432af,
            payload: payload
        });
    const $4987d65409f61620$export$9db31c0e010caedf = 'state.actions.operations.COPY_FAILED';
    const $4987d65409f61620$export$5d8d1af388d10413 = (payload)=>({
            type: $4987d65409f61620$export$9db31c0e010caedf,
            payload: payload
        });
});
parcelRegister("lyrWK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12ff8026b7aa76d6$export$2e2bcd8739ae039);
    var $7VHMR;
    const $12ff8026b7aa76d6$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "directories.filters-v2.main.flags.copy.error.title",
            "defaultMessage": "We couldn't create {name}"
        },
        description: {
            "id": "directories.filters-v2.main.flags.copy.error.description",
            "defaultMessage": "There was an error, please try again."
        }
    });
    var $12ff8026b7aa76d6$export$2e2bcd8739ae039 = (name)=>({
            type: 'error',
            title: [
                $12ff8026b7aa76d6$var$messages.title,
                {
                    name: name
                }
            ],
            description: $12ff8026b7aa76d6$var$messages.description
        });
});
parcelRegister("aCttf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$908b82319d1a2257$export$2e2bcd8739ae039);
    var $7VHMR;
    const $908b82319d1a2257$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "directories.filters-v2.main.flags.copy.success.title",
            "defaultMessage": "A copy of {name} was successfully created."
        }
    });
    var $908b82319d1a2257$export$2e2bcd8739ae039 = ({ name: name })=>({
            type: 'success',
            title: [
                $908b82319d1a2257$var$messages.title,
                {
                    name: name
                }
            ],
            isAutoDismiss: true
        });
});
parcelRegister("dXrFW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$589d0026efbddbec$export$2e2bcd8739ae039);
    var $7VHMR;
    const $589d0026efbddbec$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "directories.filters-v2.main.flags.delete.error.title",
            "defaultMessage": "We couldn't delete {name}"
        },
        description: {
            "id": "directories.filters-v2.main.flags.delete.error.description",
            "defaultMessage": "There was an error, please try again."
        }
    });
    var $589d0026efbddbec$export$2e2bcd8739ae039 = ({ name: name })=>({
            type: 'error',
            title: [
                $589d0026efbddbec$var$messages.title,
                {
                    name: name
                }
            ],
            description: $589d0026efbddbec$var$messages.description
        });
});
parcelRegister("7B6Sy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7fffd95b0653be30$export$2e2bcd8739ae039);
    var $7VHMR;
    const $7fffd95b0653be30$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "directories.filters-v2.main.flags.delete.success.title",
            "defaultMessage": "{name} was deleted"
        }
    });
    var $7fffd95b0653be30$export$2e2bcd8739ae039 = ({ name: name })=>({
            type: 'success',
            title: [
                $7fffd95b0653be30$var$messages.title,
                {
                    name: name
                }
            ],
            isAutoDismiss: true
        });
});
parcelRegister("5XpfZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c99c810612d5df8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $5c99c810612d5df8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "directories.filters-v2.main.flags.initiate-copy-modal.error.title",
            "defaultMessage": "We couldn't get filter data"
        },
        description: {
            "id": "directories.filters-v2.main.flags.initiate-copy-modal.error.description",
            "defaultMessage": "Something went wrong. Try again."
        }
    });
    var $5c99c810612d5df8$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $5c99c810612d5df8$var$messages.title,
            description: $5c99c810612d5df8$var$messages.description
        });
});
parcelRegister("ds4d2", function(module, exports) {
    $parcel$export(module.exports, "isQueryChanged", ()=>$630ffe7c034a2ba0$export$dcc7e61e8982458d);
    var $ajpes = parcelRequire("ajpes");
    const $630ffe7c034a2ba0$var$getOwnerIdentifier = (owner)=>owner.accountId;
    const $630ffe7c034a2ba0$var$getQueryValues = (target)=>{
        const { page: page, sortField: sortField, sortDirection: sortDirection, filter: filter } = target;
        const { query: query, owner: owner, project: project, group: group } = filter;
        return {
            page: page,
            sortField: sortField,
            sortDirection: sortDirection,
            filter: {
                query: query,
                owner: owner && $630ffe7c034a2ba0$var$getOwnerIdentifier(owner),
                project: project && project.value,
                group: group && group.value
            }
        };
    };
    const $630ffe7c034a2ba0$export$dcc7e61e8982458d = (newQuery, prevQuery)=>!(0, ($parcel$interopDefault($ajpes)))($630ffe7c034a2ba0$var$getQueryValues(newQuery), $630ffe7c034a2ba0$var$getQueryValues(prevQuery));
});
parcelRegister("lgrrw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$20a50a64ff718c99$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $bqhaK;
    var $l0SAx;
    var $20a50a64ff718c99$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("bqhaK")).default), (0, (0, parcelRequire("l0SAx")).default));
});
parcelRegister("bqhaK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ea25c070065f796$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    var $hJCUd = parcelRequire("hJCUd");
    var $kVLXA = parcelRequire("kVLXA");
    var $g81jz;
    var $hXBjD;
    var $4biUB;
    const $1ea25c070065f796$var$querySet = (action$, store)=>action$.ofType((0, (0, parcelRequire("g81jz")).SET_QUERY)).mergeMap(({ payload: payload })=>{
            const state = store.getState();
            const callback = (0, (0, parcelRequire("hXBjD")).getOnQueryChanged)(state);
            if (typeof callback === 'function') callback(payload);
            return (0, $kVLXA.Observable).empty();
        });
    const $1ea25c070065f796$var$queryPatched = (action$, store)=>action$.ofType((0, (0, parcelRequire("g81jz")).PATCH_QUERY)).mergeMap(({ payload: payload })=>{
            const state = store.getState();
            const callback = (0, (0, parcelRequire("hXBjD")).getOnQueryChanged)(state);
            if (typeof callback === 'function') callback((0, ($parcel$interopDefault($hJCUd)))(payload, (0, (0, parcelRequire("4biUB")).getQuery)(state)));
            return (0, $kVLXA.Observable).empty();
        });
    var $1ea25c070065f796$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($1ea25c070065f796$var$querySet, $1ea25c070065f796$var$queryPatched);
});
parcelRegister("g81jz", function(module, exports) {
    $parcel$export(module.exports, "SET_QUERY", ()=>$473d28dd36d8ab45$export$11bcea24b35a126f);
    $parcel$export(module.exports, "setQuery", ()=>$473d28dd36d8ab45$export$f3b215b0b382f63b);
    $parcel$export(module.exports, "PATCH_QUERY", ()=>$473d28dd36d8ab45$export$403065a1ff0b1663);
    $parcel$export(module.exports, "patchQuery", ()=>$473d28dd36d8ab45$export$8a4e224aafd3a2bf);
    const $473d28dd36d8ab45$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
    const $473d28dd36d8ab45$export$f3b215b0b382f63b = (payload)=>({
            type: $473d28dd36d8ab45$export$11bcea24b35a126f,
            payload: payload
        });
    const $473d28dd36d8ab45$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
    const $473d28dd36d8ab45$export$8a4e224aafd3a2bf = (payload)=>({
            type: $473d28dd36d8ab45$export$403065a1ff0b1663,
            payload: payload
        });
});
parcelRegister("hXBjD", function(module, exports) {
    $parcel$export(module.exports, "getAtlassianAccountId", ()=>$213159c97288625c$export$f5baf4f0aaa47428);
    $parcel$export(module.exports, "getBaseUrl", ()=>$213159c97288625c$export$f654b28f82155665);
    $parcel$export(module.exports, "getIsAdmin", ()=>$213159c97288625c$export$7d046765d192af80);
    $parcel$export(module.exports, "getOnQueryChanged", ()=>$213159c97288625c$export$59e4f8ebf6520bf7);
    $parcel$export(module.exports, "getXsrfToken", ()=>$213159c97288625c$export$14407a25c57e1f92);
    $parcel$export(module.exports, "isWithoutHeader", ()=>$213159c97288625c$export$ac359c528ee5de31);
    const $213159c97288625c$export$f5baf4f0aaa47428 = (state)=>state.app.props.atlassianAccountId;
    const $213159c97288625c$export$f654b28f82155665 = (state)=>state.app.props.baseUrl;
    const $213159c97288625c$export$7d046765d192af80 = (state)=>state.app.props.isAdmin;
    const $213159c97288625c$export$59e4f8ebf6520bf7 = (state)=>state.app.props.onQueryChanged;
    const $213159c97288625c$export$14407a25c57e1f92 = (state)=>state.app.props.xsrfToken;
    const $213159c97288625c$export$ac359c528ee5de31 = (state)=>state.app.props.withoutHeader;
    const $213159c97288625c$export$29e8a85166eb4498 = (state)=>state.app.props.withPageReadyMetrics;
});
parcelRegister("4biUB", function(module, exports) {
    $parcel$export(module.exports, "getQuery", ()=>$12ff88bc7ce0b1fb$export$71eec30d9db46a56);
    $parcel$export(module.exports, "getSortField", ()=>$12ff88bc7ce0b1fb$export$9b753af5a9fb5911);
    $parcel$export(module.exports, "getSortDirection", ()=>$12ff88bc7ce0b1fb$export$509e2b9937961873);
    $parcel$export(module.exports, "getPage", ()=>$12ff88bc7ce0b1fb$export$c2a6433281518c91);
    $parcel$export(module.exports, "getFilter", ()=>$12ff88bc7ce0b1fb$export$61ec8404f465cd36);
    $parcel$export(module.exports, "getSearchQuery", ()=>$12ff88bc7ce0b1fb$export$1664b92369554829);
    $parcel$export(module.exports, "getSelectedProject", ()=>$12ff88bc7ce0b1fb$export$1ebc7a42c839af66);
    $parcel$export(module.exports, "getSelectedGroup", ()=>$12ff88bc7ce0b1fb$export$27ee39f0d715ac22);
    $parcel$export(module.exports, "getSelectedOwner", ()=>$12ff88bc7ce0b1fb$export$858444e3fc2798fd);
    $parcel$export(module.exports, "isFilterApplied", ()=>$12ff88bc7ce0b1fb$export$980aed36f19060a5);
    var $dGvGJ = parcelRequire("dGvGJ");
    const $12ff88bc7ce0b1fb$export$71eec30d9db46a56 = (state)=>state.query;
    const $12ff88bc7ce0b1fb$export$9b753af5a9fb5911 = (state)=>state.query.sortField;
    const $12ff88bc7ce0b1fb$export$509e2b9937961873 = (state)=>state.query.sortDirection;
    const $12ff88bc7ce0b1fb$export$c2a6433281518c91 = (state)=>state.query.page;
    const $12ff88bc7ce0b1fb$export$61ec8404f465cd36 = (state)=>state.query.filter;
    const $12ff88bc7ce0b1fb$export$1664b92369554829 = (state)=>$12ff88bc7ce0b1fb$export$61ec8404f465cd36(state)?.query || '';
    const $12ff88bc7ce0b1fb$export$1ebc7a42c839af66 = (state)=>$12ff88bc7ce0b1fb$export$61ec8404f465cd36(state)?.project;
    const $12ff88bc7ce0b1fb$export$27ee39f0d715ac22 = (state)=>$12ff88bc7ce0b1fb$export$61ec8404f465cd36(state)?.group;
    const $12ff88bc7ce0b1fb$export$858444e3fc2798fd = (state)=>$12ff88bc7ce0b1fb$export$61ec8404f465cd36(state)?.owner;
    const $12ff88bc7ce0b1fb$export$980aed36f19060a5 = (0, $dGvGJ.createSelector)($12ff88bc7ce0b1fb$export$1664b92369554829, $12ff88bc7ce0b1fb$export$1ebc7a42c839af66, $12ff88bc7ce0b1fb$export$27ee39f0d715ac22, $12ff88bc7ce0b1fb$export$858444e3fc2798fd, (queryValue, projectValue, groupValue, ownerValue)=>!!queryValue || !!projectValue || !!groupValue || !!ownerValue);
});
parcelRegister("l0SAx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81e033301b263805$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("7qVV7");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $jcw0u;
    var $05iiI;
    var $2UX9B;
    var $hXBjD;
    var $4biUB;
    var $i0CUl;
    var $81e033301b263805$export$2e2bcd8739ae039 = (action$, store)=>{
        const getFiltersRequestAction$ = action$.ofType((0, (0, parcelRequire("2UX9B")).RETRIEVE));
        return getFiltersRequestAction$.mergeMap(()=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("hXBjD")).getBaseUrl)(state);
            const request = (0, (0, parcelRequire("i0CUl")).getServiceRequest)(state);
            const filter = (0, (0, parcelRequire("4biUB")).getFilter)(state);
            const isAdmin = (0, (0, parcelRequire("hXBjD")).getIsAdmin)(state);
            return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("05iiI")).default)(baseUrl, request, filter, isAdmin)).mergeMap((result)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("2UX9B")).retrieved)(result))).takeUntil(getFiltersRequestAction$).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'retrieveFilters',
                        packageName: 'jiraFiltersMain',
                        teamName: 'jira-cosmos'
                    }
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("2UX9B")).retrieveFailed)());
            });
        });
    };
});
parcelRegister("05iiI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e11696e02827824$export$2e2bcd8739ae039);
    var $iUBbS;
    var $bpsHV;
    var $2e11696e02827824$export$2e2bcd8739ae039 = async (baseUrl, request, filter, isAdmin)=>{
        const restResponse = await (0, (0, parcelRequire("iUBbS")).default)(baseUrl, request, filter, isAdmin);
        return (0, (0, parcelRequire("bpsHV")).transformFilters)(baseUrl, restResponse.values, restResponse.total);
    };
});
parcelRegister("iUBbS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cca849b16fe2a082$export$2e2bcd8739ae039);
    var $3NMrl = parcelRequire("3NMrl");
    var $ebyGx = parcelRequire("ebyGx");
    var $aDvGo;
    var $8xvPa;
    var $ePCtu;
    var $fsh9d;
    var $4R6GH;
    const $cca849b16fe2a082$var$createQueryFilter = (filter)=>({
            filterName: filter.query,
            ...(0, (0, parcelRequire("4R6GH")).fg)('empanada_filter_name_substring_search') ? {
                isSubstringMatch: true
            } : undefined
        });
    const $cca849b16fe2a082$var$createProjectFilter = (filter)=>({
            projectId: filter.project ? filter.project.value : undefined
        });
    const $cca849b16fe2a082$var$createGroupFilter = (filter)=>({
            groupname: filter.group ? filter.group.value : undefined
        });
    const $cca849b16fe2a082$var$createOwnerFilter = (filter)=>({
            accountId: filter.owner ? filter.owner.accountId : undefined,
            owner: undefined
        });
    const $cca849b16fe2a082$var$logError = async (error, currentTry)=>{
        (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'ops.rest.filters.get', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8), `Cannot fetch filters - is SSR: ${String(false)}, attempt: ${currentTry}`);
    };
    const $cca849b16fe2a082$export$20e00d0048bb5104 = ()=>'/rest/api/2/filter/search';
    const $cca849b16fe2a082$export$7138c24907de3954 = (baseUrl, request, filter, isAdmin)=>{
        const queryParams = {
            ...(0, ($parcel$interopDefault($3NMrl)))(request, 'startAt', 'maxResults', 'orderBy', 'expand'),
            ...filter.query ? $cca849b16fe2a082$var$createQueryFilter(filter) : undefined,
            ...filter.project ? $cca849b16fe2a082$var$createProjectFilter(filter) : undefined,
            ...filter.group ? $cca849b16fe2a082$var$createGroupFilter(filter) : undefined,
            ...filter.owner ? $cca849b16fe2a082$var$createOwnerFilter(filter) : undefined
        };
        return `${$cca849b16fe2a082$export$20e00d0048bb5104()}?${(0, $ebyGx.stringify)(queryParams)}${isAdmin ? '&overrideSharePermissions=true' : ''}`;
    };
    var $cca849b16fe2a082$export$2e2bcd8739ae039 = async (baseUrl, request, filter, isAdmin)=>{
        const url = $cca849b16fe2a082$export$7138c24907de3954(baseUrl, request, filter, isAdmin);
        const response = await (0, (0, parcelRequire("ePCtu")).fetchWithRetry)(url, (0, (0, parcelRequire("aDvGo")).default), $cca849b16fe2a082$var$logError);
        if (response.ok) return response.json();
        throw await (0, (0, parcelRequire("8xvPa")).getErrorFromResponse)(response, 'Cannot fetch filters');
    };
});
parcelRegister("3NMrl", function(module, exports) {
    var $i2e26 = parcelRequire("i2e26");
    var $9SRAA = parcelRequire("9SRAA");
    var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
        return object == null ? {} : $i2e26(object, paths);
    });
    module.exports = $2c4b85df1af41471$var$pick;
});
parcelRegister("i2e26", function(module, exports) {
    var $4gaCO = parcelRequire("4gaCO");
    var $fh9gH = parcelRequire("fh9gH");
    function $d2134c8f0f8064b1$var$basePick(object, paths) {
        return $4gaCO(object, paths, function(value, path) {
            return $fh9gH(object, path);
        });
    }
    module.exports = $d2134c8f0f8064b1$var$basePick;
});
parcelRegister("8xvPa", function(module, exports) {
    $parcel$export(module.exports, "getErrorFromResponse", ()=>$8065287d9cd7a779$export$7780d7826aafbede);
    var $jJZqs;
    var $eusud;
    const $8065287d9cd7a779$export$7780d7826aafbede = async (response, defaultMessage)=>{
        let errorMessage = defaultMessage;
        try {
            const json = await response.json();
            const { errors: errors, errorMessages: errorMessages } = json;
            if (errors && Object.keys(errors).length) return (0, (0, parcelRequire("eusud")).transformValidationErrorFromServer)(json);
            errorMessage = errorMessages[0];
        } catch (e) {}
        return new (0, (0, parcelRequire("jJZqs")).default)(response.status, errorMessage);
    };
});
parcelRegister("ePCtu", function(module, exports) {
    $parcel$export(module.exports, "fetchWithRetry", ()=>$97da449f15cd9238$export$cffaac380b94df26);
    var $aDvGo;
    var $8xvPa;
    const $97da449f15cd9238$export$fbc55f9ab8ae7207 = false ? 1 : 3;
    const $97da449f15cd9238$var$logResponseError = async (logSafeErrorWithoutCustomerData, response, currentTry)=>{
        const error = await (0, (0, parcelRequire("8xvPa")).getErrorFromResponse)(response, 'Directory fetch with retry failed');
        await logSafeErrorWithoutCustomerData(error, currentTry);
    };
    const $97da449f15cd9238$export$cffaac380b94df26 = async (url, options, logSafeErrorWithoutCustomerData, currentTry = 1)=>{
        try {
            const response = await fetch(url, (0, (0, parcelRequire("aDvGo")).default));
            if (!response.ok) {
                await $97da449f15cd9238$var$logResponseError(logSafeErrorWithoutCustomerData, response, currentTry);
                if (currentTry < $97da449f15cd9238$export$fbc55f9ab8ae7207) return $97da449f15cd9238$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
            }
            return response;
        } catch (error) {
            await logSafeErrorWithoutCustomerData(error, currentTry);
            if (currentTry < $97da449f15cd9238$export$fbc55f9ab8ae7207) return $97da449f15cd9238$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
            throw error;
        }
    };
});
parcelRegister("fsh9d", function(module, exports) {
    $parcel$export(module.exports, "logSafeErrorWithoutCustomerData", ()=>$064efdbf2b7e743c$export$c77be5886e7f1d9e);
    var $dJl1T;
    const $064efdbf2b7e743c$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message || error.message, error);
    const $064efdbf2b7e743c$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message || error.message, error);
});
const $c6c682f59adc6c63$export$9c2a9d62bcf944f8 = 'directories.filters.error';
parcelRegister("bpsHV", function(module, exports) {
    $parcel$export(module.exports, "transformFilters", ()=>$bfb2b3de2ad77495$export$6b801750e47278fe);
    var $4Xk2W = parcelRequire("4Xk2W");
    var $dPSWJ = parcelRequire("dPSWJ");
    var $1Tbo7;
    const $bfb2b3de2ad77495$export$6b801750e47278fe = (baseUrl, filters, total)=>{
        const order = filters.map((i)=>i.id);
        const responsesById = (0, ($parcel$interopDefault($4Xk2W)))(filters, (filter)=>filter.id);
        const page = (0, ($parcel$interopDefault($dPSWJ)))(responsesById, (response)=>(0, (0, parcelRequire("1Tbo7")).transformFilter)(baseUrl, response));
        return {
            page: page,
            order: order,
            total: total
        };
    };
});
parcelRegister("4Xk2W", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $4CZTG = parcelRequire("4CZTG");
    var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
        $1m3dq(result, key, value);
    });
    module.exports = $39bc38f0156cacc0$var$keyBy;
});
parcelRegister("1Tbo7", function(module, exports) {
    $parcel$export(module.exports, "transformFilter", ()=>$b92180b5876a8d46$export$4f94cef62d9cfa51);
    var $knvh6;
    const $b92180b5876a8d46$export$4f94cef62d9cfa51 = (baseUrl, item)=>({
            id: item.id,
            name: item.name,
            viewUrl: `/issues/?filter=${item.id}`,
            owner: item.owner ? (0, (0, parcelRequire("knvh6")).transformUser)(baseUrl, item.owner) : null,
            isFavourite: item.favourite,
            popularity: item.favouritedCount || 0,
            shares: item.sharePermissions ? item.sharePermissions.map((0, (0, parcelRequire("knvh6")).transformSharePermission)).filter(Boolean) : [],
            edits: item.editPermissions ? item.editPermissions.map((0, (0, parcelRequire("knvh6")).transformSharePermission)).filter(Boolean) : [],
            description: item.description,
            jql: item.jql,
            isWritable: item.isWritable === true
        });
});
parcelRegister("knvh6", function(module, exports) {
    $parcel$export(module.exports, "transformUser", ()=>$879c58d3b16279dc$export$88dcd5c1adae8021);
    $parcel$export(module.exports, "transformSharePermission", ()=>$879c58d3b16279dc$export$443a799045209d52);
    $parcel$export(module.exports, "transformSharePermissionsToServer", ()=>$879c58d3b16279dc$export$e05899da868da914);
    const $879c58d3b16279dc$var$assertUnreachable = (_x)=>{
        throw new Error("Didn't expect to get here");
    };
    const $879c58d3b16279dc$export$88dcd5c1adae8021 = (baseUrl, user)=>({
            displayName: user.displayName,
            avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
            accountId: user.accountId,
            profileUrl: `/jira/people/${user.accountId}`
        });
    const $879c58d3b16279dc$export$443a799045209d52 = (sharePermission)=>{
        switch(sharePermission.type){
            case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                return {
                    type: (0, $a889b3091d5309c7$export$86517eb0163ef745)
                };
            case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                return {
                    type: (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)
                };
            case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                return {
                    type: (0, $a889b3091d5309c7$export$b02d7412182d1bce),
                    group: {
                        ...sharePermission.group
                    }
                };
            case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                {
                    const { project: project, role: role } = sharePermission;
                    return {
                        type: (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                        project: {
                            id: project.id,
                            name: project.name,
                            avatarUrl: project.avatarUrls['48x48']
                        },
                        role: role && {
                            id: role.id,
                            name: role.name
                        }
                    };
                }
            case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                return sharePermission;
            case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                {
                    const { user: user } = sharePermission;
                    return {
                        type: (0, $a889b3091d5309c7$export$aea0835048e1c730),
                        user: {
                            accountId: user.accountId,
                            displayName: user.displayName,
                            avatarUrl: user.avatarUrls['48x48']
                        }
                    };
                }
            default:
                $879c58d3b16279dc$var$assertUnreachable(sharePermission);
                return null;
        }
    };
    const $879c58d3b16279dc$export$e05899da868da914 = (sharePermissions, shouldReturnGroupIdForGroupIfAvailable = false)=>sharePermissions.map((sharePermission)=>{
            switch(sharePermission.type){
                case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                    {
                        let group = {
                            name: sharePermission.group.name
                        };
                        if (shouldReturnGroupIdForGroupIfAvailable && sharePermission.group.groupId) group = {
                            groupId: sharePermission.group.groupId
                        };
                        return {
                            type: sharePermission.type,
                            group: group
                        };
                    }
                case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                    return {
                        type: sharePermission.type,
                        user: {
                            accountId: sharePermission.user.accountId
                        }
                    };
                case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                    {
                        const permission = {
                            type: sharePermission.role ? (0, $3f2163233a19a685$export$4d955b5fb0c1d4d7) : (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                            project: {
                                id: sharePermission.project.id
                            }
                        };
                        if (sharePermission.role) permission.role = {
                            id: sharePermission.role.id
                        };
                        return permission;
                    }
                case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                    return sharePermission;
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                    return {
                        type: (0, $3f2163233a19a685$export$e2fe9963c33d5918)
                    };
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                    return sharePermission;
                default:
                    $879c58d3b16279dc$var$assertUnreachable(sharePermission);
                    return sharePermission;
            }
        });
});
const $a889b3091d5309c7$export$b02d7412182d1bce = 'group';
const $a889b3091d5309c7$export$5ef95a67b8fd1ff6 = 'project';
const $a889b3091d5309c7$export$487da0972e3459fe = 'project-unknown';
const $a889b3091d5309c7$export$b0a0e62d9b1a8269 = 'loggedin';
const $a889b3091d5309c7$export$86517eb0163ef745 = 'global';
const $a889b3091d5309c7$export$aea0835048e1c730 = 'user';
const $3f2163233a19a685$export$e2fe9963c33d5918 = 'authenticated';
const $3f2163233a19a685$export$4d955b5fb0c1d4d7 = 'projectRole';
parcelRegister("2UX9B", function(module, exports) {
    $parcel$export(module.exports, "RETRIEVE", ()=>$7877f29733d95837$export$7bf2c28a4e08c796);
    $parcel$export(module.exports, "retrieve", ()=>$7877f29733d95837$export$8a4d17b6e8486e66);
    $parcel$export(module.exports, "RETRIEVED", ()=>$7877f29733d95837$export$1a07e8ff5bab976c);
    $parcel$export(module.exports, "retrieved", ()=>$7877f29733d95837$export$4058166ec369dd8);
    $parcel$export(module.exports, "RETRIEVE_FAILED", ()=>$7877f29733d95837$export$26e5d507c83e3d5a);
    $parcel$export(module.exports, "retrieveFailed", ()=>$7877f29733d95837$export$1c9b9c3d8868d26f);
    $parcel$export(module.exports, "PATCH", ()=>$7877f29733d95837$export$54950d96c4d7b0);
    $parcel$export(module.exports, "patch", ()=>$7877f29733d95837$export$b76953f99ab2be78);
    const $7877f29733d95837$export$7bf2c28a4e08c796 = 'state.actions.filters.RETRIEVE';
    const $7877f29733d95837$export$8a4d17b6e8486e66 = ()=>({
            type: $7877f29733d95837$export$7bf2c28a4e08c796
        });
    const $7877f29733d95837$export$1a07e8ff5bab976c = 'state.actions.filters.RETRIEVED';
    const $7877f29733d95837$export$4058166ec369dd8 = (payload)=>({
            type: $7877f29733d95837$export$1a07e8ff5bab976c,
            payload: payload
        });
    const $7877f29733d95837$export$26e5d507c83e3d5a = 'state.actions.filters.RETRIEVE_FAILED';
    const $7877f29733d95837$export$1c9b9c3d8868d26f = ()=>({
            type: $7877f29733d95837$export$26e5d507c83e3d5a
        });
    const $7877f29733d95837$export$54950d96c4d7b0 = 'state.actions.filters.PATCH';
    const $7877f29733d95837$export$b76953f99ab2be78 = (payload)=>({
            type: $7877f29733d95837$export$54950d96c4d7b0,
            payload: payload
        });
});
parcelRegister("i0CUl", function(module, exports) {
    $parcel$export(module.exports, "getServiceRequest", ()=>$d2f4336c6070bf3e$export$d7889f7cae5c51ff);
    var $b3NWe;
    var $aRmgJ;
    var $e9yg4;
    var $4biUB;
    const $d2f4336c6070bf3e$var$SORT_FIELDS = {
        [(0, (0, parcelRequire("e9yg4")).NAME)]: 'NAME',
        [(0, (0, parcelRequire("e9yg4")).OWNER)]: 'OWNER',
        [(0, (0, parcelRequire("e9yg4")).FAVOURITED)]: 'IS_FAVOURITE',
        [(0, (0, parcelRequire("e9yg4")).POPULARITY)]: 'FAVOURITE_COUNT'
    };
    const $d2f4336c6070bf3e$var$getSort = (state)=>({
            direction: (0, (0, parcelRequire("4biUB")).getSortDirection)(state),
            field: $d2f4336c6070bf3e$var$SORT_FIELDS[(0, (0, parcelRequire("4biUB")).getSortField)(state)]
        });
    const $d2f4336c6070bf3e$export$d7889f7cae5c51ff = (state)=>(0, (0, parcelRequire("b3NWe")).createPageRequest)((0, (0, parcelRequire("4biUB")).getPage)(state), (0, (0, parcelRequire("aRmgJ")).ITEMS_PER_PAGE), $d2f4336c6070bf3e$var$getSort(state), (0, (0, parcelRequire("aRmgJ")).EXPAND_PARAMETERS));
});
parcelRegister("b3NWe", function(module, exports) {
    $parcel$export(module.exports, "createPageRequest", ()=>$76f67021d51b1075$export$6c268d1798324d1);
    const $76f67021d51b1075$export$a2b44ae778ac3391 = (startAt, maxResults, order, expand)=>{
        const pageRequest = {
            maxResults: maxResults,
            startAt: startAt
        };
        if (order) {
            const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
            pageRequest.orderBy = orderString;
        }
        if (expand && expand.length) pageRequest.expand = expand.join(',');
        return pageRequest;
    };
    const $76f67021d51b1075$export$2db35c6ee4729a76 = (startAt, maxResults, order, expand, searchBy)=>{
        const pageRequest = {
            maxResults: maxResults,
            startAt: startAt
        };
        if (order) {
            const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
            pageRequest.orderBy = orderString;
        }
        if (expand && expand.length) pageRequest.expand = expand.join(',');
        if (searchBy && searchBy.length) pageRequest.searchBy = searchBy.join(',');
        return pageRequest;
    };
    const $76f67021d51b1075$export$6c268d1798324d1 = (page, itemsPerPage, order, expand)=>$76f67021d51b1075$export$a2b44ae778ac3391(itemsPerPage * (page - 1), itemsPerPage, order, expand);
    const $76f67021d51b1075$export$98ffd4f2a2fa32d7 = (page, itemsPerPage, order, expand, searchBy)=>$76f67021d51b1075$export$2db35c6ee4729a76(itemsPerPage * (page - 1), itemsPerPage, order, expand, searchBy);
});
parcelRegister("9U2WO", function(module, exports) {
    $parcel$export(module.exports, "SET_APP_PROPS", ()=>$05ed3b55ae66b821$export$8aefe701a6f431e0);
    $parcel$export(module.exports, "setAppProps", ()=>$05ed3b55ae66b821$export$cfda7627848a58cd);
    const $05ed3b55ae66b821$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
    const $05ed3b55ae66b821$export$cfda7627848a58cd = (payload)=>({
            type: $05ed3b55ae66b821$export$8aefe701a6f431e0,
            payload: payload
        });
});
parcelRegister("hGfxd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd276c550df891db$export$2e2bcd8739ae039);
    var $F2Mxm;
    var $3sbO7;
    var $cd276c550df891db$export$2e2bcd8739ae039 = (rootEpic, initialState)=>(0, (0, parcelRequire("F2Mxm")).default)({
            initialState: initialState,
            appName: 'directories/filters',
            rootReducer: (0, parcelRequire("3sbO7")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("3sbO7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e44ff8c9aef63065$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $j8MrP;
    var $bOupe;
    var $ef3e5;
    var $7XGTR;
    var $e44ff8c9aef63065$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
        app: (0, parcelRequire("j8MrP")).default,
        filters: (0, parcelRequire("ef3e5")).default,
        query: (0, parcelRequire("7XGTR")).default,
        copyFilterModal: (0, parcelRequire("bOupe")).default
    });
});
parcelRegister("j8MrP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$193619407f596e0d$export$2e2bcd8739ae039);
    var $fr1K2 = parcelRequire("fr1K2");
    var $9U2WO;
    const $193619407f596e0d$export$d4c72bab9d6cc13a = {
        props: undefined
    };
    var $193619407f596e0d$export$2e2bcd8739ae039 = (state = $193619407f596e0d$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("9U2WO")).SET_APP_PROPS:
                return {
                    ...state,
                    props: (0, ($parcel$interopDefault($fr1K2)))(action.payload, 'query')
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("bOupe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e9c4af67d268a03$export$2e2bcd8739ae039);
    var $kWgA3;
    const $9e9c4af67d268a03$export$d4c72bab9d6cc13a = {
        isCopyFilterModalOpen: false
    };
    var $9e9c4af67d268a03$export$2e2bcd8739ae039 = (state = $9e9c4af67d268a03$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("kWgA3")).OPEN_COPY_FILTER_MODAL:
                return {
                    isCopyFilterModalOpen: true
                };
            case 0, (0, parcelRequire("kWgA3")).CLOSE_COPY_FILTER_MODAL:
                return {
                    isCopyFilterModalOpen: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("kWgA3", function(module, exports) {
    $parcel$export(module.exports, "OPEN_COPY_FILTER_MODAL", ()=>$4e42ce4b41a05efa$export$ffe8b20c0eaae005);
    $parcel$export(module.exports, "openCopyFilterModal", ()=>$4e42ce4b41a05efa$export$444d12d73e6452c6);
    $parcel$export(module.exports, "CLOSE_COPY_FILTER_MODAL", ()=>$4e42ce4b41a05efa$export$4ef64fde5562fa6a);
    $parcel$export(module.exports, "closeCopyFilterModal", ()=>$4e42ce4b41a05efa$export$fa2b70863b7e4314);
    const $4e42ce4b41a05efa$export$ffe8b20c0eaae005 = 'state.actions.copy-filter-modal.OPEN_COPY_FILTER_MODAL';
    const $4e42ce4b41a05efa$export$444d12d73e6452c6 = ()=>({
            type: $4e42ce4b41a05efa$export$ffe8b20c0eaae005
        });
    const $4e42ce4b41a05efa$export$4ef64fde5562fa6a = 'state.actions.copy-filter-modal.CLOSE_COPY_FILTER_MODAL';
    const $4e42ce4b41a05efa$export$fa2b70863b7e4314 = ()=>({
            type: $4e42ce4b41a05efa$export$4ef64fde5562fa6a
        });
});
parcelRegister("ef3e5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a201ddc2a139894d$export$2e2bcd8739ae039);
    var $2UX9B;
    const $a201ddc2a139894d$export$d4c72bab9d6cc13a = {
        page: {},
        order: [],
        total: 0,
        isLoading: true,
        isError: false
    };
    var $a201ddc2a139894d$export$2e2bcd8739ae039 = (state = $a201ddc2a139894d$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("2UX9B")).RETRIEVE:
                return {
                    ...state,
                    isLoading: true
                };
            case 0, (0, parcelRequire("2UX9B")).RETRIEVED:
                return {
                    ...state,
                    page: action.payload.page,
                    order: action.payload.order,
                    total: action.payload.total,
                    isLoading: false,
                    isError: false
                };
            case 0, (0, parcelRequire("2UX9B")).RETRIEVE_FAILED:
                return {
                    ...state,
                    isLoading: false,
                    isError: true
                };
            case 0, (0, parcelRequire("2UX9B")).PATCH:
                return {
                    ...state,
                    page: {
                        ...state.page,
                        [action.payload.id]: {
                            ...state.page[action.payload.id],
                            ...action.payload.patch
                        }
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("7XGTR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f870ebda6ac32f8a$export$2e2bcd8739ae039);
    var $aRmgJ;
    var $g81jz;
    const $f870ebda6ac32f8a$export$d4c72bab9d6cc13a = (0, (0, parcelRequire("aRmgJ")).initialQuery);
    var $f870ebda6ac32f8a$export$2e2bcd8739ae039 = (state = $f870ebda6ac32f8a$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("g81jz")).SET_QUERY:
                return action.payload;
            case 0, (0, parcelRequire("g81jz")).PATCH_QUERY:
                return {
                    ...state,
                    ...action.payload,
                    filter: {
                        ...state.filter,
                        ...action.payload.filter ? action.payload.filter : undefined
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("64LCo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eae8629e7e825b49$export$2e2bcd8739ae039);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $eHTfV;
    var $bC2fB;
    var $aRmgJ;
    var $2UX9B;
    var $g81jz;
    var $hXBjD;
    var $b9OA0;
    var $4biUB;
    var $lOB3Y;
    var $hdUWf;
    var $dCHeQ;
    var $jTnv2;
    const $eae8629e7e825b49$var$getHeaderConfigurationMemoized = ()=>(0, $dGvGJ.createSelector)((state)=>(0, (0, parcelRequire("hXBjD")).isWithoutHeader)(state) ? {
                FilterView: (0, parcelRequire("dCHeQ")).default
            } : {
                headerConfiguration: (0, (0, parcelRequire("jTnv2")).getHeaderConfiguration)()
            }, (res)=>res);
    const $eae8629e7e825b49$var$mapStateToPropsFactory = ()=>{
        const getHeaderConfigurationInstance = $eae8629e7e825b49$var$getHeaderConfigurationMemoized();
        return (state)=>({
                entityIds: (0, (0, parcelRequire("b9OA0")).getIds)(state),
                totalItems: (0, (0, parcelRequire("b9OA0")).getTotal)(state),
                itemsPerPage: (0, (0, parcelRequire("aRmgJ")).ITEMS_PER_PAGE),
                isLoading: (0, (0, parcelRequire("b9OA0")).isLoading)(state),
                isError: (0, (0, parcelRequire("b9OA0")).isError)(state),
                page: (0, (0, parcelRequire("4biUB")).getPage)(state),
                sortField: (0, (0, parcelRequire("4biUB")).getSortField)(state),
                sortDirection: (0, (0, parcelRequire("4biUB")).getSortDirection)(state),
                filter: (0, (0, parcelRequire("4biUB")).isFilterApplied)(state) ? (0, (0, parcelRequire("4biUB")).getFilter)(state) : undefined,
                firstColumnHeadingAlignment: 'center',
                ...getHeaderConfigurationInstance(state),
                tableConfiguration: (0, (0, parcelRequire("jTnv2")).getTableConfiguration)(state),
                tableLabel: (0, (0, parcelRequire("jTnv2")).getTableLabel)(),
                resultsAnnouncerMessage: (0, (0, parcelRequire("jTnv2")).getResultsAnnouncerMessage)(),
                emptyFilterResultConfiguration: (0, parcelRequire("jTnv2")).emptyFilterResultConfiguration,
                operationModals: (0, parcelRequire("jTnv2")).operationModals,
                EmptyView: (0, parcelRequire("lOB3Y")).default,
                ErrorView: (0, parcelRequire("hdUWf")).default
            });
    };
    const $eae8629e7e825b49$var$mapDispatchToProps = (dispatch)=>({
            onPatch: ({ id: id, patch: patch })=>dispatch((0, (0, parcelRequire("2UX9B")).patch)({
                    id: id,
                    patch: patch
                })),
            onReload: (query)=>{
                dispatch((0, (0, parcelRequire("g81jz")).patchQuery)(query));
                dispatch((0, (0, parcelRequire("2UX9B")).retrieve)());
            }
        });
    var $eae8629e7e825b49$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($eae8629e7e825b49$var$mapStateToPropsFactory, $eae8629e7e825b49$var$mapDispatchToProps)((0, (0, parcelRequire("eHTfV")).default));
});
parcelRegister("eHTfV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68b9ede2efb547aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dJl1T;
    var $dZw8H;
    var $j1FRT;
    var $6E8KZ;
    var $2g1f1;
    var $5wSMM;
    var $iqNVX;
    var $iOBt9;
    const $68b9ede2efb547aa$var$defaultEntityIds = [];
    class $68b9ede2efb547aa$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isOnboardingEnabled: false,
                headerConfiguration: undefined,
                FilterView: undefined,
                TableMaskView: undefined,
                CreateModal: undefined,
                metrics: {
                    tableMounted: undefined
                },
                entityIds: $68b9ede2efb547aa$var$defaultEntityIds,
                dataProvider: undefined,
                renderOnboardingSpotlight: ()=>null,
                tableLabel: undefined,
                onboardingSpotlightTargets: [],
                onFirstRender: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        constructor(props){
            super(props);
            if (props.entityIds !== $68b9ede2efb547aa$var$defaultEntityIds && props.dataProvider) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('directory.base', 'Please provide only one of props: [entityIds] or [dataProvider], dataProvider will be used');
            this.store = (0, (0, parcelRequire("iqNVX")).default)((0, (0, parcelRequire("2g1f1")).default));
            this.store.dispatch((0, (0, parcelRequire("5wSMM")).setAppProps)(props));
        }
        componentDidUpdate() {
            this.store.dispatch((0, (0, parcelRequire("5wSMM")).setAppProps)(this.props));
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6E8KZ")).Provider), {
                store: this.store
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j1FRT")).default), {
                onFirstMount: this.props.onFirstRender
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iOBt9")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null)));
        }
    }
});
parcelRegister("j1FRT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1db2b6388142380$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bKLSv;
    class $b1db2b6388142380$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { children: children } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKLSv")).default).Provider, {
                value: {
                    reportMount: this.onSubtreeMount
                }
            }, children);
        }
        constructor(...args){
            super(...args), this.onSubtreeMount = ()=>{
                if (!this.hasAnyMounted) {
                    this.hasAnyMounted = true;
                    this.props.onFirstMount();
                }
            }, this.hasAnyMounted = false;
        }
    }
});
parcelRegister("bKLSv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78841c2f4061c1bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $78841c2f4061c1bf$export$2e2bcd8739ae039 = (0, $5uXOq.createContext)({
        reportMount: (0, ($parcel$interopDefault($8Rkzz)))
    });
});
parcelRegister("6E8KZ", function(module, exports) {
    $parcel$export(module.exports, "storeOptions", ()=>$faa45d572897b119$export$12cf63d9f5bd0793);
    $parcel$export(module.exports, "Provider", ()=>$faa45d572897b119$export$2881499e37b75b9a);
    $parcel$export(module.exports, "connect", ()=>$faa45d572897b119$export$64605811ab45167f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    const $faa45d572897b119$var$STORE_KEY = 'project-directories.directory.story';
    const $faa45d572897b119$export$d03cc44e35038f93 = (0, $5uXOq.createContext)(null);
    const $faa45d572897b119$export$12cf63d9f5bd0793 = {
        storeKey: $faa45d572897b119$var$STORE_KEY,
        context: $faa45d572897b119$export$d03cc44e35038f93
    };
    const $faa45d572897b119$export$2881499e37b75b9a = (0, (0, parcelRequire("bC2fB")).createProvider)($faa45d572897b119$export$d03cc44e35038f93);
    const $faa45d572897b119$export$64605811ab45167f = (mapStateToProps, mapDispatchToProps, mergeProps, options = Object.freeze({}))=>(0, (0, parcelRequire("bC2fB")).connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
            ...options,
            context: $faa45d572897b119$export$d03cc44e35038f93,
            storeKey: $faa45d572897b119$var$STORE_KEY
        });
});
parcelRegister("2g1f1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98259b1e80972783$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $gcE5m;
    var $eh8lN;
    var $98259b1e80972783$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("gcE5m")).default), (0, (0, parcelRequire("eh8lN")).default));
});
parcelRegister("gcE5m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dab58ae642be3a4d$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $26mQL;
    var $eVVoZ;
    var $dab58ae642be3a4d$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("26mQL")).ENTITY_CREATED)).mergeMap(()=>{
            const state = store.getState();
            const page = (0, (0, parcelRequire("eVVoZ")).getPage)(state);
            (0, (0, parcelRequire("eVVoZ")).getOnReload)(state)({
                page: page
            });
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("26mQL", function(module, exports) {
    $parcel$export(module.exports, "INITIATE", ()=>$fd2eed6f29a3dd08$export$643daa42aa3148d5);
    $parcel$export(module.exports, "initiate", ()=>$fd2eed6f29a3dd08$export$b14c4413e822aa8d);
    $parcel$export(module.exports, "ENTITY_CREATED", ()=>$fd2eed6f29a3dd08$export$61bc72c2b62d14ed);
    $parcel$export(module.exports, "entityCreated", ()=>$fd2eed6f29a3dd08$export$5e2c0a0dc191dd3e);
    $parcel$export(module.exports, "ENTITY_CREATE_FAILED", ()=>$fd2eed6f29a3dd08$export$ac0dd97afb285388);
    $parcel$export(module.exports, "entityCreateFailed", ()=>$fd2eed6f29a3dd08$export$b71626a5d7099742);
    $parcel$export(module.exports, "CANCELLED", ()=>$fd2eed6f29a3dd08$export$6b4658081fcf1aed);
    $parcel$export(module.exports, "cancelled", ()=>$fd2eed6f29a3dd08$export$b108ea1063c657e3);
    const $fd2eed6f29a3dd08$export$643daa42aa3148d5 = 'state.actions.create.INITIATE';
    const $fd2eed6f29a3dd08$export$b14c4413e822aa8d = ()=>({
            type: $fd2eed6f29a3dd08$export$643daa42aa3148d5
        });
    const $fd2eed6f29a3dd08$export$61bc72c2b62d14ed = 'state.actions.create.ENTITY_CREATED';
    const $fd2eed6f29a3dd08$export$5e2c0a0dc191dd3e = (payload)=>({
            type: $fd2eed6f29a3dd08$export$61bc72c2b62d14ed,
            payload: payload
        });
    const $fd2eed6f29a3dd08$export$ac0dd97afb285388 = 'state.actions.create.ENTITY_CREATE_FAILED';
    const $fd2eed6f29a3dd08$export$b71626a5d7099742 = (payload)=>({
            type: $fd2eed6f29a3dd08$export$ac0dd97afb285388,
            payload: payload
        });
    const $fd2eed6f29a3dd08$export$6b4658081fcf1aed = 'state.actions.create.CANCELLED';
    const $fd2eed6f29a3dd08$export$b108ea1063c657e3 = ()=>({
            type: $fd2eed6f29a3dd08$export$6b4658081fcf1aed
        });
});
parcelRegister("eVVoZ", function(module, exports) {
    $parcel$export(module.exports, "getEntityIds", ()=>$6cea3ab9141d1142$export$1fe43832be7d1fcb);
    $parcel$export(module.exports, "getDataProvider", ()=>$6cea3ab9141d1142$export$add6bf8e4261fead);
    $parcel$export(module.exports, "getTotalItems", ()=>$6cea3ab9141d1142$export$cbc4bdd6c02fac4d);
    $parcel$export(module.exports, "getPage", ()=>$6cea3ab9141d1142$export$c2a6433281518c91);
    $parcel$export(module.exports, "getItemsPerPage", ()=>$6cea3ab9141d1142$export$347447940701b338);
    $parcel$export(module.exports, "getSortField", ()=>$6cea3ab9141d1142$export$9b753af5a9fb5911);
    $parcel$export(module.exports, "getSortDirection", ()=>$6cea3ab9141d1142$export$509e2b9937961873);
    $parcel$export(module.exports, "getFilter", ()=>$6cea3ab9141d1142$export$61ec8404f465cd36);
    $parcel$export(module.exports, "getHeaderConfiguration", ()=>$6cea3ab9141d1142$export$60b0ef02721854ed);
    $parcel$export(module.exports, "getFilterView", ()=>$6cea3ab9141d1142$export$4a62b01f13af161e);
    $parcel$export(module.exports, "getTableConfiguration", ()=>$6cea3ab9141d1142$export$6847365bea1c5392);
    $parcel$export(module.exports, "getTableLabel", ()=>$6cea3ab9141d1142$export$b2d196af18e06ad6);
    $parcel$export(module.exports, "getResultsAnnouncerMessage", ()=>$6cea3ab9141d1142$export$64df75861e57fb7f);
    $parcel$export(module.exports, "getEmptyView", ()=>$6cea3ab9141d1142$export$6ad7beec028137c);
    $parcel$export(module.exports, "getErrorView", ()=>$6cea3ab9141d1142$export$67942d5525c28c28);
    $parcel$export(module.exports, "getEmptyFilterResultConfiguration", ()=>$6cea3ab9141d1142$export$dae3c68be4c9569d);
    $parcel$export(module.exports, "getTableMaskView", ()=>$6cea3ab9141d1142$export$7a35128187f8245c);
    $parcel$export(module.exports, "getCreateModal", ()=>$6cea3ab9141d1142$export$be5bc82ccf7ca5ca);
    $parcel$export(module.exports, "getOperationModal", ()=>$6cea3ab9141d1142$export$3f5ae3b2bfec9457);
    $parcel$export(module.exports, "getOnReload", ()=>$6cea3ab9141d1142$export$7158eb69f7a0b59);
    $parcel$export(module.exports, "getOnPatch", ()=>$6cea3ab9141d1142$export$944f52419ab8e737);
    $parcel$export(module.exports, "isLoading", ()=>$6cea3ab9141d1142$export$20bb0d907fbbe433);
    $parcel$export(module.exports, "isError", ()=>$6cea3ab9141d1142$export$e6127cc7fe7395c3);
    $parcel$export(module.exports, "getTotalPages", ()=>$6cea3ab9141d1142$export$652b307566494a6);
    $parcel$export(module.exports, "getFirstColumnHeadingAlignment", ()=>$6cea3ab9141d1142$export$22b039be773dbf63);
    $parcel$export(module.exports, "getLastColumnHeadingAlignment", ()=>$6cea3ab9141d1142$export$affaf5a34a669e16);
    $parcel$export(module.exports, "isCreateOpen", ()=>$6cea3ab9141d1142$export$996a71275221ab9e);
    $parcel$export(module.exports, "getOperations", ()=>$6cea3ab9141d1142$export$acc17f62bededcaf);
    $parcel$export(module.exports, "getOperationInitializationStatusPerEntity", ()=>$6cea3ab9141d1142$export$69a0d9b5be75b55d);
    $parcel$export(module.exports, "getIsOnboardingEnabled", ()=>$6cea3ab9141d1142$export$65890ce3309e3ccf);
    $parcel$export(module.exports, "getRenderOnboardingSpotlight", ()=>$6cea3ab9141d1142$export$98db60f26810390);
    $parcel$export(module.exports, "getSpotlightForCell", ()=>$6cea3ab9141d1142$export$1faee8e10b588885);
    $parcel$export(module.exports, "getAvailableSpotlightTargets", ()=>$6cea3ab9141d1142$export$7eda79d5ce9a0b8b);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $4Xk2W = parcelRequire("4Xk2W");
    var $dPSWJ = parcelRequire("dPSWJ");
    var $k15gu;
    const $6cea3ab9141d1142$export$876089ea65adc54 = (state)=>state.app.props;
    const $6cea3ab9141d1142$export$1fe43832be7d1fcb = (state)=>state.app.props.entityIds;
    const $6cea3ab9141d1142$export$add6bf8e4261fead = (state)=>state.app.props.dataProvider || undefined;
    const $6cea3ab9141d1142$export$cbc4bdd6c02fac4d = (state)=>state.app.props.totalItems;
    const $6cea3ab9141d1142$export$c2a6433281518c91 = (state)=>state.app.props.page;
    const $6cea3ab9141d1142$export$347447940701b338 = (state)=>state.app.props.itemsPerPage;
    const $6cea3ab9141d1142$export$9b753af5a9fb5911 = (state)=>state.app.props.sortField;
    const $6cea3ab9141d1142$export$509e2b9937961873 = (state)=>state.app.props.sortDirection;
    const $6cea3ab9141d1142$export$61ec8404f465cd36 = (state)=>state.app.props.filter;
    const $6cea3ab9141d1142$export$60b0ef02721854ed = (state)=>state.app.props.headerConfiguration;
    const $6cea3ab9141d1142$export$4a62b01f13af161e = (state)=>state.app.props.FilterView;
    const $6cea3ab9141d1142$export$6847365bea1c5392 = (state)=>state.app.props.tableConfiguration;
    const $6cea3ab9141d1142$export$b2d196af18e06ad6 = (state)=>state.app.props.tableLabel;
    const $6cea3ab9141d1142$export$64df75861e57fb7f = (state)=>state.app.props.resultsAnnouncerMessage;
    const $6cea3ab9141d1142$export$6ad7beec028137c = (state)=>state.app.props.EmptyView;
    const $6cea3ab9141d1142$export$67942d5525c28c28 = (state)=>state.app.props.ErrorView;
    const $6cea3ab9141d1142$export$dae3c68be4c9569d = (state)=>state.app.props.emptyFilterResultConfiguration;
    const $6cea3ab9141d1142$export$7a35128187f8245c = (state)=>state.app.props.TableMaskView;
    const $6cea3ab9141d1142$export$be5bc82ccf7ca5ca = (state)=>state.app.props.CreateModal;
    const $6cea3ab9141d1142$export$3f5ae3b2bfec9457 = (state, operation)=>state.app.props.operationModals[operation];
    const $6cea3ab9141d1142$export$7158eb69f7a0b59 = (state)=>state.app.props.onReload;
    const $6cea3ab9141d1142$export$944f52419ab8e737 = (state)=>state.app.props.onPatch;
    const $6cea3ab9141d1142$export$20bb0d907fbbe433 = (state)=>state.app.props.isLoading;
    const $6cea3ab9141d1142$export$e6127cc7fe7395c3 = (state)=>state.app.props.isError;
    const $6cea3ab9141d1142$var$getTotalPagesInternal = (0, $dGvGJ.createSelector)($6cea3ab9141d1142$export$cbc4bdd6c02fac4d, $6cea3ab9141d1142$export$347447940701b338, (totalItems, itemsOnPage)=>(0, (0, parcelRequire("k15gu")).calculateTotalPages)(totalItems, itemsOnPage));
    const $6cea3ab9141d1142$export$652b307566494a6 = (state)=>$6cea3ab9141d1142$var$getTotalPagesInternal(state);
    const $6cea3ab9141d1142$export$22b039be773dbf63 = (state)=>state.app.props.firstColumnHeadingAlignment;
    const $6cea3ab9141d1142$export$affaf5a34a669e16 = (state)=>state.app.props.lastColumnHeadingAlignment;
    const $6cea3ab9141d1142$export$996a71275221ab9e = (state)=>state.create.isOpen;
    const $6cea3ab9141d1142$export$acc17f62bededcaf = (state)=>state.operations;
    const $6cea3ab9141d1142$var$getOperationInitializationStatusPerEntityInternal = (0, $dGvGJ.createSelector)((state)=>state.operations, (operations)=>(0, ($parcel$interopDefault($dPSWJ)))((0, ($parcel$interopDefault($4Xk2W)))(operations, ({ id: id })=>id), ({ isInitializing: isInitializing })=>isInitializing));
    const $6cea3ab9141d1142$export$69a0d9b5be75b55d = (state)=>$6cea3ab9141d1142$var$getOperationInitializationStatusPerEntityInternal(state);
    const $6cea3ab9141d1142$export$65890ce3309e3ccf = (state)=>state.app.props.isOnboardingEnabled;
    const $6cea3ab9141d1142$export$ee9bc95b4b33fe7b = (state)=>state.app.props.onboardingSpotlightTargets;
    const $6cea3ab9141d1142$export$98db60f26810390 = (state)=>state.app.props.renderOnboardingSpotlight;
    const $6cea3ab9141d1142$export$1faee8e10b588885 = (state)=>(id, colIndex)=>$6cea3ab9141d1142$export$ee9bc95b4b33fe7b(state).find((c)=>c.entityId === id && c.colIndex === colIndex);
    const $6cea3ab9141d1142$export$7eda79d5ce9a0b8b = (state)=>(0, $dGvGJ.createSelector)($6cea3ab9141d1142$export$6847365bea1c5392, $6cea3ab9141d1142$export$add6bf8e4261fead, $6cea3ab9141d1142$export$1fe43832be7d1fcb, $6cea3ab9141d1142$export$1faee8e10b588885, (tableConfig, dataProvider, entitiesIds, getSpotlightCellTarget)=>{
            const availableSpotlightTargets = [];
            const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entitiesIds;
            if (ids && tableConfig) ids.forEach((entityId)=>{
                for(let i = 0; i < tableConfig.length; i += 1){
                    const cellMatch = getSpotlightCellTarget(entityId, i);
                    if (cellMatch && cellMatch.spotlightId) availableSpotlightTargets.push(entityId);
                }
            });
            return availableSpotlightTargets;
        })(state);
});
parcelRegister("eh8lN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37ecadf93c93225f$export$2e2bcd8739ae039);
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $k15gu;
    var $lxmKy;
    var $eVVoZ;
    var $37ecadf93c93225f$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("lxmKy")).ENTITY_UPDATED)).mergeMap((action)=>{
            const { id: id, operation: operation, patch: patch } = action.payload;
            const state = store.getState();
            const currentPage = (0, (0, parcelRequire("eVVoZ")).getPage)(state);
            if (patch) {
                (0, (0, parcelRequire("eVVoZ")).getOnPatch)(state)({
                    id: id,
                    patch: patch
                });
                return (0, $kVLXA.Observable).empty();
            }
            if (operation === (0, $088bf273559ead46$export$4bd2facc4a3e6aa1)) {
                const itemsPerPage = (0, (0, parcelRequire("eVVoZ")).getItemsPerPage)(state);
                const totalItems = (0, (0, parcelRequire("eVVoZ")).getTotalItems)(state);
                const predictedPage = (0, (0, parcelRequire("k15gu")).predictPageToRequestAfterItemDeletion)(itemsPerPage, totalItems, currentPage);
                (0, (0, parcelRequire("eVVoZ")).getOnReload)(state)({
                    page: predictedPage
                });
            } else (0, (0, parcelRequire("eVVoZ")).getOnReload)(state)({
                page: currentPage
            });
            return (0, $kVLXA.Observable).empty();
        });
});
const $088bf273559ead46$export$250171a898bf7ef = 'EDIT';
const $088bf273559ead46$export$4bd2facc4a3e6aa1 = 'DELETE';
const $088bf273559ead46$export$257be95a51c84145 = 'DUPLICATE';
const $088bf273559ead46$export$a7c1ec142e70d69d = 'ARCHIVE';
const $088bf273559ead46$export$92f9e1ed9114d3a6 = 'COPY';
const $088bf273559ead46$export$346f08c1f0d0fe41 = 'MOVE';
const $088bf273559ead46$export$bbf2495ca7d54c9f = 'SHOW_DETAILS';
const $088bf273559ead46$export$39d2a7fb21967424 = 'CHANGE_OWNER';
const $088bf273559ead46$export$2b848a0670941e75 = 'TRASH';
const $088bf273559ead46$export$aeed50488a8a79d7 = 'RESTORE';
parcelRegister("lxmKy", function(module, exports) {
    $parcel$export(module.exports, "INITIATE", ()=>$7c27857a14ac40bb$export$643daa42aa3148d5);
    $parcel$export(module.exports, "initiate", ()=>$7c27857a14ac40bb$export$b14c4413e822aa8d);
    $parcel$export(module.exports, "ENTITY_DATA_RETRIEVE_FAILED", ()=>$7c27857a14ac40bb$export$d5657bfeb6a06769);
    $parcel$export(module.exports, "entityDataRetrieveFailed", ()=>$7c27857a14ac40bb$export$7771a5f3a1cb2756);
    $parcel$export(module.exports, "DIALOG_SHOWN", ()=>$7c27857a14ac40bb$export$54e32bf20c0b405b);
    $parcel$export(module.exports, "dialogShown", ()=>$7c27857a14ac40bb$export$7aca9ee5930fa3ea);
    $parcel$export(module.exports, "ENTITY_UPDATED", ()=>$7c27857a14ac40bb$export$93e8e914b5b8b20d);
    $parcel$export(module.exports, "entityUpdated", ()=>$7c27857a14ac40bb$export$c0932263cb70e08f);
    $parcel$export(module.exports, "ENTITY_UPDATE_FAILED", ()=>$7c27857a14ac40bb$export$d2d41c22dcb7b1db);
    $parcel$export(module.exports, "entityUpdateFailed", ()=>$7c27857a14ac40bb$export$fbb84be2ae83b4ed);
    $parcel$export(module.exports, "CANCELLED", ()=>$7c27857a14ac40bb$export$6b4658081fcf1aed);
    $parcel$export(module.exports, "cancelled", ()=>$7c27857a14ac40bb$export$b108ea1063c657e3);
    const $7c27857a14ac40bb$export$643daa42aa3148d5 = 'state.actions.operation.INITIATE';
    const $7c27857a14ac40bb$export$b14c4413e822aa8d = (payload)=>({
            type: $7c27857a14ac40bb$export$643daa42aa3148d5,
            payload: payload
        });
    const $7c27857a14ac40bb$export$d5657bfeb6a06769 = 'state.actions.operation.ENTITY_DATA_RETRIEVE_FAILED';
    const $7c27857a14ac40bb$export$7771a5f3a1cb2756 = (payload)=>({
            type: $7c27857a14ac40bb$export$d5657bfeb6a06769,
            payload: payload
        });
    const $7c27857a14ac40bb$export$54e32bf20c0b405b = 'state.actions.operation.DIALOG_SHOWN';
    const $7c27857a14ac40bb$export$7aca9ee5930fa3ea = (payload)=>({
            type: $7c27857a14ac40bb$export$54e32bf20c0b405b,
            payload: payload
        });
    const $7c27857a14ac40bb$export$93e8e914b5b8b20d = 'state.actions.operation.ENTITY_UPDATED';
    const $7c27857a14ac40bb$export$c0932263cb70e08f = (payload)=>({
            type: $7c27857a14ac40bb$export$93e8e914b5b8b20d,
            payload: payload
        });
    const $7c27857a14ac40bb$export$d2d41c22dcb7b1db = 'state.actions.operation.ENTITY_UPDATE_FAILED';
    const $7c27857a14ac40bb$export$fbb84be2ae83b4ed = (payload)=>({
            type: $7c27857a14ac40bb$export$d2d41c22dcb7b1db,
            payload: payload
        });
    const $7c27857a14ac40bb$export$6b4658081fcf1aed = 'state.actions.operation.CANCELLED';
    const $7c27857a14ac40bb$export$b108ea1063c657e3 = (payload)=>({
            type: $7c27857a14ac40bb$export$6b4658081fcf1aed,
            payload: payload
        });
});
parcelRegister("5wSMM", function(module, exports) {
    $parcel$export(module.exports, "SET_APP_PROPS", ()=>$2b3ff44e59fa5c9c$export$8aefe701a6f431e0);
    $parcel$export(module.exports, "setAppProps", ()=>$2b3ff44e59fa5c9c$export$cfda7627848a58cd);
    const $2b3ff44e59fa5c9c$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
    const $2b3ff44e59fa5c9c$export$cfda7627848a58cd = (payload)=>({
            type: $2b3ff44e59fa5c9c$export$8aefe701a6f431e0,
            payload: payload
        });
});
parcelRegister("iqNVX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$908bc238b7ffec6c$export$2e2bcd8739ae039);
    var $F2Mxm;
    var $1EQqh;
    var $908bc238b7ffec6c$export$2e2bcd8739ae039 = (rootEpic)=>{
        const fixedTypeRootReducer = (0, (0, parcelRequire("1EQqh")).default);
        return (0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'directory-base',
            rootReducer: fixedTypeRootReducer,
            rootEpic: rootEpic
        });
    };
});
parcelRegister("1EQqh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7f8876305395d63$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $bDEL5;
    var $grerf;
    var $9Oh3c;
    var $b7f8876305395d63$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
        app: (0, parcelRequire("bDEL5")).default,
        create: (0, parcelRequire("grerf")).default,
        operations: (0, parcelRequire("9Oh3c")).default
    });
});
parcelRegister("bDEL5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6089ea8d621e8008$export$2e2bcd8739ae039);
    var $5wSMM;
    var $6089ea8d621e8008$export$2e2bcd8739ae039 = (state = {
        props: undefined
    }, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("5wSMM")).SET_APP_PROPS:
                return {
                    ...state,
                    props: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("grerf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e84fac704b397d4d$export$2e2bcd8739ae039);
    var $26mQL;
    const $e84fac704b397d4d$var$initialState = {
        isOpen: false
    };
    var $e84fac704b397d4d$export$2e2bcd8739ae039 = (state = $e84fac704b397d4d$var$initialState, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("26mQL")).INITIATE:
                return {
                    isOpen: true
                };
            case 0, (0, parcelRequire("26mQL")).ENTITY_CREATED:
            case 0, (0, parcelRequire("26mQL")).ENTITY_CREATE_FAILED:
            case 0, (0, parcelRequire("26mQL")).CANCELLED:
                return {
                    isOpen: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("9Oh3c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32f9982687de3ac1$export$2e2bcd8739ae039);
    var $lxmKy;
    const $32f9982687de3ac1$var$reducer = (state = [], action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("lxmKy")).INITIATE:
                return [
                    ...state,
                    {
                        ...action.payload,
                        isInitializing: true
                    }
                ];
            case 0, (0, parcelRequire("lxmKy")).DIALOG_SHOWN:
                return [
                    ...state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation),
                    {
                        ...action.payload,
                        isInitializing: false
                    }
                ];
            case 0, (0, parcelRequire("lxmKy")).ENTITY_DATA_RETRIEVE_FAILED:
            case 0, (0, parcelRequire("lxmKy")).ENTITY_UPDATED:
            case 0, (0, parcelRequire("lxmKy")).ENTITY_UPDATE_FAILED:
            case 0, (0, parcelRequire("lxmKy")).CANCELLED:
                return state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation);
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $32f9982687de3ac1$export$2e2bcd8739ae039 = $32f9982687de3ac1$var$reducer;
});
parcelRegister("iOBt9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63bf7e60b7f91719$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6E8KZ;
    var $lm3g2;
    var $gZxo5;
    var $1Evzn;
    var $63bf7e60b7f91719$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(()=>({
            Content: (0, parcelRequire("lm3g2")).default,
            Modals: (0, parcelRequire("gZxo5")).default
        }), null, null, (0, (0, parcelRequire("6E8KZ")).storeOptions))((0, (0, parcelRequire("1Evzn")).default));
});
parcelRegister("lm3g2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cdf0f9e385dafe4e$export$2e2bcd8739ae039);
    var $8QpSo;
    var $bC2fB;
    var $6dDSs;
    var $l3DlM;
    var $6E8KZ;
    var $26mQL;
    var $eVVoZ;
    var $hLegl;
    var $gSSqP;
    var $geyiO;
    var $fjCWQ;
    var $1zjdB;
    var $do0bP;
    var $gO9Up;
    const $cdf0f9e385dafe4e$var$getEmptyViewSelectorMemoized = ()=>(0, (0, parcelRequire("6dDSs")).createSelector)((state)=>(0, (0, parcelRequire("l3DlM")).withMountReporting)((0, (0, parcelRequire("eVVoZ")).getEmptyView)(state)), (res)=>res);
    const $cdf0f9e385dafe4e$var$getErrorViewSelectorMemoized = ()=>(0, (0, parcelRequire("6dDSs")).createSelector)((state)=>(0, (0, parcelRequire("l3DlM")).withMountReporting)((0, (0, parcelRequire("eVVoZ")).getErrorView)(state)), (res)=>res);
    const $cdf0f9e385dafe4e$var$getAvailableSpotlightTargetsSelectorMemoized = ()=>(0, (0, parcelRequire("6dDSs")).createSelector)((state)=>(0, (0, parcelRequire("eVVoZ")).getAvailableSpotlightTargets)(state), (res)=>res);
    const $cdf0f9e385dafe4e$var$mapStateToPropsFactory = ()=>{
        const getEmptyViewSelectorInstance = $cdf0f9e385dafe4e$var$getEmptyViewSelectorMemoized();
        const getErrorViewSelectorInstance = $cdf0f9e385dafe4e$var$getErrorViewSelectorMemoized();
        const getAvailableSpotlightTargetsSelectorInstance = $cdf0f9e385dafe4e$var$getAvailableSpotlightTargetsSelectorMemoized();
        const onRetryFactory = (0, (0, parcelRequire("8QpSo")).default)((state)=>()=>(0, (0, parcelRequire("eVVoZ")).getOnReload)(state)({}));
        return (state)=>{
            let Header;
            const FilterView = (0, (0, parcelRequire("eVVoZ")).getFilterView)(state);
            if (FilterView) Header = (0, (0, parcelRequire("gSSqP")).default);
            else {
                const headerConfiguration = (0, (0, parcelRequire("eVVoZ")).getHeaderConfiguration)(state);
                if (headerConfiguration) {
                    if (headerConfiguration.View) Header = (0, (0, parcelRequire("fjCWQ")).default);
                    else Header = (0, (0, parcelRequire("geyiO")).default);
                }
            }
            return {
                Header: Header,
                Table: (0, parcelRequire("do0bP")).default,
                Paginator: (0, parcelRequire("1zjdB")).default,
                Empty: getEmptyViewSelectorInstance(state),
                Error: getErrorViewSelectorInstance(state),
                status: (0, (0, parcelRequire("hLegl")).getStatus)(state),
                onRetry: onRetryFactory(state),
                isOnboardingEnabled: (0, (0, parcelRequire("eVVoZ")).getIsOnboardingEnabled)(state),
                renderOnboardingSpotlight: (0, (0, parcelRequire("eVVoZ")).getRenderOnboardingSpotlight)(state),
                availableSpotlightTargets: getAvailableSpotlightTargetsSelectorInstance(state)
            };
        };
    };
    const $cdf0f9e385dafe4e$var$mapDispatchToProps = {
        onAdd: (0, (0, parcelRequire("26mQL")).initiate)
    };
    var $cdf0f9e385dafe4e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($cdf0f9e385dafe4e$var$mapStateToPropsFactory, $cdf0f9e385dafe4e$var$mapDispatchToProps, null, (0, (0, parcelRequire("6E8KZ")).storeOptions))((0, (0, parcelRequire("gO9Up")).default));
});
parcelRegister("l3DlM", function(module, exports) {
    $parcel$export(module.exports, "withMountReporting", ()=>$626145856bfd7724$export$95fa4b7a60ebef6);
    $parcel$export(module.exports, "default", ()=>$626145856bfd7724$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $bKLSv;
    class $626145856bfd7724$var$Reporter extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                performanceMarkKey: undefined
            };
        }
        componentDidMount() {
            this.props.onMounted();
        }
        render() {
            const { performanceMarkKey: performanceMarkKey } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, performanceMarkKey && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
                metricKey: performanceMarkKey
            }), this.props.children);
        }
    }
    function $626145856bfd7724$export$95fa4b7a60ebef6(Wrapped) {
        return (props)=>{
            const { performanceMarkKey: performanceMarkKey, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKLSv")).default).Consumer, null, ({ reportMount: reportMount })=>(0, ($parcel$interopDefault($5uXOq))).createElement($626145856bfd7724$var$Reporter, {
                    onMounted: reportMount,
                    performanceMarkKey: performanceMarkKey
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapped, rest)));
        };
    }
    const $626145856bfd7724$var$MountReporter = $626145856bfd7724$export$95fa4b7a60ebef6(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    var $626145856bfd7724$export$2e2bcd8739ae039 = $626145856bfd7724$var$MountReporter;
});
parcelRegister("hLegl", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$2846182b2726a0e3$export$b70265791d2079d4);
    var $eVVoZ;
    const $2846182b2726a0e3$export$b70265791d2079d4 = (state)=>{
        if ((0, (0, parcelRequire("eVVoZ")).isError)(state)) return 'error';
        if ((0, (0, parcelRequire("eVVoZ")).isLoading)(state)) return 'has-entities';
        const dataProvider = (0, (0, parcelRequire("eVVoZ")).getDataProvider)(state);
        const elementsCount = dataProvider ? dataProvider.getData().length : (0, (0, parcelRequire("eVVoZ")).getEntityIds)(state).length;
        return elementsCount === 0 && (0, (0, parcelRequire("eVVoZ")).getFilter)(state) === undefined && (0, (0, parcelRequire("eVVoZ")).getPage)(state) === 1 ? 'empty' : 'has-entities';
    };
});
parcelRegister("gSSqP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebd0a798fbf431b0$export$2e2bcd8739ae039);
    var $8QpSo;
    var $6E8KZ;
    var $eVVoZ;
    var $hLegl;
    var $6Wj1D;
    const $ebd0a798fbf431b0$var$mapStateToPropsFactory = ()=>{
        const onFilterFactory = (0, (0, parcelRequire("8QpSo")).default)((state)=>(filter)=>(0, (0, parcelRequire("eVVoZ")).getOnReload)(state)({
                    page: 1,
                    filter: filter
                }));
        return (state)=>({
                FilterView: (0, (0, parcelRequire("eVVoZ")).getFilterView)(state),
                onFilter: onFilterFactory(state),
                hasEntities: (0, (0, parcelRequire("hLegl")).getStatus)(state) === 'has-entities'
            });
    };
    var $ebd0a798fbf431b0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("6E8KZ")).connect)($ebd0a798fbf431b0$var$mapStateToPropsFactory, {})((0, (0, parcelRequire("6Wj1D")).default));
});
parcelRegister("6Wj1D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5eb63d55477b9357$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    function $5eb63d55477b9357$export$2e2bcd8739ae039(props) {
        const { hasEntities: hasEntities, FilterView: FilterView, onFilter: onFilter } = props;
        return hasEntities ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5eb63d55477b9357$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(FilterView, {
            onFilter: onFilter
        })) : null;
    }
    const $5eb63d55477b9357$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.200'
    });
});
parcelRegister("geyiO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef20ad5474450900$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6E8KZ;
    var $eVVoZ;
    var $hLegl;
    var $kBSkq;
    var $9WoAf;
    var $gg466;
    const $ef20ad5474450900$var$mapStateToProps = (state)=>{
        const headerConfiguration = (0, (0, parcelRequire("eVVoZ")).getHeaderConfiguration)(state);
        if (!headerConfiguration || headerConfiguration.View) throw new Error('Invalid state - Default Header view must not be mounted');
        return {
            Filter: (0, parcelRequire("9WoAf")).default,
            Actions: headerConfiguration.ActionsView || (0, (0, parcelRequire("kBSkq")).default),
            hasEntities: (0, (0, parcelRequire("hLegl")).getStatus)(state) === 'has-entities',
            caption: headerConfiguration.caption || null
        };
    };
    var $ef20ad5474450900$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($ef20ad5474450900$var$mapStateToProps, null, null, (0, (0, parcelRequire("6E8KZ")).storeOptions))((0, (0, parcelRequire("gg466")).default));
});
parcelRegister("kBSkq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$665d045383a33008$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6E8KZ;
    var $26mQL;
    var $eVVoZ;
    var $k0n1b;
    const $665d045383a33008$var$mapStateToProps = (state)=>{
        const headerConfiguration = (0, (0, parcelRequire("eVVoZ")).getHeaderConfiguration)(state);
        if (headerConfiguration && !headerConfiguration.View && !headerConfiguration.ActionsView) {
            const { isAddAllowed: isAddAllowed, addButtonCaption: addButtonCaption } = headerConfiguration;
            return {
                canAdd: isAddAllowed,
                caption: addButtonCaption
            };
        }
        return {};
    };
    const $665d045383a33008$var$mapDispatchToProps = {
        onAdd: (0, (0, parcelRequire("26mQL")).initiate)
    };
    var $665d045383a33008$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($665d045383a33008$var$mapStateToProps, $665d045383a33008$var$mapDispatchToProps, null, (0, (0, parcelRequire("6E8KZ")).storeOptions))((0, (0, parcelRequire("k0n1b")).default));
});
parcelRegister("k0n1b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e2628b3f0abf572$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $koVbs;
    function $5e2628b3f0abf572$var$Add(props) {
        const { canAdd: canAdd, caption: caption, onAdd: onAdd } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return canAdd ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            onClick: onAdd
        }, caption && formatMessage(caption)) : null;
    }
    $5e2628b3f0abf572$var$Add.defaultProps = {
        canAdd: false
    };
    var $5e2628b3f0abf572$export$2e2bcd8739ae039 = $5e2628b3f0abf572$var$Add;
});
parcelRegister("9WoAf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$900e6ddadbcb8d02$export$2e2bcd8739ae039);
    var $8QpSo;
    var $6E8KZ;
    var $eVVoZ;
    var $fwdEW;
    const $900e6ddadbcb8d02$var$mapStateToPropsFactory = ()=>{
        const onFilterFactory = (0, (0, parcelRequire("8QpSo")).default)((state)=>(filter)=>(0, (0, parcelRequire("eVVoZ")).getOnReload)(state)({
                    page: 1,
                    filter: filter
                }));
        return (state)=>{
            const headerConfiguration = (0, (0, parcelRequire("eVVoZ")).getHeaderConfiguration)(state);
            if (!headerConfiguration || !headerConfiguration.FilterView) throw new Error('Invalid state - Filter wrapper must not be mounted');
            return {
                FilterView: headerConfiguration.FilterView,
                onFilter: onFilterFactory(state)
            };
        };
    };
    var $900e6ddadbcb8d02$export$2e2bcd8739ae039 = (0, (0, parcelRequire("6E8KZ")).connect)($900e6ddadbcb8d02$var$mapStateToPropsFactory, {})((0, (0, parcelRequire("fwdEW")).default));
});
parcelRegister("fwdEW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2acfb424a6da5ad8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $2acfb424a6da5ad8$export$2e2bcd8739ae039(props) {
        const { FilterView: FilterView, onFilter: onFilter } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(FilterView, {
            onFilter: onFilter
        });
    }
});
parcelRegister("gg466", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c60de6ef876d0e76$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cS37j;
    var $az4zD;
    function $c60de6ef876d0e76$var$Default(props) {
        const { Filter: Filter, Actions: Actions, caption: caption, hasEntities: hasEntities, intl: { formatMessage: formatMessage } } = props;
        let searchBar = null;
        let actions = null;
        if (hasEntities) {
            searchBar = (0, ($parcel$interopDefault($5uXOq))).createElement(Filter, null);
            actions = (0, ($parcel$interopDefault($5uXOq))).createElement(Actions, null);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            truncateTitle: true,
            actions: actions,
            bottomBar: searchBar
        }, caption ? formatMessage(caption) : '');
    }
    var $c60de6ef876d0e76$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($c60de6ef876d0e76$var$Default);
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $57MwZ;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("az4zD", function(module, exports) {
    $parcel$export(module.exports, "injectIntlV2", ()=>$90dc1bd887533804$export$440265f0ca78e98e);
    var $5uXOq = parcelRequire("5uXOq");
    var $dY8Js = parcelRequire("dY8Js");
    var $koVbs;
    const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
    function $90dc1bd887533804$var$getDisplayName(Component) {
        if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) return Component.displayName;
        if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
        return 'Component';
    }
    const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
        const { withRef: withRef = false } = options || {};
        const WithIntl = (props)=>{
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            const intlRef = (0, $5uXOq.useRef)(null);
            if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
            if (!intlRef.current) intlRef.current = {
                messages: intl.messages,
                locale: intl.locale,
                formats: intl.formats,
                formatDate: intl.formatDate,
                formatMessage: intl.formatMessage,
                formatNumber: intl.formatNumber,
                formatPlural: intl.formatPlural,
                formatTime: intl.formatTime
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                intl: intlRef.current,
                ref: withRef ? props.forwardedRef : null
            });
        };
        WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
        WithIntl.WrappedComponent = WrappedComponent;
        if (withRef) return (0, ($parcel$interopDefault($dY8Js)))((0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WithIntl, {
                ...props,
                forwardedRef: ref
            })), WrappedComponent);
        return (0, ($parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
    };
});
parcelRegister("fjCWQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06b8144acd42bd1f$export$2e2bcd8739ae039);
    var $8QpSo;
    var $6E8KZ;
    var $26mQL;
    var $eVVoZ;
    var $hLegl;
    var $1F2yg;
    const $06b8144acd42bd1f$var$mapStateToPropsFactory = ()=>{
        const onFilterFactory = (0, (0, parcelRequire("8QpSo")).default)((state)=>(filter)=>(0, (0, parcelRequire("eVVoZ")).getOnReload)(state)({
                    page: 1,
                    filter: filter
                }));
        return (state)=>{
            const headerConfiguration = (0, (0, parcelRequire("eVVoZ")).getHeaderConfiguration)(state);
            if (!headerConfiguration || !headerConfiguration.View) throw new Error('Invalid state - Header wrapper must not be mounted');
            return {
                HeaderView: headerConfiguration.View,
                hasEntities: (0, (0, parcelRequire("hLegl")).getStatus)(state) === 'has-entities',
                onFilter: onFilterFactory(state)
            };
        };
    };
    const $06b8144acd42bd1f$var$mapDispatchToProps = {
        onAdd: (0, (0, parcelRequire("26mQL")).initiate)
    };
    var $06b8144acd42bd1f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("6E8KZ")).connect)($06b8144acd42bd1f$var$mapStateToPropsFactory, $06b8144acd42bd1f$var$mapDispatchToProps)((0, (0, parcelRequire("1F2yg")).default));
});
parcelRegister("1F2yg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$197bfc3e7904115c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $197bfc3e7904115c$export$2e2bcd8739ae039(props) {
        const { HeaderView: HeaderView, hasEntities: hasEntities, onAdd: onAdd, onFilter: onFilter } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(HeaderView, {
            hasEntities: hasEntities,
            onAdd: onAdd,
            onFilter: onFilter
        });
    }
});
parcelRegister("1zjdB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c7e92938aa45f06$export$2e2bcd8739ae039);
    var $8QpSo;
    var $bC2fB;
    var $6E8KZ;
    var $eVVoZ;
    var $hNlad;
    const $6c7e92938aa45f06$var$mapStateToPropsFactory = ()=>{
        const onPageChangeFactory = (0, (0, parcelRequire("8QpSo")).default)((state)=>(event, page)=>(0, (0, parcelRequire("eVVoZ")).getOnReload)(state)({
                    page: page
                }));
        return (state)=>({
                currentPage: (0, (0, parcelRequire("eVVoZ")).getPage)(state),
                totalPages: (0, (0, parcelRequire("eVVoZ")).getTotalPages)(state),
                onPageChange: onPageChangeFactory(state)
            });
    };
    var $6c7e92938aa45f06$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($6c7e92938aa45f06$var$mapStateToPropsFactory, {}, null, (0, (0, parcelRequire("6E8KZ")).storeOptions))((0, (0, parcelRequire("hNlad")).default));
});
parcelRegister("hNlad", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83c4a3856827caa5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $iASWI = parcelRequire("iASWI");
    var $xBgAj;
    var $az4zD;
    var $8zOmE;
    var $4iWLf;
    function $83c4a3856827caa5$var$Paginator(props) {
        const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = props;
        const onPageChange = (data, event, analyticsEvent)=>{
            props.onPageChange(data, event);
            if (analyticsEvent) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'pagination');
        };
        if (totalPages > 1) return (0, ($parcel$interopDefault($5uXOq))).createElement($83c4a3856827caa5$var$Container, {
            "data-test-id": "global-pages.directories.directory-base.content.paginator.container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xBgAj")).default), {
            selectedIndex: currentPage - 1,
            onChange: onPageChange,
            pages: (0, ($parcel$interopDefault($iASWI)))(1, totalPages + 1),
            previousLabel: formatMessage((0, (0, parcelRequire("4iWLf")).default).previousButton),
            nextLabel: formatMessage((0, (0, parcelRequire("4iWLf")).default).nextButton)
        }));
        return null;
    }
    var $83c4a3856827caa5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($83c4a3856827caa5$var$Paginator);
    const $83c4a3856827caa5$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3td1ejb _18u0xmi2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iASWI", function(module, exports) {
    var $irTmi = parcelRequire("irTmi");
    var $d89635f071f7433a$var$range = $irTmi();
    module.exports = $d89635f071f7433a$var$range;
});
parcelRegister("irTmi", function(module, exports) {
    var $7DMj9 = parcelRequire("7DMj9");
    var $4rDUz = parcelRequire("4rDUz");
    var $kJ0Lf = parcelRequire("kJ0Lf");
    function $d6e5b0af0cc26ead$var$createRange(fromRight) {
        return function(start, end, step) {
            if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
            start = $kJ0Lf(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = $kJ0Lf(end);
            step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
            return $7DMj9(start, end, step, fromRight);
        };
    }
    module.exports = $d6e5b0af0cc26ead$var$createRange;
});
parcelRegister("7DMj9", function(module, exports) {
    var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
    function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
        var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
        while(length--){
            result[fromRight ? length : ++index] = start;
            start += step;
        }
        return result;
    }
    module.exports = $5901a5dd7694a169$var$baseRange;
});
parcelRegister("xBgAj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8aaadfaafd170b3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $33etG;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $5HBW9;
    var $15F6T;
    var $lmPue;
    var $fc5SA;
    var $gRWrA;
    const $8aaadfaafd170b3c$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $8aaadfaafd170b3c$var$paginationMenuStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $8aaadfaafd170b3c$var$paginationMenuItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $8aaadfaafd170b3c$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.075'
    });
    function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))) : (0, ($parcel$interopDefault((0, parcelRequire("6s76W")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $8aaadfaafd170b3c$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, (0, parcelRequire("fc5SA")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("fc5SA")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("lmPue")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("33etG")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$8aaadfaafd170b3c$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                as: "li",
                xcss: $8aaadfaafd170b3c$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("15F6T")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $8aaadfaafd170b3c$var$paginationMenuStyles
        }, (0, (0, parcelRequire("gRWrA")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $8aaadfaafd170b3c$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
    var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("5HBW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63acbbc2953d9b5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("15F6T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097dd42f19f41562$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("lmPue", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d144cd0d91a90ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $jldZL;
    const $3d144cd0d91a90ab$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $3d144cd0d91a90ab$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("fc5SA", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$cbef1c2cfb373aca$export$3f860eba1218f8d3);
    const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};
});
parcelRegister("gRWrA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48fbac64848b775a$export$2e2bcd8739ae039);
    var $8QpSo;
    const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;
});
parcelRegister("4iWLf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f9b7bf6876a52ce$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3f9b7bf6876a52ce$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        previousButton: {
            "id": "directory-base.content.paginator.previous-button",
            "defaultMessage": "Prev"
        },
        nextButton: {
            "id": "directory-base.content.paginator.next-button",
            "defaultMessage": "Next"
        }
    });
});
parcelRegister("do0bP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cca8b4269a3eb958$export$2e2bcd8739ae039);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $8QpSo;
    var $6E8KZ;
    var $lxmKy;
    var $eVVoZ;
    var $d0BRN;
    var $c3kRB;
    var $joT8a;
    const $cca8b4269a3eb958$var$getSpotlightForCellSelectorMemoized = ()=>(0, $dGvGJ.createSelector)((state)=>(0, (0, parcelRequire("eVVoZ")).getSpotlightForCell)(state), (res)=>res);
    const $cca8b4269a3eb958$var$mapStateToPropsFactory = ()=>{
        const getSpotlightForCellSelectorInstance = $cca8b4269a3eb958$var$getSpotlightForCellSelectorMemoized();
        const onSortFactory = (0, (0, parcelRequire("8QpSo")).default)((state)=>(sort)=>(0, (0, parcelRequire("eVVoZ")).getOnReload)(state)({
                    page: 1,
                    ...sort
                }));
        return (state)=>{
            const EmptyView = (0, (0, parcelRequire("eVVoZ")).getEmptyFilterResultConfiguration)(state).View || (0, (0, parcelRequire("c3kRB")).default);
            const TableMaskView = (0, (0, parcelRequire("eVVoZ")).getTableMaskView)(state);
            const filter = (0, (0, parcelRequire("eVVoZ")).getFilter)(state);
            const filterQuery = filter ? filter.query : '';
            return {
                tableConfiguration: (0, (0, parcelRequire("eVVoZ")).getTableConfiguration)(state),
                tableLabel: (0, (0, parcelRequire("eVVoZ")).getTableLabel)(state),
                resultsAnnouncerMessage: (0, (0, parcelRequire("eVVoZ")).getResultsAnnouncerMessage)(state),
                EmptyView: EmptyView,
                TableMaskView: TableMaskView,
                dataProvider: (0, (0, parcelRequire("eVVoZ")).getDataProvider)(state),
                entityIds: (0, (0, parcelRequire("eVVoZ")).getEntityIds)(state),
                totalItems: (0, (0, parcelRequire("eVVoZ")).getTotalItems)(state),
                operationInitializationStatusPerEntity: (0, (0, parcelRequire("eVVoZ")).getOperationInitializationStatusPerEntity)(state),
                isLoading: (0, (0, parcelRequire("eVVoZ")).isLoading)(state),
                sortField: (0, (0, parcelRequire("eVVoZ")).getSortField)(state),
                sortDirection: (0, (0, parcelRequire("eVVoZ")).getSortDirection)(state),
                onSort: onSortFactory(state),
                mountMetricKey: (0, (0, parcelRequire("d0BRN")).getTableMountedMetricKey)(state),
                getSpotlightForCell: getSpotlightForCellSelectorInstance(state),
                firstColumnHeadingAlignment: (0, (0, parcelRequire("eVVoZ")).getFirstColumnHeadingAlignment)(state),
                lastColumnHeadingAlignment: (0, (0, parcelRequire("eVVoZ")).getLastColumnHeadingAlignment)(state),
                filterQuery: filterQuery
            };
        };
    };
    const $cca8b4269a3eb958$var$mapDispatchToProps = {
        onOperationRequested: (0, (0, parcelRequire("lxmKy")).initiate)
    };
    var $cca8b4269a3eb958$export$2e2bcd8739ae039 = (0, (0, parcelRequire("6E8KZ")).connect)($cca8b4269a3eb958$var$mapStateToPropsFactory, $cca8b4269a3eb958$var$mapDispatchToProps)((0, (0, parcelRequire("joT8a")).default));
});
parcelRegister("d0BRN", function(module, exports) {
    $parcel$export(module.exports, "getTableMountedMetricKey", ()=>$fda68c97331475d3$export$b6c1493984bb04f9);
    const $fda68c97331475d3$export$b6c1493984bb04f9 = (state)=>state.app.props.metrics.tableMounted;
});
parcelRegister("c3kRB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68cb0124d97ea366$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6E8KZ;
    var $eVVoZ;
    var $dh6ia;
    const $68cb0124d97ea366$var$mapStateToProps = (state)=>{
        const configuration = (0, (0, parcelRequire("eVVoZ")).getEmptyFilterResultConfiguration)(state);
        if (!configuration.message) throw new Error('Invalid state - Default empty view should not be mounted');
        return {
            message: configuration.message
        };
    };
    var $68cb0124d97ea366$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($68cb0124d97ea366$var$mapStateToProps, null, null, (0, (0, parcelRequire("6E8KZ")).storeOptions))((0, (0, parcelRequire("dh6ia")).default));
});
parcelRegister("dh6ia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d730ce5cb03c7be1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hTEpF;
    var $8RXs9;
    var $b3sGD = parcelRequire("b3sGD");
    function $d730ce5cb03c7be1$var$DefaultEmptyView(props) {
        const { message: message } = props;
        const { intl: { formatMessage: formatMessage } } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-test-id": "global-pages.directories.directory-base.content.table.default-empty-view.empty-state"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            imageUrl: (0, ($parcel$interopDefault($b3sGD))),
            header: formatMessage(message),
            size: "narrow"
        }));
    }
    var $d730ce5cb03c7be1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($d730ce5cb03c7be1$var$DefaultEmptyView);
});
parcelRegister("b3sGD", function(module, exports) {
    module.exports = new URL("generic-no-results.fb302821.svg", import.meta.url).toString();
});
parcelRegister("joT8a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c01d48f0796d7f8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2sHuS = parcelRequire("2sHuS");
    var $dHbUn;
    var $5Fk4Z;
    var $kgoHi;
    var $8CUq3;
    var $fraBZ;
    var $4R6GH;
    var $az4zD;
    var $8zOmE;
    var $dCm1o;
    var $l3DlM;
    var $8Tb2p;
    class $5c01d48f0796d7f8$var$Table extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isLoading: false,
                entityIds: [],
                totalItems: 0,
                sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
                mountMetricKey: undefined,
                getSpotlightForCell: (0, ($parcel$interopDefault($8Rkzz))),
                TableMaskView: undefined,
                firstColumnHeadingAlignment: 'left',
                lastColumnHeadingAlignment: 'left',
                filterQuery: '',
                tableLabel: undefined,
                resultsAnnouncerMessage: (0, (0, parcelRequire("8Tb2p")).default).filterResultsAnnouncement,
                onSort: (0, ($parcel$interopDefault($8Rkzz))),
                onOperationRequested: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        componentDidUpdate(prevProps) {
            if (prevProps.sortDirection !== this.props.sortDirection || prevProps.sortField !== this.props.sortField) this.state.hasSortingChanged = true;
            if (!prevProps.isLoading && this.props.isLoading) this.state.shouldAnnounceResults = !this.state.hasSortingChanged;
            else if (prevProps.isLoading && !this.props.isLoading) this.state.hasSortingChanged = false;
        }
        render() {
            const { tableConfiguration: tableConfiguration, entityIds: entityIds, totalItems: totalItems, EmptyView: EmptyView, isLoading: isLoading, operationInitializationStatusPerEntity: operationInitializationStatusPerEntity, sortField: sortField, sortDirection: sortDirection, mountMetricKey: mountMetricKey, getSpotlightForCell: getSpotlightForCell, TableMaskView: TableMaskView, dataProvider: dataProvider, firstColumnHeadingAlignment: firstColumnHeadingAlignment, lastColumnHeadingAlignment: lastColumnHeadingAlignment, intl: { formatMessage: formatMessage }, tableLabel: tableLabel, resultsAnnouncerMessage: resultsAnnouncerMessage } = this.props;
            const headCells = tableConfiguration.map(({ title: title, width: width, sortField: cellSortField, dataTestId: dataTestId })=>{
                let content = '';
                const wrapperProps = dataTestId ? {
                    'data-test-id': dataTestId
                } : {};
                if (dataTestId) content = (0, ($parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$NonBreakingCell, wrapperProps);
                if (typeof title === 'function') {
                    const HeaderCell = title;
                    content = (0, ($parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$HeaderWrapper, wrapperProps, (0, ($parcel$interopDefault($5uXOq))).createElement(HeaderCell, null));
                } else if (typeof title !== 'undefined') {
                    const message = title;
                    content = (0, ($parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$NonBreakingCell, wrapperProps, formatMessage(message));
                }
                return {
                    key: cellSortField || (0, ($parcel$interopDefault($2sHuS)))(),
                    isSortable: !!cellSortField,
                    content: content,
                    width: width
                };
            });
            const head = {
                cells: headCells
            };
            const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entityIds;
            const tableAriaLabel = tableLabel ? formatMessage(tableLabel) : undefined;
            const rowCells = ids.map((entityId, rowIndex)=>{
                const key = sortDirection === 'DESC' ? -(rowIndex + 1) : rowIndex + 1;
                const entity = dataProvider ? dataProvider.getData()[rowIndex] : undefined;
                const cells = tableConfiguration.map(({ Cell: Cell }, colIndex)=>{
                    const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                        alignItems: "center",
                        xcss: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_2') ? $5c01d48f0796d7f8$var$cellWrapperStyles : undefined
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement(Cell, {
                        id: entityId,
                        entity: entity,
                        isOperationInProgress: !!operationInitializationStatusPerEntity[entityId],
                        onOperationRequested: (operation, operationParams)=>this.props.onOperationRequested({
                                id: entityId,
                                childEntityId: operationParams && operationParams.childEntityId,
                                operation: operation
                            })
                    }));
                    const cellMatch = getSpotlightForCell(entityId, colIndex);
                    if (cellMatch && cellMatch.spotlightId) {
                        const onboardingContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
                            name: cellMatch.spotlightId
                        }, content);
                        return {
                            content: onboardingContent,
                            key: key
                        };
                    }
                    return {
                        content: content,
                        key: key
                    };
                });
                return {
                    cells: cells
                };
            });
            return ((0, ($parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$Container, {
                "data-test-id": "global-pages.directories.directory-base.content.table.container",
                firstColumnHeadingAlignment: firstColumnHeadingAlignment,
                lastColumnHeadingAlignment: lastColumnHeadingAlignment,
                visualRefreshEnabled: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_2')
            }, !isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l3DlM")).default), {
                performanceMarkKey: mountMetricKey
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fraBZ")).AnnouncerV2), {
                message: formatMessage(resultsAnnouncerMessage || (0, (0, parcelRequire("8Tb2p")).default).filterResultsAnnouncement, {
                    itemCount: totalItems
                }),
                shouldAnnounce: !isLoading && this.state.shouldAnnounceResults
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHbUn")).default), {
                isFixedSize: true,
                isLoading: isLoading,
                head: head,
                rows: rowCells,
                onSort: this.onSort,
                sortKey: sortField,
                sortOrder: sortDirection,
                emptyView: isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement($5c01d48f0796d7f8$var$EmptyLoadingView, null) : (0, ($parcel$interopDefault($5uXOq))).createElement(EmptyView, null),
                label: tableAriaLabel
            }), TableMaskView && (0, ($parcel$interopDefault($5uXOq))).createElement(TableMaskView, null)));
        }
        constructor(...args){
            super(...args), this.state = {
                hasSortingChanged: false,
                shouldAnnounceResults: false
            }, this.onSort = (attrs, analyticsEvent)=>{
                const { key: key, sortOrder: sortOrder } = attrs;
                const { onSort: onSort } = this.props;
                if (analyticsEvent) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'tableHeader', {
                    key: key
                });
                onSort({
                    sortField: key,
                    sortDirection: sortOrder
                });
            };
        }
    }
    var $5c01d48f0796d7f8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($5c01d48f0796d7f8$var$Table);
    const $5c01d48f0796d7f8$var$TABLE_ROW_HEIGHT = '40px';
    const $5c01d48f0796d7f8$var$NonBreakingCell = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c",
                __cmplp.className
            ])
        });
    });
    const $5c01d48f0796d7f8$var$cellWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '40px'
    });
    const $5c01d48f0796d7f8$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { firstColumnHeadingAlignment: firstColumnHeadingAlignment, lastColumnHeadingAlignment: lastColumnHeadingAlignment, visualRefreshEnabled: visualRefreshEnabled, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1bgnkvw": (0, (0, parcelRequire("lD23V")).default)(__cmplp.firstColumnHeadingAlignment),
                "--_jlq5ur": (0, (0, parcelRequire("lD23V")).default)(__cmplp.lastColumnHeadingAlignment)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2ws7jp4b _p4liidpf _6autidpf _7dd61ux8 _13jcdlk8 _496idlk8 _9yen1pfg _10wbnkob _jwot4jg8",
                __cmplp.visualRefreshEnabled && "_1s5rzgxb _19ibi2wt _cnoh16g6 _1m2zqbzx _1cuj1ylp _qassi2wt _1g00i2wt",
                __cmplp.className
            ])
        });
    });
    const $5c01d48f0796d7f8$var$EmptyLoadingView = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1w81",
                __cmplp.className
            ])
        });
    });
    const $5c01d48f0796d7f8$var$HeaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dHbUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb6422faa785b221$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $gS5Cm;
    var $hiWL0;
    var $kF3yx;
    var $fkvnY;
    var $hK8cd;
    var $dDBI6;
    var $dk72m;
    var $50Tma;
    var $jlnvO;
    function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
                return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
            case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
                return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("eGmKJ")).default), onSort: providedOnSort = (0, (0, parcelRequire("eGmKJ")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("eGmKJ")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("eGmKJ")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("gS5Cm")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("gS5Cm")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dk72m")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jlnvO")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("50Tma")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dDBI6")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $cb6422faa785b221$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("f9SMa")));
    const $cb6422faa785b221$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkvnY")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hK8cd")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;
});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;
parcelRegister("gS5Cm", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$7f55105045703159$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$7f55105045703159$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$7f55105045703159$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$7f55105045703159$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$7f55105045703159$export$c476bbe5da59992d);
    const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("hiWL0", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $3b29b0d00cd7b5c6$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $3b29b0d00cd7b5c6$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`
    });
    const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).highlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverHighlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("54lmm")).row).focusOutline
            },
            css: [
                $3b29b0d00cd7b5c6$var$tableStyles,
                isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
                hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $3b29b0d00cd7b5c6$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $3b29b0d00cd7b5c6$var$captionStyles
        }, children);
    const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("54lmm", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$b728acac6d8ee4bc$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$b728acac6d8ee4bc$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$b728acac6d8ee4bc$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$b728acac6d8ee4bc$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$b728acac6d8ee4bc$export$38d703b73e2cf64d);
    const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
    };
    const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("kF3yx", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$0852c529eaab7231$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$0852c529eaab7231$export$381ea436de119582);
    var $f8Sb3;
    function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0852c529eaab7231$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $0852c529eaab7231$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("fkvnY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32bba7afdbc8736a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7bJDt;
    var $ggqAE;
    class $32bba7afdbc8736a$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ggqAE")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $32bba7afdbc8736a$var$Body = (0, (0, parcelRequire("7bJDt")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;
});
parcelRegister("7bJDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc6eeecb3dc05edd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("gS5Cm")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("ggqAE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$136b57fea50cecd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1g0dL;
    var $d9WgS;
    const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9WgS")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1g0dL")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;
});
parcelRegister("1g0dL", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$11c3ea74eda01ab8$export$948e91fcef170792);
    var $f8Sb3;
    var $9GQPi;
    const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                (0, (0, parcelRequire("9GQPi")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("9GQPi", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$99c9652c1fab2b08$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$99c9652c1fab2b08$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$99c9652c1fab2b08$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$99c9652c1fab2b08$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$99c9652c1fab2b08$export$f7913df521f684e2);
    var $f8Sb3;
    function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $99c9652c1fab2b08$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
    });
    const $99c9652c1fab2b08$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $99c9652c1fab2b08$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("d9WgS", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$ba9cb59faf06ce7f$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hiWL0;
    const $ba9cb59faf06ce7f$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $ba9cb59faf06ce7f$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $ba9cb59faf06ce7f$var$rowStyles,
                isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("hK8cd", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$883137116243a6a0$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $883137116243a6a0$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("dDBI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4b90b361173610$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $lLAKY;
    class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("lLAKY", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$d0e2766ad96d94ad$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$d0e2766ad96d94ad$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$d0e2766ad96d94ad$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
    const $d0e2766ad96d94ad$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $d0e2766ad96d94ad$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $d0e2766ad96d94ad$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("dk72m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba39c903b39a83b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $4xXH4;
    class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args), this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            }, this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            }, this.componentWillUnmount = ()=>{
                this.detachListeners();
            }, this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            }, this.handleResize = ()=>{
                this.updateSpinnerPosition();
            }, this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            }, this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("4xXH4", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$48301faf1109874f$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$48301faf1109874f$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$48301faf1109874f$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48301faf1109874f$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $48301faf1109874f$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $48301faf1109874f$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $48301faf1109874f$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $48301faf1109874f$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("50Tma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21d5ee5c6331aeb9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $xBgAj;
    class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xBgAj")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("jlnvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097ee65829e33b82$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    var $9Ooyy;
    var $a41RA;
    var $dpXLF;
    class $097ee65829e33b82$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("gS5Cm")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("a41RA")).default) : (0, (0, parcelRequire("dpXLF")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;
});
parcelRegister("9Ooyy", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$e002e0403dc403bb$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$e002e0403dc403bb$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    var $9GQPi;
    function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $e002e0403dc403bb$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $e002e0403dc403bb$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $e002e0403dc403bb$var$headStyles,
                isRanking && $e002e0403dc403bb$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $e002e0403dc403bb$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $e002e0403dc403bb$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $e002e0403dc403bb$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("54lmm")).head).textColor
        };
        const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("9GQPi")).cellStyles),
                $e002e0403dc403bb$var$headCellBaseStyles,
                onClick && $e002e0403dc403bb$var$onClickStyles,
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                isSortable && $e002e0403dc403bb$var$baseStyles,
                isASC && $e002e0403dc403bb$var$ascendingStyles,
                isDESC && $e002e0403dc403bb$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("a41RA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$669a06e89a9827f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cVljL;
    var $gS5Cm;
    var $dpXLF;
    class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("gS5Cm")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dpXLF")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $669a06e89a9827f7$var$RankableTableHeadCell = (0, (0, parcelRequire("cVljL")).default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
    var $669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;
});
parcelRegister("cVljL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3e49a9b167764eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    refWidth: 0,
                    refHeight: 0
                }, this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                }, this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("dpXLF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9c80f4a483cfd6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Ooyy;
    const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;
});
parcelRegister("f9SMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bz1jP")
    ]).then(()=>parcelRequire('4THp8'));
});
parcelRegister("fraBZ", function(module, exports) {
    $parcel$export(module.exports, "AnnouncerV2", ()=>$f73a83ae5cba96ea$export$a43c8a2f4981e0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dqoiX;
    const $f73a83ae5cba96ea$var$NON_BREAKING_SPACE = '\u00A0';
    const $f73a83ae5cba96ea$export$a43c8a2f4981e0e = (0, $5uXOq.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
        const previousMessage = (0, $5uXOq.useRef)('');
        const setAlternatePolite = (0, $5uXOq.useRef)(false);
        const addSuffix = (0, $5uXOq.useRef)(false);
        const [oldMessage, setOldMessage] = (0, $5uXOq.useState)('');
        const [newMessage, setNewMessage] = (0, $5uXOq.useState)('');
        (0, $5uXOq.useEffect)(()=>{
            let message = shouldAnnounce ? originalMessage : $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
            if (previousMessage.current === message) {
                addSuffix.current = !addSuffix.current;
                if (addSuffix.current) message += $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
            }
            setOldMessage(setAlternatePolite.current ? '' : message);
            setNewMessage(setAlternatePolite.current ? message : '');
            if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
            previousMessage.current = originalMessage;
        }, [
            originalMessage,
            shouldAnnounce
        ]);
        return $5uXOq.createElement("div", {
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            role: "status",
            "aria-live": liveMode,
            "aria-relevant": "additions text",
            "aria-atomic": "true"
        }, oldMessage), $5uXOq.createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            role: "status",
            "aria-live": liveMode,
            "aria-relevant": "additions text",
            "aria-atomic": "true"
        }, newMessage));
    });
    const $f73a83ae5cba96ea$var$positionRelative = null;
});
parcelRegister("dqoiX", function(module, exports) {
    $parcel$export(module.exports, "visuallyHiddenStyles", ()=>$11827e0613b04108$export$8dd524ceb40e3d16);
    $parcel$export(module.exports, "ScreenReaderText", ()=>$11827e0613b04108$export$88fad6aa294f111c);
    $parcel$export(module.exports, "ScreenReaderCaption", ()=>$11827e0613b04108$export$200c8e5d652aa9af);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $11827e0613b04108$export$8dd524ceb40e3d16 = {
        clip: 'rect(1px, 1px, 1px, 1px)',
        clipPath: 'inset(50%)',
        height: '1px',
        width: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute'
    };
    const $11827e0613b04108$export$88fad6aa294f111c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
    const $11827e0613b04108$export$200c8e5d652aa9af = (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8Tb2p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ccc3b7593e6b203$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3ccc3b7593e6b203$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterResultAnnounce: {
            "id": "directory-base.content.table.filter-result-announce",
            "defaultMessage": "{itemCount, plural, one {One item was found after filtering.} other {{itemCount} items were found after filtering.}}"
        },
        filterResultsAnnouncement: {
            "id": "directory-base.content.table.filter-results-announcement",
            "defaultMessage": "{itemCount, plural, =0 {No results were found that match your search} one {{itemCount} result found} other {{itemCount} results found}}"
        }
    });
});
parcelRegister("gO9Up", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c83f1ab25cac0ee$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $imZsD;
    var $3HwlS;
    const $8c83f1ab25cac0ee$var$styles = {
        pageContainerNav3: "_1ul94na8"
    };
    function $8c83f1ab25cac0ee$export$2e2bcd8739ae039(props) {
        const { Header: Header, Table: Table, Paginator: Paginator, Empty: Empty, Error: Error, status: status, onAdd: onAdd, onRetry: onRetry, isOnboardingEnabled: isOnboardingEnabled, renderOnboardingSpotlight: renderOnboardingSpotlight, availableSpotlightTargets: availableSpotlightTargets } = props;
        let main = null;
        let spotlight = null;
        switch(status){
            case 'has-entities':
                main = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Table, null), (0, ($parcel$interopDefault($5uXOq))).createElement(Paginator, null));
                spotlight = isOnboardingEnabled && renderOnboardingSpotlight && renderOnboardingSpotlight(availableSpotlightTargets);
                break;
            case 'empty':
                main = Empty ? (0, ($parcel$interopDefault($5uXOq))).createElement(Empty, {
                    onAdd: onAdd
                }) : null;
                break;
            case 'error':
                main = Error ? (0, ($parcel$interopDefault($5uXOq))).createElement(Error, {
                    onRetry: onRetry
                }) : null;
                break;
            default:
                break;
        }
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, spotlight, Header ? (0, ($parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $8c83f1ab25cac0ee$var$styles.pageContainerNav3
            ])
        }, spotlight, Header ? (0, ($parcel$interopDefault($5uXOq))).createElement(Header, null) : null, main));
    }
    $8c83f1ab25cac0ee$export$2e2bcd8739ae039.defaultProps = {
        isOnboardingEnabled: false,
        renderOnboardingSpotlight: ()=>null,
        availableSpotlightTargets: [],
        onAdd: (0, ($parcel$interopDefault($8Rkzz))),
        onRetry: (0, ($parcel$interopDefault($8Rkzz)))
    };
});
parcelRegister("gZxo5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad9e30bbc17bbf06$export$2e2bcd8739ae039);
    var $6E8KZ;
    var $eVVoZ;
    var $7vDsW;
    var $dXqrk;
    var $jd28H;
    const $ad9e30bbc17bbf06$var$mapStateToProps = (state)=>({
            isCreateModalShown: (0, (0, parcelRequire("eVVoZ")).isCreateOpen)(state),
            CreateModal: (0, parcelRequire("7vDsW")).default,
            operations: (0, (0, parcelRequire("eVVoZ")).getOperations)(state),
            OperationModal: (0, parcelRequire("dXqrk")).default
        });
    var $ad9e30bbc17bbf06$export$2e2bcd8739ae039 = (0, (0, parcelRequire("6E8KZ")).connect)($ad9e30bbc17bbf06$var$mapStateToProps, {})((0, (0, parcelRequire("jd28H")).default));
});
parcelRegister("7vDsW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7d32de1c8b6343c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6E8KZ;
    var $26mQL;
    var $eVVoZ;
    var $k3e3M;
    const $f7d32de1c8b6343c$var$mapStateToProps = (state)=>{
        const CreateModal = (0, (0, parcelRequire("eVVoZ")).getCreateModal)(state);
        if (!CreateModal) throw new Error('Invalid state - no Create Modal provided');
        return {
            CreateModal: CreateModal
        };
    };
    const $f7d32de1c8b6343c$var$mapDispatchToProps = {
        onCreated: (0, (0, parcelRequire("26mQL")).entityCreated),
        onCreateFailed: (0, (0, parcelRequire("26mQL")).entityCreateFailed),
        onCancel: (0, (0, parcelRequire("26mQL")).cancelled)
    };
    var $f7d32de1c8b6343c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($f7d32de1c8b6343c$var$mapStateToProps, $f7d32de1c8b6343c$var$mapDispatchToProps, null, (0, (0, parcelRequire("6E8KZ")).storeOptions))((0, (0, parcelRequire("k3e3M")).default));
});
parcelRegister("k3e3M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4842467b44d7e63d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $4842467b44d7e63d$export$2e2bcd8739ae039(props) {
        const { CreateModal: CreateModal, onCreated: onCreated, onCreateFailed: onCreateFailed, onCancel: onCancel } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(CreateModal, {
            onCreated: onCreated,
            onCreateFailed: onCreateFailed,
            onCancel: onCancel
        });
    }
});
parcelRegister("dXqrk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dde6756d9548826$export$2e2bcd8739ae039);
    var $8QpSo;
    var $6E8KZ;
    var $lxmKy;
    var $eVVoZ;
    var $1jyVQ;
    const $5dde6756d9548826$var$mapStateToPropsFactory = ()=>{
        const onDataRetrievedFactory = (0, (0, parcelRequire("8QpSo")).default)((state, id)=>({ patch: patch })=>(0, (0, parcelRequire("eVVoZ")).getOnPatch)(state)({
                    id: id,
                    patch: patch
                }));
        return (state, ownProps)=>{
            const { id: id, operation: operation } = ownProps;
            return {
                OperationModal: (0, (0, parcelRequire("eVVoZ")).getOperationModal)(state, operation),
                onDataRetrieved: onDataRetrievedFactory(state, id)
            };
        };
    };
    const $5dde6756d9548826$var$mapDispatchToProps = (dispatch, ownProps)=>{
        const { id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing } = ownProps;
        return {
            entityId: id,
            isInitializing: isInitializing,
            onDialogShown: ()=>dispatch((0, (0, parcelRequire("lxmKy")).dialogShown)({
                    id: id,
                    operation: operation,
                    childEntityId: childEntityId
                })),
            onDataRetrieveFailed: ()=>dispatch((0, (0, parcelRequire("lxmKy")).entityDataRetrieveFailed)({
                    id: id,
                    operation: operation
                })),
            onUpdated: ({ patch: patch } = {})=>dispatch((0, (0, parcelRequire("lxmKy")).entityUpdated)({
                    id: id,
                    operation: operation,
                    patch: patch
                })),
            onUpdateFailed: ()=>dispatch((0, (0, parcelRequire("lxmKy")).entityUpdateFailed)({
                    id: id,
                    operation: operation
                })),
            onCancel: ()=>dispatch((0, (0, parcelRequire("lxmKy")).cancelled)({
                    id: id,
                    operation: operation
                }))
        };
    };
    var $5dde6756d9548826$export$2e2bcd8739ae039 = (0, (0, parcelRequire("6E8KZ")).connect)($5dde6756d9548826$var$mapStateToPropsFactory, $5dde6756d9548826$var$mapDispatchToProps)((0, (0, parcelRequire("1jyVQ")).default));
});
parcelRegister("1jyVQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd144476f98eada3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $bd144476f98eada3$export$2e2bcd8739ae039(props) {
        const { OperationModal: OperationModal, ...modalProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(OperationModal, modalProps);
    }
});
parcelRegister("jd28H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5c2b4eef0dc70b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a5c2b4eef0dc70b8$export$2e2bcd8739ae039(props) {
        const { isCreateModalShown: isCreateModalShown, CreateModal: CreateModal, operations: operations, OperationModal: OperationModal } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, isCreateModalShown && (0, ($parcel$interopDefault($5uXOq))).createElement(CreateModal, null), operations.map(({ id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing })=>(0, ($parcel$interopDefault($5uXOq))).createElement(OperationModal, {
                key: id,
                id: id,
                operation: operation,
                childEntityId: childEntityId,
                isInitializing: isInitializing
            })));
    }
});
parcelRegister("1Evzn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$17f4de78934b94b3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $17f4de78934b94b3$export$2e2bcd8739ae039(props) {
        const { Content: Content, Modals: Modals } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Content, null), (0, ($parcel$interopDefault($5uXOq))).createElement(Modals, null));
    }
});
parcelRegister("b9OA0", function(module, exports) {
    $parcel$export(module.exports, "getIds", ()=>$644d9d1cda833da7$export$24b60fe7179439bc);
    $parcel$export(module.exports, "getTotal", ()=>$644d9d1cda833da7$export$94860ac4a286a8d9);
    $parcel$export(module.exports, "isLoading", ()=>$644d9d1cda833da7$export$20bb0d907fbbe433);
    $parcel$export(module.exports, "isError", ()=>$644d9d1cda833da7$export$e6127cc7fe7395c3);
    $parcel$export(module.exports, "getName", ()=>$644d9d1cda833da7$export$7d9f7e9c1c02b41e);
    $parcel$export(module.exports, "getDescription", ()=>$644d9d1cda833da7$export$67580b1c13935958);
    $parcel$export(module.exports, "getOwner", ()=>$644d9d1cda833da7$export$5f4ed0d56c2c0edf);
    $parcel$export(module.exports, "getViewUrl", ()=>$644d9d1cda833da7$export$bdccd6a672e4a607);
    $parcel$export(module.exports, "getShares", ()=>$644d9d1cda833da7$export$3b3cfad4475f6525);
    $parcel$export(module.exports, "getEdits", ()=>$644d9d1cda833da7$export$ade2933f0cc600b);
    $parcel$export(module.exports, "getFilter", ()=>$644d9d1cda833da7$export$61ec8404f465cd36);
    $parcel$export(module.exports, "getIsWritable", ()=>$644d9d1cda833da7$export$8e04de5241998cf7);
    $parcel$export(module.exports, "manageSubscriptionsUrl", ()=>$644d9d1cda833da7$export$e68f39a61961e36b);
    $parcel$export(module.exports, "getChangeFavorite", ()=>$644d9d1cda833da7$export$85b24bd43a2bd6cf);
    $parcel$export(module.exports, "isFavorite", ()=>$644d9d1cda833da7$export$70b3463aa7e3e514);
    $parcel$export(module.exports, "isPending", ()=>$644d9d1cda833da7$export$872dec21e9a69476);
    $parcel$export(module.exports, "getPopularity", ()=>$644d9d1cda833da7$export$34145270e160ba15);
    var $ebyGx = parcelRequire("ebyGx");
    var $hXBjD;
    const $644d9d1cda833da7$export$dd1bc94b04021eeb = (state)=>state.filters.order.length === 0;
    const $644d9d1cda833da7$export$24b60fe7179439bc = (state)=>state.filters.order;
    const $644d9d1cda833da7$export$94860ac4a286a8d9 = (state)=>state.filters.total;
    const $644d9d1cda833da7$export$20bb0d907fbbe433 = (state)=>state.filters.isLoading;
    const $644d9d1cda833da7$export$e6127cc7fe7395c3 = (state)=>state.filters.isError;
    const $644d9d1cda833da7$export$7d9f7e9c1c02b41e = (state, id)=>state.filters.page[id]?.name;
    const $644d9d1cda833da7$export$67580b1c13935958 = (state, id)=>state.filters.page[id]?.description;
    const $644d9d1cda833da7$export$5f4ed0d56c2c0edf = (state, id)=>state.filters.page[id]?.owner;
    const $644d9d1cda833da7$export$bdccd6a672e4a607 = (state, id)=>state.filters.page[id]?.viewUrl;
    const $644d9d1cda833da7$export$3b3cfad4475f6525 = (state, id)=>state.filters.page[id]?.shares;
    const $644d9d1cda833da7$export$ade2933f0cc600b = (state, id)=>state.filters.page[id]?.edits;
    const $644d9d1cda833da7$export$61ec8404f465cd36 = (state, id)=>state.filters.page[id];
    const $644d9d1cda833da7$export$8e04de5241998cf7 = (state, id)=>state.filters.page[id]?.isWritable || false;
    const $644d9d1cda833da7$export$9b4c238bf352f0c9 = (actionType)=>(state, filterId)=>{
            const xsrfToken = (0, (0, parcelRequire("hXBjD")).getXsrfToken)(state);
            const parsed = (0, ($parcel$interopDefault($ebyGx))).stringify({
                atl_token: xsrfToken,
                returnUrl: 'ManageFilters.jspa',
                filterId: filterId
            });
            return `/${actionType}!default.jspa?${parsed}`;
        };
    const $644d9d1cda833da7$export$e68f39a61961e36b = $644d9d1cda833da7$export$9b4c238bf352f0c9('ViewSubscriptions');
    const $644d9d1cda833da7$var$getFavoriteChangeContext = (state)=>state.app.props.favoriteChangeContext;
    const $644d9d1cda833da7$export$85b24bd43a2bd6cf = (state)=>{
        const context = $644d9d1cda833da7$var$getFavoriteChangeContext(state);
        return context && context.changeFavorite;
    };
    const $644d9d1cda833da7$var$getChangedFilter = (state, id)=>{
        const context = $644d9d1cda833da7$var$getFavoriteChangeContext(state);
        return context && context.items.filters[id];
    };
    const $644d9d1cda833da7$var$getIsFavoriteFromState = (state, id)=>state.page[id]?.isFavourite;
    const $644d9d1cda833da7$var$getPopularityFromState = (state, id)=>state.page[id]?.popularity;
    const $644d9d1cda833da7$export$70b3463aa7e3e514 = (state, id)=>{
        const itemChanged = $644d9d1cda833da7$var$getChangedFilter(state, id);
        return itemChanged ? itemChanged.value : $644d9d1cda833da7$var$getIsFavoriteFromState(state.filters, id);
    };
    const $644d9d1cda833da7$export$872dec21e9a69476 = (state, id)=>{
        const item = $644d9d1cda833da7$var$getChangedFilter(state, id);
        return !!(item && item.pending);
    };
    const $644d9d1cda833da7$export$34145270e160ba15 = (state, id)=>{
        const popularityInState = $644d9d1cda833da7$var$getPopularityFromState(state.filters, id);
        const isFavoriteInState = $644d9d1cda833da7$var$getIsFavoriteFromState(state.filters, id);
        const item = $644d9d1cda833da7$var$getChangedFilter(state, id);
        if (!item) return popularityInState;
        if (item.value && !isFavoriteInState && popularityInState) return popularityInState + 1;
        if (!item.value && isFavoriteInState && popularityInState) return popularityInState - 1;
        return popularityInState;
    };
});
parcelRegister("lOB3Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58a07c47635c495b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hTEpF;
    var $ousew;
    var $az4zD;
    var $9wjVQ = parcelRequire("9wjVQ");
    var $jELjD;
    function $58a07c47635c495b$var$Empty({ intl: { formatMessage: formatMessage } }) {
        const description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("jELjD")).default).description,
            values: {
                viewAllIssues: (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, formatMessage((0, (0, parcelRequire("jELjD")).default).viewAllIssues)),
                saveFilterAs: (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, formatMessage((0, (0, parcelRequire("jELjD")).default).saveFilterAs))
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            imageUrl: (0, ($parcel$interopDefault($9wjVQ))),
            header: formatMessage((0, (0, parcelRequire("jELjD")).default).header),
            description: description,
            headingLevel: 2
        });
    }
    var $58a07c47635c495b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($58a07c47635c495b$var$Empty);
});
parcelRegister("9wjVQ", function(module, exports) {
    module.exports = new URL("empty.368985dc.svg", import.meta.url).toString();
});
parcelRegister("jELjD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$109a7738ed819bd4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $109a7738ed819bd4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "directories.filters-v2.main.content.empty.header",
            "defaultMessage": "You don't have any filters"
        },
        description: {
            "id": "directories.filters-v2.main.content.empty.description",
            "defaultMessage": "You can create a filter by searching. Select {viewAllIssues} option from the Filters top bar item and enter your search criteria. Then, select {saveFilterAs} to create a filter"
        },
        viewAllIssues: {
            "id": "directories.filters-v2.main.content.empty.view-all-issues",
            "defaultMessage": "View all issues"
        },
        saveFilterAs: {
            "id": "directories.filters-v2.main.content.empty.save-filter-as",
            "defaultMessage": "Save filter"
        }
    });
});
parcelRegister("hdUWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07fb65c497884ecc$export$2e2bcd8739ae039);
    var $bC2fB;
    var $b9OA0;
    var $blhJn;
    const $07fb65c497884ecc$var$mapStateToProps = (state)=>({
            isLoading: (0, (0, parcelRequire("b9OA0")).isLoading)(state)
        });
    var $07fb65c497884ecc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($07fb65c497884ecc$var$mapStateToProps, {})((0, (0, parcelRequire("blhJn")).default));
});
parcelRegister("blhJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d60c1c435a7ef60$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eae50;
    var $koVbs;
    var $6Nspm;
    function $0d60c1c435a7ef60$var$Error(props) {
        const { isLoading: isLoading, onRetry: onRetry } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eae50")).default), {
            header: formatMessage((0, (0, parcelRequire("6Nspm")).default).header),
            description: formatMessage((0, (0, parcelRequire("6Nspm")).default).description),
            isLoading: isLoading,
            onRetry: onRetry,
            headingLevel: 2
        });
    }
    $0d60c1c435a7ef60$var$Error.defaultProps = {
        isLoading: false
    };
    var $0d60c1c435a7ef60$export$2e2bcd8739ae039 = $0d60c1c435a7ef60$var$Error;
});
parcelRegister("eae50", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da809c0c454ce05f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $hTEpF;
    var $co1wz;
    var $4R6GH;
    var $az4zD;
    var $lB1Xg = parcelRequire("lB1Xg");
    var $9Le4I = parcelRequire("9Le4I");
    var $63TJV;
    function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
        const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
        const buttonAppearance = isSubtle ? 'default' : 'primary';
        const defaultImageUrl = isSubtle ? (0, ($parcel$interopDefault($lB1Xg))) : (0, ($parcel$interopDefault($9Le4I)));
        const fallbackImage = errorImage || defaultImageUrl;
        let imageUrl;
        if ((0, (0, parcelRequire("co1wz")).ff)('jfe-asset-consolidation-itsm-agni_po996')) {
            if (renderErrorImage) imageUrl = undefined;
            else imageUrl = fallbackImage;
        } else imageUrl = fallbackImage;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            testId: "common-components-error-state.empty-state",
            size: size,
            imageWidth: imageWidth,
            imageUrl: imageUrl,
            header: header,
            description: description,
            isLoading: isLoading,
            maxImageHeight: maxImageHeight,
            primaryAction: !onRetry ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: buttonAppearance,
                isDisabled: isLoading,
                onClick: onRetry
            }, formatMessage(retryMessage)),
            renderImage: renderErrorImage,
            headingLevel: (0, (0, parcelRequire("4R6GH")).fg)('blu-4174-enghealth-13917-filters-dir-actions-title') ? headingLevel : undefined
        });
    }
    $da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
        header: '',
        size: 'wide',
        isLoading: false,
        isSubtle: false,
        retryMessage: (0, (0, parcelRequire("63TJV")).default).retry
    };
    var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);
});
parcelRegister("lB1Xg", function(module, exports) {
    module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();
});
parcelRegister("9Le4I", function(module, exports) {
    module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();
});
parcelRegister("63TJV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbeb04399739f055$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        retry: {
            "id": "common.components.error-state.retry-action",
            "defaultMessage": "Try again"
        }
    });
});
parcelRegister("6Nspm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb31d6d707dd59d9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fb31d6d707dd59d9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "directories.filters-v2.main.content.error.header",
            "defaultMessage": "We couldn't load your filters"
        },
        description: {
            "id": "directories.filters-v2.main.content.error.description",
            "defaultMessage": "Give it another try. If you run into more trouble, contact your admin for help."
        }
    });
});
parcelRegister("dCHeQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddd9d68418563101$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $iQv12;
    var $5JMh5;
    var $lMdZA;
    var $fs8YG;
    var $bC2fB;
    var $imOJb;
    var $aRmgJ;
    var $hXBjD;
    var $4biUB;
    var $cOGXp;
    var $lNjU3;
    const $ddd9d68418563101$var$SearchWithAnalytics = (0, (0, parcelRequire("iQv12")).default)({
        onChange: 'search'
    })((0, (0, parcelRequire("5JMh5")).default));
    const $ddd9d68418563101$var$OwnerPickerWithAnalytics = (0, (0, parcelRequire("iQv12")).default)({
        onChange: 'owner'
    })((0, (0, parcelRequire("imOJb")).default));
    const $ddd9d68418563101$var$ProjectTypePickerWithAnalytics = (0, (0, parcelRequire("iQv12")).default)({
        onChange: 'project'
    })((0, (0, parcelRequire("fs8YG")).default));
    const $ddd9d68418563101$var$GroupPickerWithAnalytics = (0, (0, parcelRequire("iQv12")).default)({
        onChange: 'group'
    })((0, (0, parcelRequire("lMdZA")).default));
    const $ddd9d68418563101$var$renderFilterSearch = (state)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ddd9d68418563101$var$SearchWithAnalytics, {
                ...props,
                value: (0, (0, parcelRequire("4biUB")).getSearchQuery)(state),
                isAlwaysExpanded: true
            });
    const $ddd9d68418563101$var$renderOwnerPicker = (state)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ddd9d68418563101$var$OwnerPickerWithAnalytics, {
                ...props,
                selectedUser: (0, (0, parcelRequire("4biUB")).getSelectedOwner)(state),
                suggestedAccountId: (0, (0, parcelRequire("hXBjD")).getAtlassianAccountId)(state),
                baseUrl: (0, (0, parcelRequire("hXBjD")).getBaseUrl)(state),
                isCompact: true
            });
    const $ddd9d68418563101$var$renderProjectPicker = (state)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ddd9d68418563101$var$ProjectTypePickerWithAnalytics, {
                ...props,
                selectedProject: (0, (0, parcelRequire("4biUB")).getSelectedProject)(state),
                baseUrl: (0, (0, parcelRequire("hXBjD")).getBaseUrl)(state),
                isCompact: true
            });
    const $ddd9d68418563101$var$renderGroupPicker = (state)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ddd9d68418563101$var$GroupPickerWithAnalytics, {
                ...props,
                selectedGroup: (0, (0, parcelRequire("4biUB")).getSelectedGroup)(state),
                baseUrl: (0, (0, parcelRequire("hXBjD")).getBaseUrl)(state),
                isCompact: true
            });
    const $ddd9d68418563101$var$renderClear = (state)=>(props)=>(0, (0, parcelRequire("4biUB")).isFilterApplied)(state) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOGXp")).default), props);
    const $ddd9d68418563101$var$mapStateToPropsFactory = ()=>{
        const renderFilterSearchFactory = (0, (0, parcelRequire("8QpSo")).default)($ddd9d68418563101$var$renderFilterSearch);
        const renderOwnerPickerFactory = (0, (0, parcelRequire("8QpSo")).default)($ddd9d68418563101$var$renderOwnerPicker);
        const renderProjectPickerFactory = (0, (0, parcelRequire("8QpSo")).default)($ddd9d68418563101$var$renderProjectPicker);
        const renderGroupPickerFactory = (0, (0, parcelRequire("8QpSo")).default)($ddd9d68418563101$var$renderGroupPicker);
        const renderClearFactory = (0, (0, parcelRequire("8QpSo")).default)($ddd9d68418563101$var$renderClear);
        return (state, ownProps)=>({
                renderFilterSearch: renderFilterSearchFactory(state),
                renderOwnerPicker: renderOwnerPickerFactory(state),
                renderProjectPicker: renderProjectPickerFactory(state),
                renderGroupPicker: renderGroupPickerFactory(state),
                renderClear: renderClearFactory(state),
                initialFilter: (0, (0, parcelRequire("aRmgJ")).initialQuery).filter,
                value: (0, (0, parcelRequire("4biUB")).getFilter)(state),
                onChange: ownProps.onFilter
            });
    };
    var $ddd9d68418563101$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($ddd9d68418563101$var$mapStateToPropsFactory, {})((0, (0, parcelRequire("lNjU3")).default));
});
parcelRegister("iQv12", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$945500a9598c3ac2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gvRPW;
    const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
        const providedKeys = Object.keys(ConnectedProps).sort();
        const cachedMappedProps = {};
        const cachedConnectedProps = {};
        const getStateFromMappedProps = (mapped)=>{
            providedKeys.forEach((key, index)=>{
                const prop = mapped[index];
                if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
                cachedMappedProps[key] = prop;
                cachedConnectedProps[key] = (...attrs)=>{
                    const analyticsEvent = attrs[attrs.length - 1].clone();
                    const connectedProp = ConnectedProps[key];
                    if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                        name: connectedProp,
                        analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                    }).fire();
                    else if (typeof connectedProp === 'function') {
                        const update = connectedProp(...attrs);
                        analyticsEvent.update({
                            ...update,
                            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                        }).fire();
                    }
                    if (typeof prop === 'function') prop(...attrs);
                };
            });
            return cachedConnectedProps;
        };
        return (WrappedComponent)=>class WithAnalytics extends (0, $5uXOq.Component) {
                static{
                    this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
                }
                render() {
                    const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        ...newMappedProps
                    });
                }
            };
    };
    var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;
});
parcelRegister("5JMh5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c6c98eab5c64edc$export$2e2bcd8739ae039);
    var $8oe80;
    var $3as6V;
    var $1c6c98eab5c64edc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('filterSearch', {
        onChange: 'changed'
    })((0, (0, parcelRequire("3as6V")).default));
});
parcelRegister("3as6V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$466d610aa4e058b2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $2xSAL;
    var $dCm1o;
    const $466d610aa4e058b2$export$4c4c11a6ab1f5b09 = 1000;
    const $466d610aa4e058b2$var$debouncedSearch = (0, ($parcel$interopDefault($lFKmC)))((value, callback)=>callback(value), $466d610aa4e058b2$export$4c4c11a6ab1f5b09);
    class $466d610aa4e058b2$var$Filter extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                value: '',
                placeholder: '',
                describedById: '',
                hasAutoFocus: false,
                isCompact: true,
                increasedWidth: false,
                placeholderAlwaysVisible: false
            };
        }
        getSearchValue(value) {
            const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
            if (value !== this.prevSearchValue) {
                this.prevSearchValue = value;
                this.prevQueryValue = value;
            }
            return searchValue;
        }
        render() {
            const searchValue = this.getSearchValue(this.props.value);
            const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2xSAL")).SearchField), {
                ...props,
                autoFocus: autoFocus,
                value: searchValue,
                onChange: this.handleOnChange,
                onEnter: this.handleNewValue,
                ariaLabelText: ariaLabelText,
                showIconBeforeInput: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
            });
        }
        constructor(...args){
            super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
                $466d610aa4e058b2$var$debouncedSearch.cancel();
                if (newValue !== this.props.value) this.props.onChange(newValue);
            }, this.handleOnChange = (newValue)=>{
                this.prevQueryValue = newValue;
                newValue === '' ? this.handleNewValue(newValue) : $466d610aa4e058b2$var$debouncedSearch(newValue, this.handleNewValue);
            };
        }
    }
    var $466d610aa4e058b2$export$2e2bcd8739ae039 = $466d610aa4e058b2$var$Filter;
});
parcelRegister("2xSAL", function(module, exports) {
    $parcel$export(module.exports, "SearchField", ()=>$f115db1c327fbbaa$export$b94867ecbd698f21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $fW62l = parcelRequire("fW62l");
    var $2NMNM;
    var $kY99m;
    var $koVbs;
    var $dCm1o;
    var $cBssJ;
    var $hJBhl;
    var $5yLnO;
    const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
    const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const textInput = (0, $5uXOq.useRef)(null);
        const previousValueRef = (0, $5uXOq.useRef)();
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) setValue(externalValue);
        previousValueRef.current = externalValue;
        const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
            setIsFocused(true);
            onFocus && onFocus(event);
        }, [
            onFocus
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur && onBlur(event);
            setIsFocused(false);
        }, [
            onBlur
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
            const { value: val } = currentTarget;
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue(val);
            onChange(val, analyticsEvent);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            if (event.key === 'Escape') {
                setValue('');
                onChange('', analyticsEvent);
            }
            if (onEnter && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('enter')) {
                event.preventDefault();
                onEnter(event.currentTarget && event.currentTarget.value);
            }
        }, [
            createAnalyticsEvent,
            onChange,
            onEnter
        ]);
        const handleOnClear = (0, $5uXOq.useCallback)(()=>{
            if (value !== '') {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed'
                });
                setValue('');
                onChange('', analyticsEvent);
            }
            if (inputRef && inputRef.current !== null) inputRef.current.blur();
            if (textInput.current !== null) textInput.current.blur();
        }, [
            createAnalyticsEvent,
            inputRef,
            onChange,
            value
        ]);
        const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
        const textFieldProps = {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, (0, parcelRequire("cBssJ")).messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $f115db1c327fbbaa$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
        const searchIconDynamic = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIconDynamic), {
            onClear: handleOnClear,
            hasValue: value !== '',
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear),
            searchIconVisible: searchIconVisible,
            primaryColor: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
            onlyIconSpacing: isResponsive && !isExpanded
        });
        const searchIcon = showIconBeforeInput ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIcon), {
            searchIconVisible: searchIconVisible,
            onlyIconSpacing: isResponsive && !isExpanded
        }) : undefined;
        const clearIcon = showIconBeforeInput && value !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJBhl")).ClearFieldIcon), {
            onClear: handleOnClear,
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear)
        }) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
            shouldFitContainerWidth: shouldFitContainerWidth
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            increasedWidth: increasedWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ...textFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {}
        })));
    };
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
    const $f115db1c327fbbaa$export$b94867ecbd698f21 = (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
    $f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search';
    const $f115db1c327fbbaa$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.shouldFitContainerWidth && "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $f115db1c327fbbaa$var$InputWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1et2rhb": (0, (0, parcelRequire("lD23V")).default)(__cmplp.maxWidth, "px"),
                "--_47juog": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
                "--_5cv8rq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : '32px'),
                "--_jy5l88": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
                "--_1skyi4s": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : 0),
                "--_1qenfck": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 1 : 0),
                "--_1b7586u": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
                "--_1b72lxu": (0, (0, parcelRequire("lD23V")).default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
                __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
                __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fW62l", function(module, exports) {
    function keyCode(searchInput) {
        if (searchInput && 'object' === typeof searchInput) {
            var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
            if (hasKeyCode) searchInput = hasKeyCode;
        }
        if ('number' === typeof searchInput) return names[searchInput];
        var search = String(searchInput);
        var foundNamedKey = codes[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        var foundNamedKey = aliases[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        if (search.length === 1) return search.charCodeAt(0);
        return undefined;
    }
    keyCode.isEventKey = function isEventKey(event, nameOrCode) {
        if (event && 'object' === typeof event) {
            var keyCode = event.which || event.keyCode || event.charCode;
            if (keyCode === null || keyCode === undefined) return false;
            if (typeof nameOrCode === 'string') {
                var foundNamedKey = codes[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
                var foundNamedKey = aliases[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
            } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
            return false;
        }
    };
    exports = module.exports = keyCode;
    var codes = exports.code = exports.codes = {
        'backspace': 8,
        'tab': 9,
        'enter': 13,
        'shift': 16,
        'ctrl': 17,
        'alt': 18,
        'pause/break': 19,
        'caps lock': 20,
        'esc': 27,
        'space': 32,
        'page up': 33,
        'page down': 34,
        'end': 35,
        'home': 36,
        'left': 37,
        'up': 38,
        'right': 39,
        'down': 40,
        'insert': 45,
        'delete': 46,
        'command': 91,
        'left command': 91,
        'right command': 93,
        'numpad *': 106,
        'numpad +': 107,
        'numpad -': 109,
        'numpad .': 110,
        'numpad /': 111,
        'num lock': 144,
        'scroll lock': 145,
        'my computer': 182,
        'my calculator': 183,
        ';': 186,
        '=': 187,
        ',': 188,
        '-': 189,
        '.': 190,
        '/': 191,
        '`': 192,
        '[': 219,
        '\\': 220,
        ']': 221,
        "'": 222
    };
    var aliases = exports.aliases = {
        'windows': 91,
        "\u21E7": 16,
        "\u2325": 18,
        "\u2303": 17,
        "\u2318": 91,
        'ctl': 17,
        'control': 17,
        'option': 18,
        'pause': 19,
        'break': 19,
        'caps': 20,
        'return': 13,
        'escape': 27,
        'spc': 32,
        'spacebar': 32,
        'pgup': 33,
        'pgdn': 34,
        'ins': 45,
        'del': 46,
        'cmd': 91
    };
    for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
    for(var i = 48; i < 58; i++)codes[i - 48] = i;
    for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
    for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
    var names = exports.names = exports.title = {};
    for(i in codes)names[codes[i]] = i;
    for(var alias in aliases)codes[alias] = aliases[alias];
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("cBssJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$08273d4fc2a6d6da$export$defe85febe8b728c);
    var $7VHMR;
    const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "searchfield.clear",
            "defaultMessage": "Clear"
        },
        search: {
            "id": "searchfield.search",
            "defaultMessage": "Search"
        }
    });
});
parcelRegister("hJBhl", function(module, exports) {
    $parcel$export(module.exports, "ClearFieldIcon", ()=>$99940a7c159b00c0$export$84038b503874befa);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $i28qQ;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $99940a7c159b00c0$var$wrapperStylesCloseIcon
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            testId: "searchfield.ui.clearfield-icon.clear-button",
            onClick: onClear,
            label: clearIconLabel,
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ")))))
        }));
    const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.025',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.050'
        }
    });
});
parcelRegister("5yLnO", function(module, exports) {
    $parcel$export(module.exports, "SearchFieldIconDynamic", ()=>$71cc18983db63a0d$export$9eef03e91cdeba14);
    $parcel$export(module.exports, "SearchFieldIcon", ()=>$71cc18983db63a0d$export$8a82bff895521bd9);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $84THj;
    var $26g7Y;
    var $hyOJh;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
        const akSearchIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            LEGACY_size: "small",
            label: "",
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        });
        const searchIcon = searchIconVisible ? akSearchIcon : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStyles,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
            ]
        }, hasValue ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
            testId: "searchfield.ui.searchfield-icon.clear-button",
            onClick: onClear,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                LEGACY_size: "small",
                label: clearIconLabel,
                LEGACY_primaryColor: primaryColor,
                color: "currentColor"
            })
        }) : searchIcon);
    };
    const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStylesBefore,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
            ]
        }, searchIconVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    const $71cc18983db63a0d$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.accent.gray',
        marginTop: 'space.0',
        marginRight: 'space.100',
        marginBottom: 'space.0',
        marginLeft: 'space.0',
        height: '16px',
        display: 'flex'
    });
    const $71cc18983db63a0d$var$spacingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$wrapperStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.0',
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$spacingStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
});
parcelRegister("lMdZA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab630e8f21974ebe$export$2e2bcd8739ae039);
    var $8oe80;
    var $cz6xH;
    var $ab630e8f21974ebe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('GroupPicker', {
        onChange: 'changed'
    })((0, (0, parcelRequire("cz6xH")).default));
});
parcelRegister("cz6xH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$407c71fa53420c90$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $kFO36;
    var $4USKh;
    var $az4zD;
    var $iTyDa;
    var $frWNK;
    class $407c71fa53420c90$export$471c4c2b52766e8d extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isRequired: false,
                isDisabled: false,
                isClearable: true,
                isCompact: false,
                fetchOnce: false,
                width: 200
            };
        }
        constructor(props){
            super(props), this.state = {
                options: [],
                selectedGroup: this.props.selectedGroup,
                prevSelectedGroup: this.props.selectedGroup
            }, this.onSelected = (selectedOption)=>{
                this.setState({
                    selectedGroup: selectedOption
                });
                this.props.onChange(selectedOption);
            }, this.formatOptionDataTransformer = (group)=>({
                    avatar: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kFO36"))))), {
                        size: "small"
                    }),
                    label: group.name
                }), this.fetchAllGroups = (searchQuery)=>(0, (0, parcelRequire("iTyDa")).getAllGroups)(this.props.baseUrl, searchQuery), this.fetchUserGroups = (searchQuery)=>this.props.withMember ? (0, (0, parcelRequire("iTyDa")).getUserGroups)(this.props.baseUrl, this.props.withMember, searchQuery) : Promise.resolve();
            this.groupPickerId = `group-picker.label.id-${(0, ($parcel$interopDefault($7Jxgt)))()}`;
        }
        static getDerivedStateFromProps(props, state) {
            const currentGroup = props.selectedGroup && props.selectedGroup.value;
            const prevGroup = state.prevSelectedGroup && state.prevSelectedGroup.value;
            if (currentGroup !== prevGroup) return {
                ...state,
                selectedGroup: props.selectedGroup,
                prevSelectedGroup: props.selectedGroup
            };
            return null;
        }
        componentDidMount() {
            const { fetchOnce: fetchOnce } = this.props;
            if (fetchOnce === true) {
                const getOptions = this.getFetchOptionsFunction();
                getOptions('').then((groups)=>this.setState({
                        options: groups
                    }));
            }
        }
        getFetchOptionsFunction() {
            return this.props.withMember ? this.fetchUserGroups : this.fetchAllGroups;
        }
        render() {
            const { intl: { formatMessage: formatMessage }, placeholder: placeholder = this.props.placeholder || formatMessage((0, (0, parcelRequire("frWNK")).default).placeholder), onChange: onChange, fetchOnce: fetchOnce, ...props } = this.props;
            const { selectedGroup: selectedGroup } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4USKh")).PickerWithAvatar), {
                "aria-label": !this.props.label ? formatMessage((0, (0, parcelRequire("frWNK")).default).labelText) : undefined,
                inputId: this.groupPickerId,
                ...props,
                errorMessage: formatMessage((0, (0, parcelRequire("frWNK")).default).error),
                placeholder: placeholder,
                onSelected: this.onSelected,
                options: fetchOnce === true ? this.state.options : this.getFetchOptionsFunction(),
                formatOptionDataTransformer: this.formatOptionDataTransformer,
                value: selectedGroup && selectedGroup.name ? selectedGroup : null
            });
        }
    }
    var $407c71fa53420c90$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($407c71fa53420c90$export$471c4c2b52766e8d);
});
parcelRegister("4USKh", function(module, exports) {
    $parcel$export(module.exports, "PickerWithAvatar", ()=>$63c33924209c0872$export$e6b8a87858f7afd1);
    $parcel$export(module.exports, "PickerWithAvatarAndAnalytics", ()=>$63c33924209c0872$export$3d409af828769e2e);
    var $8oe80;
    var $4U4qk;
    var $9M5Oz;
    const $63c33924209c0872$export$e6b8a87858f7afd1 = (0, (0, parcelRequire("9M5Oz")).default);
    const $63c33924209c0872$export$3d409af828769e2e = (0, (0, parcelRequire("8oe80")).default)('picker', {
        onSelected: 'changed',
        onMultiSelected: 'multi-changed'
    })((0, (0, parcelRequire("9M5Oz")).default));
    const $63c33924209c0872$export$d8d9f25d80d89b16 = (0, (0, parcelRequire("8oe80")).default)('picker', {
        onSelected: 'changed',
        onMultiSelected: 'multi-changed'
    })((0, (0, parcelRequire("4U4qk")).default));
});
parcelRegister("4U4qk", function(module, exports) {
    $parcel$export(module.exports, "getOptionBaseStyles", ()=>$0d1a93ba35d548ba$export$cef6e25059b681a);
    $parcel$export(module.exports, "Picker", ()=>$0d1a93ba35d548ba$export$ba25329847403e11);
    $parcel$export(module.exports, "default", ()=>$0d1a93ba35d548ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lFKmC = parcelRequire("lFKmC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $ctg8C;
    var $dC5iT;
    var $8CUq3;
    var $1ZftP;
    var $94bNw;
    var $bChGW;
    var $iOwNT;
    var $7K5PP;
    var $3bDjY;
    var $VgvL1;
    var $fVAPR;
    var $gwIPs;
    var $az4zD;
    var $e239o;
    const $0d1a93ba35d548ba$export$3a3072dd741f354b = 500;
    const $0d1a93ba35d548ba$export$cef6e25059b681a = (optionState)=>({
            ...optionState.isDisabled ? {
                cursor: 'not-allowed',
                color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N90})`,
                '&, :active': {
                    backgroundColor: 'transparent'
                }
            } : {
                cursor: 'pointer'
            },
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        });
    class $0d1a93ba35d548ba$export$ba25329847403e11 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isRequired: false,
                isDisabled: false,
                isClearable: false,
                isCompact: false,
                isCreatable: false,
                isMulti: false,
                noPortal: false,
                isCheckbox: false,
                label: '',
                defaultValue: undefined,
                width: 'auto',
                onSelected: (0, ($parcel$interopDefault($8Rkzz))),
                onMultiSelected: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        static getDerivedStateFromProps(props) {
            if (props.menuIsOpen !== undefined) return {
                menuIsOpen: props.menuIsOpen
            };
            return null;
        }
        constructor(props){
            super(props), this.state = {
                validationState: 'default',
                showErrorMessage: false,
                menuWasOpen: false,
                menuIsOpen: false,
                initialFocusHandled: false
            }, this.onSelected = (selection, action, analyticsEvent)=>{
                this.setState(()=>({
                        menuIsOpen: false
                    }));
                const { isMulti: isMulti } = this.props;
                if (Array.isArray(selection)) {
                    if (isMulti) this.props.onMultiSelected(selection, analyticsEvent);
                    else this.props.onSelected(undefined, analyticsEvent);
                } else selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
            }, this.onMenuOpen = ()=>{
                this.setState(()=>({
                        menuIsOpen: true,
                        menuWasOpen: true
                    }));
            }, this.onMenuClose = ()=>{
                this.setState(()=>({
                        menuIsOpen: false
                    }));
            }, this.onBlur = (event)=>{
                this.hideErrorMessage();
                const { onBlur: onBlur } = this.props;
                if (onBlur && typeof onBlur === 'function') onBlur(event);
            }, this.onFocus = (event)=>{
                this.showErrorMessage();
                const { onFocus: onFocus } = this.props;
                if (onFocus && typeof onFocus === 'function') onFocus(event);
            }, this.setErrorState = ()=>{
                this.setState({
                    showErrorMessage: true,
                    validationState: 'error'
                });
            }, this.showErrorMessage = ()=>this.setState({
                    showErrorMessage: true
                }), this.hideErrorMessage = ()=>this.setState({
                    showErrorMessage: false
                }), this.loadOptions = (filter, callback)=>{
                this.setState({
                    validationState: 'default'
                });
                this.debouncedLoadOptions(filter, callback);
            }, this.renderOption = (props)=>{
                const propsData = props.data;
                const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    position: "right",
                    content: disableReason
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, props));
            }, this.renderMenuList = (menuListProps)=>{
                const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MenuList, menuListProps, isClearable && menuListProps.hasValue && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $0d1a93ba35d548ba$var$clearButtonWrapperStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "link",
                    shouldFitContainer: true,
                    onClick: menuListProps.clearValue
                }, formatMessage((0, (0, parcelRequire("e239o")).default).clearSelected))), menuListProps.children));
            }, this.renderValueContainer = (props)=>{
                const { onValueContainerClick: onValueContainerClick } = props.selectProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$StyledValueContainer, {
                    "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                    onClick: onValueContainerClick
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ValueContainer, props));
            };
            this.debouncedLoadOptions = (0, ($parcel$interopDefault($lFKmC)))((filter, callback)=>{
                this.props.options(filter).then(callback, ()=>{
                    callback([]);
                    this.setErrorState();
                });
            }, $0d1a93ba35d548ba$export$3a3072dd741f354b);
            this.selectRef = (0, $5uXOq.createRef)();
        }
        getSelectComponent(isAsync) {
            if (this.props.isCreatable) return isAsync ? (0, (0, parcelRequire("1ZftP")).default) : (0, (0, parcelRequire("iOwNT")).default);
            if (isAsync) return 0, (0, parcelRequire("VgvL1")).AsyncSelectWithAnalytics;
            return this.props.isCheckbox ? (0, (0, parcelRequire("94bNw")).default) : (0, (0, parcelRequire("7K5PP")).default);
        }
        getComponentOverrides() {
            const { menuWasOpen: menuWasOpen } = this.state;
            const Option = {
                Option: this.renderOption
            };
            const MenuList = {
                MenuList: this.renderMenuList
            };
            const LoadingIndicator = menuWasOpen ? {} : {
                LoadingIndicator: null
            };
            return {
                ...Option,
                ...MenuList,
                ...LoadingIndicator
            };
        }
        render() {
            const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, (0, parcelRequire("e239o")).default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
            const isAsync = typeof options === 'function';
            const SelectComponent = this.getSelectComponent(isAsync);
            const isErrorMessageOpened = showErrorMessage && validationState === 'error';
            let selectParams = {
                placeholder: placeholder,
                isDisabled: isDisabled,
                isClearable: isClearableWithCrossIcon || false,
                defaultValue: defaultValue,
                defaultOptions: true,
                autoFocus: !!this.props.autoFocus,
                loadOptions: isAsync && this.loadOptions,
                options: !isAsync && options,
                onChange: this.onSelected,
                noOptionsMessage: ()=>formatMessage((0, (0, parcelRequire("e239o")).default).noOptions),
                loadingMessage: ()=>formatMessage((0, (0, parcelRequire("e239o")).default).loading),
                validationState: this.state.validationState,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                menuPortalTarget: noPortal ? null : document.body,
                spacing: isCompact ? 'compact' : 'default',
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
                        }),
                    container: (base)=>({
                            ...base,
                            width: width,
                            minWidth: minWidth
                        }),
                    option: (base, optionState)=>({
                            ...base,
                            ...$0d1a93ba35d548ba$export$cef6e25059b681a(optionState),
                            ...listItemCustomStyles
                        })
                }
            };
            if (!isCheckbox) selectParams = {
                ...selectParams,
                menuIsOpen: menuIsOpen,
                onMenuOpen: this.onMenuOpen,
                onMenuClose: this.onMenuClose,
                components: this.getComponentOverrides()
            };
            if (hasDraggableParentComponent) {
                const { initialFocusHandled: initialFocusHandled } = this.state;
                const handleClick = ()=>{
                    if (initialFocusHandled) this.setState((state)=>({
                            menuIsOpen: !state.menuIsOpen
                        }));
                    else if (!menuIsOpen) {
                        this.selectRef.current.focus();
                        this.setState(()=>({
                                initialFocusHandled: true
                            }));
                    }
                };
                selectParams = {
                    ...selectParams,
                    ref: this.selectRef,
                    components: {
                        ...this.getComponentOverrides,
                        ValueContainer: this.renderValueContainer
                    },
                    onValueContainerClick: handleClick,
                    openMenuOnFocus: true
                };
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, label && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVAPR")).FieldLabel), {
                htmlFor: this.props.inputId,
                label: label,
                isRequired: isRequired
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctg8C")).default), {
                content: errorMessage,
                isOpen: isErrorMessageOpened,
                placement: "right"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
                inputId: this.props.inputId,
                ...this.props,
                ...selectParams,
                options: isAsync ? undefined : this.props.options
            })));
        }
    }
    const $0d1a93ba35d548ba$var$PickerWithIntl = (0, (0, parcelRequire("az4zD")).injectIntlV2)($0d1a93ba35d548ba$export$ba25329847403e11);
    const $0d1a93ba35d548ba$var$DefaultPicker = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$PickerWithIntl, props);
    };
    $0d1a93ba35d548ba$var$DefaultPicker.defaultProps = $0d1a93ba35d548ba$export$ba25329847403e11.defaultProps;
    var $0d1a93ba35d548ba$export$2e2bcd8739ae039 = $0d1a93ba35d548ba$var$DefaultPicker;
    const $0d1a93ba35d548ba$var$StyledValueContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $0d1a93ba35d548ba$var$clearButtonWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
    });
});
parcelRegister("1ZftP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffe39b95a8bd43db$export$2e2bcd8739ae039);
    var $isgat;
    var $3c98u;
    const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("isgat")).default));
    var $ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;
});
parcelRegister("isgat", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6ce0d05b9e97e68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $2HH7Y;
    var $9uJ4X;
    const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const stateManagerProps = (0, (0, parcelRequire("iaInK")).default)(props);
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(stateManagerProps);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props), this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            }, this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)(), this.controlRef = null, this.getControlRef = (ref)=>{
                this.controlRef = ref;
            }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            }, this.inputRef = null, this.getInputRef = (ref)=>{
                this.inputRef = ref;
            }, this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            }, this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            }, this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            }, this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            }, this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            }, this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            }, this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            }, this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            }, this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            }, this.getStyles = (key, props)=>{
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            }, this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            }, this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            }, this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            }, this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            }, this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            }, this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            }, this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            }, this.onCompositionStart = ()=>{
                this.isComposing = true;
            }, this.onCompositionEnd = ()=>{
                this.isComposing = false;
            }, this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            }, this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            }, this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            }, this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            }, this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            }, this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            }, this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            }, this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            }, this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            }, this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            }, this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            }, this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            }, this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } })=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } })=>({
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        });
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } })=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } })=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } })=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } })=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } })=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            textAlign: 'center',
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } })=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis })=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused })=>({
            alignItems: 'center',
            display: 'flex',
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } })=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } })=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } })=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("2HH7Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$994aeb783b6f955a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eEtcC;
    var $gyjU7;
    const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
        const candidate = String(inputValue).toLowerCase();
        const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
        const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
        return optionValue === candidate || optionLabel === candidate;
    };
    const $994aeb783b6f955a$var$builtins = {
        formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
        isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
        getNewOptionData: (inputValue, optionLabel)=>({
                label: optionLabel,
                value: inputValue,
                __isNew__: true
            })
    };
    function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
        const { getOptionValue: getOptionValue = (0, (0, parcelRequire("eEtcC")).getOptionValue), getOptionLabel: getOptionLabel = (0, (0, parcelRequire("eEtcC")).getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
        const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, (0, parcelRequire("gyjU7")).cleanValue)(value), propsOptions, {
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel
            }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
            formatCreateLabel,
            getNewOptionData,
            getOptionLabel,
            getOptionValue,
            inputValue,
            isValidNewOption,
            propsOptions,
            value
        ]);
        const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
                newOption,
                ...propsOptions
            ] : [
                ...propsOptions,
                newOption
            ] : propsOptions, [
            allowCreateWhileLoading,
            createOptionPosition,
            isLoading,
            newOption,
            propsOptions
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
            const valueArray = Array.isArray(newValue) ? newValue : [
                newValue
            ];
            if (valueArray[valueArray.length - 1] === newOption) {
                if (onCreateOption) onCreateOption(inputValue);
                else {
                    const newOptionData = getNewOptionData(inputValue, inputValue);
                    const newActionMeta = {
                        action: 'create-option',
                        name: name,
                        option: newOptionData
                    };
                    propsOnChange((0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, [
                        ...(0, (0, parcelRequire("gyjU7")).cleanValue)(value),
                        newOptionData
                    ], newOptionData), newActionMeta);
                }
                return;
            }
            propsOnChange(newValue, actionMeta);
        }, [
            getNewOptionData,
            inputValue,
            isMulti,
            name,
            newOption,
            onCreateOption,
            propsOnChange,
            value
        ]);
        return {
            ...restSelectProps,
            options: options,
            onChange: onChange
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("94bNw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebf832c571222d72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7K5PP;
    var $itpgN;
    const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
        const mergedComponents = (0, $5uXOq.useMemo)(()=>({
                ...components,
                Option: (0, (0, parcelRequire("itpgN")).CheckboxOption)
            }), [
            components
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            isMulti: true,
            ...props,
            components: mergedComponents
        });
    };
    const $ebf832c571222d72$var$CheckboxSelect = (0, ($parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
    var $ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("itpgN", function(module, exports) {
    $parcel$export(module.exports, "CheckboxOption", ()=>$f5875245cd0ad0c1$export$d40cc97ecda916f9);
    $parcel$export(module.exports, "RadioOption", ()=>$f5875245cd0ad0c1$export$82ab7168879267a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6aY6N;
    var $iQHJo;
    var $dV6Te;
    var $VSDnB;
    function $f5875245cd0ad0c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f5875245cd0ad0c1$var$getPrimitiveStyles = (props)=>{
        const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
        const baseStyles = {
            alignItems: 'center',
            backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : 'transparent',
            color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
            display: 'flex ',
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-050, 4px)",
            boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}` : 'none',
            ':active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: isFocused ? '2px solid transparent' : ''
            }
        };
        const augmentedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
            ...getStyles('option', props),
            ...baseStyles
        });
        const bemClasses = {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        };
        return [
            augmentedStyles,
            cx(bemClasses, className)
        ];
    };
    const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isActive) return `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
        else if (isFocused) return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
        else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (!isSelected) return 'transparent';
        return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isActive) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused) return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
    };
    const $f5875245cd0ad0c1$var$baseIconStyles = {
        name: "35x0q3",
        styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
    };
    const $f5875245cd0ad0c1$var$baseOptionStyles = {
        name: "16e0ede",
        styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    class $f5875245cd0ad0c1$var$ControlOption extends (0, $5uXOq.Component) {
        render() {
            const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
            const props = {
                ...innerProps,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            const [styles, classes] = $f5875245cd0ad0c1$var$getPrimitiveStyles({
                getStyles: getStyles,
                ...rest
            });
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: styles,
                className: classes,
                ref: innerRef,
                ...props
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $f5875245cd0ad0c1$var$baseIconStyles,
                    {
                        '& svg rect, & svg circle:first-of-type': {
                            stroke: $f5875245cd0ad0c1$var$getBorderColor({
                                ...this.props,
                                ...this.state
                            })
                        }
                    }
                ]
            }, !!Icon ? (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
                label: "",
                primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                    ...this.props,
                    ...this.state
                }),
                secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                    ...this.props,
                    ...this.state
                }),
                isFacadeDisabled: true
            }) : null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $f5875245cd0ad0c1$var$baseOptionStyles
            }, children)));
        }
        constructor(...args){
            super(...args), this.state = {
                isActive: false
            }, this.onMouseDown = ()=>this.setState({
                    isActive: true
                }), this.onMouseUp = ()=>this.setState({
                    isActive: false
                }), this.onMouseLeave = ()=>this.setState({
                    isActive: false
                });
        }
    }
    const $f5875245cd0ad0c1$var$NewCheckboxIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$var$NewRadioIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "6.75",
            fill: "currentColor",
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "3",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewCheckboxIcon : (0, ($parcel$interopDefault((0, parcelRequire("6aY6N"))))),
            ...props
        });
    const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewRadioIcon : (0, ($parcel$interopDefault((0, parcelRequire("iQHJo"))))),
            ...props
        });
});
parcelRegister("6aY6N", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
    function $47f24d9003b82760$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $47f24d9003b82760$var$CheckboxIcon = (props)=>$47f24d9003b82760$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $47f24d9003b82760$var$_checkboxChecked.default
        }));
    $47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
    var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;
});
parcelRegister("aoKYM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79209663d32c0c44$var$_UNSAFE_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $79209663d32c0c44$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>$79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
    var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;
});
parcelRegister("iQHJo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
    function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $db8f016a0af5fda9$var$RadioIcon = (props)=>$db8f016a0af5fda9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
        }, props, {
            newIcon: $db8f016a0af5fda9$var$_radioChecked.default
        }));
    $db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
    var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;
});
parcelRegister("kqGQn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $edf7783e719984ba$var$_UNSAFE_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $edf7783e719984ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>$edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
        }, props));
    $edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
    var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;
});
parcelRegister("iOwNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59b6485f0cb008dd$export$2e2bcd8739ae039);
    var $9OU1i;
    var $3c98u;
    const $59b6485f0cb008dd$var$CreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("9OU1i")).default));
    var $59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;
});
parcelRegister("9OU1i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29f1caecd9c7d5a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useCreatable", ()=>(parcelRequire("2HH7Y")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $2HH7Y;
    var $9uJ4X;
    const $b29f1caecd9c7d5a$var$CreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(props);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;
});
parcelRegister("VgvL1", function(module, exports) {
    $parcel$export(module.exports, "AsyncSelectWithAnalytics", ()=>$462c399840da3e1c$export$ee664e5add893f9);
    var $d7FF4;
    var $8oe80;
    const $462c399840da3e1c$export$ee664e5add893f9 = (0, (0, parcelRequire("8oe80")).default)('select', {
        onChange: 'changed'
    })((0, (0, parcelRequire("d7FF4")).default));
});
parcelRegister("d7FF4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac4d84cf4438daea$export$2e2bcd8739ae039);
    var $eAthk;
    var $3c98u;
    const $ac4d84cf4438daea$var$AsyncSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    var $ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;
});
parcelRegister("fVAPR", function(module, exports) {
    $parcel$export(module.exports, "FieldLabel", ()=>$97462970d1593b07$export$1acdcf5a973a8414);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    var $gwIPs;
    const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
            htmlFor: htmlFor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$LabelText, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$RequiredIndicator, {
            role: "presentation"
        }, "*") : null));
    const $97462970d1593b07$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule",
                __cmplp.className
            ])
        });
    });
    const $97462970d1593b07$var$LabelText = (0, $47bDC.default).div.withConfig({
        componentId: "sc-9kgl5s-0"
    })`${(0, (0, parcelRequire("3RZIb")).h200)()} display:block;font-family:${(0, (0, parcelRequire("gwIPs")).fontFamily)};margin:0;${(0, $47bDC.css)({
        padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
    })}`;
    const $97462970d1593b07$var$RequiredIndicator = (0, $47bDC.default).span.withConfig({
        componentId: "sc-9kgl5s-1"
    })({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$exports).R400})`,
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        paddingLeft: "var(--ds-space-025, 2px)"
    });
    $97462970d1593b07$var$RequiredIndicator.displayName = 'RequiredIndicator';
});
parcelRegister("e239o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c6849afedcc0fa8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1c6849afedcc0fa8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOptions: {
            "id": "common.components.picker.base.no-options",
            "defaultMessage": "No results"
        },
        loading: {
            "id": "common.components.picker.base.loading",
            "defaultMessage": "Searching..."
        },
        defaultPlaceholder: {
            "id": "common.components.picker.base.default-placeholder",
            "defaultMessage": "Select..."
        },
        clearSelected: {
            "id": "common.components.picker.base.clear-selected",
            "defaultMessage": "Clear selected"
        }
    });
});
parcelRegister("9M5Oz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae2cb265c5b0a53f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    var $4U4qk;
    class $ae2cb265c5b0a53f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                showFocusedAvatar: false
            };
        }
        render() {
            const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4U4qk")).default), {
                ...props,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                formatOptionLabel: this.renderOption
            });
        }
        constructor(...args){
            super(...args), this.state = {
                canShowAvatar: true
            }, this.onBlur = (event)=>{
                this.setState(()=>({
                        canShowAvatar: true
                    }));
                this.props.onBlur && this.props.onBlur(event);
            }, this.onFocus = (event)=>{
                if (!this.props.showFocusedAvatar) this.setState(()=>({
                        canShowAvatar: false
                    }));
                this.props.onFocus && this.props.onFocus(event);
            }, this.renderOption = (option, { context: context })=>{
                const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
                return (0, ($parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? (0, ($parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$AvatarWrapper, null, typeof avatar === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    src: avatar,
                    size: "xsmall"
                }) : avatar) : null, (0, ($parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$LabelWrapper, null, label));
            };
        }
    }
    const $ae2cb265c5b0a53f$var$OptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $ae2cb265c5b0a53f$var$AvatarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxu2gc _vwz4kb7n",
                __cmplp.className
            ])
        });
    });
    const $ae2cb265c5b0a53f$var$LabelWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iTyDa", function(module, exports) {
    $parcel$export(module.exports, "getAllGroups", ()=>$3f576979452c6c2a$export$c243565349cba18c);
    $parcel$export(module.exports, "getUserGroups", ()=>$3f576979452c6c2a$export$bda937ecc753b1f3);
    var $aDmD8;
    var $48hcp;
    const $3f576979452c6c2a$export$c243565349cba18c = (baseUrl, searchQuery, maxResults)=>(0, (0, parcelRequire("aDmD8")).getAllGroups)(baseUrl, searchQuery, maxResults).then((0, (0, parcelRequire("48hcp")).transformAllGroups));
    const $3f576979452c6c2a$export$bda937ecc753b1f3 = (baseUrl, accountId, searchQuery)=>{
        if (!accountId) return Promise.resolve([]);
        return (0, (0, parcelRequire("aDmD8")).getUserGroups)(baseUrl, accountId).then((response)=>{
            const filteredGroups = (0, (0, parcelRequire("48hcp")).filterUserGroups)(response, searchQuery);
            return (0, (0, parcelRequire("48hcp")).transformUserGroups)(filteredGroups);
        });
    };
});
parcelRegister("aDmD8", function(module, exports) {
    $parcel$export(module.exports, "getAllGroups", ()=>$76137711d5dac9f8$export$c243565349cba18c);
    $parcel$export(module.exports, "getUserGroups", ()=>$76137711d5dac9f8$export$bda937ecc753b1f3);
    var $7f4tk;
    const $76137711d5dac9f8$var$MAX_GROUPS = 5;
    const $76137711d5dac9f8$export$dc22b2cc8b5a1431 = (baseUrl)=>`${baseUrl}/rest/api/2/groups/picker`;
    const $76137711d5dac9f8$var$getAllGroupsUrl = (baseUrl, query, maxResults = $76137711d5dac9f8$var$MAX_GROUPS)=>`${$76137711d5dac9f8$export$dc22b2cc8b5a1431(baseUrl)}?maxResults=${maxResults}&query=${encodeURIComponent(query)}`;
    const $76137711d5dac9f8$export$c243565349cba18c = (baseUrl, query = '', maxResults = $76137711d5dac9f8$var$MAX_GROUPS)=>(0, (0, parcelRequire("7f4tk")).default)($76137711d5dac9f8$var$getAllGroupsUrl(baseUrl, query, maxResults));
    const $76137711d5dac9f8$export$a1f49428f96f52c7 = (baseUrl)=>`${baseUrl}/rest/api/3/user/groups`;
    const $76137711d5dac9f8$var$getUserGroupsUrl = (baseUrl, accountId)=>`${$76137711d5dac9f8$export$a1f49428f96f52c7(baseUrl)}?accountId=${accountId}`;
    const $76137711d5dac9f8$export$bda937ecc753b1f3 = (baseUrl, accountId)=>(0, (0, parcelRequire("7f4tk")).default)($76137711d5dac9f8$var$getUserGroupsUrl(baseUrl, accountId));
});
parcelRegister("48hcp", function(module, exports) {
    $parcel$export(module.exports, "transformAllGroups", ()=>$aaa6afc95e0ce151$export$b53a6053f3a37f82);
    $parcel$export(module.exports, "filterUserGroups", ()=>$aaa6afc95e0ce151$export$3803c0f966c39ffc);
    $parcel$export(module.exports, "transformUserGroups", ()=>$aaa6afc95e0ce151$export$3e297671f207b321);
    const $aaa6afc95e0ce151$export$b53a6053f3a37f82 = (response)=>response && response.groups && response.groups.map(({ name: name, groupId: groupId })=>({
                name: name,
                label: name,
                value: name,
                groupId: groupId
            }));
    const $aaa6afc95e0ce151$export$3803c0f966c39ffc = (groupsRest, searchQuery)=>{
        if (!searchQuery) return groupsRest;
        return groupsRest.filter((group)=>group.name.includes(searchQuery || ''));
    };
    const $aaa6afc95e0ce151$export$3e297671f207b321 = (groupsRest)=>groupsRest.map(({ name: name, groupId: groupId })=>({
                name: name,
                label: name,
                value: name,
                groupId: groupId
            }));
});
parcelRegister("frWNK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62452bef71d985c7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $62452bef71d985c7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        error: {
            "id": "group-picker.error",
            "defaultMessage": "We couldn't retrieve groups"
        },
        placeholder: {
            "id": "group-picker.placeholder",
            "defaultMessage": "Group"
        },
        labelText: {
            "id": "group-picker.label-text",
            "defaultMessage": "Group"
        }
    });
});
parcelRegister("fs8YG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90f47b7198869b8c$export$2e2bcd8739ae039);
    var $8oe80;
    var $59ECx;
    var $90f47b7198869b8c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('ProjectPicker', {
        onChange: 'changed'
    })((0, (0, parcelRequire("59ECx")).default));
});
parcelRegister("59ECx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1af03db95f8cb63b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4USKh;
    var $az4zD;
    var $5gPNV;
    var $2oK1T;
    class $1af03db95f8cb63b$export$a4519235a2ef9605 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isRequired: false,
                isDisabled: false,
                isClearable: true,
                isCompact: false,
                detailed: false,
                width: '200px',
                requireBrowsePermission: false,
                label: undefined,
                inputId: undefined,
                projectType: undefined
            };
        }
        constructor(props){
            super(props), this.state = {
                selectedProject: this.props.selectedProject,
                projects: [],
                prevSelectedProject: this.props.selectedProject
            }, this.onSelected = (selectedOption)=>{
                this.setState({
                    selectedProject: selectedOption
                });
                this.props.onChange(selectedOption);
            }, this.formatOptionDataTransformer = (project)=>({
                    avatar: project.avatarUrl,
                    label: project.name
                }), this.fetchOptions = async (filter)=>{
                const projects = await (0, (0, parcelRequire("5gPNV")).requestProjects)(this.props.baseUrl, filter, {
                    detailed: this.props.detailed,
                    requireBrowsePermission: this.props.requireBrowsePermission,
                    projectType: this.props.projectType
                });
                this.setState({
                    projects: projects
                });
                return projects;
            };
            this.projectPickerId = `project-picker.label.id-${(0, ($parcel$interopDefault($7Jxgt)))()}`;
        }
        static getDerivedStateFromProps(props, state) {
            const currentProjectId = props.selectedProject && props.selectedProject.value;
            const prevProjectId = state.prevSelectedProject && state.prevSelectedProject.value;
            if (currentProjectId !== prevProjectId) return {
                ...state,
                selectedProject: props.selectedProject,
                prevSelectedProject: props.selectedProject
            };
            return null;
        }
        componentDidMount() {
            const { selectedProject: selectedProject } = this.state;
            if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
        }
        componentDidUpdate() {
            const { selectedProject: selectedProject } = this.state;
            if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
        }
        fetchProject(selectedProject) {
            const { baseUrl: baseUrl } = this.props;
            const projectValue = selectedProject.value;
            const updateSelectedProject = (newProject)=>{
                const currentProject = this.state.selectedProject;
                const currentProjectValue = currentProject && currentProject.value;
                if (currentProjectValue === projectValue) {
                    this.setState({
                        selectedProject: newProject
                    });
                    this.props.onChange(newProject);
                }
            };
            return (0, (0, parcelRequire("5gPNV")).requestProject)(baseUrl, projectValue).then((project)=>updateSelectedProject(project)).catch(()=>updateSelectedProject(undefined));
        }
        render() {
            const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, selectedProject: selectedProject, onChange: onChange, ...props } = this.props;
            const { selectedProject: project, projects: projects } = this.state;
            const selectedOptionWithObjectReference = projects?.find((projectInList)=>projectInList.value === project?.value);
            const selectedOption = selectedOptionWithObjectReference || (project && project.name ? project : null);
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4USKh")).PickerWithAvatar), {
                "aria-label": !this.props.label ? formatMessage((0, (0, parcelRequire("2oK1T")).default).labelText) : undefined,
                ...props,
                inputId: !this.props.inputId ? this.projectPickerId : this.props.inputId,
                errorMessage: formatMessage((0, (0, parcelRequire("2oK1T")).default).error),
                placeholder: this.props.placeholder || formatMessage((0, (0, parcelRequire("2oK1T")).default).placeholder),
                onSelected: this.onSelected,
                options: this.fetchOptions,
                formatOptionDataTransformer: this.formatOptionDataTransformer,
                value: selectedOption,
                showFocusedAvatar: true
            }));
        }
    }
    var $1af03db95f8cb63b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($1af03db95f8cb63b$export$a4519235a2ef9605);
});
parcelRegister("5gPNV", function(module, exports) {
    $parcel$export(module.exports, "requestProjects", ()=>$cc6820a29e56f420$export$fd47004f2da106d6);
    $parcel$export(module.exports, "requestProject", ()=>$cc6820a29e56f420$export$5fc96122a11240fa);
    var $4SXEu;
    var $9V0kk;
    const $cc6820a29e56f420$export$fd47004f2da106d6 = (baseUrl, filter, { detailed: detailed, requireBrowsePermission: requireBrowsePermission, maxResults: maxResults, projectType: projectType })=>(0, (0, parcelRequire("4SXEu")).getProjects)(baseUrl, filter, detailed, requireBrowsePermission, maxResults, projectType).then((0, (0, parcelRequire("9V0kk")).transformProjects));
    const $cc6820a29e56f420$export$5fc96122a11240fa = (baseUrl, projectId)=>(0, (0, parcelRequire("4SXEu")).getProject)(baseUrl, projectId).then((0, (0, parcelRequire("9V0kk")).transformProject));
});
parcelRegister("4SXEu", function(module, exports) {
    $parcel$export(module.exports, "getProjects", ()=>$7b7f1e9303cf186f$export$b00a271f69f3d728);
    $parcel$export(module.exports, "getProject", ()=>$7b7f1e9303cf186f$export$637b60a42bb03f06);
    var $7f4tk;
    const $7b7f1e9303cf186f$var$MAX_PROJECTS = 5;
    const $7b7f1e9303cf186f$var$VALID_PROJECT_TYPES = [
        'business',
        'service_desk',
        'software'
    ];
    const $7b7f1e9303cf186f$export$897983d170945c20 = (baseUrl)=>`${baseUrl}/rest/api/2/project/search`;
    const $7b7f1e9303cf186f$export$40e632ede9793c84 = (baseUrl)=>`${baseUrl}/rest/api/2/project`;
    const $7b7f1e9303cf186f$export$3675f59ca23820db = (baseUrl, filter, detailed, requireBrowsePermission, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>{
        const urlSearchParams = new URLSearchParams();
        urlSearchParams.set('orderBy', 'NAME');
        urlSearchParams.set('startAt', '0');
        urlSearchParams.set('query', filter);
        urlSearchParams.set('maxResults', maxResults.toString());
        if (detailed) urlSearchParams.set('expand', 'lead,issueTypes');
        if (requireBrowsePermission) urlSearchParams.set('action', 'browse');
        if ($7b7f1e9303cf186f$var$VALID_PROJECT_TYPES.includes(projectType)) urlSearchParams.set('typeKey', projectType);
        const urlParams = `?${urlSearchParams.toString()}`;
        return `${$7b7f1e9303cf186f$export$897983d170945c20(baseUrl)}${urlParams}`;
    };
    const $7b7f1e9303cf186f$export$42f2db4bad372151 = (baseUrl, projectId)=>`${$7b7f1e9303cf186f$export$40e632ede9793c84(baseUrl)}/${encodeURIComponent(projectId)}`;
    const $7b7f1e9303cf186f$export$b00a271f69f3d728 = (baseUrl, filter = '', detailed = false, requireBrowsePermission = false, maxResults = $7b7f1e9303cf186f$var$MAX_PROJECTS, projectType = '')=>(0, (0, parcelRequire("7f4tk")).default)($7b7f1e9303cf186f$export$3675f59ca23820db(baseUrl, filter, detailed, requireBrowsePermission, maxResults, projectType));
    const $7b7f1e9303cf186f$export$637b60a42bb03f06 = (baseUrl, projectId = '')=>(0, (0, parcelRequire("7f4tk")).default)($7b7f1e9303cf186f$export$42f2db4bad372151(baseUrl, projectId));
});
parcelRegister("9V0kk", function(module, exports) {
    $parcel$export(module.exports, "transformProject", ()=>$6541540d335a62b4$export$e179869ce707f546);
    $parcel$export(module.exports, "transformProjects", ()=>$6541540d335a62b4$export$227473965d2e27db);
    const $6541540d335a62b4$var$transformLead = (leadResponse)=>leadResponse && {
            key: leadResponse.key,
            name: leadResponse.name,
            displayName: leadResponse.displayName,
            avatarUrl: leadResponse.avatarUrls['24x24']
        };
    const $6541540d335a62b4$var$transformIssueTypes = (types)=>types.map((t)=>({
                id: t.id,
                name: t.name,
                description: t.description,
                iconUrl: t.iconUrl,
                subtask: t.subtask
            }));
    const $6541540d335a62b4$var$transformDetails = (restResponse)=>({
            id: restResponse.id,
            key: restResponse.key,
            lead: $6541540d335a62b4$var$transformLead(restResponse.lead),
            issueTypes: restResponse.issueTypes ? $6541540d335a62b4$var$transformIssueTypes(restResponse.issueTypes) : [],
            projectTypeKey: restResponse.projectTypeKey,
            simplified: restResponse.simplified
        });
    const $6541540d335a62b4$export$e179869ce707f546 = (restResponse)=>restResponse && {
            value: restResponse.id,
            name: restResponse.name,
            label: restResponse.name,
            avatarUrl: restResponse.avatarUrls['24x24'],
            details: $6541540d335a62b4$var$transformDetails(restResponse)
        };
    const $6541540d335a62b4$export$227473965d2e27db = (restResponse)=>restResponse && restResponse.values && restResponse.values.map($6541540d335a62b4$export$e179869ce707f546);
});
parcelRegister("2oK1T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a2fad71e32e9ef5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5a2fad71e32e9ef5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        error: {
            "id": "project-picker.error",
            "defaultMessage": "We couldn't retrieve projects"
        },
        placeholder: {
            "id": "project-picker.placeholder",
            "defaultMessage": "Project"
        },
        labelText: {
            "id": "project-picker.label-text",
            "defaultMessage": "Project"
        }
    });
});
parcelRegister("imOJb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66ffec577315758c$export$2e2bcd8739ae039);
    var $8oe80;
    var $7ffSD;
    var $66ffec577315758c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('UserPicker', {
        onChange: 'changed'
    })((0, (0, parcelRequire("7ffSD")).default));
});
parcelRegister("7ffSD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63ea91f281eaff85$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4USKh;
    var $dJl1T;
    var $az4zD;
    var $6GCo0;
    var $8jpCj;
    class $63ea91f281eaff85$export$83e0c73b09b3a9cd extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isRequired: false,
                isDisabled: false,
                isClearable: true,
                isCompact: false,
                shouldFitContainer: false,
                width: '200px'
            };
        }
        constructor(props){
            super(props), this.state = {
                selectedUser: this.props.selectedUser,
                prevSelectedUser: this.props.selectedUser
            }, this.onSelected = (selectedUser)=>{
                this.setState({
                    selectedUser: selectedUser
                });
                this.props.onChange(selectedUser);
            }, this.formatOptionDataTransformer = (user)=>({
                    avatar: user.avatarUrl,
                    label: user.displayName
                }), this.fetchOptions = (query)=>{
                const { baseUrl: baseUrl, suggestedAccountId: suggestedAccountId } = this.props;
                if (query) return (0, (0, parcelRequire("6GCo0")).requestUsers)(baseUrl, query);
                if (suggestedAccountId) return new Promise((resolve)=>{
                    (0, (0, parcelRequire("6GCo0")).requestUser)(baseUrl, suggestedAccountId).then((user)=>resolve([
                            user
                        ])).catch(()=>resolve([]));
                });
                return Promise.resolve([]);
            };
            this.userPickerId = `group-picker.label.id-${(0, ($parcel$interopDefault($7Jxgt)))()}`;
        }
        static getDerivedStateFromProps(props, state) {
            const currentAccountId = props.selectedUser && props.selectedUser.accountId;
            const prevAccountId = state.prevSelectedUser && state.prevSelectedUser.accountId;
            if (currentAccountId !== prevAccountId) return {
                ...state,
                selectedUser: props.selectedUser,
                prevSelectedUser: props.selectedUser
            };
            return null;
        }
        componentDidMount() {
            this.ensureSelectedUserInfoPresent();
        }
        componentDidUpdate(prevProps) {
            this.ensureSelectedUserInfoPresent();
            if (prevProps.suggestedAccountId !== this.props.suggestedAccountId) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('user-picker.prop-update', "suggestedAccountId prop change won't be applied, you have to replace the component with a new one");
        }
        ensureSelectedUserInfoPresent() {
            const { selectedUser: selectedUser } = this.state;
            if (!selectedUser || selectedUser.displayName) return;
            const { accountId: accountId } = selectedUser;
            const updateSelectedUser = (newUser)=>{
                const currentUser = this.state.selectedUser;
                const currentAccountId = currentUser && currentUser.accountId;
                if (currentAccountId === accountId) this.setState({
                    selectedUser: newUser
                });
            };
            (0, (0, parcelRequire("6GCo0")).requestUser)(this.props.baseUrl, accountId).then((user)=>updateSelectedUser(user)).catch(()=>updateSelectedUser(undefined));
        }
        render() {
            const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, suggestedAccountId: suggestedAccountId, selectedUser: selectedUser, placeholder: placeholder = this.props.placeholder || formatMessage((0, (0, parcelRequire("8jpCj")).default).placeholder), onChange: onChange, shouldFitContainer: shouldFitContainer, width: width, ...props } = this.props;
            const { selectedUser: user } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4USKh")).PickerWithAvatar), {
                "aria-label": !this.props.label ? formatMessage((0, (0, parcelRequire("8jpCj")).default).labelText) : undefined,
                inputId: this.userPickerId,
                ...props,
                errorMessage: formatMessage((0, (0, parcelRequire("8jpCj")).default).error),
                placeholder: placeholder,
                onSelected: this.onSelected,
                options: this.fetchOptions,
                formatOptionDataTransformer: this.formatOptionDataTransformer,
                value: user && user.displayName ? user : null,
                width: shouldFitContainer ? undefined : width
            });
        }
    }
    var $63ea91f281eaff85$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($63ea91f281eaff85$export$83e0c73b09b3a9cd);
});
parcelRegister("6GCo0", function(module, exports) {
    $parcel$export(module.exports, "requestUser", ()=>$c396037537d957cc$export$949646a1c1731536);
    $parcel$export(module.exports, "requestUsers", ()=>$c396037537d957cc$export$55b721778f931cc1);
    var $i4N0u;
    var $bQgxR;
    const $c396037537d957cc$export$949646a1c1731536 = (baseUrl, accountId)=>(0, (0, parcelRequire("i4N0u")).getUser)(baseUrl, accountId).then((0, (0, parcelRequire("bQgxR")).transformUser));
    const $c396037537d957cc$export$55b721778f931cc1 = (baseUrl, query)=>(0, (0, parcelRequire("i4N0u")).getUsers)(baseUrl, query).then((0, (0, parcelRequire("bQgxR")).transformUsers));
});
parcelRegister("i4N0u", function(module, exports) {
    $parcel$export(module.exports, "getUser", ()=>$de20a383ad0b74fc$export$7cbf767827cd68ba);
    $parcel$export(module.exports, "getUsers", ()=>$de20a383ad0b74fc$export$925a4945a6cd0f3e);
    var $7f4tk;
    const $de20a383ad0b74fc$export$e45b57f6c6c40475 = 5;
    const $de20a383ad0b74fc$export$7eaa662f51e316ae = (baseUrl)=>`${baseUrl}/rest/api/2/user`;
    const $de20a383ad0b74fc$export$8df721f926f55c9a = (baseUrl, accountId = '')=>`${$de20a383ad0b74fc$export$7eaa662f51e316ae(baseUrl)}?accountId=${encodeURIComponent(accountId)}`;
    const $de20a383ad0b74fc$export$715964ba85b11e2b = (baseUrl)=>`${baseUrl}/rest/api/2/user/picker`;
    const $de20a383ad0b74fc$export$977bdbd87001f83 = (baseUrl, query = '')=>`${$de20a383ad0b74fc$export$715964ba85b11e2b(baseUrl)}?showAvatar=true&maxResults=${$de20a383ad0b74fc$export$e45b57f6c6c40475}&query=${query}`;
    const $de20a383ad0b74fc$export$7cbf767827cd68ba = (baseUrl, accountId = '')=>(0, (0, parcelRequire("7f4tk")).default)($de20a383ad0b74fc$export$8df721f926f55c9a(baseUrl, accountId));
    const $de20a383ad0b74fc$export$925a4945a6cd0f3e = (baseUrl, query = '')=>(0, (0, parcelRequire("7f4tk")).default)($de20a383ad0b74fc$export$977bdbd87001f83(baseUrl, query));
});
parcelRegister("bQgxR", function(module, exports) {
    $parcel$export(module.exports, "transformUser", ()=>$c04a8a4571b1f523$export$88dcd5c1adae8021);
    $parcel$export(module.exports, "transformUsers", ()=>$c04a8a4571b1f523$export$fb8c90bfc4beaa59);
    const $c04a8a4571b1f523$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrls['24x24']
        });
    const $c04a8a4571b1f523$export$fb8c90bfc4beaa59 = (response)=>response.users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
                accountId: accountId,
                value: accountId,
                displayName: displayName,
                label: displayName,
                avatarUrl: avatarUrl
            }));
});
parcelRegister("8jpCj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2a1beea71a0796f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e2a1beea71a0796f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        error: {
            "id": "user-picker.error",
            "defaultMessage": "We couldn't retrieve users"
        },
        placeholder: {
            "id": "user-picker.placeholder",
            "defaultMessage": "User"
        },
        labelText: {
            "id": "user-picker.label-text",
            "defaultMessage": "User"
        }
    });
});
parcelRegister("cOGXp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df375eedc711ef59$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $fVnbM;
    var $iQv12;
    var $az4zD;
    var $afEZu;
    function $df375eedc711ef59$export$47d037774b685574(props) {
        const { onClick: onClick, intl: { formatMessage: formatMessage } } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: onClick
        }, formatMessage((0, (0, parcelRequire("afEZu")).default).label));
    }
    var $df375eedc711ef59$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("iQv12")).default)({
        onClick: 'clearFilters'
    }), (0, (0, parcelRequire("az4zD")).injectIntlV2))($df375eedc711ef59$export$47d037774b685574);
});
parcelRegister("afEZu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c003103d44ed418f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c003103d44ed418f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "directories.filters-v2.main.content.filter.clear.label",
            "defaultMessage": "Clear filters"
        }
    });
});
parcelRegister("lNjU3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fecacae643758aa8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kgoHi;
    var $az4zD;
    var $jA8tN;
    class $fecacae643758aa8$export$ec91da630f36d5ea extends (0, $5uXOq.Component) {
        render() {
            const { renderFilterSearch: renderFilterSearch, renderOwnerPicker: renderOwnerPicker, renderProjectPicker: renderProjectPicker, renderGroupPicker: renderGroupPicker, renderClear: renderClear, intl: { formatMessage: formatMessage } } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                alignItems: "center",
                gap: "space.200"
            }, renderFilterSearch({
                onChange: this.onSearchChange
            }), renderOwnerPicker({
                onChange: this.onOwnerChange,
                placeholder: formatMessage((0, (0, parcelRequire("jA8tN")).default).ownerPlaceholder)
            }), renderProjectPicker({
                onChange: this.onProjectChange
            }), renderGroupPicker({
                onChange: this.onGroupChange
            }), renderClear({
                onClick: this.onClear
            }));
        }
        constructor(...args){
            super(...args), this.onSearchChange = (query, analyticsEvent)=>{
                this.props.onChange({
                    ...this.props.value,
                    query: query
                }, analyticsEvent);
            }, this.onOwnerChange = (owner, analyticsEvent)=>{
                this.props.onChange({
                    ...this.props.value,
                    owner: owner
                }, analyticsEvent);
            }, this.onProjectChange = (project, analyticsEvent)=>{
                this.props.onChange({
                    ...this.props.value,
                    project: project
                }, analyticsEvent);
            }, this.onGroupChange = (group, analyticsEvent)=>{
                this.props.onChange({
                    ...this.props.value,
                    group: group
                }, analyticsEvent);
            }, this.onClear = (analyticsEvent)=>{
                this.props.onChange({
                    ...this.props.initialFilter
                }, analyticsEvent);
            };
        }
    }
    var $fecacae643758aa8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($fecacae643758aa8$export$ec91da630f36d5ea);
});
parcelRegister("jA8tN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$736fe18408db0791$export$2e2bcd8739ae039);
    var $7VHMR;
    var $736fe18408db0791$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        ownerPlaceholder: {
            "id": "directories.filters-v2.main.content.filter.owner-placeholder",
            "defaultMessage": "Owner"
        },
        searchFilterAriaSearchDescription: {
            "id": "directories.filters-v2.main.content.filter.search-filter-aria-search-description",
            "defaultMessage": "The table will be filtered below as you type into the field"
        }
    });
});
parcelRegister("jTnv2", function(module, exports) {
    $parcel$export(module.exports, "operationModals", ()=>$3e826f4478fcbffd$export$fee8081fa482dfbf);
    $parcel$export(module.exports, "emptyFilterResultConfiguration", ()=>$3e826f4478fcbffd$export$972f54d0cb76a888);
    $parcel$export(module.exports, "getHeaderConfiguration", ()=>$3e826f4478fcbffd$export$60b0ef02721854ed);
    $parcel$export(module.exports, "getTableConfiguration", ()=>$3e826f4478fcbffd$export$6847365bea1c5392);
    $parcel$export(module.exports, "getTableLabel", ()=>$3e826f4478fcbffd$export$b2d196af18e06ad6);
    $parcel$export(module.exports, "getResultsAnnouncerMessage", ()=>$3e826f4478fcbffd$export$64df75861e57fb7f);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $epVKM;
    var $4R6GH;
    var $e9yg4;
    var $hXBjD;
    var $d5Jh8;
    var $42upA;
    var $bQVVy;
    var $cC4iO;
    var $1pMLe;
    var $klPHH;
    var $jUOiQ;
    var $d1Eg6;
    var $kA97t;
    var $2xUX2;
    var $jwPQ3;
    var $1XGvI;
    var $dCHeQ;
    var $h2X1I;
    const $3e826f4478fcbffd$export$fee8081fa482dfbf = {
        [(0, $088bf273559ead46$export$92f9e1ed9114d3a6)]: (0, (0, parcelRequire("2xUX2")).default),
        [(0, $088bf273559ead46$export$39d2a7fb21967424)]: (0, (0, parcelRequire("kA97t")).default),
        [(0, $088bf273559ead46$export$250171a898bf7ef)]: (0, (0, parcelRequire("1XGvI")).default),
        [(0, $088bf273559ead46$export$4bd2facc4a3e6aa1)]: (0, (0, parcelRequire("jwPQ3")).default)
    };
    const $3e826f4478fcbffd$export$972f54d0cb76a888 = {
        message: (0, (0, parcelRequire("h2X1I")).default).emptyFilterResultMessage
    };
    const $3e826f4478fcbffd$export$60b0ef02721854ed = ()=>({
            ActionsView: (0, parcelRequire("d5Jh8")).default,
            FilterView: (0, parcelRequire("dCHeQ")).default,
            caption: (0, (0, parcelRequire("h2X1I")).default).headerCaption
        });
    const $3e826f4478fcbffd$export$6847365bea1c5392 = (0, $dGvGJ.createSelector)((0, (0, parcelRequire("hXBjD")).getAtlassianAccountId), (atlassianAccountId)=>[
            atlassianAccountId !== undefined ? {
                title: (0, (0, parcelRequire("epVKM")).default),
                Cell: (0, (0, parcelRequire("1pMLe")).default),
                sortField: (0, (0, parcelRequire("e9yg4")).FAVOURITED),
                width: 3.1
            } : undefined,
            {
                title: (0, (0, parcelRequire("h2X1I")).default).filter,
                Cell: (0, (0, parcelRequire("d1Eg6")).default),
                sortField: (0, (0, parcelRequire("e9yg4")).NAME),
                width: atlassianAccountId ? 22 : 25
            },
            atlassianAccountId !== undefined ? {
                title: (0, (0, parcelRequire("h2X1I")).default).owner,
                Cell: (0, (0, parcelRequire("klPHH")).default),
                sortField: (0, (0, parcelRequire("e9yg4")).OWNER),
                width: 20
            } : undefined,
            {
                title: (0, (0, parcelRequire("h2X1I")).default).viewers,
                Cell: (0, (0, parcelRequire("42upA")).default),
                width: atlassianAccountId ? 20 : 30
            },
            {
                title: (0, (0, parcelRequire("h2X1I")).default).editors,
                Cell: (0, (0, parcelRequire("cC4iO")).default),
                width: atlassianAccountId ? 20 : 30
            },
            {
                title: (0, (0, parcelRequire("h2X1I")).default).popularity,
                Cell: (0, (0, parcelRequire("jUOiQ")).default),
                sortField: (0, (0, parcelRequire("e9yg4")).POPULARITY),
                width: atlassianAccountId ? 10 : 15
            },
            atlassianAccountId !== undefined ? {
                title: (0, (0, parcelRequire("4R6GH")).fg)('blu-4174-enghealth-13917-filters-dir-actions-title') ? (0, (0, parcelRequire("h2X1I")).default).actions : undefined,
                Cell: (0, (0, parcelRequire("bQVVy")).default),
                width: 3.4,
                dataTestId: 'filters-main.content.headerCell.actions.container'
            } : undefined
        ].filter(Boolean));
    const $3e826f4478fcbffd$export$b2d196af18e06ad6 = ()=>(0, (0, parcelRequire("h2X1I")).default).tableAriaLabel;
    const $3e826f4478fcbffd$export$64df75861e57fb7f = ()=>(0, (0, parcelRequire("h2X1I")).default).filterResultsAnnouncement;
});
parcelRegister("epVKM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7b567d1c855c884$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bH1hf;
    var $koVbs;
    var $75Uq1;
    const $f7b567d1c855c884$var$StarTitleCell = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bH1hf"))))), {
            size: "small",
            label: formatMessage((0, (0, parcelRequire("75Uq1")).messages).starred)
        });
    };
    var $f7b567d1c855c884$export$2e2bcd8739ae039 = $f7b567d1c855c884$var$StarTitleCell;
});
parcelRegister("75Uq1", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$8eb82dc6fef00b40$export$defe85febe8b728c);
    var $7VHMR;
    const $8eb82dc6fef00b40$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        starred: {
            "id": "directories.common.components.star-title-cell.starred",
            "defaultMessage": "Starred"
        }
    });
});
parcelRegister("d5Jh8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f1bb68f8de4f998d$export$2e2bcd8739ae039);
    var $l2xCT;
    var $bC2fB;
    var $hXBjD;
    const $f1bb68f8de4f998d$var$mapStateToProps = (state)=>({
            baseUrl: (0, (0, parcelRequire("hXBjD")).getBaseUrl)(state)
        });
    var $f1bb68f8de4f998d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($f1bb68f8de4f998d$var$mapStateToProps, {})((0, (0, parcelRequire("l2xCT")).default));
});
parcelRegister("l2xCT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ade654b56edd64f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $fVnbM;
    var $iQv12;
    var $8RXs9;
    var $hDzhb;
    var $3s2qa;
    const $4ade654b56edd64f$export$6d3c345ce7c38fd9 = ({ onClick: onClick, intl: { formatMessage: formatMessage } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
            onClick: onClick,
            appearance: "primary",
            externalId: "directory.filters-v2.create-button",
            component: (0, (0, parcelRequire("hDzhb")).default)
        }, formatMessage((0, (0, parcelRequire("3s2qa")).default).createFilter));
    var $4ade654b56edd64f$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("iQv12")).default)({
        onClick: 'createFilter'
    }), (0, (0, parcelRequire("8RXs9")).default))($4ade654b56edd64f$export$6d3c345ce7c38fd9);
});
parcelRegister("3s2qa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82baf4f5409c8685$export$2e2bcd8739ae039);
    var $7VHMR;
    var $82baf4f5409c8685$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createFilter: {
            "id": "create-filter-button.create-filter",
            "defaultMessage": "Create filter"
        }
    });
});
parcelRegister("42upA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcc7362652b343e6$export$2e2bcd8739ae039);
    var $bC2fB;
    var $b9OA0;
    var $5V4zU;
    const $dcc7362652b343e6$var$mapStateToProps = ()=>(state, ownProps)=>({
                shares: (0, (0, parcelRequire("b9OA0")).getShares)(state, ownProps.id)
            });
    var $dcc7362652b343e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($dcc7362652b343e6$var$mapStateToProps, {})((0, (0, parcelRequire("5V4zU")).default));
});
parcelRegister("5V4zU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6688a85a9f546f65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    var $bP37O;
    var $3G2gB;
    var $icDh5;
    var $kFO36;
    var $4GsX0;
    var $az4zD;
    var $bNpnm;
    const $6688a85a9f546f65$var$assertUnreachable = (_x)=>{
        throw new Error("Didn't expect to get here");
    };
    class $6688a85a9f546f65$export$3026e5a52c747d2c extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                shares: []
            };
        }
        static renderAvatar(text, avatarUrl, idx, appearance = 'square') {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$Container, {
                key: idx
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$AvatarContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "small",
                src: avatarUrl,
                appearance: appearance
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$TextContainer, null, text));
        }
        static renderIcon(text, IconComponent, idx = 1) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$Container, {
                key: idx
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$IconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement(IconComponent, {
                size: "medium",
                label: ""
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$TextContainer, null, text));
        }
        render() {
            const { shares: shares, intl: { formatMessage: formatMessage } } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($6688a85a9f546f65$var$CellContainer, null, shares.length > 0 ? shares.map((share, idx)=>{
                switch(share.type){
                    case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                        return $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(formatMessage((0, (0, parcelRequire("bNpnm")).default).myOrganizationAccess), (0, ($parcel$interopDefault((0, parcelRequire("icDh5"))))), idx);
                    case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                        return $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(formatMessage((0, (0, parcelRequire("bNpnm")).default).publicAccess), (0, ($parcel$interopDefault((0, parcelRequire("4GsX0"))))), idx);
                    case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                        return $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(share.group.name || '', (0, ($parcel$interopDefault((0, parcelRequire("kFO36"))))), idx);
                    case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                        {
                            const roleName = share.role ? share.role.name : formatMessage((0, (0, parcelRequire("bNpnm")).default).allProjectRoles);
                            const text = `${share.project.name}, ${roleName}`;
                            return $6688a85a9f546f65$export$3026e5a52c747d2c.renderAvatar(text, share.project.avatarUrl, idx);
                        }
                    case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                        return $6688a85a9f546f65$export$3026e5a52c747d2c.renderAvatar(share.user.displayName, share.user.avatarUrl, idx, 'circle');
                    case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                        return $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(formatMessage((0, (0, parcelRequire("bNpnm")).default).unknownProject), (0, ($parcel$interopDefault((0, parcelRequire("bP37O"))))), idx);
                    default:
                        $6688a85a9f546f65$var$assertUnreachable(share);
                        return null;
                }
            }) : $6688a85a9f546f65$export$3026e5a52c747d2c.renderIcon(formatMessage((0, (0, parcelRequire("bNpnm")).default).privateAccess), (0, ($parcel$interopDefault((0, parcelRequire("3G2gB")))))));
        }
    }
    var $6688a85a9f546f65$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($6688a85a9f546f65$export$3026e5a52c747d2c);
    const $6688a85a9f546f65$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _n3td1b66",
                __cmplp.className
            ])
        });
    });
    const $6688a85a9f546f65$var$AvatarContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_u5f3u2gc _vwz4kb7n _1o9zidpf",
                __cmplp.className
            ])
        });
    });
    const $6688a85a9f546f65$var$IconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4v77o _u5f3utpp _vwz4kb7n _1o9zidpf",
                __cmplp.className
            ])
        });
    });
    const $6688a85a9f546f65$var$TextContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_slp31hna _16jlkb7n _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $6688a85a9f546f65$var$CellContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0q12x7 _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3G2gB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
    function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ad70d7fd26028c0$var$LockIcon = (props)=>$2ad70d7fd26028c0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
        }, props, {
            newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
        }));
    $2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
    var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;
});
parcelRegister("bwyQI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $863db7350f859785$var$_UNSAFE_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $863db7350f859785$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $863db7350f859785$var$LockLockedIcon = (props)=>$863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
        }, props));
    $863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
    var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;
});
parcelRegister("icDh5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d407d01834f2f44a$var$_react = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d407d01834f2f44a$var$_officeBuilding = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("4bTdk")));
    function $d407d01834f2f44a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d407d01834f2f44a$var$OfficeBuildingIcon = (props)=>$d407d01834f2f44a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
        }, props, {
            newIcon: $d407d01834f2f44a$var$_officeBuilding.default
        }));
    $d407d01834f2f44a$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
    var $d407d01834f2f44a$var$_default = module.exports.default = $d407d01834f2f44a$var$OfficeBuildingIcon;
});
parcelRegister("4bTdk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $30d304d6d8375db3$var$_UNSAFE_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $30d304d6d8375db3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>$30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15.25V2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v13.25m10.5 0h-3.5m3.5 0H15m-12.25 0h3.5m-3.5 0H1m4-11.5h2m2 0h2m0 3H9m-2 0H5m1.25 8.5v-4.5h3.5v4.5m-3.5 0h3.5"/>`
        }, props));
    $30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
    var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;
});
parcelRegister("4GsX0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36918aadf9f6e08c$var$_react = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36918aadf9f6e08c$var$_globe = $36918aadf9f6e08c$var$_interopRequireDefault((parcelRequire("9x5pH")));
    function $36918aadf9f6e08c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36918aadf9f6e08c$var$WorldIcon = (props)=>$36918aadf9f6e08c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
        }, props, {
            newIcon: $36918aadf9f6e08c$var$_globe.default
        }));
    $36918aadf9f6e08c$var$WorldIcon.displayName = 'WorldIcon';
    var $36918aadf9f6e08c$var$_default = module.exports.default = $36918aadf9f6e08c$var$WorldIcon;
});
parcelRegister("9x5pH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6f0b6523520f8759$var$_react = $6f0b6523520f8759$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6f0b6523520f8759$var$_UNSAFE_baseNew = $6f0b6523520f8759$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $6f0b6523520f8759$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6f0b6523520f8759$var$GlobeIcon = (props)=>$6f0b6523520f8759$var$_react.default.createElement($6f0b6523520f8759$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 0 1 8 15.25M15.25 8A7.25 7.25 0 0 0 8 .75M15.25 8H.75M8 15.25A7.25 7.25 0 0 1 .75 8M8 15.25c1.657 0 3-3.246 3-7.25S9.657.75 8 .75m0 14.5c-1.657 0-3-3.246-3-7.25S6.343.75 8 .75M.75 8A7.25 7.25 0 0 1 8 .75"/>`
        }, props));
    $6f0b6523520f8759$var$GlobeIcon.displayName = 'GlobeIcon';
    var $6f0b6523520f8759$var$_default = module.exports.default = $6f0b6523520f8759$var$GlobeIcon;
});
parcelRegister("bNpnm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4bb30c4c1fbe3078$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4bb30c4c1fbe3078$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        myOrganizationAccess: {
            "id": "directories.filters-v2.main.content.cells.access.my-organization-access",
            "defaultMessage": "My organization"
        },
        publicAccess: {
            "id": "directories.filters-v2.main.content.cells.access.public-access",
            "defaultMessage": "Public"
        },
        privateAccess: {
            "id": "directories.filters-v2.main.content.cells.access.private-access",
            "defaultMessage": "Private"
        },
        allProjectRoles: {
            "id": "directories.filters-v2.main.content.cells.access.all-project-roles",
            "defaultMessage": "All roles"
        },
        unknownProject: {
            "id": "directories.filters-v2.main.content.cells.access.unknown-project",
            "defaultMessage": "Unknown project"
        }
    });
});
parcelRegister("bQVVy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$538f3a4e79245c2a$export$2e2bcd8739ae039);
    var $8QpSo;
    var $bC2fB;
    var $kWgA3;
    var $hXBjD;
    var $3t4xG;
    var $b9OA0;
    var $hIjLa;
    const $538f3a4e79245c2a$var$mapStateToPropsFactory = ()=>{
        const onCopyFactory = (0, (0, parcelRequire("8QpSo")).default)((onOperationRequested)=>()=>onOperationRequested((0, $088bf273559ead46$export$92f9e1ed9114d3a6)));
        const onEditFactory = (0, (0, parcelRequire("8QpSo")).default)((onOperationRequested)=>()=>onOperationRequested((0, $088bf273559ead46$export$250171a898bf7ef)));
        const onChangeOwnerFactory = (0, (0, parcelRequire("8QpSo")).default)((onOperationRequested)=>()=>onOperationRequested((0, $088bf273559ead46$export$39d2a7fb21967424)));
        const onDeleteFactory = (0, (0, parcelRequire("8QpSo")).default)((onOperationRequested)=>()=>onOperationRequested((0, $088bf273559ead46$export$4bd2facc4a3e6aa1)));
        return (state, ownProps)=>({
                onCopy: onCopyFactory(ownProps.onOperationRequested),
                onEdit: onEditFactory(ownProps.onOperationRequested),
                onChangeOwner: onChangeOwnerFactory(ownProps.onOperationRequested),
                onDelete: onDeleteFactory(ownProps.onOperationRequested),
                manageSubscriptionsUrl: (0, (0, parcelRequire("b9OA0")).manageSubscriptionsUrl)(state, ownProps.id),
                owner: (0, (0, parcelRequire("b9OA0")).getOwner)(state, ownProps.id),
                atlassianAccountId: (0, (0, parcelRequire("hXBjD")).getAtlassianAccountId)(state),
                showSpinner: ownProps.isOperationInProgress,
                isCopyFilterModalOpen: (0, (0, parcelRequire("3t4xG")).isCopyFilterModalOpen)(state),
                isWritable: (0, (0, parcelRequire("b9OA0")).getIsWritable)(state, ownProps.id),
                isAdmin: (0, (0, parcelRequire("hXBjD")).getIsAdmin)(state)
            });
    };
    const $538f3a4e79245c2a$var$mapDispatchToProps = {
        onOpenCopyFilterModal: (0, (0, parcelRequire("kWgA3")).openCopyFilterModal)
    };
    var $538f3a4e79245c2a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($538f3a4e79245c2a$var$mapStateToPropsFactory, $538f3a4e79245c2a$var$mapDispatchToProps)((0, (0, parcelRequire("hIjLa")).default));
});
parcelRegister("3t4xG", function(module, exports) {
    $parcel$export(module.exports, "isCopyFilterModalOpen", ()=>$e76778399f10c63b$export$d4543442696c05ca);
    const $e76778399f10c63b$export$d4543442696c05ca = (state)=>state.copyFilterModal.isCopyFilterModalOpen;
});
parcelRegister("hIjLa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9d4d760a041a480$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $3oUqw;
    var $iQv12;
    var $8oe80;
    var $8RXs9;
    var $lM5Su;
    const $d9d4d760a041a480$var$styles = {
        container: "_1e0c1txw _1bahesu3 _ca0q1b66 _u5f3v77o _n3tdze3t _19bvze3t",
        spinnerContainer: "_4t3i7vkz _1bsb1tcg"
    };
    const $d9d4d760a041a480$var$DropdownMenuWithAnalytics = (0, (0, parcelRequire("8oe80")).default)('dropdownMenu', {
        onOpenChange: 'open'
    })((0, (0, parcelRequire("BLPHT")).default));
    const $d9d4d760a041a480$var$DropdownItemWithAnalytics = (0, (0, parcelRequire("8oe80")).default)('dropdownItem', {
        onClick: 'clicked'
    })((0, (0, parcelRequire("6B7KL")).default));
    class $d9d4d760a041a480$var$Actions extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isWritable: false,
                defaultOpen: false,
                showSpinner: false,
                manageSubscriptionsUrl: '',
                owner: null,
                onCopy: (0, ($parcel$interopDefault($8Rkzz))),
                onChangeOwner: (0, ($parcel$interopDefault($8Rkzz))),
                onEdit: (0, ($parcel$interopDefault($8Rkzz))),
                onDelete: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        componentDidUpdate(prevProps) {
            if (prevProps.isCopyFilterModalOpen && this.state.isCopyFilterModalOpen && !this.props.isCopyFilterModalOpen) this.setState({
                isCopyFilterModalOpen: false
            }, ()=>{
                if (this.triggerButtonRef && this.triggerButtonRef.current) this.triggerButtonRef.current.focus();
            });
        }
        delayedClose() {
            setTimeout(()=>this.setState(()=>({
                        isOpen: false
                    })));
        }
        render() {
            const { showSpinner: showSpinner, intl: { formatMessage: formatMessage }, manageSubscriptionsUrl: manageSubscriptionsUrl, atlassianAccountId: atlassianAccountId, owner: owner, isWritable: isWritable, isAdmin: isAdmin } = this.props;
            const isOwner = owner && owner.accountId === atlassianAccountId;
            const { isOpen: isOpen } = this.state;
            const triggerFunction = ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...props,
                    appearance: "subtle",
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))),
                    ref: triggerRef,
                    isLoading: showSpinner,
                    label: formatMessage((0, (0, parcelRequire("lM5Su")).default).tooltip)
                });
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    $d9d4d760a041a480$var$styles.container
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownMenuWithAnalytics, {
                position: "bottom right",
                isOpen: isOpen,
                onOpenChange: this.onOpenChange,
                trigger: triggerFunction
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
                href: manageSubscriptionsUrl,
                onClick: this.onManageSubscriptionsClick
            }, formatMessage((0, (0, parcelRequire("lM5Su")).default).manageAction)), (0, ($parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
                onClick: this.onCopyFilterClick
            }, formatMessage((0, (0, parcelRequire("lM5Su")).default).copyAction)), (isWritable || isOwner === true) && (0, ($parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
                onClick: this.onEditFilterClick
            }, formatMessage((0, (0, parcelRequire("lM5Su")).default).editFilter)), (isOwner === true || isAdmin === true) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
                onClick: this.onChangeOwnerFilterClick
            }, formatMessage((0, (0, parcelRequire("lM5Su")).default).changeOwner)), (0, ($parcel$interopDefault($5uXOq))).createElement($d9d4d760a041a480$var$DropdownItemWithAnalytics, {
                onClick: this.onDeleteFilterClick
            }, formatMessage((0, (0, parcelRequire("lM5Su")).default).deleteFilter))))));
        }
        constructor(...args){
            super(...args), this.state = {
                isOpen: this.props.defaultOpen,
                isCopyFilterModalOpen: false
            }, this.triggerButtonRef = (0, $5uXOq.createRef)(), this.onOpenChange = ({ isOpen: isOpen })=>{
                this.setState(()=>({
                        isOpen: isOpen
                    }));
            }, this.onCopyFilterClick = (e, analytics)=>{
                this.props.onCopyFilterClick(analytics);
                this.props.onCopy();
                this.props.onOpenCopyFilterModal();
                this.setState(()=>({
                        isCopyFilterModalOpen: true
                    }));
            }, this.onManageSubscriptionsClick = (e, analytics)=>{
                this.props.onManageSubscriptionsClick(analytics);
                this.delayedClose();
            }, this.onEditFilterClick = (e, analytics)=>{
                this.props.onEditFilterClick(analytics);
                this.props.onEdit();
            }, this.onChangeOwnerFilterClick = (e, analytics)=>{
                this.props.onChangeOwnerFilterClick(analytics);
                this.props.onChangeOwner();
            }, this.onDeleteFilterClick = (e, analytics)=>{
                this.props.onDeleteFilterClick(analytics);
                this.props.onDelete();
            };
        }
    }
    var $d9d4d760a041a480$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("8RXs9")).default), (0, (0, parcelRequire("iQv12")).default)({
        onManageSubscriptionsClick: 'manageSubscriptions',
        onCopyFilterClick: 'copy',
        onChangeOwnerFilterClick: 'changeOwner',
        onEditFilterClick: 'edit',
        onDeleteFilterClick: 'delete'
    }))($d9d4d760a041a480$var$Actions);
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("lM5Su", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2340d0326caef0c6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2340d0326caef0c6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyAction: {
            "id": "directories.filters-v2.main.content.cells.actions.copy-action",
            "defaultMessage": "Copy filter"
        },
        editFilter: {
            "id": "directories.filters-v2.main.content.cells.actions.edit-filter",
            "defaultMessage": "Edit"
        },
        changeOwner: {
            "id": "directories.filters-v2.main.content.cells.actions.change-owner",
            "defaultMessage": "Change owner"
        },
        deleteFilter: {
            "id": "directories.filters-v2.main.content.cells.actions.delete-filter",
            "defaultMessage": "Delete"
        },
        manageAction: {
            "id": "directories.filters-v2.main.content.cells.actions.manage-action",
            "defaultMessage": "Manage subscriptions"
        },
        tooltip: {
            "id": "directories.filters-v2.main.content.cells.actions.tooltip",
            "defaultMessage": "More"
        }
    });
});
parcelRegister("cC4iO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26019ad53a262e9c$export$2e2bcd8739ae039);
    var $3pUkE;
    var $bC2fB;
    var $b9OA0;
    const $26019ad53a262e9c$var$mapStateToProps = (state, ownProps)=>({
            shares: (0, (0, parcelRequire("b9OA0")).getEdits)(state, ownProps.id)
        });
    var $26019ad53a262e9c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($26019ad53a262e9c$var$mapStateToProps, {})((0, (0, parcelRequire("3pUkE")).default));
});
parcelRegister("3pUkE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f5f0405f4933c54$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    var $3G2gB;
    var $icDh5;
    var $kFO36;
    var $4GsX0;
    var $az4zD;
    var $3pSGI;
    const $6f5f0405f4933c54$var$assertUnreachable = (_x)=>{
        throw new Error("Didn't expect to get here");
    };
    class $6f5f0405f4933c54$export$3026e5a52c747d2c extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                shares: []
            };
        }
        static renderAvatar(text, avatarUrl, idx, appearance) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$Container, {
                key: idx
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$AvatarContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "small",
                src: avatarUrl,
                appearance: appearance
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$TextContainer, null, text));
        }
        static renderIcon(text, IconComponent, idx = 1) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$Container, {
                key: idx
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$IconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement(IconComponent, {
                label: "",
                size: "medium"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$TextContainer, null, text));
        }
        render() {
            const { shares: shares, intl: { formatMessage: formatMessage } } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($6f5f0405f4933c54$var$CellContainer, null, shares.length > 0 ? shares.map((share, idx)=>{
                switch(share.type){
                    case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                        return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(formatMessage((0, (0, parcelRequire("3pSGI")).default).myOrganizationAccess), (0, ($parcel$interopDefault((0, parcelRequire("icDh5"))))), idx);
                    case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                        return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(formatMessage((0, (0, parcelRequire("3pSGI")).default).publicAccess), (0, ($parcel$interopDefault((0, parcelRequire("4GsX0"))))), idx);
                    case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                        return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(share.group.name, (0, ($parcel$interopDefault((0, parcelRequire("kFO36"))))), idx);
                    case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                        return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderAvatar(share.user.displayName, share.user.avatarUrl, idx, 'circle');
                    case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                        {
                            const roleName = share.role ? share.role.name : formatMessage((0, (0, parcelRequire("3pSGI")).default).allProjectRoles);
                            const text = `${share.project.name}, ${roleName}`;
                            return $6f5f0405f4933c54$export$3026e5a52c747d2c.renderAvatar(text, share.project.avatarUrl, idx, 'square');
                        }
                    case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                        return null;
                    default:
                        $6f5f0405f4933c54$var$assertUnreachable(share);
                        return null;
                }
            }) : $6f5f0405f4933c54$export$3026e5a52c747d2c.renderIcon(formatMessage((0, (0, parcelRequire("3pSGI")).default).privateAccess), (0, ($parcel$interopDefault((0, parcelRequire("3G2gB")))))));
        }
    }
    var $6f5f0405f4933c54$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($6f5f0405f4933c54$export$3026e5a52c747d2c);
    const $6f5f0405f4933c54$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _n3td1b66",
                __cmplp.className
            ])
        });
    });
    const $6f5f0405f4933c54$var$AvatarContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_u5f3u2gc _vwz4kb7n _1o9zidpf",
                __cmplp.className
            ])
        });
    });
    const $6f5f0405f4933c54$var$IconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4v77o _u5f3utpp _vwz4kb7n _1o9zidpf",
                __cmplp.className
            ])
        });
    });
    const $6f5f0405f4933c54$var$TextContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_slp31hna _16jlkb7n _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $6f5f0405f4933c54$var$CellContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0q12x7 _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3pSGI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b7c2aa888a93a27$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9b7c2aa888a93a27$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        myOrganizationAccess: {
            "id": "directories.common.components.access-cell.my-organization-access",
            "defaultMessage": "My organization"
        },
        publicAccess: {
            "id": "directories.common.components.access-cell.public-access",
            "defaultMessage": "Public"
        },
        privateAccess: {
            "id": "directories.common.components.access-cell.private-access",
            "defaultMessage": "Private"
        },
        allProjectRoles: {
            "id": "directories.common.components.access-cell.all-project-roles",
            "defaultMessage": "All roles"
        }
    });
});
parcelRegister("1pMLe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc6f54e837af54bb$export$2e2bcd8739ae039);
    var $basmW = parcelRequire("basmW");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8QpSo;
    var $jzjy1;
    var $in0Fz;
    var $bC2fB;
    var $b9OA0;
    const $bc6f54e837af54bb$var$mapStateToPropsFactory = ()=>{
        const onClickFactory = (0, (0, parcelRequire("8QpSo")).default)((state, id)=>(analyticsEvent)=>{
                const changeFavorite = (0, (0, parcelRequire("b9OA0")).getChangeFavorite)(state);
                return changeFavorite ? changeFavorite({
                    id: id,
                    type: 'filters',
                    value: !(0, (0, parcelRequire("b9OA0")).isFavorite)(state, id)
                }, analyticsEvent) : (0, ($parcel$interopDefault($8Rkzz)));
            });
        return (state, ownProps)=>({
                isFavorite: (0, (0, parcelRequire("b9OA0")).isFavorite)(state, ownProps.id),
                favoriteItemName: (0, (0, parcelRequire("b9OA0")).getName)(state, ownProps.id),
                id: ownProps.id,
                onClick: onClickFactory(state, ownProps.id),
                pending: (0, (0, parcelRequire("b9OA0")).isPending)(state, ownProps.id),
                isShownInList: true
            });
    };
    var $bc6f54e837af54bb$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("jzjy1")).AnalyticsSubject)('filter'), (0, (0, parcelRequire("bC2fB")).connect)($bc6f54e837af54bb$var$mapStateToPropsFactory, {}))((0, (0, parcelRequire("in0Fz")).FavoriteCellView));
});
parcelRegister("in0Fz", function(module, exports) {
    $parcel$export(module.exports, "FavoriteCellView", ()=>$6abb13e9102dee85$export$7e4dcb8ef4c4afcd);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $hcObS;
    var $4R6GH;
    var $dCm1o;
    const $6abb13e9102dee85$var$styles = {
        root: "_1e0c1txw _1bah1h6o _1yt41b66"
    };
    function $6abb13e9102dee85$export$7e4dcb8ef4c4afcd(props) {
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6abb13e9102dee85$var$rootStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hcObS")).default), props)) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $6abb13e9102dee85$var$styles.root
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hcObS")).default), props));
    }
    $6abb13e9102dee85$export$7e4dcb8ef4c4afcd.defaultProps = {
        isFavorite: undefined
    };
    const $6abb13e9102dee85$var$rootStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        paddingInline: 'space.050',
        paddingBlock: 'space.100',
        alignItems: 'center',
        height: '40px',
        width: '32px'
    });
});
parcelRegister("hcObS", function(module, exports) {
    $parcel$export(module.exports, "FavoriteButtonWrapper", ()=>$0a68425ce3fc2fa8$export$bb1478fee6cd5f0c);
    $parcel$export(module.exports, "default", ()=>$0a68425ce3fc2fa8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $basmW = parcelRequire("basmW");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $dm1qi;
    var $dAf5R;
    var $5oTeF;
    var $bH1hf;
    var $7FtaJ;
    var $1Cvrw;
    var $fNobW;
    var $3bDjY;
    var $iQv12;
    var $7XYc4;
    var $az4zD;
    var $dCm1o;
    var $6fQ6A;
    const $0a68425ce3fc2fa8$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
    const $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
    class $0a68425ce3fc2fa8$export$f8ad2acf0ec4860f extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isFavorite: undefined,
                favoriteItemName: undefined,
                isShownInList: false,
                isSmall: false,
                hideTooltip: false,
                onClick: (0, ($parcel$interopDefault($8Rkzz))),
                tooltipPosition: 'bottom',
                skipAnimation: false
            };
        }
        componentDidUpdate(prevProps) {
            if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
                this.onAnimationStart();
                this.onSettingAnimationEnd();
            }
        }
        onAnimationStart() {
            this.setState({
                isAnimating: !this.state.isAnimating
            });
        }
        onSettingAnimationEnd() {
            setTimeout(()=>{
                this.setState({
                    isAnimating: false
                });
            }, $0a68425ce3fc2fa8$var$animationTime * 2);
        }
        render() {
            const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
            const { isAnimating: isAnimating } = this.state;
            if (isFavorite === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
                name: "favourite-button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$db65185b5889c83, {
                "data-testid": $0a68425ce3fc2fa8$var$SKELETON_TEST_ID,
                isSmall: isSmall
            }));
            const iconWrapperTestId = isShownInList ? `${$0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX;
            const buttonContentOld = (0, ($parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
                isFavorite: isFavorite,
                isAnimating: isAnimating,
                "data-testid": iconWrapperTestId,
                isSmall: isSmall
            }, isFavorite ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dm1qi"))))), {
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("bH1hf"))))),
                LEGACY_size: isSmall ? 'small' : undefined,
                color: "currentColor",
                label: formatMessage((0, (0, parcelRequire("6fQ6A")).default).removeFromStarred)
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dAf5R"))))), {
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("5oTeF"))))),
                LEGACY_size: isSmall ? 'small' : undefined,
                color: "currentColor",
                label: formatMessage((0, (0, parcelRequire("6fQ6A")).default).addToStarred)
            }));
            const renderIcon = ()=>{
                const label = isFavorite ? formatMessage((0, (0, parcelRequire("6fQ6A")).default).removeFromStarred) : formatMessage((0, (0, parcelRequire("6fQ6A")).default).addToStarred);
                let StarIconComponent;
                if (isSmall) StarIconComponent = isFavorite ? (0, ($parcel$interopDefault((0, parcelRequire("7FtaJ"))))) : (0, ($parcel$interopDefault((0, parcelRequire("1Cvrw")))));
                else StarIconComponent = isFavorite ? (0, ($parcel$interopDefault((0, parcelRequire("dm1qi"))))) : (0, ($parcel$interopDefault((0, parcelRequire("dAf5R")))));
                return (0, ($parcel$interopDefault($5uXOq))).createElement(StarIconComponent, {
                    color: "currentColor",
                    label: label
                });
            };
            const buttonContent = (0, ($parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
                isFavorite: isFavorite,
                isAnimating: isAnimating,
                "data-testid": iconWrapperTestId,
                isSmall: isSmall
            }, renderIcon());
            const tooltipContent = isFavorite ? formatMessage((0, (0, parcelRequire("6fQ6A")).default).removeFromStarred) : formatMessage((0, (0, parcelRequire("6fQ6A")).default).addToStarred);
            const ariaLabel = favoriteItemName ? formatMessage((0, (0, parcelRequire("6fQ6A")).default).toggleStarredWithItemName, {
                itemName: favoriteItemName
            }) : formatMessage((0, (0, parcelRequire("6fQ6A")).default).toggleStarred);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$bb1478fee6cd5f0c, {
                role: "presentation",
                onClick: this.onBtnClickWrapper,
                onKeyPress: this.onBtnClickWrapper,
                "data-is-favorite": isFavorite
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: !hideTooltip && tooltipContent,
                hideTooltipOnClick: true,
                position: tooltipPosition
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: isShownInList ? 'subtle-link' : 'subtle',
                spacing: "none",
                "aria-label": ariaLabel,
                "aria-pressed": isFavorite,
                onClick: !pending ? this.onClick : (0, ($parcel$interopDefault($8Rkzz)))
            }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
        }
        constructor(...args){
            super(...args), this.state = {
                isAnimating: false
            }, this.onBtnClickWrapper = (e)=>{
                e.stopPropagation();
                e.preventDefault();
            }, this.onClick = (_, analyticsEvent)=>{
                this.props.onClick(analyticsEvent);
            };
        }
    }
    var $0a68425ce3fc2fa8$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("iQv12")).default)({
        onClick: ()=>({
                name: 'star'
            })
    }), (0, (0, parcelRequire("az4zD")).injectIntlV2))($0a68425ce3fc2fa8$export$f8ad2acf0ec4860f);
    const $0a68425ce3fc2fa8$var$animationTime = 500;
    const $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l",
                __cmplp.className
            ])
        });
    });
    const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
                __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
                __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
                __cmplp.className
            ])
        });
    });
    const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
                __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
                __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
                __cmplp.className
            ])
        });
    });
    const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew, $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld);
    const $0a68425ce3fc2fa8$var$FavIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isFavorite ? "_syaz2kyj" : "_syaz2u25",
                __cmplp.isFavorite ? "_30l31ebw" : "_30l3w9a8",
                __cmplp.className
            ])
        });
    });
    const $0a68425ce3fc2fa8$export$db65185b5889c83 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSmall: isSmall, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
                __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6fQ6A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10bc2ec5d9a72db1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $10bc2ec5d9a72db1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addToStarred: {
            "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
            "defaultMessage": "Add to Starred"
        },
        removeFromStarred: {
            "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
            "defaultMessage": "Remove from Starred"
        },
        toggleStarred: {
            "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
            "defaultMessage": "Star"
        },
        toggleStarredWithItemName: {
            "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
            "defaultMessage": "Star {itemName}"
        }
    });
});
parcelRegister("klPHH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$069f9742a580df5e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7dpkb;
    var $bC2fB;
    var $b9OA0;
    const $069f9742a580df5e$var$mapStateToProps = (state, ownProps)=>({
            user: (0, (0, parcelRequire("b9OA0")).getOwner)(state, ownProps.id)
        });
    const $069f9742a580df5e$var$UserCell = (props)=>{
        const { user: user } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7dpkb")).default), {
            user: user
        });
    };
    $069f9742a580df5e$var$UserCell.defaultProps = {
        onClick: null
    };
    var $069f9742a580df5e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($069f9742a580df5e$var$mapStateToProps, {})($069f9742a580df5e$var$UserCell);
});
parcelRegister("7dpkb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b027fe8ebdaa54a8$export$2e2bcd8739ae039);
    var $iQv12;
    var $dqcdn;
    var $b027fe8ebdaa54a8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iQv12")).default)({
        onClick: 'userProfile'
    })((0, (0, parcelRequire("dqcdn")).default));
});
parcelRegister("dqcdn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc1d1c3ed200d230$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $kYYfm;
    var $9OXo1;
    var $9nJ7V;
    function $dc1d1c3ed200d230$export$2e2bcd8739ae039(props) {
        const { user: user } = props;
        if (!user) return null;
        const { accountId: accountId, displayName: displayName, avatarUrl: avatarUrl } = user;
        const profileUrl = (0, (0, parcelRequire("4R6GH")).fg)('blu-4174-enghealth-11799-a11y-fix') ? undefined : user.profileUrl;
        const onClick = (0, (0, parcelRequire("4R6GH")).fg)('blu-4174-enghealth-11799-a11y-fix') ? undefined : props.onClick;
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9nJ7V")).default), {
            displayName: displayName,
            avatarUrl: avatarUrl,
            href: profileUrl,
            onClick: onClick
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kYYfm")).AsyncProfileCardNext), {
            accountId: accountId,
            TenantContextSubscriber: (0, (0, parcelRequire("9OXo1")).TenantContextSubscriber)
        }, content);
    }
});
parcelRegister("kYYfm", function(module, exports) {
    $parcel$export(module.exports, "AsyncProfileCardNext", ()=>$15521008cc986085$export$a3c0845f856d4292);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $gcl1l;
    var $lfTZh;
    var $kxZPA;
    const $15521008cc986085$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("beEVQ")).then((module)=>module.ProfileCard), {
        moduleId: "./src/packages/profilecard-next/src/main.tsx"
    });
    const $15521008cc986085$export$a3c0845f856d4292 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "AsyncProfileCardNext",
            packageName: "jiraProfilecardNext",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children),
            sendToPrivacyUnsafeSplunk: true,
            teamName: "empanada",
            attributes: (0, (0, parcelRequire("gcl1l")).isLoaderErrorAttributes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-profile-card-next-view",
            fallback: props.children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($15521008cc986085$var$LazyComponent, props)));
    var $15521008cc986085$export$2e2bcd8739ae039 = $15521008cc986085$export$a3c0845f856d4292;
});
parcelRegister("gcl1l", function(module, exports) {
    $parcel$export(module.exports, "isLoaderErrorAttributes", ()=>$ecfe970d67067a10$export$c7209ce2e0d060ea);
    var $bCf8q;
    const $ecfe970d67067a10$export$c7209ce2e0d060ea = (error)=>({
            isLoaderError: (0, (0, parcelRequire("bCf8q")).isLoaderError)(error)
        });
});
parcelRegister("beEVQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("ek7ue")
    ]).then(()=>parcelRequire('jO6eK'));
});
parcelRegister("9nJ7V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37198d620d9c114f$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $dC5iT;
    var $8CUq3;
    var $41j30;
    var $cSD7y;
    var $4R6GH;
    var $dCm1o;
    const $37198d620d9c114f$var$styles = {
        avatarContainer: "_u5f3u2gc _vwz4idpf _16jlidpf _1o9zidpf _i0dl1wug",
        container: "_ca0q12x7 _n3td12x7 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug",
        contentContainer: "_1e0c1txw _4cvr1h6o _16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1osq",
        accessibleContentContainer: "_ca0qu2gc _n3tdu2gc _1e0c1txw _4cvr1h6o _16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1osq",
        link: "_1bsb1osq",
        textContainer: "_slp31hna _1reo15vq _18m915vq _o5721q9c _1bto1l2s"
    };
    function $37198d620d9c114f$export$2e2bcd8739ae039(props) {
        const { avatarUrl: avatarUrl, displayName: displayName, href: href, appearance: appearance, onClick: onClick } = props;
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement($37198d620d9c114f$var$Content, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $37198d620d9c114f$var$styles.avatarContainer
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            src: avatarUrl,
            size: "small",
            appearance: appearance
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $37198d620d9c114f$var$styles.textContainer
            ])
        }, displayName));
        if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $37198d620d9c114f$var$styles.container
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $37198d620d9c114f$var$styles.link
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
            href: href,
            onClick: onClick
        }, content)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $37198d620d9c114f$var$styles.contentContainer
            ])
        }, content);
    }
    $37198d620d9c114f$export$2e2bcd8739ae039.defaultProps = {
        avatarUrl: undefined,
        href: undefined,
        appearance: 'circle',
        onClick: undefined
    };
    const $37198d620d9c114f$var$accessibleContent = (props)=>{
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $37198d620d9c114f$var$accessibleContentContainerStyles
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $37198d620d9c114f$var$styles.accessibleContentContainer
            ])
        }, props.children);
    };
    const $37198d620d9c114f$var$inaccessibleContent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $37198d620d9c114f$var$styles.contentContainer
            ])
        }, props.children);
    const $37198d620d9c114f$var$Content = (0, (0, parcelRequire("cSD7y")).componentWithFG)('blu-4174-enghealth-11799-a11y-fix', $37198d620d9c114f$var$accessibleContent, $37198d620d9c114f$var$inaccessibleContent);
    const $37198d620d9c114f$var$accessibleContentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        display: 'flex',
        alignItems: 'center',
        flex: '1 1 auto',
        width: '100%',
        height: '40px'
    });
});
parcelRegister("41j30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c2f3c33a6194375$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8oe80;
    var $hDzhb;
    function $7c2f3c33a6194375$var$Link(props) {
        const { children: children, ...rest } = props;
        delete rest.createAnalyticsEvent;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), rest, children);
    }
    var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })($7c2f3c33a6194375$var$Link);
});
parcelRegister("jUOiQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32cae55d1651d4bb$export$2e2bcd8739ae039);
    var $bC2fB;
    var $b9OA0;
    var $iVFHn;
    const $32cae55d1651d4bb$var$mapStateToProps = ()=>(state, ownProps)=>({
                popularity: (0, (0, parcelRequire("b9OA0")).getPopularity)(state, ownProps.id)
            });
    var $32cae55d1651d4bb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($32cae55d1651d4bb$var$mapStateToProps, {})((0, (0, parcelRequire("iVFHn")).default));
});
parcelRegister("iVFHn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3a80abb914b0f96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $az4zD;
    var $fptXw;
    function $b3a80abb914b0f96$var$Popularity(props) {
        const { popularity: popularity, intl: { formatMessage: formatMessage } } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b3a80abb914b0f96$var$Container, null, formatMessage((0, (0, parcelRequire("fptXw")).default).popularity, {
            popularity: popularity
        }));
    }
    const $b3a80abb914b0f96$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _2lx2vrvc _1bsb1osq _o5721q9c _1reo15vq _18m915vq _1bto1l2s _ca0qutpp _n3tdutpp",
                __cmplp.className
            ])
        });
    });
    var $b3a80abb914b0f96$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($b3a80abb914b0f96$var$Popularity);
});
parcelRegister("fptXw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4b1ef608e1b5649$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c4b1ef608e1b5649$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        popularity: {
            "id": "directories.filters-v2.main.content.cells.popularity.popularity",
            "defaultMessage": "{popularity, plural, one {{popularity} person} other {{popularity} people}}"
        }
    });
});
parcelRegister("d1Eg6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$913a97de0f9c06f2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $iQv12;
    var $ff0tU;
    var $asoHC;
    var $bC2fB;
    var $b9OA0;
    const $913a97de0f9c06f2$var$TitleLink = ({ caption: caption, href: href, onClick: onClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("asoHC")).TransitionComponent), {
            href: href,
            onClick: onClick
        }, (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ff0tU")).default), {
                ...props,
                caption: caption
            }));
    const $913a97de0f9c06f2$var$mapStateToProps = ()=>(state, ownProps)=>({
                caption: (0, (0, parcelRequire("b9OA0")).getName)(state, ownProps.id),
                href: (0, (0, parcelRequire("b9OA0")).getViewUrl)(state, ownProps.id)
            });
    var $913a97de0f9c06f2$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("iQv12")).default)({
        onClick: 'filter'
    }), (0, (0, parcelRequire("bC2fB")).connect)($913a97de0f9c06f2$var$mapStateToProps, {}))($913a97de0f9c06f2$var$TitleLink);
});
parcelRegister("ff0tU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9c2d361e5e2d6e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $41j30;
    var $4R6GH;
    var $dCm1o;
    function $c9c2d361e5e2d6e3$export$2e2bcd8739ae039({ caption: caption, href: href, onClick: onClick, ...props }) {
        const content = href ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
            href: href,
            onClick: onClick
        }, caption) : caption;
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            wrap: "nowrap",
            direction: "row",
            xcss: $c9c2d361e5e2d6e3$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c9c2d361e5e2d6e3$var$wrapperStyles
        }, content)) : (0, ($parcel$interopDefault($5uXOq))).createElement($c9c2d361e5e2d6e3$var$Container, props, content);
    }
    const $c9c2d361e5e2d6e3$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingBlock: 'space.100',
        flex: '1 1 auto'
    });
    const $c9c2d361e5e2d6e3$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.025'
    });
    const $c9c2d361e5e2d6e3$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _2lx2vrvc _1bsb1osq _o5721q9c _1reo15vq _18m915vq _1bto1l2s _ca0qutpp _n3tdutpp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("asoHC", function(module, exports) {
    $parcel$export(module.exports, "TransitionComponent", ()=>$f14567bdbac8ba9f$export$3c61ec5cd62a42f9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5y0F0;
    const $f14567bdbac8ba9f$export$3c61ec5cd62a42f9 = ({ children: children, onClick: onClick, href: href })=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5y0F0")).RouterActions), null, ({ push: push })=>{
            const clickHandler = (e, analyticsEvent)=>{
                if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return;
                e.preventDefault();
                onClick && onClick(e, analyticsEvent);
                push(href);
            };
            return children({
                href: href,
                onClick: clickHandler
            });
        }) : children({
            href: href,
            onClick: onClick
        });
});
parcelRegister("kA97t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1943a67ef8b3aa01$export$2e2bcd8739ae039);
    var $bSlMQ;
    var $bC2fB;
    var $1943a67ef8b3aa01$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, ownProps)=>({
            id: ownProps.entityId,
            onCancel: ownProps.onCancel,
            onSuccess: ownProps.onUpdated,
            onInitiateSuccess: ownProps.onDialogShown,
            onInitiateFailed: ownProps.onDataRetrieveFailed
        }), {})((0, (0, parcelRequire("bSlMQ")).default));
});
parcelRegister("bSlMQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b0e45c1a3e32250$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $j55bS;
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $5b0e45c1a3e32250$var$NoLazyAsyncChangeOwnerFilterModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("5MWVh")), {
        moduleId: "./src/packages/global-pages/directories/filters-directory-v2/change-owner-filter-modal/src/index.tsx"
    });
    const $5b0e45c1a3e32250$var$AsyncChangeOwnerFilterModal = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "configure-owner-modal",
            packageName: "filter",
            fallback: "flag",
            teamName: "endeavour"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "change-owner-filter-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j55bS")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5b0e45c1a3e32250$var$NoLazyAsyncChangeOwnerFilterModal, props)));
    var $5b0e45c1a3e32250$export$2e2bcd8739ae039 = $5b0e45c1a3e32250$var$AsyncChangeOwnerFilterModal;
});
parcelRegister("5MWVh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("8g8En")
    ]).then(()=>parcelRequire('2gMly'));
});
parcelRegister("2xUX2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2125cb47e79f5cf$export$2e2bcd8739ae039);
    var $gN92f;
    var $e5wyW;
    var $4R6GH;
    var $bC2fB;
    var $kWgA3;
    var $hXBjD;
    var $b9OA0;
    const $a2125cb47e79f5cf$var$mapStateToPropsOld = (state, ownProps)=>({
            baseUrl: (0, (0, parcelRequire("hXBjD")).getBaseUrl)(state),
            id: ownProps.entityId,
            isFavourite: (0, (0, parcelRequire("b9OA0")).isFavorite)(state, ownProps.entityId),
            onCancel: ownProps.onCancel,
            onInitiateSuccess: ()=>{
                ownProps.onDialogShown();
            },
            onDataRetrieveFailed: ()=>{
                ownProps.onDataRetrieveFailed();
            },
            onCopied: ()=>{
                ownProps.onUpdated();
            }
        });
    const $a2125cb47e79f5cf$var$mapStateToPropsNew = (initialState, ownProps)=>{
        const onInitiateSuccess = ()=>{
            ownProps.onDialogShown();
        };
        const onDataRetrieveFailed = ()=>{
            ownProps.onDataRetrieveFailed();
        };
        const onCopied = ()=>{
            ownProps.onUpdated();
        };
        return (_)=>({
                baseUrl: '',
                id: ownProps.entityId,
                onCancel: ownProps.onCancel,
                onInitiateSuccess: onInitiateSuccess,
                onDataRetrieveFailed: onDataRetrieveFailed,
                onCopied: onCopied
            });
    };
    var $a2125cb47e79f5cf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('fix_unstable_selector_in_filter_directory'), $a2125cb47e79f5cf$var$mapStateToPropsNew, $a2125cb47e79f5cf$var$mapStateToPropsOld), {
        onCloseCopyFilterModal: (0, (0, parcelRequire("kWgA3")).closeCopyFilterModal)
    })((0, (0, parcelRequire("gN92f")).default));
});
parcelRegister("gN92f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af5be036c4f98f42$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jzjy1;
    var $jD5no;
    var $lf2Au;
    var $7iJwP;
    var $jOazq;
    function $af5be036c4f98f42$var$CreateModal(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "unhandled",
            packageName: "jiraCopyFiltersModal",
            teamName: "jira-cosmos"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lf2Au")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jOazq")).default), props))));
    }
    $af5be036c4f98f42$var$CreateModal.defaultProps = {
        onCopied: (0, ($parcel$interopDefault($8Rkzz))),
        onCancel: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $af5be036c4f98f42$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('copyFilter', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($af5be036c4f98f42$var$CreateModal);
});
parcelRegister("jOazq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91cb2ec44f5649d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4041n;
    var $pa9q9;
    var $aWse0;
    var $3HwlS;
    var $itmJb;
    var $iHuZq;
    var $gzMQe;
    const $91cb2ec44f5649d0$var$noop = ()=>{};
    function $91cb2ec44f5649d0$var$CopyModal(props) {
        const { id: id, onDataRetrieveFailed: onDataRetrieveFailed } = props;
        const flagService = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        let emitChangedFavorite = $91cb2ec44f5649d0$var$noop;
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
            const hookValue = (0, (0, parcelRequire("4041n")).useChangeFavorite)();
            emitChangedFavorite = hookValue.emitChangedFavorite;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHuZq")).default), {
            id: id,
            flagService: flagService,
            onDataRetrieveFailed: onDataRetrieveFailed,
            isAdmin: isAdmin
        }, ({ error: error, data: data })=>{
            if (error) return null;
            return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gzMQe")).default), {
                emitChangedFavorite: emitChangedFavorite,
                intl: intl,
                flagService: flagService,
                filter: data,
                isAdmin: isAdmin,
                ...props
            }) : null;
        });
    }
    var $91cb2ec44f5649d0$export$2e2bcd8739ae039 = $91cb2ec44f5649d0$var$CopyModal;
});
parcelRegister("iHuZq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ff69060c3add28b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $ivMO1;
    class $2ff69060c3add28b$var$FilterDataProvider extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.fetchData();
        }
        async fetchData() {
            const { id: id, isAdmin: isAdmin } = this.props;
            try {
                const data = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/2/filter/${id}${isAdmin ? '?overrideSharePermissions=true' : ''}`);
                this.setState({
                    loading: false,
                    error: undefined,
                    data: data
                });
            } catch (e) {
                this.setState({
                    loading: false,
                    error: e
                }, ()=>{
                    this.showErrorFlag();
                });
            }
        }
        showErrorFlag() {
            const { flagService: flagService, onDataRetrieveFailed: onDataRetrieveFailed } = this.props;
            flagService.showFlag((0, (0, parcelRequire("ivMO1")).default)());
            onDataRetrieveFailed();
        }
        render() {
            const { children: children } = this.props;
            const { loading: loading, error: error, data: data } = this.state;
            return children({
                loading: loading,
                error: error,
                data: data
            });
        }
        constructor(...args){
            super(...args), this.state = {
                loading: true,
                error: undefined,
                data: undefined
            };
        }
    }
    var $2ff69060c3add28b$export$2e2bcd8739ae039 = $2ff69060c3add28b$var$FilterDataProvider;
});
parcelRegister("ivMO1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2065fd0a676d6fa1$export$2e2bcd8739ae039);
    var $7VHMR;
    const $2065fd0a676d6fa1$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "copy-filters-modal.common.flags.filter-loading-failed.title",
            "defaultMessage": "Filter loading failed."
        }
    });
    var $2065fd0a676d6fa1$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $2065fd0a676d6fa1$var$messages.title,
            isAutoDismiss: true
        });
});
parcelRegister("gzMQe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f42f9be9f2d36e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hZHze;
    var $hhweD;
    var $akuTQ;
    var $dJl1T;
    var $jJZqs;
    var $8zOmE;
    var $70IFa;
    var $6325A;
    var $d6KcG;
    var $2ZmUc;
    var $54Uq9;
    const $9f42f9be9f2d36e7$var$getServerSideValidationErrors = (0, (0, parcelRequire("akuTQ")).createServerSideValidationErrorsGetter)({
        filterName: (0, $99958954cd57b065$export$b85469cbf362db42),
        shares: (0, $99958954cd57b065$export$378fd4cd7d69440f),
        edit_permissions: (0, $99958954cd57b065$export$fb465a1f4d511f87)
    });
    class $9f42f9be9f2d36e7$var$CopyModal extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.props.onInitiateSuccess();
        }
        render() {
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { name: name, description: description, editPermissions: editPermissions, sharePermissions: sharePermissions } = this.props.filter;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("70IFa")).SharingPermissionAwareShareableEntityModal), {
                sharingPermissionType: "filter",
                avoidInitialPublicSharePermission: true,
                sharePermissions: sharePermissions,
                editPermissions: editPermissions,
                title: formatMessage((0, (0, parcelRequire("54Uq9")).default).header, {
                    name: name
                }),
                actionButtonCaption: formatMessage((0, (0, parcelRequire("54Uq9")).default).saveButtonCaption),
                initialName: name,
                initialDescription: description,
                initialOwner: undefined,
                onCancel: this.onCancel,
                onOperationSucceed: this.onOperationSucceed,
                onOperationFailed: this.onOperationFailed,
                getServerSideValidationErrors: $9f42f9be9f2d36e7$var$getServerSideValidationErrors,
                operation: this.onOperation
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null));
        }
        constructor(...args){
            super(...args), this.onOperation = (filter)=>{
                const { isAdmin: isAdmin, filter: { favourite: favourite, jql: jql } } = this.props;
                return (0, (0, parcelRequire("2ZmUc")).default)(filter, jql, favourite, isAdmin);
            }, this.onOperationSucceed = (filter, result, analyticsEvent)=>{
                const { flagService: flagService, onCopied: onCopied, id: id } = this.props;
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'copiedFilter', {
                    isViewerPrivate: filter.sharePermissions.length === 0,
                    isEditorPrivate: filter.editPermissions && filter.editPermissions.length === 0
                });
                flagService.showFlag((0, (0, parcelRequire("d6KcG")).default)(filter.name));
                if (result.favourite) this.props.emitChangedFavorite({
                    id: result?.id,
                    type: 'filters',
                    value: result.favourite
                });
                onCopied();
                (0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(analyticsEvent, {
                    action: 'copied',
                    actionSubjectId: `${id}`
                });
                this.props.onCloseCopyFilterModal();
            }, this.onOperationFailed = (error, analyticsEvent)=>{
                const { flagService: flagService, id: id } = this.props;
                const isValidationError = error.name && error.name === (0, (0, parcelRequire("jJZqs")).VALIDATION_ERROR_NAME);
                if (!isValidationError) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('directories.filters.copy-modal.submit', `copy filter has failed, id=${id}`, error);
                flagService.showFlag((0, (0, parcelRequire("6325A")).default)());
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'copy failed', id, {
                    isValidationError: isValidationError
                });
            }, this.onCancel = ()=>{
                this.props.onCancel();
                this.props.onCloseCopyFilterModal();
            };
        }
    }
    var $9f42f9be9f2d36e7$export$2e2bcd8739ae039 = $9f42f9be9f2d36e7$var$CopyModal;
});
parcelRegister("akuTQ", function(module, exports) {
    $parcel$export(module.exports, "createServerSideValidationErrorsGetter", ()=>$641c8e591e94e209$export$eba34c1c9e48e66a);
    var $e5RQM;
    const $641c8e591e94e209$export$eba34c1c9e48e66a = (errorFieldToFormFieldDictionary)=>(validationError)=>{
            if (!validationError.errors) return {};
            return validationError.errors.reduce((validationErrors, error)=>{
                const formFieldName = errorFieldToFormFieldDictionary[error.field];
                if (formFieldName) validationErrors[formFieldName] = (0, (0, parcelRequire("e5RQM")).toServerValidationError)(error.error);
                return validationErrors;
            }, {});
        };
});
parcelRegister("e5RQM", function(module, exports) {
    $parcel$export(module.exports, "toServerValidationError", ()=>$1e019e7acbd94ec5$export$567171750b320ae6);
    const $1e019e7acbd94ec5$export$3037a58507b4b815 = 'filter';
    const $1e019e7acbd94ec5$export$4e138ae87e5d431f = 'dashboard';
    const $1e019e7acbd94ec5$export$567171750b320ae6 = (value)=>value;
});
parcelRegister("70IFa", function(module, exports) {
    $parcel$export(module.exports, "SharingPermissionAwareShareableEntityDialog", ()=>$aa7bbc74c826116d$export$da33277a49efaed2);
    $parcel$export(module.exports, "SharingPermissionAwareShareableEntityModal", ()=>$aa7bbc74c826116d$export$e563fb6c5adbcd15);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $jD5no;
    var $lf2Au;
    var $9fuVs;
    var $co1wz;
    var $kMQVm;
    var $2JOo9;
    var $1irmd;
    var $gp761;
    class $aa7bbc74c826116d$var$ShareableEntityDialog extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isNameReadOnly: false,
                isShareScopeLoading: false,
                initialOwner: undefined,
                shareeOptions: (0, parcelRequire("kMQVm")).shareeOptions,
                editOptions: (0, parcelRequire("kMQVm")).editOptions
            };
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lf2Au")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gp761")).default), this.props)));
        }
    }
    const $aa7bbc74c826116d$export$da33277a49efaed2 = ({ avoidInitialPublicSharePermission: avoidInitialPublicSharePermission = false, sharingPermissionType: sharingPermissionType, sharePermissions: sharePermissions = [], viewersCustomMessage: viewersCustomMessage = '', nameTooltip: nameTooltip = '', allowSharePublicOrganizationOnly: allowSharePublicOrganizationOnly = false, editPermissions: editPermissions = [], forceHideEditors: forceHideEditors = false, isShareScopeLoading: isShareScopeLoading = false, isNameReadOnly: isNameReadOnly = false, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JOo9")).default), null, ({ data: data, sharedObjectsPermission: sharedObjectsPermission, loading: loading })=>{
            const shareeOptionsFiltered = (0, (0, parcelRequire("1irmd")).getShareeOptions)({
                data: data,
                sharedObjectsPermission: sharedObjectsPermission,
                loading: loading
            }, sharePermissions, sharingPermissionType, allowSharePublicOrganizationOnly);
            const entitySharePermissions = (0, (0, parcelRequire("1irmd")).getSharePermissions)({
                data: data,
                sharedObjectsPermission: sharedObjectsPermission,
                loading: loading
            }, sharePermissions, avoidInitialPublicSharePermission);
            const canCreateSharedObjectsPermission = (0, (0, parcelRequire("1irmd")).isCreateSharedObjectsPermission)(sharedObjectsPermission);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($aa7bbc74c826116d$var$ShareableEntityDialog, {
                ...props,
                isEditorListShown: !forceHideEditors && (sharingPermissionType === 'dashboard' || sharingPermissionType === 'filter'),
                isNameReadOnly: isNameReadOnly,
                sharePermissions: entitySharePermissions,
                viewersCustomMessage: viewersCustomMessage,
                nameTooltip: nameTooltip,
                shareeOptions: shareeOptionsFiltered,
                editPermissions: canCreateSharedObjectsPermission === false || loading ? [] : editPermissions,
                editOptions: (0, (0, parcelRequire("kMQVm")).editOptions),
                isShareScopeLoading: isShareScopeLoading || loading
            });
        });
    const $aa7bbc74c826116d$export$e563fb6c5adbcd15 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "medium",
            onClose: props.onCancel,
            ...(0, (0, parcelRequire("co1wz")).ff)('fix-filter-permission-modal-scroll-behaviour_v3g08') ? {
                shouldScrollInViewport: true
            } : {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($aa7bbc74c826116d$export$da33277a49efaed2, props)));
    var $aa7bbc74c826116d$export$2e2bcd8739ae039 = $aa7bbc74c826116d$var$ShareableEntityDialog;
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("kMQVm", function(module, exports) {
    $parcel$export(module.exports, "isPublicOrOpenOrPrivate", ()=>$f0bf949584737870$export$e08b925cf70f767b);
    $parcel$export(module.exports, "areSharePermissionsEqual", ()=>$f0bf949584737870$export$8c0ff6f403e15e9c);
    $parcel$export(module.exports, "mapAccessTypeFromPermissions", ()=>$f0bf949584737870$export$1c2ded3e2d5331b3);
    $parcel$export(module.exports, "allShareTypesProperties", ()=>$f0bf949584737870$export$4de258fee4f5aca0);
    $parcel$export(module.exports, "shareeOptions", ()=>$f0bf949584737870$export$9db6e6707f968cf1);
    $parcel$export(module.exports, "editOptions", ()=>$f0bf949584737870$export$dfc3fbb12e12e5a2);
    $parcel$export(module.exports, "shareeOptionsWithPublicAccessDisabled", ()=>$f0bf949584737870$export$c47f666f037e39f1);
    $parcel$export(module.exports, "shareeOptionsWithoutPublicAccess", ()=>$f0bf949584737870$export$927a4a38aa2e02e7);
    $parcel$export(module.exports, "sharingTypeToPermissionsMap", ()=>$f0bf949584737870$export$fba0af8514fddf9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $3NMrl = parcelRequire("3NMrl");
    var $8QpSo;
    var $bP37O;
    var $icDh5;
    var $kFO36;
    var $j85Tc;
    var $4GsX0;
    var $cCoT9;
    const $f0bf949584737870$export$e08b925cf70f767b = (type)=>[
            (0, $a889b3091d5309c7$export$86517eb0163ef745),
            (0, $99958954cd57b065$export$52e14e112503bf52),
            (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)
        ].includes(type);
    const $f0bf949584737870$export$8c0ff6f403e15e9c = (share1, share2)=>{
        if (share1.type !== share2.type) return false;
        if (share1.type === (0, $99958954cd57b065$export$52e14e112503bf52) || share1.type === (0, $a889b3091d5309c7$export$86517eb0163ef745) || share1.type === (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)) return true;
        if (share1.type === (0, $a889b3091d5309c7$export$b02d7412182d1bce) && share2.type === (0, $a889b3091d5309c7$export$b02d7412182d1bce)) {
            if (share1.group.groupId && share2.group.groupId) return share1.group.groupId === share2.group.groupId;
            return share1.group.name === share2.group.name;
        }
        if (share1.type === (0, $a889b3091d5309c7$export$aea0835048e1c730) && share2.type === (0, $a889b3091d5309c7$export$aea0835048e1c730)) return share1.user.accountId === share2.user.accountId;
        if (share1.type === (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6) && share2.type === (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6)) return share1.project.id === share2.project.id && (share1.role && share1.role.id) === (share2.role && share2.role.id);
        return false;
    };
    const $f0bf949584737870$export$1c2ded3e2d5331b3 = (0, (0, parcelRequire("8QpSo")).default)((sharePermissions)=>{
        if (sharePermissions.length === 0) return 0, $99958954cd57b065$export$52e14e112503bf52;
        return sharePermissions.length === 1 ? sharePermissions[0].type : undefined;
    });
    const $f0bf949584737870$export$4de258fee4f5aca0 = {
        [(0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6)]: {
            messageDescriptor: (0, (0, parcelRequire("cCoT9")).default).project,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bP37O"))))), {
                label: ""
            })
        },
        [(0, $a889b3091d5309c7$export$487da0972e3459fe)]: {
            messageDescriptor: (0, (0, parcelRequire("cCoT9")).default).unknownProject,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bP37O"))))), {
                label: ""
            })
        },
        [(0, $a889b3091d5309c7$export$b02d7412182d1bce)]: {
            messageDescriptor: (0, (0, parcelRequire("cCoT9")).default).group,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kFO36"))))), {
                label: ""
            })
        },
        [(0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)]: {
            messageDescriptor: (0, (0, parcelRequire("cCoT9")).default).myOrganization,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("icDh5"))))), {
                label: ""
            })
        },
        [(0, $a889b3091d5309c7$export$86517eb0163ef745)]: {
            messageDescriptor: (0, (0, parcelRequire("cCoT9")).default).public,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4GsX0"))))), {
                label: ""
            })
        },
        [(0, $a889b3091d5309c7$export$aea0835048e1c730)]: {
            messageDescriptor: (0, (0, parcelRequire("cCoT9")).default).user,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("j85Tc"))))), {
                label: ""
            })
        },
        [(0, $99958954cd57b065$export$52e14e112503bf52)]: {
            messageDescriptor: (0, (0, parcelRequire("cCoT9")).default).private,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("j85Tc"))))), {
                label: ""
            })
        }
    };
    const $f0bf949584737870$export$9b1f09fb42db6641 = (0, ($parcel$interopDefault($3NMrl)))($f0bf949584737870$export$4de258fee4f5aca0, (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6), (0, $a889b3091d5309c7$export$b02d7412182d1bce), (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269), (0, $a889b3091d5309c7$export$86517eb0163ef745), (0, $a889b3091d5309c7$export$aea0835048e1c730), (0, $99958954cd57b065$export$52e14e112503bf52));
    const $f0bf949584737870$export$d26c8129d623af6c = (0, ($parcel$interopDefault($3NMrl)))($f0bf949584737870$export$4de258fee4f5aca0, (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6), (0, $a889b3091d5309c7$export$b02d7412182d1bce), (0, $a889b3091d5309c7$export$aea0835048e1c730), (0, $99958954cd57b065$export$52e14e112503bf52));
    const $f0bf949584737870$export$9db6e6707f968cf1 = Object.keys($f0bf949584737870$export$9b1f09fb42db6641).map((shareType)=>({
            ...$f0bf949584737870$export$9b1f09fb42db6641[shareType],
            isDisabled: false,
            value: shareType
        }));
    const $f0bf949584737870$export$dfc3fbb12e12e5a2 = Object.keys($f0bf949584737870$export$d26c8129d623af6c).map((shareType)=>({
            ...$f0bf949584737870$export$d26c8129d623af6c[shareType],
            isDisabled: false,
            value: shareType
        }));
    const $f0bf949584737870$export$c47f666f037e39f1 = $f0bf949584737870$export$9db6e6707f968cf1.map((option)=>({
            ...option,
            isDisabled: option.value === (0, $a889b3091d5309c7$export$86517eb0163ef745)
        }));
    const $f0bf949584737870$export$927a4a38aa2e02e7 = $f0bf949584737870$export$9db6e6707f968cf1.filter((option)=>option.value !== (0, $a889b3091d5309c7$export$86517eb0163ef745));
    const $f0bf949584737870$export$fba0af8514fddf9f = {
        filter: 'globalsharing',
        dashboard: 'globalsharing'
    };
});
const $99958954cd57b065$export$52e14e112503bf52 = 'private';
const $99958954cd57b065$export$b0a0e62d9b1a8269 = 'loggedin';
const $99958954cd57b065$export$b85469cbf362db42 = 'name';
const $99958954cd57b065$export$a1d4ae33ba772a5b = 'description';
const $99958954cd57b065$export$378fd4cd7d69440f = 'sharePermissions';
const $99958954cd57b065$export$fb465a1f4d511f87 = 'editPermissions';
parcelRegister("cCoT9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7978393c0dce22b9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7978393c0dce22b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        group: {
            "id": "shareable-entity-dialog.model.group",
            "defaultMessage": "Group"
        },
        project: {
            "id": "shareable-entity-dialog.model.project",
            "defaultMessage": "Project"
        },
        private: {
            "id": "shareable-entity-dialog.model.private",
            "defaultMessage": "Private"
        },
        user: {
            "id": "shareable-entity-dialog.model.user",
            "defaultMessage": "User"
        },
        myOrganization: {
            "id": "shareable-entity-dialog.model.my-organization",
            "defaultMessage": "My organization"
        },
        public: {
            "id": "shareable-entity-dialog.model.public",
            "defaultMessage": "Public"
        },
        unknownProject: {
            "id": "shareable-entity-dialog.model.unknown-project",
            "defaultMessage": "Unknown project"
        }
    });
});
parcelRegister("2JOo9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$343b8babc2950638$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $jcw0u;
    var $eusud;
    class $343b8babc2950638$export$471356de977a9b27 extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.fetchData();
            this.fetchPermissions();
        }
        render() {
            const { children: children } = this.props;
            const { loading: loading, error: error, data: data, sharedObjectsPermission: sharedObjectsPermission, sharedObjectError: sharedObjectError, sharedObjectPermissionLoading: sharedObjectPermissionLoading } = this.state;
            return children({
                loading: loading || sharedObjectPermissionLoading,
                error: error,
                data: data,
                sharedObjectError: sharedObjectError,
                sharedObjectsPermission: sharedObjectsPermission
            });
        }
        constructor(...args){
            super(...args), this.state = {
                loading: false,
                error: undefined,
                data: undefined,
                sharedObjectError: undefined,
                sharedObjectPermissionLoading: false,
                sharedObjectsPermission: undefined
            }, this.fetchData = async ()=>{
                this.setState({
                    loading: true
                });
                try {
                    const url = '/rest/internal/2/sharing-permissions';
                    const permissions = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
                    this.setState({
                        loading: false,
                        error: undefined,
                        data: permissions
                    });
                } catch (e) {
                    this.setState({
                        loading: false,
                        error: e,
                        data: undefined
                    });
                    const event = this.props.createAnalyticsEvent({});
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e,
                        event: event,
                        meta: {
                            id: 'fetchData',
                            packageName: 'jiraShareableEntityDialog'
                        }
                    });
                }
            }, this.fetchPermissions = async ()=>{
                this.setState({
                    sharedObjectPermissionLoading: true
                });
                try {
                    const sharedObjectsPermission = await (0, (0, parcelRequire("eusud")).performGetRequest)('/rest/api/3/mypermissions?permissions=CREATE_SHARED_OBJECTS');
                    this.setState({
                        sharedObjectPermissionLoading: false,
                        sharedObjectError: undefined,
                        sharedObjectsPermission: sharedObjectsPermission
                    });
                } catch (e) {
                    this.setState({
                        sharedObjectPermissionLoading: false,
                        sharedObjectError: e,
                        sharedObjectsPermission: undefined
                    });
                    const event = this.props.createAnalyticsEvent({});
                    (0, (0, parcelRequire("jcw0u")).default)({
                        event: event,
                        error: e,
                        meta: {
                            id: 'fetchPermissions',
                            packageName: 'jiraShareableEntityDialog'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
        }
    }
    var $343b8babc2950638$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($343b8babc2950638$export$471356de977a9b27);
});
parcelRegister("1irmd", function(module, exports) {
    $parcel$export(module.exports, "isCreateSharedObjectsPermission", ()=>$d87451c3878a5bc2$export$af4fc7cee18c1f8a);
    $parcel$export(module.exports, "getSharePermissions", ()=>$d87451c3878a5bc2$export$96717b662cf0e6e8);
    $parcel$export(module.exports, "getShareeOptions", ()=>$d87451c3878a5bc2$export$2b470b7fa9b9f6ca);
    var $kMQVm;
    const $d87451c3878a5bc2$var$getShareeOptionsIfPublicSharingDisabled = (isEntitySharePermissionSetAsPublic)=>isEntitySharePermissionSetAsPublic ? (0, (0, parcelRequire("kMQVm")).shareeOptionsWithPublicAccessDisabled) : (0, (0, parcelRequire("kMQVm")).shareeOptionsWithoutPublicAccess);
    const $d87451c3878a5bc2$var$getShareOptionsPublicOrganizationOnly = (isPublicSharingEnabled, isEntitySharePermissionSetAsPublic)=>{
        const publicOrganizationOnlyShareOptions = (0, (0, parcelRequire("kMQVm")).shareeOptions).filter((option)=>option.value === (0, $a889b3091d5309c7$export$86517eb0163ef745) || option.value === (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269));
        if (isPublicSharingEnabled === true) return publicOrganizationOnlyShareOptions;
        return isEntitySharePermissionSetAsPublic ? publicOrganizationOnlyShareOptions.map((option)=>({
                ...option,
                isDisabled: option.value === (0, $a889b3091d5309c7$export$86517eb0163ef745)
            })) : publicOrganizationOnlyShareOptions.filter((option)=>option.value !== (0, $a889b3091d5309c7$export$86517eb0163ef745));
    };
    const $d87451c3878a5bc2$export$56bc389f739d17f8 = (sharePermissions)=>Boolean((0, (0, parcelRequire("kMQVm")).mapAccessTypeFromPermissions)(sharePermissions) === (0, $a889b3091d5309c7$export$86517eb0163ef745));
    const $d87451c3878a5bc2$export$af4fc7cee18c1f8a = (sharedObjectsPermission)=>sharedObjectsPermission?.permissions?.CREATE_SHARED_OBJECTS?.havePermission;
    const $d87451c3878a5bc2$export$96717b662cf0e6e8 = ({ sharedObjectsPermission: sharedObjectsPermission, loading: loading }, sharePermissions, avoidInitialPublicSharePermission = false)=>{
        if ($d87451c3878a5bc2$export$af4fc7cee18c1f8a(sharedObjectsPermission) === false || loading) return [];
        const isEntitySharePermissionSetAsPublic = (0, (0, parcelRequire("kMQVm")).mapAccessTypeFromPermissions)(sharePermissions) === (0, $a889b3091d5309c7$export$86517eb0163ef745);
        return isEntitySharePermissionSetAsPublic && avoidInitialPublicSharePermission ? [] : sharePermissions;
    };
    const $d87451c3878a5bc2$export$2b470b7fa9b9f6ca = ({ data: data, sharedObjectsPermission: sharedObjectsPermission, loading: loading }, sharePermissions, sharingPermissionType, allowSharePublicOrganizationOnly = false)=>{
        const isPublicSharingEnabled = data && data[(0, (0, parcelRequire("kMQVm")).sharingTypeToPermissionsMap)[sharingPermissionType]];
        const isEntitySharePermissionSetAsPublic = $d87451c3878a5bc2$export$56bc389f739d17f8(sharePermissions);
        let dialogShareeOptions;
        if (allowSharePublicOrganizationOnly) dialogShareeOptions = $d87451c3878a5bc2$var$getShareOptionsPublicOrganizationOnly(isPublicSharingEnabled, isEntitySharePermissionSetAsPublic);
        else dialogShareeOptions = isPublicSharingEnabled === true ? (0, (0, parcelRequire("kMQVm")).shareeOptions) : $d87451c3878a5bc2$var$getShareeOptionsIfPublicSharingDisabled(isEntitySharePermissionSetAsPublic);
        if ($d87451c3878a5bc2$export$af4fc7cee18c1f8a(sharedObjectsPermission) === false || loading) return dialogShareeOptions.filter((option)=>option.value === (allowSharePublicOrganizationOnly ? (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269) : (0, $99958954cd57b065$export$52e14e112503bf52)));
        return dialogShareeOptions;
    };
});
parcelRegister("gp761", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e26c74732d0b6af6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $iQv12;
    var $jJZqs;
    var $imOJb;
    var $eNz6S;
    var $iJRxf;
    const $e26c74732d0b6af6$var$UserPickerWithAnalytics = (0, (0, parcelRequire("iQv12")).default)({
        onChange: 'owner'
    })((0, (0, parcelRequire("imOJb")).default));
    const $e26c74732d0b6af6$var$isNameEmpty = (name)=>!name.trim();
    const $e26c74732d0b6af6$var$transformToUser = ({ accountId: accountId, displayName: displayName, avatarUrl: avatarUrl, label: label })=>({
            accountId: accountId,
            displayName: displayName,
            avatarUrl: avatarUrl,
            label: label
        });
    class $e26c74732d0b6af6$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props), this.nameInputRef = (0, $5uXOq.createRef)(), this.onNameChange = (event)=>{
                const name = event.target.value;
                this.setState({
                    name: name,
                    isNameRequiredError: $e26c74732d0b6af6$var$isNameEmpty(name),
                    serverValidationErrors: {
                        ...this.state.serverValidationErrors,
                        [(0, $99958954cd57b065$export$b85469cbf362db42)]: undefined
                    }
                });
            }, this.onDescriptionChange = (event)=>{
                this.setState({
                    description: event.target.value,
                    serverValidationErrors: {
                        ...this.state.serverValidationErrors,
                        [(0, $99958954cd57b065$export$a1d4ae33ba772a5b)]: undefined
                    }
                });
            }, this.onOwnerChange = (selectedUser)=>{
                const { initialOwner: initialOwner } = this.props;
                const owner = selectedUser ? $e26c74732d0b6af6$var$transformToUser(selectedUser) : initialOwner;
                this.setState({
                    owner: owner
                });
            }, this.onAction = (event, analyticsEvent)=>{
                const { operation: operation, onOperationSucceed: onOperationSucceed, onOperationFailed: onOperationFailed, getServerSideValidationErrors: getServerSideValidationErrors } = this.props;
                const { name: name, description: description, owner: owner, sharePermissions: sharePermissions, editPermissions: editPermissions } = this.state;
                this.setState({
                    isPending: true
                });
                const filteredSharePermissions = sharePermissions.filter((share)=>share.type !== (0, $a889b3091d5309c7$export$487da0972e3459fe));
                const filteredEditPermissions = editPermissions.filter((share)=>share.type !== (0, $a889b3091d5309c7$export$487da0972e3459fe));
                const operationData = {
                    name: name,
                    description: description,
                    owner: owner,
                    sharePermissions: filteredSharePermissions,
                    editPermissions: filteredEditPermissions
                };
                operation(operationData).then((operationResult)=>{
                    this.setStateIfMounted({
                        isPending: false,
                        serverValidationErrors: {}
                    });
                    onOperationSucceed(operationData, operationResult, analyticsEvent);
                }, (error)=>{
                    this.setStateIfMounted({
                        isPending: false
                    });
                    if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError)) {
                        const newServerValidationErrors = getServerSideValidationErrors(error);
                        this.setStateIfMounted({
                            serverValidationErrors: newServerValidationErrors
                        });
                        if (newServerValidationErrors.name) requestAnimationFrame(()=>this.nameInputRef.current?.focus());
                    }
                    onOperationFailed(error, analyticsEvent);
                });
            }, this.onSharePermissionChange = (sharePermissions)=>{
                this.setState({
                    sharePermissions: sharePermissions,
                    serverValidationErrors: {
                        ...this.state.serverValidationErrors,
                        [(0, $99958954cd57b065$export$378fd4cd7d69440f)]: undefined
                    }
                });
            }, this.onEditPermissionChange = (editPermissions)=>{
                this.setState({
                    editPermissions: editPermissions,
                    serverValidationErrors: {
                        ...this.state.serverValidationErrors,
                        [(0, $99958954cd57b065$export$fb465a1f4d511f87)]: undefined
                    }
                });
            };
            const { initialName: initialName, initialDescription: initialDescription, initialOwner: initialOwner, sharePermissions: sharePermissions, editPermissions: editPermissions, viewersCustomMessage: viewersCustomMessage, nameTooltip: nameTooltip } = props;
            this.state = {
                name: initialName || '',
                description: initialDescription || '',
                owner: initialOwner,
                isPending: false,
                isNameRequiredError: false,
                serverValidationErrors: {},
                sharePermissions: sharePermissions || [],
                viewersCustomMessage: viewersCustomMessage || '',
                nameTooltip: nameTooltip || '',
                editPermissions: editPermissions || []
            };
        }
        componentDidMount() {
            this.isComponentMounted = true;
        }
        componentDidUpdate(prevProps) {
            if (prevProps.isShareScopeLoading && !this.props.isShareScopeLoading) this.setState({
                sharePermissions: this.props.sharePermissions,
                editPermissions: this.props.editPermissions
            });
        }
        componentWillUnmount() {
            this.isComponentMounted = false;
        }
        setStateIfMounted(stateUpdates) {
            if (this.isComponentMounted) this.setState(stateUpdates);
        }
        render() {
            const { isShareScopeLoading: isShareScopeLoading, onCancel: onCancel, title: title, headingTitleLevel: headingTitleLevel, shareeOptions: shareeOptions, editOptions: editOptions, actionButtonCaption: actionButtonCaption, isEditorListShown: isEditorListShown, isNameReadOnly: isNameReadOnly } = this.props;
            const { name: name, description: description, owner: owner, isPending: isPending, isNameRequiredError: isNameRequiredError, sharePermissions: sharePermissions, viewersCustomMessage: viewersCustomMessage, nameTooltip: nameTooltip, editPermissions: editPermissions, serverValidationErrors: serverValidationErrors } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iJRxf")).default), {
                isPending: isPending,
                isNameRequiredError: isNameRequiredError,
                isShareScopeLoading: isShareScopeLoading,
                title: title,
                headingTitleLevel: headingTitleLevel,
                shareeOptions: shareeOptions,
                editOptions: editOptions,
                name: name,
                nameTooltip: nameTooltip,
                description: description,
                owner: owner,
                serverValidationErrors: serverValidationErrors,
                actionButtonCaption: actionButtonCaption,
                UserPicker: $e26c74732d0b6af6$var$UserPickerWithAnalytics,
                Access: (0, (0, parcelRequire("eNz6S")).default),
                isEditorListShown: isEditorListShown,
                isNameReadOnly: isNameReadOnly,
                onNameChange: this.onNameChange,
                onDescriptionChange: this.onDescriptionChange,
                onOwnerChange: this.onOwnerChange,
                onAction: this.onAction,
                onCancel: onCancel,
                sharePermissions: sharePermissions,
                viewersCustomMessage: viewersCustomMessage,
                editPermissions: editPermissions,
                onSharePermissionChange: this.onSharePermissionChange,
                onEditPermissionChange: this.onEditPermissionChange,
                nameInputRef: this.nameInputRef
            });
        }
    }
    const $e26c74732d0b6af6$export$f99395d0d1e1a10e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1i6y _18u010v4 _n3tdv77o",
                __cmplp.className
            ])
        });
    });
    const $e26c74732d0b6af6$export$1005c9f9ab7599e8 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyr1i6y _2hwx10v4 _ca0qv77o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eNz6S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbf86bf462330f63$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $7O4UO;
    var $dqoiX;
    var $dOvpK;
    var $az4zD;
    var $kMQVm;
    var $9Aocd;
    var $lDzQy;
    const $cbf86bf462330f63$export$b704bccf33aa8fc7 = (0, (0, parcelRequire("8QpSo")).default)((sharePermissions)=>{
        const accessType = (0, (0, parcelRequire("kMQVm")).mapAccessTypeFromPermissions)(sharePermissions);
        const sharePermissionRows = accessType === (0, $99958954cd57b065$export$52e14e112503bf52) ? [
            {
                type: (0, $99958954cd57b065$export$52e14e112503bf52)
            }
        ] : [
            ...sharePermissions
        ];
        return {
            accessType: accessType,
            sharePermissionRows: sharePermissionRows
        };
    });
    const $cbf86bf462330f63$export$42cefa6463604ece = (0, (0, parcelRequire("8QpSo")).default)((sharePermissions)=>{
        const editAccessType = (0, (0, parcelRequire("kMQVm")).mapAccessTypeFromPermissions)(sharePermissions);
        const editPermissionRows = editAccessType === (0, $99958954cd57b065$export$52e14e112503bf52) ? [
            {
                type: (0, $99958954cd57b065$export$52e14e112503bf52)
            }
        ] : [
            ...sharePermissions
        ];
        return {
            editAccessType: editAccessType,
            editPermissionRows: editPermissionRows
        };
    });
    class $cbf86bf462330f63$var$AccessWrapper extends (0, $5uXOq.Component) {
        setSharePermission(sharePermission, analyticsEvent) {
            const { onSharePermissionChange: onSharePermissionChange } = this.props;
            const { type: type } = sharePermission;
            const attributes = {
                shareeType: type,
                shareesCount: undefined,
                allRoles: undefined
            };
            switch(sharePermission.type){
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                    onSharePermissionChange([
                        sharePermission
                    ]);
                    break;
                case 0, $99958954cd57b065$export$52e14e112503bf52:
                    onSharePermissionChange([]);
                    break;
                default:
                    {
                        const newPermissions = this.props.sharePermissions.filter((element)=>!(0, (0, parcelRequire("kMQVm")).isPublicOrOpenOrPrivate)(element.type)).concat(sharePermission);
                        attributes.shareesCount = newPermissions.length;
                        attributes.allRoles = sharePermission.type === (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6) ? !sharePermission.role : undefined;
                        onSharePermissionChange(newPermissions);
                    }
                    break;
            }
            (0, (0, parcelRequire("dOvpK")).fireUiAnalytics)(analyticsEvent, {
                name: 'shareeRowAddButton',
                attributes: attributes
            });
        }
        setEditPermission(sharePermission, analyticsEvent) {
            const { onEditPermissionChange: onEditPermissionChange } = this.props;
            const { type: type } = sharePermission;
            const attributes = {
                shareeType: type,
                shareesCount: undefined,
                allRoles: undefined
            };
            switch(sharePermission.type){
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                    onEditPermissionChange([
                        sharePermission
                    ]);
                    break;
                case 0, $99958954cd57b065$export$52e14e112503bf52:
                    onEditPermissionChange([]);
                    break;
                default:
                    {
                        const newPermissions = this.props.editPermissions.filter((element)=>!(0, (0, parcelRequire("kMQVm")).isPublicOrOpenOrPrivate)(element.type)).concat(sharePermission);
                        attributes.shareesCount = newPermissions.length;
                        attributes.allRoles = sharePermission.type === (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6) ? !sharePermission.role : undefined;
                        onEditPermissionChange(newPermissions);
                    }
                    break;
            }
            (0, (0, parcelRequire("dOvpK")).fireUiAnalytics)(analyticsEvent, {
                name: 'editorRowAddButton',
                attributes: attributes
            });
        }
        render() {
            const { intl: { formatMessage: formatMessage }, shareeOptions: shareeOptions, editOptions: editOptions, editPermissions: editPermissions, sharePermissions: sharePermissions, viewersCustomMessage: viewersCustomMessage, isShareScopeLoading: isShareScopeLoading, isEditorListShown: isEditorListShown, sharePermissionsServerValidationError: sharePermissionsServerValidationError, editPermissionsServerValidationError: editPermissionsServerValidationError } = this.props;
            const { accessType: accessType, sharePermissionRows: sharePermissionRows } = $cbf86bf462330f63$export$b704bccf33aa8fc7(sharePermissions);
            const { editAccessType: editAccessType, editPermissionRows: editPermissionRows } = $cbf86bf462330f63$export$42cefa6463604ece(editPermissions);
            const { duplicatedIndex: duplicatedIndex, duplicatedEditIndex: duplicatedEditIndex, revokePermissionMessage: revokePermissionMessage } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
                "aria-live": "polite",
                "data-testid": "shareable-entity-dialog.access.screen"
            }, revokePermissionMessage), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                label: formatMessage((0, (0, parcelRequire("9Aocd")).default).access),
                isInvalid: !!sharePermissionsServerValidationError,
                invalidMessage: sharePermissionsServerValidationError,
                name: "access"
            }, ({ fieldProps: { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lDzQy")).default), {
                    ariaLabel: ariaLabel,
                    ariaLabelledby: ariaLabelledby,
                    type: accessType,
                    duplicatedIndex: duplicatedIndex,
                    isShareScopeLoading: isShareScopeLoading,
                    shareeOptions: shareeOptions,
                    customMessage: viewersCustomMessage,
                    sharePermissionRows: sharePermissionRows,
                    onAddSharePermission: this.onAddSharePermission,
                    onRemove: this.onRemove,
                    errorMessage: sharePermissionsServerValidationError
                })), ' ', isEditorListShown && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                label: formatMessage((0, (0, parcelRequire("9Aocd")).default).editor),
                isInvalid: !!editPermissionsServerValidationError,
                invalidMessage: editPermissionsServerValidationError,
                name: "editor"
            }, ({ fieldProps: { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lDzQy")).default), {
                    ariaLabel: ariaLabel,
                    ariaLabelledby: ariaLabelledby,
                    isEditorList: true,
                    type: editAccessType,
                    duplicatedIndex: duplicatedEditIndex,
                    isShareScopeLoading: isShareScopeLoading,
                    shareeOptions: editOptions,
                    sharePermissionRows: editPermissionRows,
                    onAddSharePermission: this.onAddEditPermission,
                    onRemove: this.onEditRemove,
                    errorMessage: editPermissionsServerValidationError
                })));
        }
        constructor(...args){
            super(...args), this.state = {
                duplicatedIndex: undefined,
                duplicatedEditIndex: undefined,
                revokePermissionMessage: undefined
            }, this.onRemove = (index, analyticsEvent)=>{
                const { sharePermissions: sharePermissions, onSharePermissionChange: onSharePermissionChange } = this.props;
                const newPermissions = sharePermissions.filter((_, i)=>i !== index);
                const permission = sharePermissions[index];
                const { type: type } = permission;
                (0, (0, parcelRequire("dOvpK")).fireUiAnalytics)(analyticsEvent, {
                    name: 'shareeRowRemoveButton',
                    attributes: {
                        shareeType: type,
                        shareeIndex: index,
                        shareesRemaining: newPermissions.length
                    }
                });
                this.setState({
                    duplicatedIndex: undefined,
                    duplicatedEditIndex: undefined
                });
                const { formatMessage: formatMessage } = this.props.intl;
                let title;
                switch(type){
                    case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                        title = permission.group.name;
                        break;
                    case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                        title = permission.project.name;
                        break;
                    case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                        title = formatMessage((0, (0, parcelRequire("kMQVm")).allShareTypesProperties)[type].messageDescriptor);
                        break;
                    case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                        title = permission.user.displayName;
                        break;
                    case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                    case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                    case 0, $99958954cd57b065$export$52e14e112503bf52:
                        title = formatMessage((0, (0, parcelRequire("kMQVm")).allShareTypesProperties)[type].messageDescriptor);
                        break;
                    default:
                        title = 'none';
                }
                this.setState({
                    revokePermissionMessage: formatMessage((0, (0, parcelRequire("9Aocd")).default).permissionsRevoke, {
                        title: title
                    })
                });
                onSharePermissionChange(newPermissions);
            }, this.onEditRemove = (index, analyticsEvent)=>{
                const { editPermissions: editPermissions, onEditPermissionChange: onEditPermissionChange } = this.props;
                const newPermissions = editPermissions.filter((_, i)=>i !== index);
                (0, (0, parcelRequire("dOvpK")).fireUiAnalytics)(analyticsEvent, {
                    name: 'editorRowRemoveButton',
                    attributes: {
                        shareeType: editPermissions[index].type,
                        shareeIndex: index,
                        shareesRemaining: newPermissions.length
                    }
                });
                this.setState({
                    duplicatedIndex: undefined,
                    duplicatedEditIndex: undefined
                });
                onEditPermissionChange(newPermissions);
            }, this.onAddSharePermission = (sharePermission, analyticsEvent)=>{
                const { sharePermissions: sharePermissions, editPermissions: editPermissions, isEditorListShown: isEditorListShown } = this.props;
                const { type: type } = sharePermission;
                this.setState({
                    duplicatedIndex: undefined
                });
                if ((0, (0, parcelRequire("kMQVm")).isPublicOrOpenOrPrivate)(type)) this.setSharePermission(sharePermission, analyticsEvent);
                else {
                    const duplicatedIndex = sharePermissions.findIndex((element)=>(0, (0, parcelRequire("kMQVm")).areSharePermissionsEqual)(sharePermission, element));
                    if (duplicatedIndex >= 0) this.setState({
                        duplicatedIndex: duplicatedIndex
                    });
                    else if (isEditorListShown) {
                        const duplicatedEditIndex = editPermissions.findIndex((element)=>(0, (0, parcelRequire("kMQVm")).areSharePermissionsEqual)(sharePermission, element));
                        if (duplicatedEditIndex >= 0) this.setState({
                            duplicatedEditIndex: duplicatedEditIndex
                        });
                        else this.setSharePermission(sharePermission, analyticsEvent);
                    } else this.setSharePermission(sharePermission, analyticsEvent);
                }
            }, this.onAddEditPermission = (sharePermission, analyticsEvent)=>{
                const { sharePermissions: sharePermissions, editPermissions: editPermissions } = this.props;
                const { type: type } = sharePermission;
                this.setState({
                    duplicatedIndex: undefined
                });
                if ((0, (0, parcelRequire("kMQVm")).isPublicOrOpenOrPrivate)(type)) this.setEditPermission(sharePermission, analyticsEvent);
                else {
                    const duplicatedIndex = sharePermissions.findIndex((element)=>(0, (0, parcelRequire("kMQVm")).areSharePermissionsEqual)(sharePermission, element));
                    if (duplicatedIndex >= 0) this.onRemove(duplicatedIndex, analyticsEvent);
                    const duplicatedEditIndex = editPermissions.findIndex((element)=>(0, (0, parcelRequire("kMQVm")).areSharePermissionsEqual)(sharePermission, element));
                    if (duplicatedEditIndex >= 0) this.setState({
                        duplicatedEditIndex: duplicatedEditIndex
                    });
                    else this.setEditPermission(sharePermission, analyticsEvent);
                }
            };
        }
    }
    var $cbf86bf462330f63$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($cbf86bf462330f63$var$AccessWrapper);
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("dOvpK", function(module, exports) {
    $parcel$export(module.exports, "fireUiAnalytics", ()=>$8c2abcc805e894f7$export$4909253b5bf1eed7);
    var $4f8Oj = parcelRequire("4f8Oj");
    var $gvRPW;
    var $i4iBk;
    const $8c2abcc805e894f7$var$isNotUndefined = (a)=>a !== undefined;
    const $8c2abcc805e894f7$var$mapPayload = (payload)=>{
        const context = (0, (0, parcelRequire("i4iBk")).default)(payload);
        const { name: name } = payload;
        return (0, ($parcel$interopDefault($4f8Oj)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            name: name
        }, $8c2abcc805e894f7$var$isNotUndefined);
    };
    const $8c2abcc805e894f7$export$4909253b5bf1eed7 = (event, payload)=>{
        event.update({
            ...$8c2abcc805e894f7$var$mapPayload(payload),
            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("9Aocd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09484d9a2d012b50$export$2e2bcd8739ae039);
    var $7VHMR;
    var $09484d9a2d012b50$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "shareable-entity-dialog.name",
            "defaultMessage": "Name"
        },
        description: {
            "id": "shareable-entity-dialog.description",
            "defaultMessage": "Description"
        },
        access: {
            "id": "shareable-entity-dialog.access",
            "defaultMessage": "Viewers"
        },
        editor: {
            "id": "shareable-entity-dialog.editor",
            "defaultMessage": "Editors"
        },
        owner: {
            "id": "shareable-entity-dialog.owner",
            "defaultMessage": "Owner"
        },
        nameIsRequired: {
            "id": "shareable-entity-dialog.name-is-required",
            "defaultMessage": "Name field is required"
        },
        permissionsRevoke: {
            "id": "shareable-entity-dialog.permissions-revoke",
            "defaultMessage": "Permission to share revoked for {title}"
        },
        requiredFieldsSummary: {
            "id": "shareable-entity-dialog.required-fields-summary",
            "defaultMessage": "Required fields are marked with an asterisk"
        }
    });
});
parcelRegister("lDzQy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7179c7fdb3a506d3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $qfj8c;
    var $dC5iT;
    var $8CUq3;
    var $6cSbZ;
    var $2X0ZZ;
    class $7179c7fdb3a506d3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isEditorList: false,
                type: undefined,
                duplicatedIndex: undefined,
                customMessage: undefined,
                errorMessage: undefined
            };
        }
        render() {
            const { isEditorList: isEditorList, isShareScopeLoading: isShareScopeLoading, type: type, shareeOptions: shareeOptions, sharePermissionRows: sharePermissionRows, duplicatedIndex: duplicatedIndex, onRemove: onRemove, onAddSharePermission: onAddSharePermission, customMessage: customMessage, errorMessage: errorMessage, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby } = this.props;
            const isOnlyPublicAndOrganization = shareeOptions.length === 2 && shareeOptions.every((i)=>i.value === (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269) || i.value === (0, $a889b3091d5309c7$export$86517eb0163ef745));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, customMessage ? (0, ($parcel$interopDefault($5uXOq))).createElement($7179c7fdb3a506d3$var$CustomMessage, null, customMessage) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2X0ZZ")).default), {
                ariaLabel: ariaLabel,
                ariaLabelledby: ariaLabelledby,
                isEditorList: isEditorList,
                isShareScopeLoading: isShareScopeLoading,
                type: type,
                options: shareeOptions,
                onAddSharePermission: onAddSharePermission
            }), errorMessage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $7179c7fdb3a506d3$var$errorMessageContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, errorMessage)), isShareScopeLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement($7179c7fdb3a506d3$var$EmptyRow, null) : !!sharePermissionRows.length && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6cSbZ")).default), {
                isEditorList: isEditorList,
                sharePermissionRows: sharePermissionRows,
                duplicatedIndex: duplicatedIndex,
                forceHideRemoveButton: isOnlyPublicAndOrganization,
                onRemove: onRemove
            }));
        }
    }
    const $7179c7fdb3a506d3$var$EmptyRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_x3dope8f _4t3i1wpv",
                __cmplp.className
            ])
        });
    });
    const $7179c7fdb3a506d3$var$CustomMessage = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81vlj _19pkidpf _syaz1rc1",
                __cmplp.className
            ])
        });
    });
    const $7179c7fdb3a506d3$var$errorMessageContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBottom: 'space.100'
    });
});
parcelRegister("qfj8c", function(module, exports) {
    $parcel$export(module.exports, "HelperMessage", ()=>$b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
    $parcel$export(module.exports, "ErrorMessage", ()=>$b2d5b368fed948c9$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ValidMessage", ()=>$b2d5b368fed948c9$export$5505afb209a532c8);
    $parcel$export(module.exports, "MessageWrapper", ()=>$b2d5b368fed948c9$export$ec445f12f63100a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $059q9;
    var $g4M8x;
    var $dRN65;
    function $b2d5b368fed948c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b2d5b368fed948c9$var$messageStyles = {
        name: "drnq1s",
        styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
    };
    const $b2d5b368fed948c9$var$messageAppearanceStyles = {
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
        }),
        error: {
            name: "g75jq6",
            styles: "color:var(--ds-text-danger, #AE2A19)"
        },
        valid: {
            name: "118r6eb",
            styles: "color:var(--ds-text-success, #216E4E)"
        }
    };
    const $b2d5b368fed948c9$var$iconWrapperStyles = {
        name: "x5c876",
        styles: "display:flex;height:16px;align-items:center"
    };
    const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b2d5b368fed948c9$var$iconWrapperStyles
        }, children);
    };
    const $b2d5b368fed948c9$var$messageIcons = {
        error: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }),
        valid: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("g4M8x"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        })
    };
    const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
        const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
        const messageRef = (0, $5uXOq.useRef)(null);
        const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
        const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$export$579aef2c392a54d4);
        (0, $5uXOq.useEffect)(()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        }, [
            isWrapper
        ]);
        const content = typeof children === 'string' ? children : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b2d5b368fed948c9$var$messageStyles,
                $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": !hasMessageWrapper ? 'polite' : undefined
        }, icon && (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$IconWrapper, null, icon), content);
    };
    const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$579aef2c392a54d4 = (0, $5uXOq.createContext)({
        isWrapper: false
    });
    const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
        const contextValue = {
            isWrapper: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$export$579aef2c392a54d4.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
    };
});
parcelRegister("059q9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));
    var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
    function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>$00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
        }, props));
    $00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;
});
parcelRegister("hAZqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ccf572dfbabebdf7$var$_UNSAFE_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>$ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
    var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;
});
parcelRegister("g4M8x", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));
    var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
    function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bb425bfe72dc5677$var$SuccessIcon = (props)=>$bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
        }, props));
    $bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;
});
parcelRegister("hs3k8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0347594f5084a834$var$_UNSAFE_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0347594f5084a834$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0347594f5084a834$var$SuccessIcon = (props)=>$0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
    var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;
});
parcelRegister("kJ541", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $f16bf031974cd311$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>$f16bf031974cd311$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
        }, props, {
            newIcon: $f16bf031974cd311$var$_success.default
        }));
    $f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
    var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;
});
parcelRegister("b0JGA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8043220a46fa3485$var$_react = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8043220a46fa3485$var$_UNSAFE_baseNew = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8043220a46fa3485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8043220a46fa3485$var$SuccessIcon = (props)=>$8043220a46fa3485$var$_react.default.createElement($8043220a46fa3485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $8043220a46fa3485$var$SuccessIcon.displayName = 'SuccessIcon';
    var $8043220a46fa3485$var$_default = module.exports.default = $8043220a46fa3485$var$SuccessIcon;
});
parcelRegister("6cSbZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$133853deadf5a9af$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2Z8eU;
    function $133853deadf5a9af$export$2e2bcd8739ae039(props) {
        const { sharePermissionRows: sharePermissionRows, onRemove: onRemove, duplicatedIndex: duplicatedIndex, forceHideRemoveButton: forceHideRemoveButton, isEditorList: isEditorList } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($133853deadf5a9af$var$ShareeListContainer, null, sharePermissionRows.map((sharePermission, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Z8eU")).default), {
                index: index,
                key: index,
                sharePermission: sharePermission,
                onRemove: onRemove,
                isDuplicated: duplicatedIndex === index,
                forceHideRemoveButton: forceHideRemoveButton,
                isEditorRow: isEditorList
            })));
    }
    $133853deadf5a9af$export$2e2bcd8739ae039.defaultProps = {
        duplicatedIndex: undefined,
        forceHideRemoveButton: false
    };
    const $133853deadf5a9af$var$ShareeListContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_x3dope8f _ca0qu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2Z8eU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db419ba2e74b286a$export$2e2bcd8739ae039);
    var $az4zD;
    var $ed5lx;
    var $db419ba2e74b286a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("ed5lx")).default));
});
parcelRegister("ed5lx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$847dd90ceba06adb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $lLLkM;
    var $kMQVm;
    var $e0lqL;
    var $fEcPB;
    var $7cdJv;
    var $kzd4I;
    var $gAIjR;
    var $8VRWt;
    var $aVieu;
    const $847dd90ceba06adb$var$assertUnreachable = (_x)=>{
        throw new Error("Didn't expect to get here");
    };
    const $847dd90ceba06adb$var$RemoveIcon = ({ sharePermission: sharePermission, isEditorRow: isEditorRow, intl: intl })=>{
        const { type: type } = sharePermission;
        let sharePermissionMessage;
        switch(type){
            case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                sharePermissionMessage = intl.formatMessage((0, (0, parcelRequire("7cdJv")).default).groupPermission, {
                    groupName: sharePermission.group.name
                });
                break;
            case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                sharePermissionMessage = intl.formatMessage((0, (0, parcelRequire("7cdJv")).default).projectPermission, {
                    projectName: sharePermission.project.name,
                    projectRole: sharePermission.role?.name ?? intl.formatMessage((0, (0, parcelRequire("kzd4I")).default).allRoles)
                });
                break;
            case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                sharePermissionMessage = intl.formatMessage((0, (0, parcelRequire("7cdJv")).default).userPermission, {
                    displayName: sharePermission.user.displayName
                });
                break;
            case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
            case 0, $a889b3091d5309c7$export$86517eb0163ef745:
            case 0, $99958954cd57b065$export$52e14e112503bf52:
            case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                sharePermissionMessage = intl.formatMessage((0, (0, parcelRequire("kMQVm")).allShareTypesProperties)[sharePermission.type].messageDescriptor);
                break;
            default:
                $847dd90ceba06adb$var$assertUnreachable(type);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
            label: intl.formatMessage(isEditorRow ? (0, (0, parcelRequire("7cdJv")).default).removeEditorSharePermissionButton : (0, (0, parcelRequire("7cdJv")).default).removeViewerSharePermissionButton, {
                sharePermission: sharePermissionMessage
            })
        });
    };
    class $847dd90ceba06adb$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                forceHideRemoveButton: false
            };
        }
        renderSharePermission() {
            const { sharePermission: sharePermission, intl: intl } = this.props;
            const { type: type } = sharePermission;
            switch(type){
                case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fEcPB")).default), {
                        sharePermission: sharePermission
                    });
                case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAIjR")).default), {
                        sharePermission: sharePermission
                    });
                case 0, $a889b3091d5309c7$export$487da0972e3459fe:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8VRWt")).default), null);
                case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVieu")).default), {
                        sharePermission: sharePermission
                    });
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                case 0, $99958954cd57b065$export$52e14e112503bf52:
                    {
                        const shareTypeProperties = (0, (0, parcelRequire("kMQVm")).allShareTypesProperties)[sharePermission.type];
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0lqL")).IconWrapper), null, shareTypeProperties.icon), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0lqL")).NameWrapper), null, intl.formatMessage(shareTypeProperties.messageDescriptor)));
                    }
                default:
                    $847dd90ceba06adb$var$assertUnreachable(type);
                    return null;
            }
        }
        renderRow() {
            const shouldShowRemoveButton = !this.props.forceHideRemoveButton && this.props.sharePermission.type !== (0, $99958954cd57b065$export$52e14e112503bf52);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$RowContainer, {
                "data-testid": "shareable-entity-dialog.access.sharee-list.sharee-list-row.group-permission"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$NameContainer, null, this.renderSharePermission()), shouldShowRemoveButton && (0, ($parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$RemoveButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "subtle",
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$RemoveIcon, {
                    intl: this.props.intl,
                    isEditorRow: this.props.isEditorRow,
                    sharePermission: this.props.sharePermission
                }),
                onClick: this.onRemove
            })));
        }
        render() {
            const { isDuplicated: isDuplicated } = this.props;
            const row = this.renderRow();
            return isDuplicated ? (0, ($parcel$interopDefault($5uXOq))).createElement($847dd90ceba06adb$var$BlinkWrapper, null, row) : row;
        }
        constructor(...args){
            super(...args), this.onRemove = (event, analyticsEvent)=>{
                const { index: index, onRemove: onRemove } = this.props;
                onRemove(index, analyticsEvent);
            };
        }
    }
    const $847dd90ceba06adb$var$RowContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1osq _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $847dd90ceba06adb$var$NameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $847dd90ceba06adb$var$RemoveButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
    const $847dd90ceba06adb$var$blinkKeyFrames = null;
    const $847dd90ceba06adb$var$BlinkWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1pby15gg _2rkoyh40 _y44v1ipw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("e0lqL", function(module, exports) {
    $parcel$export(module.exports, "NameWrapper", ()=>$918b0689b5ed9d88$export$45df02f361199409);
    $parcel$export(module.exports, "IconWrapper", ()=>$918b0689b5ed9d88$export$be58b4326e23250f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $918b0689b5ed9d88$export$45df02f361199409 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dl1wug _o5721q9c _1bto1l2s _1reo15vq _18m915vq _18u0u2gc _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $918b0689b5ed9d88$export$be58b4326e23250f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _1yt4v77o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fEcPB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41d48efa411cbf93$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kFO36;
    var $e0lqL;
    function $41d48efa411cbf93$export$2e2bcd8739ae039({ sharePermission: { group: group } }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0lqL")).IconWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kFO36"))))), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0lqL")).NameWrapper), null, group.name));
    }
});
parcelRegister("7cdJv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d74fed1ad0fcdbea$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d74fed1ad0fcdbea$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        groupPermission: {
            "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.group-permission",
            "defaultMessage": "Group {groupName}"
        },
        projectPermission: {
            "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.project-permission",
            "defaultMessage": "Project {projectName}, {projectRole}"
        },
        userPermission: {
            "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.user-permission",
            "defaultMessage": "User {displayName}"
        },
        removeViewerSharePermissionButton: {
            "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.remove-viewer-share-permission-button",
            "defaultMessage": "Remove viewer permission for {sharePermission}"
        },
        removeEditorSharePermissionButton: {
            "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.remove-editor-share-permission-button",
            "defaultMessage": "Remove editor permission for {sharePermission}"
        }
    });
});
parcelRegister("kzd4I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c660fd04fb607b64$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c660fd04fb607b64$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        allRoles: {
            "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.project-name.all-roles",
            "defaultMessage": "All roles"
        }
    });
});
parcelRegister("gAIjR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$71031e4fd465625a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    var $3xTyb;
    var $az4zD;
    var $wUom6;
    var $kzd4I;
    function $71031e4fd465625a$export$e9c1012e93a9bbb8(props) {
        const { intl: { formatMessage: formatMessage }, sharePermission: { project: project, role: role } } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !project.avatarUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("wUom6")).AvatarIllustrationContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3xTyb")).default), {
            alt: ""
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "square",
            src: project.avatarUrl,
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($71031e4fd465625a$var$ProjectNameContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($71031e4fd465625a$var$ProjectNameWrapper, null, project.name), (0, ($parcel$interopDefault($5uXOq))).createElement($71031e4fd465625a$var$RoleNameWrapper, null, `, ${role && role.name || formatMessage((0, (0, parcelRequire("kzd4I")).default).allRoles)}`)));
    }
    var $71031e4fd465625a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($71031e4fd465625a$export$e9c1012e93a9bbb8);
    const $71031e4fd465625a$var$ProjectNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $71031e4fd465625a$var$RoleNameWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c _1bto1l2s _1reo15vq _18m915vq _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $71031e4fd465625a$var$ProjectNameWrapper = (0, $5uXOq.forwardRef)(({ as: C = $71031e4fd465625a$var$RoleNameWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3xTyb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d92b5c1bcdeaec40$export$2e2bcd8739ae039);
    var $dCLgq;
    var $7K6qF = parcelRequire("7K6qF");
    const $d92b5c1bcdeaec40$export$abdf1e325e38b834 = (0, ($parcel$interopDefault($7K6qF)));
    const $d92b5c1bcdeaec40$export$87ec2877821a8f12 = (0, ($parcel$interopDefault($7K6qF)));
    const $d92b5c1bcdeaec40$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: $d92b5c1bcdeaec40$export$abdf1e325e38b834,
        srcDark: $d92b5c1bcdeaec40$export$87ec2877821a8f12,
        autoDark: false
    });
    var $d92b5c1bcdeaec40$export$2e2bcd8739ae039 = $d92b5c1bcdeaec40$var$Illustration;
    const $d92b5c1bcdeaec40$export$a179c88182cb9d56 = [
        0,
        0,
        256,
        145
    ];
});
parcelRegister("dCLgq", function(module, exports) {
    $parcel$export(module.exports, "Illustration", ()=>$191b30bb5e9fa934$export$d43c2e2ca9b2c105);
    $parcel$export(module.exports, "createIllustration", ()=>$191b30bb5e9fa934$export$4d00e7be716a0093);
    var $5uXOq = parcelRequire("5uXOq");
    var $10ozQ;
    function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("10ozQ")).AsImg), props);
    }
    function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
                srcLight: srcLight,
                srcDark: srcDark,
                autoDark: autoDark,
                ...props
            });
    }
});
parcelRegister("10ozQ", function(module, exports) {
    $parcel$export(module.exports, "AsImg", ()=>$b5af8835f639f069$export$75e378065cb7d6c0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    const $b5af8835f639f069$var$defaultStyles = null;
    const $b5af8835f639f069$var$fillStyles = null;
    const $b5af8835f639f069$var$autoDarkModeStyles = null;
    function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: colorMode === 'dark' ? srcDark : srcLight,
            alt: alt,
            "data-testid": testId,
            ...imgProps,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
                fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
                colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
            ])
        });
    }
});
parcelRegister("7K6qF", function(module, exports) {
    module.exports = new URL("default-project-avatar.6f6d91f9.svg", import.meta.url).toString();
});
parcelRegister("wUom6", function(module, exports) {
    $parcel$export(module.exports, "AvatarIllustrationContainer", ()=>$9038c7ec9dbb687d$export$eb8ddf7dfea2a0d4);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $9038c7ec9dbb687d$export$eb8ddf7dfea2a0d4 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $9038c7ec9dbb687d$var$containerStyles
        }, children);
    const $9038c7ec9dbb687d$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.050',
        display: 'inline-block',
        height: '24px',
        margin: 'space.025',
        overflow: 'hidden',
        width: '24px'
    });
});
parcelRegister("8VRWt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5832cd7416c04198$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gtreQ;
    var $3bDjY;
    var $koVbs;
    var $kMQVm;
    var $e0lqL;
    var $dRdD7;
    const $5832cd7416c04198$export$9dc8ff4861a5b6ef = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l _19bv1b66 _s7n4nkob",
                __cmplp.className
            ])
        });
    });
    const $5832cd7416c04198$var$UnknownProject = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const shareTypeProperties = (0, (0, parcelRequire("kMQVm")).allShareTypesProperties)[0, $a889b3091d5309c7$export$487da0972e3459fe];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0lqL")).IconWrapper), null, shareTypeProperties.icon), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0lqL")).NameWrapper), null, formatMessage(shareTypeProperties.messageDescriptor), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("dRdD7")).default).unknownProjectWarning),
            tag: $5832cd7416c04198$export$9dc8ff4861a5b6ef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            label: formatMessage((0, (0, parcelRequire("dRdD7")).default).unknownProjectWarning),
            size: "medium",
            primaryColor: `var(--ds-icon-accent-gray, ${(0, $829f609a65d26a98$exports).N200})`
        }))));
    };
    var $5832cd7416c04198$export$2e2bcd8739ae039 = $5832cd7416c04198$var$UnknownProject;
});
parcelRegister("dRdD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27775c6f2dd74e16$export$2e2bcd8739ae039);
    var $7VHMR;
    var $27775c6f2dd74e16$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unknownProjectWarning: {
            "id": "shareable-entity-dialog.access.sharee-list.sharee-list-row.unknown-project.unknown-project-warning",
            "defaultMessage": "You do not have access to this project. Saving will remove this share."
        }
    });
});
parcelRegister("aVieu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31c1c6d556d26b70$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    var $j85Tc;
    var $wUom6;
    const $31c1c6d556d26b70$var$UserName = (props)=>{
        const { sharePermission: { user: user } } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !user.avatarUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("wUom6")).AvatarIllustrationContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("j85Tc"))))), {
            label: ""
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "square",
            src: user.avatarUrl,
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($31c1c6d556d26b70$var$UserNameContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($31c1c6d556d26b70$var$UserNameWrapper, null, user.displayName)));
    };
    var $31c1c6d556d26b70$export$2e2bcd8739ae039 = $31c1c6d556d26b70$var$UserName;
    const $31c1c6d556d26b70$var$UserNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $31c1c6d556d26b70$var$RoleNameWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c _1bto1l2s _1reo15vq _18m915vq _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $31c1c6d556d26b70$var$UserNameWrapper = (0, $5uXOq.forwardRef)(({ as: C = $31c1c6d556d26b70$var$RoleNameWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2X0ZZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07a3ed40679122bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g5X3G;
    var $9OXo1;
    var $h18n7;
    var $07a3ed40679122bc$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: { atlassianAccountId: atlassianAccountId, isAdmin: isAdmin } })=>atlassianAccountId != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h18n7")).default), {
                accountId: (0, (0, parcelRequire("g5X3G")).toAccountId)(atlassianAccountId),
                isAdmin: isAdmin,
                ...props
            }));
});
parcelRegister("h18n7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0524d0793d201f28$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8QpSo;
    var $fVnbM;
    var $qfj8c;
    var $gwIPs;
    var $lMdZA;
    var $ousew;
    var $az4zD;
    var $fs8YG;
    var $eMLW9;
    var $imOJb;
    var $96ZCx;
    var $4tJPV;
    const $0524d0793d201f28$var$mapToPickerProject = (0, (0, parcelRequire("8QpSo")).default)((project)=>{
        if (!project) return undefined;
        return {
            value: project.id,
            name: project.name,
            avatarUrl: project.avatarUrl
        };
    });
    const $0524d0793d201f28$var$mapFromPickerProject = (0, (0, parcelRequire("8QpSo")).default)((project)=>({
            id: project.value,
            name: project.name,
            avatarUrl: project.avatarUrl
        }));
    const $0524d0793d201f28$var$defaultPickerType = (0, $a889b3091d5309c7$export$b02d7412182d1bce);
    const $0524d0793d201f28$var$getStateChangesOnTypeChange = (type)=>({
            selectedType: type,
            selectedGroup: undefined,
            selectedProject: undefined,
            selectedRole: undefined,
            selectedUser: undefined
        });
    class $0524d0793d201f28$export$aa7f7f1ebf5525ed extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                type: undefined
            };
        }
        static getDerivedStateFromProps(props, state) {
            const { type: type } = props;
            const { selectedType: selectedType, previousPropsType: previousPropsType } = state;
            if (!type || type === previousPropsType || type === selectedType) return {
                previousPropsType: type
            };
            return {
                previousPropsType: type,
                ...$0524d0793d201f28$var$getStateChangesOnTypeChange(type || selectedType || $0524d0793d201f28$var$defaultPickerType)
            };
        }
        getShareTypeHelperMessage() {
            const { selectedType: selectedType } = this.state;
            if (this.props.isShareScopeLoading) return (0, (0, parcelRequire("96ZCx")).default).shareScopeLoadingHelperMessage;
            switch(selectedType){
                case 0, $99958954cd57b065$export$52e14e112503bf52:
                    return (0, (0, parcelRequire("96ZCx")).default).privateShareHelperMessage;
                case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                    return (0, (0, parcelRequire("96ZCx")).default).safePublicShareHelperMessage;
                case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                    return (0, (0, parcelRequire("96ZCx")).default).openShareHelperMessage;
                default:
                    return undefined;
            }
        }
        getOptionsWithHelperMessage() {
            const { options: options, intl: { formatMessage: formatMessage } } = this.props;
            const { selectedType: selectedType } = this.state;
            const message = this.getShareTypeHelperMessage();
            return options.map((option)=>{
                if (message && option.value === selectedType) return {
                    ...option,
                    label: formatMessage(message, {
                        website: window.location.host
                    })
                };
                return option;
            });
        }
        onKeyDown(event) {
            if (event.key === 'Escape') event.stopPropagation();
        }
        renderPicker() {
            const { accountId: accountId, isAdmin: isAdmin, intl: { formatMessage: formatMessage } } = this.props;
            const { selectedType: selectedType, selectedGroup: selectedGroup, selectedProject: selectedProject, selectedRole: selectedRole, selectedUser: selectedUser } = this.state;
            switch(selectedType){
                case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lMdZA")).default), {
                        placeholder: formatMessage((0, (0, parcelRequire("96ZCx")).default).groupPlaceholderText),
                        baseUrl: "",
                        onChange: this.onGroupChange,
                        fetchOnce: false,
                        withMember: isAdmin ? undefined : accountId || undefined,
                        selectedGroup: selectedGroup,
                        width: (0, (0, parcelRequire("gwIPs")).gridSize) * 40,
                        isCompact: true,
                        onKeyDown: this.onKeyDown
                    });
                case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imOJb")).default), {
                        placeholder: formatMessage((0, (0, parcelRequire("96ZCx")).default).userPlaceholderText),
                        baseUrl: "",
                        onChange: this.onUserChange,
                        selectedUser: selectedUser,
                        width: (0, (0, parcelRequire("gwIPs")).gridSize) * 40,
                        isCompact: true,
                        onKeyDown: this.onKeyDown
                    });
                case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ColumnWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fs8YG")).default), {
                        placeholder: formatMessage((0, (0, parcelRequire("96ZCx")).default).projectPlaceholderText),
                        baseUrl: "",
                        onChange: this.onProjectChange,
                        selectedProject: $0524d0793d201f28$var$mapToPickerProject(selectedProject),
                        width: (0, (0, parcelRequire("gwIPs")).gridSize) * 20,
                        isCompact: true,
                        requireBrowsePermission: !isAdmin,
                        onKeyDown: this.onKeyDown
                    })), selectedProject ? (0, ($parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ColumnWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMLW9")).default), {
                        key: selectedProject.id,
                        placeholder: formatMessage((0, (0, parcelRequire("96ZCx")).default).rolePlaceholderText),
                        baseUrl: "",
                        projectId: selectedProject.id,
                        onChange: this.onRoleChange,
                        selectedRole: selectedRole,
                        width: (0, (0, parcelRequire("gwIPs")).gridSize) * 20,
                        isCompact: true,
                        isCurrentMember: !isAdmin,
                        onKeyDown: this.onKeyDown
                    })) : null);
                default:
                    return null;
            }
        }
        render() {
            const { intl: { formatMessage: formatMessage }, options: options, isShareScopeLoading: isShareScopeLoading, isEditorList: isEditorList, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby } = this.props;
            const isOnlyPublicAndOrganization = options.length === 2 && options.every((i)=>i.value === (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269) || i.value === (0, $a889b3091d5309c7$export$86517eb0163ef745));
            const { selectedType: selectedType } = this.state;
            const shareTypeHelperMessage = this.getShareTypeHelperMessage();
            const optionsWithLabelsForScreenReader = this.getOptionsWithHelperMessage();
            return (0, ($parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ShareePickerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$PickerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ColumnWrapper, null, isEditorList ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4tJPV")).EditorTypePicker), {
                ariaLabel: ariaLabel,
                ariaLabelledby: ariaLabelledby,
                type: selectedType,
                isShareScopeLoading: isShareScopeLoading,
                options: optionsWithLabelsForScreenReader,
                onChange: this.onTypeChange
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4tJPV")).default), {
                ariaLabel: ariaLabel,
                ariaLabelledby: ariaLabelledby,
                type: selectedType,
                isShareScopeLoading: isShareScopeLoading,
                options: optionsWithLabelsForScreenReader,
                onChange: this.onTypeChange
            })), shareTypeHelperMessage && (0, ($parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$ColumnWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...shareTypeHelperMessage,
                values: {
                    website: (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, window.location.host)
                }
            }))), !isShareScopeLoading && this.renderPicker()), (0, ($parcel$interopDefault($5uXOq))).createElement($0524d0793d201f28$var$AddButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                isDisabled: isShareScopeLoading,
                onClick: this.onAdd,
                "aria-label": formatMessage(isEditorList ? (0, (0, parcelRequire("96ZCx")).default).addEditors : (0, (0, parcelRequire("96ZCx")).default).addViewers)
            }, isOnlyPublicAndOrganization ? formatMessage((0, (0, parcelRequire("96ZCx")).default).update) : formatMessage((0, (0, parcelRequire("96ZCx")).default).add))));
        }
        constructor(...args){
            super(...args), this.state = {
                previousPropsType: undefined,
                selectedType: $0524d0793d201f28$var$defaultPickerType,
                selectedGroup: undefined,
                selectedProject: undefined,
                selectedRole: undefined,
                selectedUser: undefined
            }, this.onTypeChange = (type)=>{
                this.setState($0524d0793d201f28$var$getStateChangesOnTypeChange(type));
            }, this.onUserChange = (value)=>{
                this.setState({
                    selectedUser: value
                });
            }, this.onGroupChange = (value)=>{
                this.setState({
                    selectedGroup: value
                });
            }, this.onProjectChange = (value)=>{
                this.setState({
                    selectedProject: value && $0524d0793d201f28$var$mapFromPickerProject(value),
                    selectedRole: undefined
                });
            }, this.onRoleChange = (role)=>{
                this.setState({
                    selectedRole: role
                });
            }, this.onAdd = (event, analyticsEvent)=>{
                const { onAddSharePermission: onAddSharePermission } = this.props;
                const { selectedType: selectedType, selectedGroup: selectedGroup, selectedProject: selectedProject, selectedRole: selectedRole, selectedUser: selectedUser } = this.state;
                switch(selectedType){
                    case 0, $a889b3091d5309c7$export$b02d7412182d1bce:
                        if (selectedGroup) onAddSharePermission({
                            type: (0, $a889b3091d5309c7$export$b02d7412182d1bce),
                            group: selectedGroup
                        }, analyticsEvent);
                        break;
                    case 0, $a889b3091d5309c7$export$aea0835048e1c730:
                        if (selectedUser) onAddSharePermission({
                            type: (0, $a889b3091d5309c7$export$aea0835048e1c730),
                            user: selectedUser
                        }, analyticsEvent);
                        break;
                    case 0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6:
                        if (selectedProject) onAddSharePermission({
                            type: (0, $a889b3091d5309c7$export$5ef95a67b8fd1ff6),
                            project: selectedProject,
                            role: selectedRole
                        }, analyticsEvent);
                        break;
                    case 0, $99958954cd57b065$export$52e14e112503bf52:
                        onAddSharePermission({
                            type: (0, $99958954cd57b065$export$52e14e112503bf52)
                        }, analyticsEvent);
                        break;
                    case 0, $a889b3091d5309c7$export$86517eb0163ef745:
                        onAddSharePermission({
                            type: (0, $a889b3091d5309c7$export$86517eb0163ef745)
                        }, analyticsEvent);
                        break;
                    case 0, $a889b3091d5309c7$export$b0a0e62d9b1a8269:
                        onAddSharePermission({
                            type: (0, $a889b3091d5309c7$export$b0a0e62d9b1a8269)
                        }, analyticsEvent);
                        break;
                    default:
                        return undefined;
                }
                return undefined;
            };
        }
    }
    var $0524d0793d201f28$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($0524d0793d201f28$export$aa7f7f1ebf5525ed);
    const $0524d0793d201f28$var$ShareePickerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1yt41bpf",
                __cmplp.className
            ])
        });
    });
    const $0524d0793d201f28$var$PickerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $0524d0793d201f28$var$ColumnWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $0524d0793d201f28$var$AddButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eMLW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bdc4a2fd9010a2a$export$2e2bcd8739ae039);
    var $8oe80;
    var $4GgYN;
    var $1bdc4a2fd9010a2a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('RolePicker', {
        onChange: 'changed'
    })((0, (0, parcelRequire("4GgYN")).default));
});
parcelRegister("4GgYN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7261cefebafe3f4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4U4qk;
    var $az4zD;
    var $dTXVf;
    var $eyiiq;
    const $e7261cefebafe3f4$var$filterOptions = (filter = '')=>{
        const lowerCaseFilter = filter.toLowerCase();
        return (option)=>option.label && option.label.toLowerCase().includes(lowerCaseFilter);
    };
    const $e7261cefebafe3f4$var$transformRoleIntoOption = (role)=>role && {
            label: role.name,
            value: role.id,
            url: role.url,
            description: role.description
        };
    const $e7261cefebafe3f4$var$transformOptionIntoRole = (option)=>option && {
            name: option.label,
            id: option.value,
            url: option.url,
            description: option.description
        };
    class $e7261cefebafe3f4$export$fcd75734e151a80 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isRequired: false,
                isDisabled: false,
                isClearable: true,
                isCompact: false,
                isCurrentMember: true,
                width: 200
            };
        }
        constructor(props){
            super(props), this.state = {
                selectedRole: $e7261cefebafe3f4$var$transformRoleIntoOption(this.props.selectedRole),
                prevSelectedRole: $e7261cefebafe3f4$var$transformRoleIntoOption(this.props.selectedRole),
                options: []
            }, this.onSelected = (selectedOption)=>{
                this.setState({
                    selectedRole: selectedOption
                });
                this.props.onChange($e7261cefebafe3f4$var$transformOptionIntoRole(selectedOption));
            }, this.fetchOptions = (filter)=>{
                const { baseUrl: baseUrl, projectId: projectId, isCurrentMember: isCurrentMember } = this.props;
                const { options: options } = this.state;
                return new Promise((resolve, reject)=>{
                    if (options.length) return resolve(options.filter($e7261cefebafe3f4$var$filterOptions(filter)));
                    return (0, (0, parcelRequire("dTXVf")).requestRoles)(baseUrl, projectId, isCurrentMember).then((newOptions)=>{
                        this.setState({
                            options: newOptions
                        });
                        return resolve(newOptions.filter($e7261cefebafe3f4$var$filterOptions(filter)));
                    }, reject);
                });
            };
            this.rolePickerId = `project-picker.label.id-${(0, ($parcel$interopDefault($7Jxgt)))()}`;
        }
        static getDerivedStateFromProps(props, state) {
            const { selectedRole: selectedRole } = props;
            const currentRole = selectedRole && selectedRole.id;
            const prevRole = state.prevSelectedRole && state.prevSelectedRole.value;
            if (currentRole !== prevRole) {
                const selectedRoleOption = $e7261cefebafe3f4$var$transformRoleIntoOption(selectedRole);
                return {
                    ...state,
                    selectedRole: selectedRoleOption,
                    prevSelectedRole: selectedRoleOption
                };
            }
            return null;
        }
        componentDidMount() {
            const { selectedRole: selectedRole } = this.state;
            if (selectedRole && !selectedRole.label) this.fetchRole(selectedRole);
        }
        componentDidUpdate() {
            const { selectedRole: selectedRole } = this.state;
            if (selectedRole && !selectedRole.label) this.fetchRole(selectedRole);
        }
        fetchRole(selectedRole) {
            const { baseUrl: baseUrl, projectId: projectId } = this.props;
            const optionValue = selectedRole.value;
            const updateSelectedRole = (newRole)=>{
                const currentRole = this.state.selectedRole;
                const currentRoleValue = currentRole && currentRole.value;
                if (currentRoleValue === optionValue) this.setState({
                    selectedRole: newRole
                });
            };
            return (0, (0, parcelRequire("dTXVf")).requestRole)(baseUrl, projectId, optionValue).then((role)=>updateSelectedRole(role)).catch(()=>updateSelectedRole(undefined));
        }
        render() {
            const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, onChange: onChange, projectId: projectId, selectedRole: selectedRole, ...props } = this.props;
            const { selectedRole: role } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4U4qk")).default), {
                "aria-label": !this.props.label ? formatMessage((0, (0, parcelRequire("eyiiq")).default).labelText) : undefined,
                ...props,
                inputId: !this.props.inputId ? this.rolePickerId : this.props.inputId,
                errorMessage: formatMessage((0, (0, parcelRequire("eyiiq")).default).error),
                placeholder: formatMessage((0, (0, parcelRequire("eyiiq")).default).placeholder),
                onSelected: this.onSelected,
                options: this.fetchOptions,
                value: role && role.label ? role : null
            });
        }
    }
    var $e7261cefebafe3f4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($e7261cefebafe3f4$export$fcd75734e151a80);
});
parcelRegister("dTXVf", function(module, exports) {
    $parcel$export(module.exports, "requestRoles", ()=>$6817e21b7afb963f$export$81b6bcb1593f7ad8);
    $parcel$export(module.exports, "requestRole", ()=>$6817e21b7afb963f$export$258bff876f7723cb);
    var $1K1Tu;
    var $67oaB;
    const $6817e21b7afb963f$export$81b6bcb1593f7ad8 = (baseUrl, projectId, isCurrentMember)=>(0, (0, parcelRequire("1K1Tu")).getRoles)(baseUrl, projectId, isCurrentMember).then((0, (0, parcelRequire("67oaB")).transformRoles));
    const $6817e21b7afb963f$export$258bff876f7723cb = (baseUrl, projectId, RoleId)=>(0, (0, parcelRequire("1K1Tu")).getRole)(baseUrl, projectId, RoleId).then((0, (0, parcelRequire("67oaB")).transformRole));
});
parcelRegister("1K1Tu", function(module, exports) {
    $parcel$export(module.exports, "getRoles", ()=>$fcf9bea3774b5ab1$export$57690667ea6b189b);
    $parcel$export(module.exports, "getRole", ()=>$fcf9bea3774b5ab1$export$d1c3a5ff834adfa2);
    var $7f4tk;
    const $fcf9bea3774b5ab1$export$29d3dfcf36fbbba5 = (baseUrl, projectId)=>`${baseUrl}/rest/api/2/project/${encodeURIComponent(projectId)}`;
    const $fcf9bea3774b5ab1$export$1eec61a4fdaceca = (baseUrl, projectId, isCurrentMember)=>`${$fcf9bea3774b5ab1$export$29d3dfcf36fbbba5(baseUrl, projectId)}/roledetails${isCurrentMember ? '?currentMember=true' : ''}`;
    const $fcf9bea3774b5ab1$export$177b7e5a782e5173 = (baseUrl, projectId, roleId)=>`${$fcf9bea3774b5ab1$export$29d3dfcf36fbbba5(baseUrl, projectId)}/role/${encodeURIComponent(roleId)}`;
    const $fcf9bea3774b5ab1$export$57690667ea6b189b = (baseUrl, projectId, isCurrentMember)=>(0, (0, parcelRequire("7f4tk")).default)($fcf9bea3774b5ab1$export$1eec61a4fdaceca(baseUrl, projectId, isCurrentMember));
    const $fcf9bea3774b5ab1$export$d1c3a5ff834adfa2 = (baseUrl, projectId, roleId)=>(0, (0, parcelRequire("7f4tk")).default)($fcf9bea3774b5ab1$export$177b7e5a782e5173(baseUrl, projectId, roleId));
});
parcelRegister("67oaB", function(module, exports) {
    $parcel$export(module.exports, "transformRole", ()=>$b107ae56f6577753$export$4f8aa0fda592cc8e);
    $parcel$export(module.exports, "transformRoles", ()=>$b107ae56f6577753$export$18407dd0d4132046);
    const $b107ae56f6577753$export$4f8aa0fda592cc8e = (role)=>({
            value: role.id,
            label: role.name,
            description: role.description,
            url: role.self
        });
    const $b107ae56f6577753$export$18407dd0d4132046 = (roles)=>roles && roles.map($b107ae56f6577753$export$4f8aa0fda592cc8e) || [];
});
parcelRegister("eyiiq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18db9d0f15e57bec$export$2e2bcd8739ae039);
    var $7VHMR;
    var $18db9d0f15e57bec$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        error: {
            "id": "role-picker.error",
            "defaultMessage": "We couldn't retrieve roles"
        },
        placeholder: {
            "id": "role-picker.placeholder",
            "defaultMessage": "All roles"
        },
        labelText: {
            "id": "role-picker.label-text",
            "defaultMessage": "Role"
        }
    });
});
parcelRegister("96ZCx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5b1d0778f6b8c17$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f5b1d0778f6b8c17$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        add: {
            "id": "shareable-entity-dialog.access.sharee-picker.add",
            "defaultMessage": "Add"
        },
        update: {
            "id": "shareable-entity-dialog.access.sharee-picker.update",
            "defaultMessage": "Update"
        },
        openShareHelperMessage: {
            "id": "shareable-entity-dialog.access.sharee-picker.open-share-helper-message",
            "defaultMessage": "Any logged in user on {website}"
        },
        safePublicShareHelperMessage: {
            "id": "shareable-entity-dialog.access.sharee-picker.safe-public-share-helper-message",
            "defaultMessage": "Anyone on the internet. No sign-in required"
        },
        privateShareHelperMessage: {
            "id": "shareable-entity-dialog.access.sharee-picker.private-share-helper-message",
            "defaultMessage": "Only you"
        },
        shareScopeLoadingHelperMessage: {
            "id": "shareable-entity-dialog.access.sharee-picker.share-scope-loading-helper-message",
            "defaultMessage": "Checking for the default user preference"
        },
        addViewers: {
            "id": "shareable-entity-dialog.access.sharee-picker.add-viewers",
            "defaultMessage": "Add viewers"
        },
        addEditors: {
            "id": "shareable-entity-dialog.access.sharee-picker.add-editors",
            "defaultMessage": "Add editors"
        },
        projectPlaceholderText: {
            "id": "shareable-entity-dialog.access.sharee-picker.project-placeholder-text",
            "defaultMessage": "Select project"
        },
        userPlaceholderText: {
            "id": "shareable-entity-dialog.access.sharee-picker.user-placeholder-text",
            "defaultMessage": "Select user"
        },
        groupPlaceholderText: {
            "id": "shareable-entity-dialog.access.sharee-picker.group-placeholder-text",
            "defaultMessage": "Select group"
        },
        rolePlaceholderText: {
            "id": "shareable-entity-dialog.access.sharee-picker.role-placeholder-text",
            "defaultMessage": "Select role"
        }
    });
});
parcelRegister("4tJPV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0652ef7cc6a18d8$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "EditorTypePicker", ()=>$c0652ef7cc6a18d8$export$79b74763bbaf2964);
    var $iQv12;
    var $8xVQG;
    var $c0652ef7cc6a18d8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iQv12")).default)({
        onChange: 'pickShareeType'
    })((0, (0, parcelRequire("8xVQG")).default));
    const $c0652ef7cc6a18d8$export$79b74763bbaf2964 = (0, (0, parcelRequire("iQv12")).default)({
        onChange: 'pickEditorType'
    })((0, (0, parcelRequire("8xVQG")).default));
});
parcelRegister("8xVQG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a3c798582ea2821$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $4USKh;
    var $gwIPs;
    var $az4zD;
    var $coL5i;
    const $0a3c798582ea2821$var$getOption = (options, type)=>options.find((option)=>option.value === type) || options[0];
    const $0a3c798582ea2821$var$getNormalizedOptions = (0, (0, parcelRequire("8QpSo")).default)((options, formatMessage)=>options.map((option)=>{
            const returnOption = {
                ...option,
                label: formatMessage(option.messageDescriptor)
            };
            if (!returnOption.isDisabled) return returnOption;
            if (returnOption.value === (0, $a889b3091d5309c7$export$86517eb0163ef745)) return {
                ...returnOption,
                disableReason: formatMessage((0, (0, parcelRequire("coL5i")).default).globalDisableReason)
            };
            return returnOption;
        }));
    class $0a3c798582ea2821$export$60cbee36e1a5d2a2 extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            const { options: options, type: type } = props;
            if (state.selectedOption && state.selectedOption.value === type) return null;
            return {
                selectedOption: $0a3c798582ea2821$var$getOption(options, type)
            };
        }
        render() {
            const { isShareScopeLoading: isShareScopeLoading, options: options, intl: { formatMessage: formatMessage }, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby } = this.props;
            const normalizedOptions = $0a3c798582ea2821$var$getNormalizedOptions(options, formatMessage);
            const normalizedSelectOption = $0a3c798582ea2821$var$getOption(normalizedOptions, this.props.type);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4USKh")).PickerWithAvatarAndAnalytics), {
                onSelected: this.onChange,
                options: normalizedOptions,
                formatOptionDataTransformer: this.formatOptionDataTransformer,
                width: (0, (0, parcelRequire("gwIPs")).gridSize) * 20,
                listItemCustomStyles: {
                    marginBottom: 2
                },
                isRequired: false,
                isDisabled: isShareScopeLoading,
                isClearable: false,
                isCompact: true,
                ...isShareScopeLoading ? {
                    placeholder: ''
                } : {
                    value: normalizedSelectOption
                },
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledby,
                getOptionLabel: this.screenReaderLabelForOption,
                onKeyDown: this.onKeyDown
            });
        }
        constructor(...args){
            super(...args), this.state = {
                selectedOption: $0a3c798582ea2821$var$getOption(this.props.options, this.props.type)
            }, this.onChange = (option, analyticsEvent)=>{
                const { onChange: onChange } = this.props;
                onChange(option.value, analyticsEvent);
            }, this.onKeyDown = (event)=>{
                if (event.key === 'Escape') event.stopPropagation();
            }, this.screenReaderLabelForOption = (option)=>{
                const { options: options } = this.props;
                const currentOption = options?.length && options.find((optionFromList)=>optionFromList.value === option.value);
                if (currentOption && currentOption.label) return `${option.label}, ${currentOption.label}`;
                return option.label;
            }, this.formatOptionDataTransformer = (option)=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                return {
                    avatar: option.icon,
                    label: formatMessage(option.messageDescriptor)
                };
            };
        }
    }
    var $0a3c798582ea2821$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($0a3c798582ea2821$export$60cbee36e1a5d2a2);
});
parcelRegister("coL5i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$daaec463f6cc4d92$export$2e2bcd8739ae039);
    var $7VHMR;
    var $daaec463f6cc4d92$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        globalDisableReason: {
            "id": "shareable-entity-dialog.access.sharee-picker.sharee-type-picker.global-disable-reason",
            "defaultMessage": "This option has been disabled by your Jira administrator"
        }
    });
});
parcelRegister("iJRxf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31fb5dc919182b4f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8QpSo;
    var $qfj8c;
    var $7O4UO;
    var $kxqHl;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $6LCpJ;
    var $kY99m;
    var $3bDjY;
    var $hZHze;
    var $az4zD;
    var $6lbCM;
    var $7iGYR;
    var $9Aocd;
    const $31fb5dc919182b4f$export$f3336396f1d7e7f0 = 'shareable-entity-dialog.input-name';
    const $31fb5dc919182b4f$export$4ec563c550ebe302 = 'shareable-entity-dialog.text-field';
    const $31fb5dc919182b4f$var$toPickerUser = (0, (0, parcelRequire("8QpSo")).default)(({ accountId: accountId, displayName: displayName, avatarUrl: avatarUrl })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrl
        }));
    class $31fb5dc919182b4f$export$4e8eacd46550c748 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isPending: false,
                isEditorListShown: false,
                isNameReadOnly: false,
                owner: undefined
            };
        }
        renderFooter() {
            const { onCancel: onCancel, actionButtonCaption: actionButtonCaption, onAction: onAction, isPending: isPending, isNameRequiredError: isNameRequiredError, isShareScopeLoading: isShareScopeLoading = false } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iGYR")).default), {
                isActionEnabled: !isPending && !isNameRequiredError && !isShareScopeLoading,
                isActionInProgress: isPending,
                actionButtonCaption: actionButtonCaption,
                onAction: onAction,
                onCancel: onCancel
            });
        }
        renderModalBody() {
            const { isNameRequiredError: isNameRequiredError, isShareScopeLoading: isShareScopeLoading = false, intl: { formatMessage: formatMessage }, isEditorListShown: isEditorListShown, isNameReadOnly: isNameReadOnly, editOptions: editOptions, editPermissions: editPermissions, name: name, nameInputRef: nameInputRef, nameTooltip: nameTooltip, description: description, owner: owner, sharePermissions: sharePermissions, viewersCustomMessage: viewersCustomMessage, UserPicker: UserPicker, Access: Access, onDescriptionChange: onDescriptionChange, onEditPermissionChange: onEditPermissionChange, onNameChange: onNameChange, onOwnerChange: onOwnerChange, onSharePermissionChange: onSharePermissionChange, shareeOptions: shareeOptions, serverValidationErrors: serverValidationErrors } = this.props;
            const nameServerValidationError = serverValidationErrors[0, $99958954cd57b065$export$b85469cbf362db42];
            const descriptionServerValidationError = serverValidationErrors[0, $99958954cd57b065$export$a1d4ae33ba772a5b];
            const sharePermissionsServerValidationError = serverValidationErrors[0, $99958954cd57b065$export$378fd4cd7d69440f];
            const editPermissionsServerValidationError = serverValidationErrors[0, $99958954cd57b065$export$fb465a1f4d511f87];
            const nameValidationErrorMessage = isNameRequiredError ? formatMessage((0, (0, parcelRequire("9Aocd")).default).nameIsRequired) : nameServerValidationError;
            const renderNameField = (fieldProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                    ...fieldProps,
                    testId: $31fb5dc919182b4f$export$4ec563c550ebe302,
                    value: name,
                    isDisabled: isNameReadOnly,
                    onChange: onNameChange,
                    isInvalid: !!nameValidationErrorMessage,
                    ref: nameInputRef,
                    "aria-describedby": `${$31fb5dc919182b4f$export$f3336396f1d7e7f0}-error`
                });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                label: formatMessage((0, (0, parcelRequire("9Aocd")).default).name),
                isRequired: true,
                name: "name",
                id: $31fb5dc919182b4f$export$f3336396f1d7e7f0
            }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, nameTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: nameTooltip
                }, renderNameField(fieldProps)) : renderNameField(fieldProps), nameValidationErrorMessage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, nameValidationErrorMessage))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                label: formatMessage((0, (0, parcelRequire("9Aocd")).default).description),
                name: "description"
            }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6LCpJ")).default), {
                    ...fieldProps,
                    value: description,
                    onChange: onDescriptionChange,
                    isInvalid: !!descriptionServerValidationError
                }), descriptionServerValidationError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, descriptionServerValidationError))), owner && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                label: formatMessage((0, (0, parcelRequire("9Aocd")).default).owner),
                name: "owner"
            }, ({ fieldProps: { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(UserPicker, {
                    "aria-label": ariaLabel,
                    "aria-labelledby": ariaLabelledby,
                    selectedUser: $31fb5dc919182b4f$var$toPickerUser(owner),
                    onChange: onOwnerChange
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement(Access, {
                isShareScopeLoading: isShareScopeLoading,
                shareeOptions: shareeOptions,
                editOptions: editOptions,
                sharePermissions: sharePermissions,
                viewersCustomMessage: viewersCustomMessage,
                editPermissions: editPermissions,
                onSharePermissionChange: onSharePermissionChange,
                onEditPermissionChange: onEditPermissionChange,
                isEditorListShown: isEditorListShown,
                sharePermissionsServerValidationError: sharePermissionsServerValidationError,
                editPermissionsServerValidationError: editPermissionsServerValidationError
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null));
        }
        render() {
            const { title: title, headingTitleLevel: headingTitleLevel, intl: intl } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, title && (headingTitleLevel ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lbCM")).default), {
                headingLevel: headingTitleLevel,
                title: title
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($31fb5dc919182b4f$var$RequiredMessage, {
                "aria-hidden": "true"
            }, intl.formatMessage((0, (0, parcelRequire("9Aocd")).default).requiredFieldsSummary), " ", (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kxqHl")).default), null)), this.renderModalBody()), this.renderFooter());
        }
    }
    var $31fb5dc919182b4f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($31fb5dc919182b4f$export$4e8eacd46550c748);
    const $31fb5dc919182b4f$var$RequiredMessage = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1n3s",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6LCpJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$934f91ac04cc5aeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $1qQmi;
    const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
    const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
    const $934f91ac04cc5aeb$var$analyticsParams = {
        componentName: 'textArea',
        packageName: $934f91ac04cc5aeb$var$packageName,
        packageVersion: $934f91ac04cc5aeb$var$packageVersion
    };
    const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
        el.style.height = 'auto';
        const borderHeight = (0, (0, parcelRequire("1qQmi")).borderWidth);
        const paddingBoxHeight = el.scrollHeight;
        const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
        el.style.height = `${borderBoxHeight}px`;
    };
    const $934f91ac04cc5aeb$var$InnerTextArea = (0, $5uXOq.forwardRef)((props, ref)=>{
        const ourRef = (0, $5uXOq.useRef)(null);
        const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
        (0, $5uXOq.useEffect)(()=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        }, [
            resize,
            value
        ]);
        const onBlurWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const onFocusWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const getTextAreaRef = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === 'object') ref.current = elementRef;
            if (ref && typeof ref === 'function') ref(elementRef);
        };
        const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
            onChange && onChange(e);
        }, [
            onChange,
            resize
        ]);
        const controlProps = {
            'data-invalid': isInvalid ? isInvalid : undefined,
            'data-compact': isCompact ? isCompact : undefined,
            'data-testid': testId ? testId : undefined
        };
        const baseStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1qQmi")).getBaseStyles)({
                minimumRows: minimumRows,
                resize: resize,
                appearance: appearance,
                isMonospaced: isMonospaced,
                maxHeight: maxHeight
            }), [
            minimumRows,
            resize,
            appearance,
            isMonospaced,
            maxHeight
        ]);
        const textAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)([
            baseStyles,
            (0, (0, parcelRequire("1qQmi")).dynamicStyles)(appearance)
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            css: textAreaStyles,
            ...rest
        });
    });
    const $934f91ac04cc5aeb$var$TextArea = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function TextArea(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
            ref: ref,
            ...props
        });
    }));
    $934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
    var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;
});
parcelRegister("1qQmi", function(module, exports) {
    $parcel$export(module.exports, "borderWidth", ()=>$0f8aaecc0e682a20$export$12879c7697ed953d);
    $parcel$export(module.exports, "getBaseStyles", ()=>$0f8aaecc0e682a20$export$bff8031d86bb089);
    $parcel$export(module.exports, "dynamicStyles", ()=>$0f8aaecc0e682a20$export$98856a888ef36079);
    var $f8Sb3;
    var $iaE2J;
    function $0f8aaecc0e682a20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0f8aaecc0e682a20$var$disabledRules = {
        backgroundColor: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorHover: (0, parcelRequire("iaE2J")).disabledBackground,
        borderColor: (0, parcelRequire("iaE2J")).disabledBorder,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        textColor: (0, parcelRequire("iaE2J")).disabledTextColor
    };
    const $0f8aaecc0e682a20$var$invalidRules = {
        borderColor: (0, parcelRequire("iaE2J")).invalidBorderColor,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        backgroundColor: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        backgroundColorHover: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover
    };
    const $0f8aaecc0e682a20$var$backgroundColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).subtleBorderColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$lineHeightBase = 20;
    const $0f8aaecc0e682a20$var$lineHeightCompact = 16;
    const $0f8aaecc0e682a20$var$compactVerticalPadding = 2;
    const $0f8aaecc0e682a20$var$verticalPadding = 6;
    const $0f8aaecc0e682a20$var$horizontalPadding = 8;
    const $0f8aaecc0e682a20$var$transitionDuration = '0.2s';
    const $0f8aaecc0e682a20$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
    const $0f8aaecc0e682a20$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $0f8aaecc0e682a20$export$12879c7697ed953d = 2;
    const $0f8aaecc0e682a20$var$overrideSafariDisabledStyles = {
        WebkitTextFillColor: 'unset',
        WebkitOpacity: '1'
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
        const contentHeight = $0f8aaecc0e682a20$var$lineHeightBase * minimumRows;
        return contentHeight + $0f8aaecc0e682a20$var$verticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
        const contentHeightCompact = $0f8aaecc0e682a20$var$lineHeightCompact * minimumRows;
        return contentHeightCompact + $0f8aaecc0e682a20$var$compactVerticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$bgAndBorderColorStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorFocus[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$borderColorFocus[appearance]}`
            },
            '&:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColor[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColor[appearance]
            },
            '&[data-invalid]:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorFocus,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColorFocus,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColorFocus}`
            },
            '&[data-invalid]:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColor,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
            },
            ...appearance === 'standard' ? {
                '&:disabled:focus': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorFocus,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColorFocus
                },
                '&:disabled:not(:focus)': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColor,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColor
                }
            } : {}
        });
    const $0f8aaecc0e682a20$var$placeholderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::placeholder': {
            color: (0, parcelRequire("iaE2J")).placeholderTextColor
        },
        '&:disabled::placeholder': {
            color: $0f8aaecc0e682a20$var$disabledRules.textColor
        }
    });
    const $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:hover:not(:read-only):not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorHover[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorHover[appearance],
                '&:disabled': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorHover
                },
                '&[data-invalid]': {
                    backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorHover,
                    borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
                }
            }
        });
    var $0f8aaecc0e682a20$var$_ref = {
        name: "utehjx",
        styles: "resize:none"
    };
    var $0f8aaecc0e682a20$var$_ref2 = {
        name: "bolgb9",
        styles: "resize:both"
    };
    const $0f8aaecc0e682a20$var$resizeStyle = (resize)=>{
        if (resize === 'horizontal' || resize === 'vertical') return (0, (0, parcelRequire("f8Sb3")).css)({
            resize: resize
        });
        if (resize === 'auto') return $0f8aaecc0e682a20$var$_ref2;
        return $0f8aaecc0e682a20$var$_ref;
    };
    const $0f8aaecc0e682a20$var$borderStyle = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)({
            borderStyle: appearance === 'none' ? 'none' : 'solid'
        });
    const $0f8aaecc0e682a20$var$fontFamilyStyle = (isMonospaced)=>(0, (0, parcelRequire("f8Sb3")).css)({
            fontFamily: isMonospaced ? $0f8aaecc0e682a20$var$codeFontFamily : $0f8aaecc0e682a20$var$fontFamily
        });
    const $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
        const borderWidth = appearance !== 'none' ? 1 : 2;
        const horizontalPaddingWithoutBorderWidth = $0f8aaecc0e682a20$var$horizontalPadding - borderWidth;
        const borderHeight = borderWidth;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '&[data-compact]': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightCompact / 14
            },
            '&:not([data-compact])': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeight(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightBase / 14
            }
        });
    };
    const $0f8aaecc0e682a20$var$staticStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        position: 'relative',
        flex: '1 1 100%',
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        overflow: 'auto',
        transition: `background-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out,
               border-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out`,
        wordWrap: 'break-word',
        '&:disabled': {
            cursor: 'not-allowed',
            ...$0f8aaecc0e682a20$var$overrideSafariDisabledStyles
        },
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        }
    });
    const $0f8aaecc0e682a20$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$staticStyles, $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles(minimumRows, appearance), $0f8aaecc0e682a20$var$resizeStyle(resize), $0f8aaecc0e682a20$var$borderStyle(appearance), $0f8aaecc0e682a20$var$fontFamilyStyle(isMonospaced), {
            maxHeight: maxHeight
        });
    const $0f8aaecc0e682a20$export$98856a888ef36079 = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$bgAndBorderColorStyles(appearance), $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles(appearance), $0f8aaecc0e682a20$var$placeholderStyles, {
            color: (0, parcelRequire("iaE2J")).textColor,
            '&:disabled': {
                color: $0f8aaecc0e682a20$var$disabledRules.textColor
            }
        });
});
parcelRegister("iaE2J", function(module, exports) {
    $parcel$export(module.exports, "disabledBackground", ()=>$f788b902061573a8$export$ae3cba7672df0890);
    $parcel$export(module.exports, "disabledBorder", ()=>$f788b902061573a8$export$fe505fe3c5edbdf6);
    $parcel$export(module.exports, "invalidBorderColor", ()=>$f788b902061573a8$export$7f333bbf7ddab792);
    $parcel$export(module.exports, "defaultBorderColor", ()=>$f788b902061573a8$export$dafd83031c202ca8);
    $parcel$export(module.exports, "defaultBorderColorFocus", ()=>$f788b902061573a8$export$e8320c09dc1e4012);
    $parcel$export(module.exports, "defaultBackgroundColor", ()=>$f788b902061573a8$export$b13414ee9ac9cae6);
    $parcel$export(module.exports, "defaultBackgroundColorHover", ()=>$f788b902061573a8$export$bca15982c103d57b);
    $parcel$export(module.exports, "defaultBackgroundColorFocus", ()=>$f788b902061573a8$export$21287e4b7f134f09);
    $parcel$export(module.exports, "subtleBorderColorHover", ()=>$f788b902061573a8$export$a87538d56ee366ec);
    $parcel$export(module.exports, "placeholderTextColor", ()=>$f788b902061573a8$export$5e076b2557ef7bbb);
    $parcel$export(module.exports, "textColor", ()=>$f788b902061573a8$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "disabledTextColor", ()=>$f788b902061573a8$export$eb4a7d363eec53c8);
    $parcel$export(module.exports, "transparent", ()=>$f788b902061573a8$export$f4d082c200a4b4b8);
    const $f788b902061573a8$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $f788b902061573a8$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $f788b902061573a8$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
    const $f788b902061573a8$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`;
    const $f788b902061573a8$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
    const $f788b902061573a8$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`;
    const $f788b902061573a8$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $f788b902061573a8$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $f788b902061573a8$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
    const $f788b902061573a8$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
    const $f788b902061573a8$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
    const $f788b902061573a8$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`;
    const $f788b902061573a8$export$f4d082c200a4b4b8 = 'transparent';
});
parcelRegister("6lbCM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5097d73619a780fd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $5097d73619a780fd$var$ActionModalCustomHeader = ({ headingLevel: headingLevel = 1, title: title })=>{
        const Heading = `h${headingLevel}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5097d73619a780fd$var$CustomHeaderWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5097d73619a780fd$var$DynamicHeading, {
            as: Heading
        }, title));
    };
    var $5097d73619a780fd$export$2e2bcd8739ae039 = $5097d73619a780fd$var$ActionModalCustomHeader;
    const $5097d73619a780fd$var$DynamicHeading = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8o0gd",
                __cmplp.className
            ])
        });
    });
    const $5097d73619a780fd$var$headerStyles = {
        display: 'flex',
        padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"} 22px`,
        alignItems: 'center',
        justifyContent: 'space-between'
    };
    const $5097d73619a780fd$var$CustomHeaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1yt4npc0 _4cvr1h6o _1bah1yb4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7iGYR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa11b5fbf0de6c62$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $ldJSL;
    var $juxqI;
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    var $az4zD;
    var $5OJD6;
    function $fa11b5fbf0de6c62$export$1784e93004806671(props) {
        const { isActionEnabled: isActionEnabled, isActionInProgress: isActionInProgress, actionButtonCaption: actionButtonCaption, actionButtonAppearance: actionButtonAppearance, onCancel: onCancel, onAction: onAction, intl: { formatMessage: formatMessage } } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($fa11b5fbf0de6c62$var$Container, null, isActionInProgress && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $fa11b5fbf0de6c62$var$spinnerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: actionButtonAppearance,
            type: "submit",
            isDisabled: !isActionEnabled,
            onClick: onAction
        }, actionButtonCaption), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            isDisabled: isActionInProgress,
            onClick: onCancel
        }, formatMessage((0, (0, parcelRequire("5OJD6")).default).cancelButtonCaption)))));
    }
    $fa11b5fbf0de6c62$export$1784e93004806671.defaultProps = {
        isActionEnabled: true,
        isActionInProgress: false,
        actionButtonAppearance: 'primary',
        onAction: (0, ($parcel$interopDefault($8Rkzz))),
        onCancel: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $fa11b5fbf0de6c62$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($fa11b5fbf0de6c62$export$1784e93004806671);
    const $fa11b5fbf0de6c62$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $fa11b5fbf0de6c62$var$spinnerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.200'
    });
});
parcelRegister("5OJD6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1955ef7db7bf7b0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d1955ef7db7bf7b0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cancelButtonCaption: {
            "id": "shareable-entity-dialog.action-modal-footer.cancel-button-caption",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("6325A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdb76d6dda2992ec$export$2e2bcd8739ae039);
    var $7VHMR;
    const $bdb76d6dda2992ec$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "copy-filters-modal.common.flags.error.title",
            "defaultMessage": "We couldn't copy a filter"
        },
        description: {
            "id": "copy-filters-modal.common.flags.error.description",
            "defaultMessage": "There was an error, please try again."
        }
    });
    var $bdb76d6dda2992ec$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $bdb76d6dda2992ec$var$messages.title,
            description: $bdb76d6dda2992ec$var$messages.description
        });
});
parcelRegister("d6KcG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c32dd25ef56dad3d$export$2e2bcd8739ae039);
    var $7VHMR;
    const $c32dd25ef56dad3d$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "copy-filters-modal.common.flags.success.title",
            "defaultMessage": "A copy of {name} was successfully created."
        }
    });
    var $c32dd25ef56dad3d$export$2e2bcd8739ae039 = (name)=>({
            type: 'success',
            title: [
                $c32dd25ef56dad3d$var$messages.title,
                {
                    name: name
                }
            ],
            isAutoDismiss: true
        });
});
parcelRegister("2ZmUc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ecc35357e7f45af$export$2e2bcd8739ae039);
    var $eusud;
    var $dnOue;
    var $0ecc35357e7f45af$export$2e2bcd8739ae039 = (filter, jql, isFavourite, overrideSharePermissions)=>{
        const body = (0, (0, parcelRequire("dnOue")).transformCopyFilter)(filter, jql, isFavourite);
        return (0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/api/2/filter${overrideSharePermissions ? '?overrideSharePermissions=true' : ''}`, {
            body: JSON.stringify(body)
        });
    };
});
parcelRegister("dnOue", function(module, exports) {
    $parcel$export(module.exports, "transformCopyFilter", ()=>$8b07381dc62d94d1$export$bf8cb54494b88c10);
    var $knvh6;
    const $8b07381dc62d94d1$export$bf8cb54494b88c10 = (filter, jql, isFavourite)=>{
        const { description: description, name: name, owner: owner, editPermissions: editPermissions, sharePermissions: sharePermissions } = filter;
        const result = {
            name: name,
            description: description,
            favourite: isFavourite,
            jql: jql,
            sharePermissions: (0, (0, parcelRequire("knvh6")).transformSharePermissionsToServer)(sharePermissions || [], true),
            editPermissions: (0, (0, parcelRequire("knvh6")).transformSharePermissionsToServer)(editPermissions || [], true)
        };
        if (owner) result.owner = {
            accountId: owner.accountId
        };
        return result;
    };
});
parcelRegister("54Uq9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fab1748318121f9d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fab1748318121f9d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "copy-filters-modal.content.header",
            "defaultMessage": "Copy filter {name}"
        },
        saveButtonCaption: {
            "id": "copy-filters-modal.content.save-button-caption",
            "defaultMessage": "Copy"
        }
    });
});
parcelRegister("jwPQ3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3fa266e21ecf613$export$2e2bcd8739ae039);
    var $eM3no;
    var $bC2fB;
    var $99OGQ;
    var $hXBjD;
    var $b9OA0;
    const $e3fa266e21ecf613$var$mapStateToProps = (state, ownProps)=>({
            baseUrl: (0, (0, parcelRequire("hXBjD")).getBaseUrl)(state),
            filter: (0, (0, parcelRequire("b9OA0")).getFilter)(state, ownProps.entityId)
        });
    const $e3fa266e21ecf613$var$mapDispatchToProps = (dispatch, ownProps)=>({
            onInitialised: ownProps.onDialogShown,
            onFilterDeleted: (filter)=>{
                dispatch((0, (0, parcelRequire("99OGQ")).deleted)(filter.name));
                ownProps.onUpdated();
            },
            onFilterDeleteFailed: (filter)=>dispatch((0, (0, parcelRequire("99OGQ")).deleteFailed)(filter.name)),
            onFilterInitiateFailed: (filter)=>{
                dispatch((0, (0, parcelRequire("99OGQ")).deleteFailed)(filter.name));
                ownProps.onDataRetrieveFailed();
            },
            onCancel: ownProps.onCancel
        });
    var $e3fa266e21ecf613$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($e3fa266e21ecf613$var$mapStateToProps, $e3fa266e21ecf613$var$mapDispatchToProps)((0, (0, parcelRequire("eM3no")).default));
});
parcelRegister("eM3no", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06cd5fbdfa743d8b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jzjy1;
    var $jD5no;
    var $lf2Au;
    var $7iJwP;
    var $dZMvI;
    var $jemkP;
    var $aDeVF;
    var $9ekJG;
    class $06cd5fbdfa743d8b$var$DeleteModal extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onInitialised: (0, ($parcel$interopDefault($8Rkzz))),
                onFilterDeleted: (0, ($parcel$interopDefault($8Rkzz))),
                onCancel: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        constructor(props){
            super(props);
            this.store = (0, (0, parcelRequire("aDeVF")).default)((0, (0, parcelRequire("dZMvI")).default));
            this.store.dispatch((0, (0, parcelRequire("jemkP")).setAppProps)(this.props));
            this.store.dispatch((0, (0, parcelRequire("jemkP")).getAssociatedItems)());
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
                store: this.store,
                hasErrorBoundary: false
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
                id: "unhandled",
                packageName: "jiraDeleteFiltersModal",
                teamName: "jira-cosmos"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lf2Au")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ekJG")).default), null))));
        }
    }
    var $06cd5fbdfa743d8b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('deleteFilter', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($06cd5fbdfa743d8b$var$DeleteModal);
});
parcelRegister("dZMvI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8e39f8e320e7804$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $kzfeq;
    var $b5iht;
    var $a8e39f8e320e7804$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("kzfeq")).default), (0, (0, parcelRequire("b5iht")).default));
});
parcelRegister("kzfeq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b20171187c0eaaf$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $fsh9d;
    var $3HwlS;
    var $i2hR1;
    var $jemkP;
    var $iOraS;
    var $1b20171187c0eaaf$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jemkP")).DELETE_FILTER)).mergeMap(({ onComplete: onComplete })=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("iOraS")).getBaseUrl)(state);
            const filter = (0, (0, parcelRequire("iOraS")).getFilter)(state);
            return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("i2hR1")).default)(baseUrl, filter.id)).mergeMap(()=>{
                (0, (0, parcelRequire("iOraS")).getOnFilterDeleted)(state)(filter);
                (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && onComplete?.();
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("jemkP")).filterDeleted)());
            }).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.delete-modal.ops.delete-filter', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
                (0, (0, parcelRequire("iOraS")).getOnFilterDeleteFailed)(state)(filter);
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("jemkP")).deleteFilterFailed)());
            });
        });
});
parcelRegister("i2hR1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f063f6444575f430$export$2e2bcd8739ae039);
    var $lNsNP;
    var $f063f6444575f430$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, (0, parcelRequire("lNsNP")).default)(baseUrl, filterId);
});
parcelRegister("lNsNP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3cc82205e32ffce$export$2e2bcd8739ae039);
    var $eusud;
    const $d3cc82205e32ffce$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/api/3/filter/${filterId}`;
    var $d3cc82205e32ffce$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, (0, parcelRequire("eusud")).performDeleteRequest)($d3cc82205e32ffce$export$7138c24907de3954(baseUrl, filterId));
});
parcelRegister("jemkP", function(module, exports) {
    $parcel$export(module.exports, "SET_APP_PROPS", ()=>$62c4330949a1ef35$export$8aefe701a6f431e0);
    $parcel$export(module.exports, "setAppProps", ()=>$62c4330949a1ef35$export$cfda7627848a58cd);
    $parcel$export(module.exports, "GET_ASSOCIATED_ITEMS", ()=>$62c4330949a1ef35$export$30d51c320095bdf2);
    $parcel$export(module.exports, "getAssociatedItems", ()=>$62c4330949a1ef35$export$41e54fd4a1e5f9ba);
    $parcel$export(module.exports, "ASSOCIATED_ITEMS_RETRIEVED", ()=>$62c4330949a1ef35$export$ba1e7147572f059);
    $parcel$export(module.exports, "associatedItemsRetrieved", ()=>$62c4330949a1ef35$export$25e9475c64e5eda0);
    $parcel$export(module.exports, "GET_ASSOCIATED_ITEMS_FAILED", ()=>$62c4330949a1ef35$export$4c7da338bde02996);
    $parcel$export(module.exports, "getAssociatedItemsFailed", ()=>$62c4330949a1ef35$export$bc1efa3ceb08db7b);
    $parcel$export(module.exports, "DELETE_FILTER", ()=>$62c4330949a1ef35$export$c90b00f6f11adca7);
    $parcel$export(module.exports, "deleteFilter", ()=>$62c4330949a1ef35$export$d80cc0328fcc6685);
    $parcel$export(module.exports, "DELETE_FILTER_FAILED", ()=>$62c4330949a1ef35$export$d3f2a09b0efe5b07);
    $parcel$export(module.exports, "deleteFilterFailed", ()=>$62c4330949a1ef35$export$e303ddf5f6d63378);
    $parcel$export(module.exports, "FILTER_DELETED", ()=>$62c4330949a1ef35$export$c8cf94be5a7baff9);
    $parcel$export(module.exports, "filterDeleted", ()=>$62c4330949a1ef35$export$9411fafcb56b5a87);
    const $62c4330949a1ef35$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
    const $62c4330949a1ef35$export$cfda7627848a58cd = (payload)=>({
            type: $62c4330949a1ef35$export$8aefe701a6f431e0,
            payload: payload
        });
    const $62c4330949a1ef35$export$30d51c320095bdf2 = 'state.GET_ASSOCIATED_ITEMS';
    const $62c4330949a1ef35$export$41e54fd4a1e5f9ba = ()=>({
            type: $62c4330949a1ef35$export$30d51c320095bdf2
        });
    const $62c4330949a1ef35$export$ba1e7147572f059 = 'state.ASSOCIATED_ITEMS_RETRIEVED';
    const $62c4330949a1ef35$export$25e9475c64e5eda0 = (payload)=>({
            type: $62c4330949a1ef35$export$ba1e7147572f059,
            payload: payload
        });
    const $62c4330949a1ef35$export$4c7da338bde02996 = 'state.GET_ASSOCIATED_ITEMS_FAILED';
    const $62c4330949a1ef35$export$bc1efa3ceb08db7b = ()=>({
            type: $62c4330949a1ef35$export$4c7da338bde02996
        });
    const $62c4330949a1ef35$export$c90b00f6f11adca7 = 'state.DELETE_FILTER';
    const $62c4330949a1ef35$export$d80cc0328fcc6685 = (onComplete)=>({
            type: $62c4330949a1ef35$export$c90b00f6f11adca7,
            onComplete: onComplete
        });
    const $62c4330949a1ef35$export$d3f2a09b0efe5b07 = 'state.DELETE_FILTER_FAILED';
    const $62c4330949a1ef35$export$e303ddf5f6d63378 = ()=>({
            type: $62c4330949a1ef35$export$d3f2a09b0efe5b07
        });
    const $62c4330949a1ef35$export$c8cf94be5a7baff9 = 'state.FILTER_DELETED';
    const $62c4330949a1ef35$export$9411fafcb56b5a87 = ()=>({
            type: $62c4330949a1ef35$export$c8cf94be5a7baff9
        });
});
parcelRegister("iOraS", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$317d9690ead12f9d$export$f654b28f82155665);
    $parcel$export(module.exports, "getFilter", ()=>$317d9690ead12f9d$export$61ec8404f465cd36);
    $parcel$export(module.exports, "getFilterName", ()=>$317d9690ead12f9d$export$b055b0a980ec5c8b);
    $parcel$export(module.exports, "getOnInitialised", ()=>$317d9690ead12f9d$export$47263859bc15a8b8);
    $parcel$export(module.exports, "getOnFilterDeleted", ()=>$317d9690ead12f9d$export$f5f4c932a633fd32);
    $parcel$export(module.exports, "getOnFilterDeleteFailed", ()=>$317d9690ead12f9d$export$eb50a3cf06607a3c);
    $parcel$export(module.exports, "getOnFilterInitiateFailed", ()=>$317d9690ead12f9d$export$9ef18d2a82ac120);
    $parcel$export(module.exports, "getOnCancel", ()=>$317d9690ead12f9d$export$2c6267c00ffc9906);
    $parcel$export(module.exports, "isDeleteInProgress", ()=>$317d9690ead12f9d$export$906c0d65e4ece39d);
    $parcel$export(module.exports, "isDataRetrieved", ()=>$317d9690ead12f9d$export$a9211cdc0a6969f);
    $parcel$export(module.exports, "getAssociatedBoards", ()=>$317d9690ead12f9d$export$2de9e9ee805a66);
    $parcel$export(module.exports, "getAssociatedUsers", ()=>$317d9690ead12f9d$export$4004cc0feaedb1d1);
    $parcel$export(module.exports, "getAssociatedGroups", ()=>$317d9690ead12f9d$export$4f21761c9913ab49);
    $parcel$export(module.exports, "getCanDelete", ()=>$317d9690ead12f9d$export$e31d21defdc79bd5);
    const $317d9690ead12f9d$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
    const $317d9690ead12f9d$export$61ec8404f465cd36 = (state)=>state.appProps.filter;
    const $317d9690ead12f9d$export$b055b0a980ec5c8b = (state)=>state.appProps.filter.name;
    const $317d9690ead12f9d$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
    const $317d9690ead12f9d$export$f5f4c932a633fd32 = (state)=>state.appProps.onFilterDeleted;
    const $317d9690ead12f9d$export$eb50a3cf06607a3c = (state)=>state.appProps.onFilterDeleteFailed;
    const $317d9690ead12f9d$export$9ef18d2a82ac120 = (state)=>state.appProps.onFilterInitiateFailed;
    const $317d9690ead12f9d$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
    const $317d9690ead12f9d$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
    const $317d9690ead12f9d$export$a9211cdc0a6969f = (state)=>state.isDataRetrieved;
    const $317d9690ead12f9d$export$2de9e9ee805a66 = (state)=>state.boards;
    const $317d9690ead12f9d$export$4004cc0feaedb1d1 = (state)=>state.users;
    const $317d9690ead12f9d$export$4f21761c9913ab49 = (state)=>state.groups;
    const $317d9690ead12f9d$export$e31d21defdc79bd5 = (state)=>Array.isArray(state.boards) && state.boards.length === 0;
});
parcelRegister("b5iht", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b80972f9b3fefbb4$export$2e2bcd8739ae039);
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("9IWoG");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $fsh9d;
    var $2idt2;
    var $7r08o;
    var $jemkP;
    var $iOraS;
    var $b80972f9b3fefbb4$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jemkP")).GET_ASSOCIATED_ITEMS)).mergeMap(()=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("iOraS")).getBaseUrl)(state);
            const filter = (0, (0, parcelRequire("iOraS")).getFilter)(state);
            return (0, $kVLXA.Observable).forkJoin((0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("2idt2")).default)(baseUrl, filter.id)), (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("7r08o")).default)(baseUrl, filter.id))).map(([boards, subscriptions])=>{
                const { users: users, groups: groups } = subscriptions;
                (0, (0, parcelRequire("iOraS")).getOnInitialised)(state)();
                return (0, (0, parcelRequire("jemkP")).associatedItemsRetrieved)({
                    boards: boards,
                    users: users,
                    groups: groups
                });
            }).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.delete-modal.ops.get-associated-items', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
                (0, (0, parcelRequire("iOraS")).getOnFilterInitiateFailed)(state)(filter);
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("jemkP")).getAssociatedItemsFailed)());
            });
        });
});
parcelRegister("2idt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f9e6e4df190511d$export$2e2bcd8739ae039);
    var $fDRaW;
    var $1rV38;
    var $5f9e6e4df190511d$export$2e2bcd8739ae039 = async (baseUrl, filterId)=>{
        const response = await (0, (0, parcelRequire("fDRaW")).default)(baseUrl, filterId);
        return (0, (0, parcelRequire("1rV38")).default)(response, baseUrl);
    };
});
parcelRegister("fDRaW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57ef3264d1641307$export$2e2bcd8739ae039);
    var $7f4tk;
    const $57ef3264d1641307$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/agile/1.0/board/filter/${filterId}`;
    var $57ef3264d1641307$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, (0, parcelRequire("7f4tk")).default)($57ef3264d1641307$export$7138c24907de3954(baseUrl, filterId));
});
parcelRegister("1rV38", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af931ea4cf63d8b4$export$2e2bcd8739ae039);
    const $af931ea4cf63d8b4$export$b708cb7873d8352c = (baseUrl, id)=>`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;
    var $af931ea4cf63d8b4$export$2e2bcd8739ae039 = (response, baseUrl)=>{
        const boards = response && response.values || [];
        return boards.map((board)=>{
            const { name: name, id: id } = board;
            const href = $af931ea4cf63d8b4$export$b708cb7873d8352c(baseUrl, id);
            return {
                name: name,
                id: id,
                href: href
            };
        });
    };
});
parcelRegister("7r08o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddd004cba93b1adc$export$2e2bcd8739ae039);
    var $eAHx9;
    var $79DFK;
    var $ddd004cba93b1adc$export$2e2bcd8739ae039 = async (baseUrl, filterId)=>{
        const response = await (0, (0, parcelRequire("eAHx9")).default)(baseUrl, filterId);
        return (0, (0, parcelRequire("79DFK")).default)(response, baseUrl);
    };
});
parcelRegister("eAHx9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7443769520e58a35$export$2e2bcd8739ae039);
    var $7f4tk;
    const $7443769520e58a35$export$7138c24907de3954 = (baseUrl, filterId)=>`/rest/api/3/filter/${filterId}?expand=subscriptions`;
    var $7443769520e58a35$export$2e2bcd8739ae039 = (baseUrl, filterId)=>(0, (0, parcelRequire("7f4tk")).default)($7443769520e58a35$export$7138c24907de3954(baseUrl, filterId));
});
parcelRegister("79DFK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$196e75ab8ca89e74$export$2e2bcd8739ae039);
    const $196e75ab8ca89e74$export$d62b55bf0ad74ba2 = (baseUrl, id)=>`/jira/people/${id}`;
    var $196e75ab8ca89e74$export$2e2bcd8739ae039 = (response, baseUrl)=>{
        const subscriptions = response && response.subscriptions && response.subscriptions.items || [];
        const users = [];
        const groups = [];
        subscriptions.forEach((subscription)=>{
            const { user: user, group: group } = subscription;
            if (group) return groups.push({
                name: group.name
            });
            const href = $196e75ab8ca89e74$export$d62b55bf0ad74ba2(baseUrl, user.accountId);
            return user && users.push({
                displayName: user.displayName,
                href: href
            });
        });
        return {
            users: users,
            groups: groups
        };
    };
});
parcelRegister("aDeVF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ce4dd7ecc996a54$export$2e2bcd8739ae039);
    var $F2Mxm;
    var $aXcJn;
    var $9ce4dd7ecc996a54$export$2e2bcd8739ae039 = (rootEpic)=>(0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'directories/filters-v2/delete-modal',
            rootReducer: (0, parcelRequire("aXcJn")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("aXcJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3e77f8c76d4fb6d$export$2e2bcd8739ae039);
    var $jemkP;
    const $f3e77f8c76d4fb6d$export$49d5fc8cba920a0 = {
        appProps: undefined,
        boards: [],
        users: [],
        groups: [],
        isDataRetrieved: false,
        isDeleteInProgress: false
    };
    var $f3e77f8c76d4fb6d$export$2e2bcd8739ae039 = (state = $f3e77f8c76d4fb6d$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("jemkP")).SET_APP_PROPS:
                return {
                    ...state,
                    appProps: action.payload
                };
            case 0, (0, parcelRequire("jemkP")).DELETE_FILTER:
                return {
                    ...state,
                    isDeleteInProgress: true
                };
            case 0, (0, parcelRequire("jemkP")).FILTER_DELETED:
            case 0, (0, parcelRequire("jemkP")).DELETE_FILTER_FAILED:
                return {
                    ...state,
                    isDeleteInProgress: false
                };
            case 0, (0, parcelRequire("jemkP")).ASSOCIATED_ITEMS_RETRIEVED:
                {
                    const { boards: boards, users: users, groups: groups } = action.payload;
                    return {
                        ...state,
                        isDataRetrieved: true,
                        ...boards ? {
                            boards: boards
                        } : undefined,
                        ...users ? {
                            users: users
                        } : undefined,
                        ...groups ? {
                            groups: groups
                        } : undefined
                    };
                }
            case 0, (0, parcelRequire("jemkP")).GET_ASSOCIATED_ITEMS_FAILED:
            case 0, (0, parcelRequire("jemkP")).GET_ASSOCIATED_ITEMS:
                return state;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("9ekJG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffbff3d345f85465$export$2e2bcd8739ae039);
    var $bC2fB;
    var $iOraS;
    var $5d0Op;
    var $6EW7m;
    var $7rRaV;
    const $ffbff3d345f85465$var$mapStateToProps = (state)=>({
            Content: (0, parcelRequire("5d0Op")).default,
            Footer: (0, parcelRequire("6EW7m")).default,
            name: (0, (0, parcelRequire("iOraS")).getFilterName)(state),
            onCancel: (0, (0, parcelRequire("iOraS")).getOnCancel)(state),
            isOpen: (0, (0, parcelRequire("iOraS")).isDataRetrieved)(state)
        });
    var $ffbff3d345f85465$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($ffbff3d345f85465$var$mapStateToProps, {})((0, (0, parcelRequire("7rRaV")).default));
});
parcelRegister("5d0Op", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1dc72c582811a16$export$2e2bcd8739ae039);
    var $bC2fB;
    var $iOraS;
    var $8SnWj;
    const $d1dc72c582811a16$var$mapStateToProps = (state)=>({
            filter: (0, (0, parcelRequire("iOraS")).getFilter)(state),
            boards: (0, (0, parcelRequire("iOraS")).getAssociatedBoards)(state),
            users: (0, (0, parcelRequire("iOraS")).getAssociatedUsers)(state),
            groups: (0, (0, parcelRequire("iOraS")).getAssociatedGroups)(state)
        });
    var $d1dc72c582811a16$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($d1dc72c582811a16$var$mapStateToProps, {})((0, (0, parcelRequire("8SnWj")).default));
});
parcelRegister("8SnWj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62e1c0ece3b30ec8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4yMr;
    var $koVbs;
    var $cRRmC;
    const $62e1c0ece3b30ec8$var$ContentWithoutBoardsAndSubscriptions = ({ formatMessage: formatMessage })=>(0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).noSubscriptionsAndBoards));
    const $62e1c0ece3b30ec8$var$ContentWithAssociatedSubscriptions = ({ formatMessage: formatMessage, groups: groups, users: users })=>users.length === 1 && groups.length === 0 || users.length === 0 && groups.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).singleSubscription), users.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            href: users[0].href
        }, `${users[0].displayName}.`) : null, groups.length === 1 ? `${groups[0].name}.` : null), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleBoardsWarning))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleSubscriptions, {
            number: users.length + groups.length
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("ul", null, users.map(({ displayName: displayName, href: href }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                href: href
            }, displayName))), groups.map(({ name: name }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: index
            }, name))), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleSubscriptionsWarning)));
    const $62e1c0ece3b30ec8$var$ContentWithAssociatedBoards = ({ boards: boards, formatMessage: formatMessage })=>boards.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).singleBoard), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            href: boards[0].href
        }, `${boards[0].name}.`)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleBoardsWarning))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleBoards, {
            number: boards.length
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("ul", null, boards.map(({ name: name, href: href }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                href: href
            }, name)))), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).multipleBoardsWarning)));
    const $62e1c0ece3b30ec8$export$7c6e2c02157bb7d2 = ({ boards: boards, groups: groups, users: users })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (users.length === 0 && groups.length === 0 && boards.length === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithoutBoardsAndSubscriptions, {
            formatMessage: formatMessage
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("cRRmC")).default).associatedItems)), boards.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithAssociatedBoards, {
            boards: boards,
            formatMessage: formatMessage
        }) : null, users.length > 0 || groups.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement($62e1c0ece3b30ec8$var$ContentWithAssociatedSubscriptions, {
            users: users,
            groups: groups,
            formatMessage: formatMessage
        }) : null);
    };
    var $62e1c0ece3b30ec8$export$2e2bcd8739ae039 = $62e1c0ece3b30ec8$export$7c6e2c02157bb7d2;
});
parcelRegister("cRRmC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3531ea37b151c3e0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3531ea37b151c3e0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noSubscriptionsAndBoards: {
            "id": "directories.filters-v2.delete-modal.content.no-subscriptions-and-boards",
            "defaultMessage": "Are you sure you want to delete this filter?"
        },
        associatedItems: {
            "id": "directories.filters-v2.delete-modal.content.associated-items",
            "defaultMessage": "This filter is used elsewhere. Deleting it may impact other people's work."
        },
        multipleSubscriptions: {
            "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions",
            "defaultMessage": "This filter has currently {number} subscriptions:"
        },
        singleSubscription: {
            "id": "directories.filters-v2.delete-modal.content.single-subscription",
            "defaultMessage": "This filter has a subscription for "
        },
        multipleSubscriptionsWarning: {
            "id": "directories.filters-v2.delete-modal.content.multiple-subscriptions-warning",
            "defaultMessage": "Deleting this filter will cause subscription emails for these users and groups to no longer be delivered."
        },
        multipleBoards: {
            "id": "directories.filters-v2.delete-modal.content.multiple-boards",
            "defaultMessage": "This filter is currently being used by {number} boards:"
        },
        singleBoard: {
            "id": "directories.filters-v2.delete-modal.content.single-board",
            "defaultMessage": "This filter is currently being used by "
        },
        multipleBoardsWarning: {
            "id": "directories.filters-v2.delete-modal.content.multiple-boards-warning",
            "defaultMessage": "You'll need to remove this filters associations to the boards before it can be removed."
        }
    });
});
parcelRegister("6EW7m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$310670aed312a399$export$2e2bcd8739ae039);
    var $basmW = parcelRequire("basmW");
    var $iQv12;
    var $bC2fB;
    var $jemkP;
    var $iOraS;
    var $9pknF;
    const $310670aed312a399$var$mapStateToProps = (state)=>({
            filter: (0, (0, parcelRequire("iOraS")).getFilter)(state),
            canDelete: (0, (0, parcelRequire("iOraS")).getCanDelete)(state),
            deleteInProgress: (0, (0, parcelRequire("iOraS")).isDeleteInProgress)(state),
            onCancel: (0, (0, parcelRequire("iOraS")).getOnCancel)(state)
        });
    var $310670aed312a399$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("iQv12")).default)({
        onDelete: 'filterDeleted',
        onCancel: 'filterDeleteCanceled'
    }), (0, (0, parcelRequire("bC2fB")).connect)($310670aed312a399$var$mapStateToProps, {
        onDelete: (0, (0, parcelRequire("jemkP")).deleteFilter)
    }))((0, (0, parcelRequire("9pknF")).default));
});
parcelRegister("9pknF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8841fecfbc7d37be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $ldJSL;
    var $juxqI;
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    var $az4zD;
    var $3HwlS;
    var $7hmi2;
    var $7kS0u;
    const $8841fecfbc7d37be$var$Footer = ({ intl: { formatMessage: formatMessage }, canDelete: canDelete, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete })=>{
        const { publish: publish } = (0, (0, parcelRequire("7hmi2")).useDeleteChangeActions)();
        const onDeleteWithEvent = (event, analyticsEvent)=>{
            onDelete(publish, event, analyticsEvent);
        };
        const onDeleteOld = (event, analyticsEvent)=>{
            onDelete(undefined, event, analyticsEvent);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($8841fecfbc7d37be$var$Container, null, deleteInProgress && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8841fecfbc7d37be$var$spinnerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "danger",
            type: "submit",
            isDisabled: !canDelete,
            onClick: (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? onDeleteWithEvent : onDeleteOld
        }, formatMessage((0, (0, parcelRequire("7kS0u")).default).delete)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            isDisabled: deleteInProgress,
            onClick: onCancel
        }, formatMessage((0, (0, parcelRequire("7kS0u")).default).cancelButtonCaption)))));
    };
    $8841fecfbc7d37be$var$Footer.defaultProps = {
        onDelete: (0, ($parcel$interopDefault($8Rkzz))),
        onCancel: (0, ($parcel$interopDefault($8Rkzz))),
        deleteInProgress: false,
        canDelete: true
    };
    var $8841fecfbc7d37be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($8841fecfbc7d37be$var$Footer);
    const $8841fecfbc7d37be$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $8841fecfbc7d37be$var$spinnerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.200'
    });
});
parcelRegister("7hmi2", function(module, exports) {
    $parcel$export(module.exports, "useDeleteChangeActions", ()=>$4b1281a69eb8a7ab$export$ebbca0408972222d);
    var $3sQ5x;
    var $iXqE5;
    const $4b1281a69eb8a7ab$var$initialState = {
        callbacks: []
    };
    const $4b1281a69eb8a7ab$export$e324594224ef24da = {
        subscribe: (callback)=>({ getState: getState, setState: setState })=>{
                if (!getState().callbacks.includes(callback)) setState({
                    callbacks: [
                        ...getState().callbacks,
                        callback
                    ]
                });
            },
        unsubscribe: (callback)=>({ getState: getState, setState: setState })=>{
                if (getState().callbacks.includes(callback)) setState({
                    callbacks: getState().callbacks.filter((item)=>item !== callback)
                });
            },
        publish: ()=>({ getState: getState })=>{
                getState().callbacks.forEach((callback)=>callback({
                        onComplete: ()=>undefined
                    }));
            }
    };
    const $4b1281a69eb8a7ab$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $4b1281a69eb8a7ab$var$initialState,
        actions: $4b1281a69eb8a7ab$export$e324594224ef24da
    });
    const $4b1281a69eb8a7ab$export$440b46140bc86b64 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($4b1281a69eb8a7ab$var$Store);
    const $4b1281a69eb8a7ab$export$ebbca0408972222d = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($4b1281a69eb8a7ab$var$Store);
});
parcelRegister("7kS0u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc97edda63b98d49$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bc97edda63b98d49$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        delete: {
            "id": "directories.filters-v2.delete-modal.footer.delete",
            "defaultMessage": "Delete"
        },
        cancelButtonCaption: {
            "id": "directories.filters-v2.delete-modal.footer.cancel-button-caption",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("7rRaV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3b1435469220d97$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $hZHze;
    var $9fuVs;
    var $az4zD;
    var $liKYS;
    const $d3b1435469220d97$var$DeleteModal = ({ intl: { formatMessage: formatMessage }, isOpen: isOpen, Content: Content, Footer: Footer, onCancel: onCancel, name: name })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "small",
            onClose: onCancel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "danger"
        }, formatMessage((0, (0, parcelRequire("liKYS")).default).title, {
            name: name
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Content, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement(Footer, {
            onClose: onCancel
        }))));
    var $d3b1435469220d97$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($d3b1435469220d97$var$DeleteModal);
});
parcelRegister("liKYS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33404efbe1d974cc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $33404efbe1d974cc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "directories.filters-v2.delete-modal.title",
            "defaultMessage": "Delete {name}"
        }
    });
});
parcelRegister("1XGvI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a67d3a83e2814c56$export$2e2bcd8739ae039);
    var $l6Ke4;
    var $7XYc4;
    var $e5wyW;
    var $4R6GH;
    var $3HwlS;
    var $bC2fB;
    var $6KXPO;
    var $hXBjD;
    var $b9OA0;
    const $a67d3a83e2814c56$var$mapStateToPropsOld = (state, ownProps)=>({
            baseUrl: (0, (0, parcelRequire("hXBjD")).getBaseUrl)(state),
            id: ownProps.entityId,
            name: (0, (0, parcelRequire("b9OA0")).getName)(state, ownProps.entityId),
            description: (0, (0, parcelRequire("b9OA0")).getDescription)(state, ownProps.entityId),
            sharePermissions: (0, (0, parcelRequire("b9OA0")).getShares)(state, ownProps.entityId),
            editPermissions: (0, (0, parcelRequire("b9OA0")).getEdits)(state, ownProps.entityId),
            onCancel: ownProps.onCancel,
            onInitiateSuccess: ()=>{
                ownProps.onDialogShown();
            },
            onEdited: (_updatedData)=>{
                ownProps.onUpdated();
            }
        });
    const $a67d3a83e2814c56$var$mapStateToPropsNew = (initialState, ownProps)=>{
        const onEdited = (_updatedData)=>{
            ownProps.onUpdated();
        };
        const onInitiateSuccess = ()=>{
            ownProps.onDialogShown();
        };
        return (state)=>({
                baseUrl: (0, (0, parcelRequire("hXBjD")).getBaseUrl)(state),
                id: ownProps.entityId,
                name: (0, (0, parcelRequire("b9OA0")).getName)(state, ownProps.entityId),
                description: (0, (0, parcelRequire("b9OA0")).getDescription)(state, ownProps.entityId),
                sharePermissions: (0, (0, parcelRequire("b9OA0")).getShares)(state, ownProps.entityId),
                editPermissions: (0, (0, parcelRequire("b9OA0")).getEdits)(state, ownProps.entityId),
                onCancel: ownProps.onCancel,
                onInitiateSuccess: onInitiateSuccess,
                onEdited: onEdited
            });
    };
    const $a67d3a83e2814c56$var$mapStateToPropsNewModal = (initialState, ownProps)=>{
        const onEdited = (_updatedData)=>{
            ownProps.onUpdated();
        };
        return ()=>({
                onDialogShown: ownProps.onDialogShown,
                filterId: ownProps.entityId,
                onCloseModal: ownProps.onCancel,
                onSuccess: onEdited,
                isOpen: true
            });
    };
    const $a67d3a83e2814c56$var$FilterDialog = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("6KXPO")).AsyncUpdateFilterDialog), (0, (0, parcelRequire("l6Ke4")).default));
    const $a67d3a83e2814c56$var$mapStateToProps = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('fix_unstable_selector_in_filter_directory'), (0, (0, parcelRequire("e5wyW")).functionWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $a67d3a83e2814c56$var$mapStateToPropsNewModal, $a67d3a83e2814c56$var$mapStateToPropsNew), $a67d3a83e2814c56$var$mapStateToPropsOld);
    var $a67d3a83e2814c56$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($a67d3a83e2814c56$var$mapStateToProps, {})($a67d3a83e2814c56$var$FilterDialog);
});
parcelRegister("l6Ke4", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$c35f0b79aa6dfc3d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jzjy1;
    var $jD5no;
    var $lf2Au;
    var $7iJwP;
    var $itmJb;
    var $fL8H8;
    function $c35f0b79aa6dfc3d$var$EditFilterModal(props) {
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: "unhandled",
            packageName: "jiraEditFiltersModal",
            teamName: "jira-cosmos"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lf2Au")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fL8H8")).default), {
            isAdmin: isAdmin,
            ...props
        }))));
    }
    $c35f0b79aa6dfc3d$var$EditFilterModal.defaultProps = {
        onEdited: (0, ($parcel$interopDefault($8Rkzz))),
        onEditFailed: (0, ($parcel$interopDefault($8Rkzz))),
        onCancel: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $c35f0b79aa6dfc3d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('editFilter', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))((0, (0, parcelRequire("jzjy1")).AnalyticsSubject)('filter')($c35f0b79aa6dfc3d$var$EditFilterModal));
});
parcelRegister("fL8H8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a390f8fb17161711$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hhweD;
    var $akuTQ;
    var $dJl1T;
    var $jcw0u;
    var $jJZqs;
    var $34Vv8;
    var $az4zD;
    var $8zOmE;
    var $3Wfkl;
    var $55cx0;
    var $3Ght4;
    var $hMYMm;
    const $a390f8fb17161711$var$getServerSideValidationErrors = (0, (0, parcelRequire("akuTQ")).createServerSideValidationErrorsGetter)({
        filterName: (0, $99958954cd57b065$export$b85469cbf362db42),
        shares: (0, $99958954cd57b065$export$378fd4cd7d69440f),
        edit_permissions: (0, $99958954cd57b065$export$fb465a1f4d511f87)
    });
    class $a390f8fb17161711$export$c4b945a6bafc6ddb extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.props.onInitiateSuccess();
        }
        render() {
            const { baseUrl: baseUrl, onCancel: onCancel, name: name, description: description, editPermissions: editPermissions, sharePermissions: sharePermissions, intl: intl } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMYMm")).default), {
                baseUrl: baseUrl,
                intl: intl,
                onCancel: onCancel,
                name: name,
                description: description,
                sharePermissions: sharePermissions,
                editPermissions: editPermissions,
                operation: this.onOperation,
                onOperationSucceed: this.onOperationSucceed,
                onOperationFailed: this.onOperationFailed,
                getServerSideValidationErrors: $a390f8fb17161711$var$getServerSideValidationErrors
            });
        }
        constructor(...args){
            super(...args), this.onOperation = (filter)=>{
                const { id: id, isAdmin: isAdmin } = this.props;
                return (0, (0, parcelRequire("3Ght4")).default)(id, filter, isAdmin);
            }, this.onOperationSucceed = (filter, _, analyticsEvent)=>{
                const { id: id, onEdited: onEdited, flagService: flagService } = this.props;
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'editedFilter', {
                    isViewerPrivate: filter.sharePermissions.length === 0,
                    isEditorPrivate: filter.editPermissions && filter.editPermissions.length === 0
                });
                flagService.showFlag((0, (0, parcelRequire("55cx0")).default)(filter.name));
                (0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(analyticsEvent, {
                    action: 'updated',
                    actionSubjectId: `${id}`
                });
                onEdited(filter);
            }, this.onOperationFailed = (error, analyticsEvent)=>{
                const { id: id, onEditFailed: onEditFailed, flagService: flagService } = this.props;
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('directories.filters.edit-modal.submit', `edit filter has failed, id=${this.props.id}`, error);
                if (!(error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError))) flagService.showFlag((0, (0, parcelRequire("3Wfkl")).default)());
                onEditFailed();
                (0, (0, parcelRequire("jcw0u")).default)({
                    event: analyticsEvent,
                    error: error,
                    meta: {
                        id: 'operationFailedHandler',
                        packageName: 'jiraEditFiltersModal',
                        teamName: 'jira-cosmos'
                    },
                    attributes: {
                        action: 'updated',
                        actionSubjectId: `${id}`
                    }
                });
            };
        }
    }
    var $a390f8fb17161711$export$2e2bcd8739ae039 = (0, (0, parcelRequire("34Vv8")).default)((0, (0, parcelRequire("az4zD")).injectIntlV2)($a390f8fb17161711$export$c4b945a6bafc6ddb));
});
parcelRegister("34Vv8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$827c4d80e4d41b48$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                flagService: (0, (0, parcelRequire("pa9q9")).flagService)
            });
    };
    var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;
});
parcelRegister("3Wfkl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ccaec7baa697fdd$export$2e2bcd8739ae039);
    var $7VHMR;
    const $7ccaec7baa697fdd$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        genericTitle: {
            "id": "directories.filters-v2.edit-modal.flags.error.generic-title",
            "defaultMessage": "There was an error, please try again."
        }
    });
    var $7ccaec7baa697fdd$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $7ccaec7baa697fdd$var$messages.genericTitle
        });
});
parcelRegister("55cx0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e5c875dfc0997fca$export$2e2bcd8739ae039);
    var $7VHMR;
    const $e5c875dfc0997fca$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "directories.filters-v2.edit-modal.flags.success.title",
            "defaultMessage": "{name} was successfully updated."
        }
    });
    var $e5c875dfc0997fca$export$2e2bcd8739ae039 = (name)=>({
            type: 'success',
            title: [
                $e5c875dfc0997fca$var$messages.title,
                {
                    name: name
                }
            ],
            isAutoDismiss: true
        });
});
parcelRegister("3Ght4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b6c86337ac53e96$export$2e2bcd8739ae039);
    var $fsh9d;
    var $6YLvv;
    var $qazD0;
    var $8b6c86337ac53e96$export$2e2bcd8739ae039 = async (id, filter, overrideSharePermissions)=>{
        const body = (0, (0, parcelRequire("qazD0")).transformEditableFilter)(filter);
        try {
            await (0, (0, parcelRequire("6YLvv")).default)(id, body, overrideSharePermissions);
        } catch (error) {
            (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'directories.filters-v2.edit-modal.edit-filter', (0, $c6c682f59adc6c63$export$9c2a9d62bcf944f8));
            throw error;
        }
    };
});
parcelRegister("6YLvv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$144b23851a5bf169$export$2e2bcd8739ae039);
    var $eusud;
    const $144b23851a5bf169$export$4a8805dc45e0d1a2 = (filterId, overrideSharePermissions)=>`/rest/api/3/filter/${filterId}${overrideSharePermissions ? '?overrideSharePermissions=true' : ''}`;
    var $144b23851a5bf169$export$2e2bcd8739ae039 = async (filterId, body, overrideSharePermissions)=>{
        const url = $144b23851a5bf169$export$4a8805dc45e0d1a2(filterId, overrideSharePermissions);
        return (0, (0, parcelRequire("eusud")).performPutRequest)(url, {
            body: JSON.stringify(body)
        });
    };
});
parcelRegister("qazD0", function(module, exports) {
    $parcel$export(module.exports, "transformEditableFilter", ()=>$5dcb7ead13405e08$export$29126713ffd80950);
    var $knvh6;
    const $5dcb7ead13405e08$export$29126713ffd80950 = (filter)=>{
        const { description: description, name: name, owner: owner, sharePermissions: sharePermissions, editPermissions: editPermissions } = filter;
        const result = {
            name: name,
            description: description,
            sharePermissions: (0, (0, parcelRequire("knvh6")).transformSharePermissionsToServer)(sharePermissions || [], true),
            editPermissions: editPermissions ? (0, (0, parcelRequire("knvh6")).transformSharePermissionsToServer)(editPermissions, true) : undefined
        };
        if (owner) result.owner = {
            accountId: owner.accountId
        };
        return result;
    };
});
parcelRegister("hMYMm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14ee0d3e2848c0ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $70IFa;
    var $6aRCd;
    function $14ee0d3e2848c0ab$export$97b20acb2862c69e(props) {
        const { intl: { formatMessage: formatMessage }, name: name, description: description, onCancel: onCancel, ...restProps } = props;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("70IFa")).SharingPermissionAwareShareableEntityModal), {
            sharingPermissionType: "filter",
            avoidInitialPublicSharePermission: false,
            title: formatMessage((0, (0, parcelRequire("6aRCd")).default).title),
            actionButtonCaption: formatMessage((0, (0, parcelRequire("6aRCd")).default).submitButtonCaption),
            initialName: name,
            initialDescription: description,
            initialOwner: undefined,
            onCancel: onCancel,
            ...restProps
        }));
    }
    var $14ee0d3e2848c0ab$export$2e2bcd8739ae039 = $14ee0d3e2848c0ab$export$97b20acb2862c69e;
});
parcelRegister("6aRCd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d6bc3753cd08742$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8d6bc3753cd08742$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "directories.filters-v2.edit-modal.title",
            "defaultMessage": "Edit filter"
        },
        submitButtonCaption: {
            "id": "directories.filters-v2.edit-modal.submit-button-caption",
            "defaultMessage": "Save"
        }
    });
});
parcelRegister("6KXPO", function(module, exports) {
    $parcel$export(module.exports, "AsyncUpdateFilterDialog", ()=>$5522efbabcc83563$export$8692e2751472dade);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $5522efbabcc83563$var$UpdateFilterDialog = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("4LqdW")), {
        ssr: false,
        moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/update-filter-dialog/index.tsx"
    });
    const $5522efbabcc83563$export$8692e2751472dade = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-update-filter-dialog",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5522efbabcc83563$var$UpdateFilterDialog, props));
});
parcelRegister("4LqdW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fBWcb")
    ]).then(()=>parcelRequire('36hTn'));
});
parcelRegister("h2X1I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90ba86016fcd46a7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $90ba86016fcd46a7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        headerCaption: {
            "id": "directories.filters-v2.main.header-caption",
            "defaultMessage": "Filters"
        },
        filter: {
            "id": "directories.filters-v2.main.filter",
            "defaultMessage": "Name"
        },
        popularity: {
            "id": "directories.filters-v2.main.popularity",
            "defaultMessage": "Starred by"
        },
        owner: {
            "id": "directories.filters-v2.main.owner",
            "defaultMessage": "Owner"
        },
        access: {
            "id": "directories.filters-v2.main.access",
            "defaultMessage": "Access"
        },
        viewers: {
            "id": "directories.filters-v2.main.viewers",
            "defaultMessage": "Viewers"
        },
        editors: {
            "id": "directories.filters-v2.main.editors",
            "defaultMessage": "Editors"
        },
        emptyFilterResultMessage: {
            "id": "directories.filters-v2.main.empty-filter-result-message",
            "defaultMessage": "No filters were found that match your search"
        },
        tableAriaLabel: {
            "id": "directories.filters-v2.main.table-aria-label",
            "defaultMessage": "Filters details"
        },
        filterResultsAnnouncement: {
            "id": "directories.filters-v2.main.filter-results-announcement",
            "defaultMessage": "{itemCount, plural, =0 {No filters were found that match your search} one {{itemCount} filter found} other {{itemCount} filters found}}"
        },
        actions: {
            "id": "directories.filters-v2.main.actions",
            "defaultMessage": "More actions"
        }
    });
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("fhVq7", function(module, exports) {
    $parcel$export(module.exports, "ScrollablePage", ()=>$501f0ba909d41168$export$8d7a30196b47fe34);
    $parcel$export(module.exports, "PageLayout", ()=>$501f0ba909d41168$export$6d1402fb58384e4f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $dCm1o;
    const $501f0ba909d41168$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
            xcss: $501f0ba909d41168$var$scrollablePageStyles,
            paddingBlock: "space.0",
            paddingInline: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? 'space.300' : 'space.500'
        }, children);
    const $501f0ba909d41168$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
        const isVisualRefresh = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
            xcss: hideMargin ? $501f0ba909d41168$var$pageLayoutWithoutMarginStyles : isVisualRefresh ? $501f0ba909d41168$var$pageLayoutWithMarginStyles : $501f0ba909d41168$var$pageLayoutWithMarginStylesOld
        }, children);
    };
    const $501f0ba909d41168$var$scrollablePageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '800px',
        margin: 'space.0'
    });
    const $501f0ba909d41168$var$pageLayoutWithoutMarginStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.0'
    });
    const $501f0ba909d41168$var$pageLayoutWithMarginStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlock: '0',
        marginInline: 'space.500'
    });
    const $501f0ba909d41168$var$pageLayoutWithMarginStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlock: '0',
        marginInline: 'space.300'
    });
});
parcelRegister("cJXov", function(module, exports) {
    $parcel$export(module.exports, "filtersDirectoryPageLoad", ()=>$925da641693c2c42$export$4545feeca18b385d);
    var $dGrdR;
    const $925da641693c2c42$export$4545feeca18b385d = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'filters-directory',
        ssr: {
            doneAsFmp: true
        },
        featureFlags: [
            'opsgenie-consolidation-transitioning-state_d7vm9'
        ]
    });
});
const $e6a2e0952e4731b8$export$febebefae5a09065 = 'profile-card.loaded';
const $e6a2e0952e4731b8$export$3ca1936ee743bd18 = 'profile-card.view';
const $e6a2e0952e4731b8$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $e6a2e0952e4731b8$export$86aa8b9c379ebbbd = 'profile-card.error';
const $e6a2e0952e4731b8$export$4442e31da6ba4127 = 'profile-card.click';
const $e6a2e0952e4731b8$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$2549357601611c61 = 'loadError';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';
